{
  "app": {
    "name": "SilexGIS"
  },
  "iconButtons": {
    "delete": "Șterge",
    "download": "Descarcă",
    "moveUp": "Mută mai sus",
    "moveDown": "Mută mai jos"
  },
  "nav": {
    "map": "Hartă",
    "map3d": "Vizualizare 3D",
    "dashboard": "Panou de bord",
    "caves": "Peșteri",
    "features": "Obiecte",
    "geodata": "Geodate",
    "gallery": "Fotografii",
    "albums": "Albume",
    "photoLibrary": "Fototeca",
    "cabinets": "Dulapuri",
    "uploads": "Încărcări",
    "review": "Încărcări de verificat",
    "trips": "Jurnale de tură",
    "audit": "Istoric",
    "cavingGroups": "Grupuri de speologie",
    "cavers": "Speologi",
    "settings": "Setări",
    "messaging": "Mesagerie",
    "templates": "Texte mesaje",
    "permissionGroups": "Grupuri de permisiuni",
    "users": "Conturi",
    "featureSets": "Seturi de obiecte",
    "documentTypes": "Tipuri de documente",
    "featureTypes": "Tipuri de obiecte",
    "relationTypes": "Relații între obiecte",
    "tripTypes": "Scopuri de tură",
    "participantRoles": "Roluri în tură",
    "campRosterRoles": "Roluri în tabără",
    "reportTemplates": "Modele de raport",
    "termRules": "Reguli de detectare",
    "terrain": "Relief",
    "expeditions": "Tabere",
    "notificationHealth": "Trimiterea mesajelor",
    "calendar": "Calendar",
    "events": "Evenimente",
    "checklists": "Liste de verificare",
    "groups": {
      "cadastre": "Registru",
      "statistics": "Statistici",
      "library": "Bibliotecă",
      "activity": "Activitate",
      "people": "Persoane",
      "admin": "Administrare",
      "config": "Configurare",
      "tools": "Unelte"
    },
    "workAreas": "Zone de lucru",
    "coordinateConverter": "Convertor de coordonate",
    "speologie": "Catalogul peșterilor",
    "registryDistribution": "Distribuții",
    "registryCorrelation": "Corelații",
    "tripImport": "Importă ture",
    "speleolocImport": "Importă o înregistrare",
    "registryRegions": "Regiuni",
    "registryCategories": "Categorii",
    "publishedTrips": "Ture publicate"
  },
  "terrain": {
    "title": "Relief",
    "noBuilds": "Pentru această instalare nu a fost generată încă nicio suprafață de altitudine.",
    "noBuildsHint": "Trasează un dreptunghi mai sus și pornește prima generare.",
    "intro": "Trasează un dreptunghi, spune de unde vin datele de altitudine, iar instalarea generează terenul pe care îl desenează scena 3D.",
    "area": {
      "draw": "Trasează dreptunghi",
      "clear": "Șterge dreptunghiul",
      "hint": "Trage un dreptunghi pe hartă pentru a spune ce teren acoperă această generare.",
      "chosen": "Vest, sud, est, nord: {{extent}} — {{area}} grade pătrate."
    },
    "depthBands": {
      "coarse": "Nivelul {{depth}}: forma generală a reliefului. Se generează repede și ocupă puțin, dar un versant apare ca o singură pantă.",
      "coverage": "Nivelul {{depth}}: tot detaliul pe care îl conține acoperirea de treizeci de metri pe care o obține aplicația. Aceasta este valoarea obișnuită.",
      "fine": "Nivelul {{depth}}: mai fin decât acoperirea obținută. Merită cerut doar acolo unde dreptunghiul este acoperit de rastre de câțiva metri.",
      "survey": "Nivelul {{depth}}: ceea ce justifică datele de măsurătoare de o jumătate de metru. Fiecare nivel aproximativ împătrește atât numărul de dale scrise, cât și timpul necesar."
    },
    "heightDatums": {
      "orthometric": "Deasupra nivelului mării",
      "ellipsoidal": "Deasupra elipsoidului"
    },
    "form": {
      "title": "Generare nouă",
      "area": "Zonă",
      "areaRequired": "Trasează dreptunghiul pe care îl acoperă această generare.",
      "areaTooLarge": "Dreptunghiul este mai mare decât generează această instalare dintr-o dată. Generează-l ca mai multe zone mai mici.",
      "sources": "De unde vin datele de altitudine",
      "fetchCoverage": "Obține acoperirea pentru acest dreptunghi",
      "fetchCoverageHint": "Date de altitudine de treizeci de metri care acoperă întreaga suprafață uscată, aduse de aplicație. Marea nu întoarce nimic, ceea ce este un răspuns normal, nu o eroare.",
      "upload": "Rastre de pe acest calculator",
      "uploadHint": "Trage aici rastre de altitudine sau apasă pentru a le alege.",
      "uploadFormats": "Acceptate: {{formats}}. Cel mult 512 MB fiecare — ce este mai mare își are locul într-un director de pe server.",
      "rasterTooLarge": "Fișierul depășește 512 MB. Pune-l într-un director de pe server.",
      "uploadsPending": "Aceste fișiere nu au ajuns încă, așa că o generare pornită acum s-ar face fără ele: {{files}}. Așteaptă-le sau scoate-le din listă.",
      "directory": "Director pe server",
      "directoryHint": "Un director pe care operatorul l-a declarat ca fiind citibil, sau unul aflat sub el. Se citește tot ce arată acolo a rastru de altitudine.",
      "directoryPlaceholder": "Alege sau scrie un director",
      "attribution": "Sursa datelor",
      "attributionHint": "Cui îi aparțin datele. Se scrie în suprafața publicată, așa că o generare nu trebuie să poarte niciodată o mențiune care nu îi aparține.",
      "attributionRequired": "Spune cui îi aparțin rastrele pe care le-ai furnizat.",
      "licence": "Licență",
      "depth": "Adâncime",
      "depthCapped": "Nimic de aici nu poate umple acele niveluri.",
      "depthCappedDetail": "Această generare se face doar din acoperirea de treizeci de metri obținută de aplicație, care nu mai are detaliu în jurul nivelului 13. Nivelurile mai adânci nu sunt refuzate și nici raportate: suprafața pur și simplu încetează să le ofere, iar nimic nu spune asta ulterior. Adaugă rastre mai fine sau alege o adâncime mai mică.",
      "heights": "Altitudini",
      "heightDatum": "Altitudinile sunt măsurate de la",
      "heightDatumHint": "Ce înseamnă numerele din aceste rastre. O alegere greșită ridică sau coboară întreaga suprafață cu zeci de metri.",
      "geoidHeight": "Înălțimea geoidului (m)",
      "geoidHeightHint": "Cât de sus se află aici suprafața locală a nivelului mării față de elipsoid. Se folosește doar pentru altitudini elipsoidale.",
      "start": "Pornește generarea",
      "started": "Generarea a fost pusă la coadă.",
      "bakeService": "Transformarea acestor date în dale are nevoie de un serviciu separat, pe care o instalare obișnuită nu îl rulează. Dacă aceasta nu îl rulează, generarea se oprește la pasul acela, iar pagina spune atunci ce trebuie scris ca să fie pornit; tot ce se face înainte de pasul acela se face oricum.",
      "extend": "Extinde o generare terminată",
      "extendNone": "Nu — generează o piramidă nouă",
      "extendHint": "Adaugă rasterele noi la o generare deja coaptă în loc să refaci toată regiunea. Noua generare pornește de la o copie a dalelor acelei generări și costă doar ce se adaugă; baza rămâne așa cum este.",
      "extendOption": "{{id}} · nivelul {{depth}} · {{area}}",
      "extendLocked": "Această generare o extinde pe alta, așa că adâncimea ei (nivelul {{depth}}) și înălțimile sunt ale bazei și nu pot fi schimbate; acoperirea nu se mai obține încă o dată decât la cerere."
    },
    "statuses": {
      "queued": "La coadă",
      "running": "În curs",
      "succeeded": "Încheiată",
      "failed": "Eșuată"
    },
    "cancelStates": {
      "cancelling": "Se anulează",
      "cancelled": "Anulată"
    },
    "phases": {
      "pending": "Așteaptă să îi vină rândul — încă nu a început nimic.",
      "fetch": "Obținere",
      "prepare": "Pregătire",
      "bake": "Generare",
      "validate": "Verificare",
      "publish": "Publicare"
    },
    "sourceKinds": {
      "fetched": "Acoperire obținută",
      "uploaded": "Raster încărcat",
      "serverDirectory": "Director pe server"
    },
    "list": {
      "title": "Generări",
      "state": "Stare",
      "current": "Se desenează",
      "area": "Zonă",
      "depth": "Adâncime",
      "depthAsked": "cerută: {{depth}}",
      "depthShortfall": "Dalele coboară până la nivelul {{achieved}}, nu până la {{requested}}, cât s-a cerut: datele de elevație nu au mai multe detalii de oferit dincolo de el.",
      "when": "Trimisă",
      "size": "Pe disc",
      "sizeHint": "Tot ce a lăsat în urmă generarea pe disc: dalele publicate și rasterele convertite păstrate lângă ele. Rândul de dedesubt este doar dalele, singurul lucru servit unui vizualizator.",
      "sizePyramid": "{{size}} de dale",
      "sizeUnknown": "nimic deocamdată",
      "actions": "Acțiuni",
      "activate": "Desenează aceasta",
      "activated": "Scena desenează acum această generare.",
      "stop": "Nu mai desena",
      "stopped": "Scena desenează din nou teren gol.",
      "delete": "Șterge",
      "deleteConfirm": "Ștergi această generare și cei {{size}} pe care îi ține pe disc pentru {{area}}?",
      "cancel": "Oprește",
      "cancelConfirm": "Anulezi această generare? Ce a obținut și a pregătit deja se păstrează, așa că poate fi rulată din nou mai târziu, de unde s-a oprit.",
      "cancelled": "Generarea a fost anulată.",
      "cancelAsked": "Generarea se va opri la primul punct la care poate; până atunci apare ca fiind în curs de anulare.",
      "retry": "Rulează din nou",
      "retried": "Generarea este din nou la coadă și va continua de unde s-a oprit."
    },
    "detail": {
      "title": "Această generare",
      "sources": "Făcută din",
      "noSources": "Pentru această generare nu s-a înregistrat încă nimic.",
      "failed": "Această generare s-a oprit înainte să se încheie.",
      "cancelled": "Această generare a fost anulată.",
      "cancelling": "Această generare se anulează. Se oprește la primul punct la care poate — între două fișiere sau, cât timp se fac dalele, după ce unealta care face dalele a confirmat că s-a oprit.",
      "log": "Ce a spus unealta",
      "noLog": "Încă nu s-a spus nimic."
    },
    "worker": {
      "title": "Această instalare nu are cu ce să transforme rasterele în dale",
      "body": "Obținerea datelor de altitudine și pregătirea lor funcționează așa cum sunt. Transformarea lor în dale are nevoie de un serviciu separat, pe care o instalare obișnuită nu îl pornește: imaginea lui trece binișor de un gigabyte, iar o instalare care nu generează niciodată relief nu are de ce să o țină.",
      "setting": "În fișierul de mediu de lângă fișierele compose ale instalării:",
      "command": "Apoi, din același director:",
      "resumes": "Tot ce s-a întâmplat înainte de acest pas rămâne făcut, iar ce a obținut și a pregătit generarea este în continuare pe disc sub ea. După ce serviciul rulează, apasă „Rulează din nou” pe generarea oprită: continuă de la pasul la care s-a oprit, fără să mai obțină sau să mai pregătească nimic a doua oară."
    },
    "bakeLimits": {
      "memoryNote": "Memoria hotărăște cât de fin poate fi relieful. Unealta care face dalele folosește jumătate din memoria propriului container — 8 GB, dacă instalarea nu setează SILEXGIS_TERRAIN_WORKER_MEMORY — iar când nu îi ajunge nu eșuează: face un relief mai grosier decât s-a cerut. O generare care a rămas fără memorie se oprește și spune asta, iar setarea poate fi apoi mărită.",
      "degradedTitle": "Unealta care face dalele a rămas fără memorie, așa că relieful ar fi ieșit mai grosier decât s-a cerut",
      "degradedBody": "Mai grosier înseamnă mai puțin detaliu: pante și văi desenate din mai puține triunghiuri, mai mari decât cere nivelul ales pentru această generare, fără ca harta să spună asta. De aceea dalele făcute au fost aruncate. Unealta folosește jumătate din memoria containerului ei și nu are altă setare pentru asta, așa că dă-i containerului mai multă — pentru zone mari, unealta însăși recomandă 32g.",
      "degradedSetting": "În fișierul de mediu de lângă fișierele compose ale instalării:",
      "degradedCommand": "Apoi aplic-o din același director și apasă „Rulează din nou” pe această generare; ce a obținut și a pregătit rămâne păstrat:",
      "timedOutTitle": "Limita de timp a fost atinsă după {{ran}} h (limita: {{limit}} h)",
      "timedOutTitleBare": "Limita de timp a fost atinsă",
      "timedOutBody": "Generarea dalelor a fost oprită, iar dalele făcute până atunci au fost aruncate. Așa se încheie o generare care nu mai înainta, dar și una pentru o zonă mare care avea nevoie de mai mult timp. Ca să permiți mai mult, pune asta în fișierul de mediu (în secunde; 86400 înseamnă o zi), repornește aplicația și apasă „Rulează din nou” — ce a obținut și a pregătit generarea rămâne păstrat:",
      "secondsHelpTitle": "Cât înseamnă asta în secunde?",
      "secondsHelp": "1 oră = 3600\n12 ore = 43200 (valoarea implicită)\n1 zi = 86400\n2 zile = 172800\n1 săptămână = 604800 (cel mai lung permis)"
    },
    "problems": {
      "notFound": "Generarea nu mai există.",
      "forbidden": "Nu ai voie să faci asta.",
      "alreadyBuilding": "Zona respectivă este deja în lucru. Așteaptă să se termine.",
      "noSources": "O generare trebuie făcută din ceva: fie obții acoperirea dreptunghiului, fie furnizezi rastre proprii.",
      "sourceInvalid": "Unul dintre rastre nu este printre cele păstrate de această instalare. Trimite-l din nou.",
      "directoryUnavailable": "Din acel director nu se poate citi: fie nu există, fie nu este unul pe care această instalare are voie să îl citească.",
      "noRoots": "Această instalare nu citește rastre din niciun director de pe server.",
      "rasterUnsupported": "Fișierul nu este un rastru de altitudine pe care această instalare îl citește.",
      "rasterSizeInvalid": "Fișierul este gol sau mai mare decât poate fi o încărcare.",
      "rasterUnplaceable": "O dală de altitudine spune unde se află doar prin numele ei, în forma N45E024.hgt pentru pătratul al cărui colț este 45°N 24°E. Numele acestui fișier nu spune ce pătrat acoperă, așa că nimic nu îl poate așeza pe hartă. Redenumește-l după pătratul pe care îl acoperă sau trimite-l într-un format care își poartă singur poziția.",
      "extentInvalid": "Dreptunghiul acela nu este un dreptunghi pe Pământ. Trasează-l din nou.",
      "extentTooLarge": "Dreptunghiul este mai mare decât generează această instalare dintr-o dată. Generează-l ca mai multe zone mai mici.",
      "depthInvalid": "Adâncimea aceea este în afara a ceea ce generează această instalare.",
      "notPublished": "Generarea nu are nicio suprafață de desenat. Fie dalele nu au fost niciodată recitite și găsite întregi, fie nu mai sunt acolo de unde se servește relieful.",
      "active": "Generarea aceasta este relieful pe care îl desenează scena. Alege alt relief sau oprește desenarea acestuia înainte de a-l șterge.",
      "running": "Generarea nu s-a încheiat. Fișierele ei se scriu chiar acum, așa că poate fi ștearsă după ce se oprește, oricum s-ar opri.",
      "notCancellable": "Generarea s-a oprit deja, așa că nu mai este nimic de anulat.",
      "notRetryable": "Doar o generare oprită poate fi rulată din nou. Aceasta este încă la coadă sau în curs, ori s-a încheiat.",
      "bakeStopping": "Generarea a fost anulată în timp ce i se făceau dalele, iar unealta care face dalele nu a confirmat încă oprirea. Răspunde imediat ce serviciul de relief rulează; rulează generarea din nou după aceea.",
      "derivativeBuildNotFound": "Generarea nu mai există sau nu are din ce desena terenul.",
      "derivativeBuildNotFinished": "Generarea nu s-a încheiat, deci nu există încă relieful din care să se deseneze terenul.",
      "derivativeNotFound": "Imaginea nu mai există.",
      "derivativeNotReady": "Imaginea nu este încă gata, așa că nu este nimic de adus.",
      "baseNotFound": "Generarea de extins nu mai există.",
      "baseUnchecked": "Generarea de extins nu a avut niciodată dalele citite înapoi și găsite întregi, așa că nu există nimic sigur la care să se adauge.",
      "baseNotPublished": "Generarea de extins nu mai are dale acolo de unde se servește terenul. Pornește în schimb o generare nouă peste toată zona.",
      "baseDepthDiffers": "O extensie se construiește la adâncimea generării pe care o extinde; adăugarea nu poate re-face dalele deja existente la alta.",
      "baseDatumDiffers": "O extensie își măsoară înălțimile așa cum le măsoară generarea pe care o extinde; două referințe într-o singură piramidă se întâlnesc într-o treaptă de-a lungul îmbinării.",
      "beingExtended": "O altă generare care o extinde pe aceasta nu s-a terminat și încă îi citește dalele. Șterge-o după ce acea generare s-a oprit."
    },
    "derivatives": {
      "title": "Imagini ale terenului",
      "hint": "Relief umbrit, pantă și orientare, calculate dintr-o construcție de altitudini.",
      "stale": "Depășită",
      "staleHints": {
        "elevationReplaced": "Calculată din altitudini pe care instalarea nu le mai servește. Este în continuare desenată, dar nu se va potrivi cu înălțimile de dedesubt.",
        "methodRevised": "Calculată înainte ca modul în care se obține acest tip de imagine să fie corectat. Este în continuare desenată, dar nu este ceea ce ar da terenul astăzi. Cere din nou aceeași imagine și este calculată de la capăt."
      },
      "totalSize": "{{size}} pe disc",
      "statuses": {
        "queued": "La coadă",
        "computing": "În calcul",
        "ready": "Gata",
        "failed": "Eșuată"
      },
      "kinds": {
        "hillshade": "Relief umbrit",
        "slope": "Pantă",
        "aspect": "Orientare",
        "ruggednessIndex": "Asperitate",
        "positionIndex": "Poziție topografică",
        "roughness": "Rugozitate",
        "colourRelief": "Relief colorat",
        "contours": "Curbe de nivel"
      }
    },
    "derivativeForm": {
      "title": "Imagini derivate",
      "intro": "O imagine a terenului calculată dintr-o generare încheiată: relief umbrit, pantă, orientare, asperitate, poziție topografică, rugozitate, un relief colorat sau curbe de nivel. Oricine are dreptul de a citi relieful o găsește apoi în lista de straturi a hărții.",
      "needsExecute": "Cererea unei imagini are nevoie de dreptul de execuție asupra reliefului, pe care acest cont nu îl are. Registrul de mai jos rămâne de citit.",
      "noBuilds": "Nicio generare încheiată din care să se deseneze. O imagine se calculează dintr-o generare care a mers până la capăt.",
      "build": "Generare",
      "buildPlaceholder": "Alege o generare încheiată",
      "buildRequired": "Alege generarea din care se desenează imaginea.",
      "buildCurrent": "se desenează",
      "kind": "Imagine",
      "name": "Nume",
      "nameHint": "Cum o numește lista de straturi.",
      "nameRequired": "Dă imaginii un nume.",
      "nameTooLong": "Un nume are cel mult {{max}} de caractere.",
      "lighting": "Lumină",
      "lightingHint": "Sub o singură lumină, orice versant întors de la ea este negru complet, iar o dolină din umbra aceea este invizibilă. Patru lumini o păstrează lizibilă.",
      "lightings": {
        "single": "O lumină",
        "multidirectional": "Patru lumini"
      },
      "azimuth": "Lumina dinspre (°)",
      "azimuthHint": "În sensul acelor de ceasornic de la nord. Nord-vestul este convenția: luminat de acolo de unde stă de fapt soarele dimineața, majoritatea cititorilor văd văile ca pe niște creste.",
      "azimuthInvalid": "Direcția luminii se măsoară în sensul acelor de ceasornic de la nord, de la 0 până sub 360.",
      "altitude": "Înălțimea luminii (°)",
      "altitudeInvalid": "Lumina stă deasupra orizontului, așa că înălțimea ei este peste 0 și cel mult 90.",
      "zFactor": "Exagerarea înălțimilor",
      "zFactorHint": "Înmulțește fiecare înălțime înainte de calculul imaginii. Dincolo de câteva ori, un peisaj blând devine un perete de pixeli saturați.",
      "zFactorInvalid": "Exagerarea înălțimilor este un număr peste zero și cel mult {{max}}.",
      "surfaceFit": "Calculul pantei",
      "surfaceFitHint": "Horn ponderează toți cei opt vecini și se potrivește altitudinilor reale, cu zgomot. Zevenbergen–Thorne folosește doar cei patru vecini cardinali: mai clar pe suprafețe curate, mai zgomotos pe orice eșantionat din fotografii.",
      "surfaceFits": {
        "horn": "Horn (opt vecini)",
        "zevenbergenThorne": "Zevenbergen–Thorne (patru vecini)"
      },
      "slopeUnit": "Panta ca",
      "slopeUnits": {
        "degrees": "Grade față de orizontală",
        "percent": "Procent (creștere pe distanță)"
      },
      "ruggednessFit": "Definiția asperității",
      "ruggednessFitHint": "A lui Riley este cea față de care sunt enunțate clasele de asperitate publicate. A lui Wilson dă alte numere, așa că cele două nu sunt niciodată comparabile.",
      "ruggednessFits": {
        "riley": "Riley (rădăcina mediei pătratelor diferențelor)",
        "wilson": "Wilson (media diferențelor absolute)"
      },
      "contourInterval": "O curbă la fiecare (m)",
      "contourIntervalHint": "Metri de înălțime între o curbă și următoarea, numărați de la nivelul mării. Fiecare a cincea curbă este desenată mai gros. Curbele sunt o imagine: de-a lungul lor nu se poate măsura și nu pot fi selectate.",
      "contourIntervalInvalid": "Curbele de nivel se află la o distanță de la {{min}} la {{max}} metri de înălțime una de alta.",
      "computeEdges": "Calculează celulele de la margine din vecinii pe care îi au",
      "computeEdgesHint": "Oprit, fiecare rastru al generării se întâlnește cu vecinul lui printr-o linie goală. Pornit, marginea este ușor greșită — cu mai puțin decât o linie lipsă.",
      "colourRamp": "Rampa de culori",
      "colourRampHint": "O culoare la fiecare înălțime, în metri; terenul dintre două înălțimi se pictează cu amestecul lor. Cel puțin două trepte, niciodată două la aceeași înălțime.",
      "stopElevation": "Înălțime (m)",
      "stopColour": "Culoare",
      "addStop": "Adaugă o treaptă",
      "removeStop": "Scoate această treaptă",
      "rampProblems": {
        "tooShort": "Un relief colorat are nevoie de cel puțin două înălțimi între care să pună culori.",
        "heightMissing": "Fiecare treaptă a rampei de culori stă la o înălțime reală.",
        "duplicate": "Două trepte ale rampei de culori nu stau la aceeași înălțime."
      },
      "submit": "Cere imaginea",
      "requested": "Imaginea a fost pusă la coadă. Apare în registrul de mai jos, iar în lista de straturi a hărții odată ce este gata."
    },
    "derivativeList": {
      "title": "Registrul imaginilor derivate",
      "empty": "Nicio imagine a terenului nu a fost calculată încă.",
      "emptyHint": "Cere una mai sus, dintr-o generare încheiată.",
      "picture": "Imagine",
      "parameters": "Parametri",
      "build": "Din generarea",
      "buildGone": "o generare care nu mai este listată",
      "state": "Stare",
      "size": "Pe disc",
      "sizeHint": "Rasterele calculate, câte unul pentru fiecare rastru al generării.",
      "created": "Cerută",
      "actions": "Acțiuni",
      "delete": "Șterge",
      "deleteConfirm": "Ștergi această imagine și cei {{size}} pe care îi ține pe disc?",
      "params": {
        "azimuth": "lumina dinspre {{degrees}}°",
        "altitude": "{{degrees}}° deasupra orizontului",
        "zFactor": "înălțimi ×{{factor}}",
        "stops": "{{count}} trepte de culoare",
        "interval": "o curbă la fiecare {{metres}} m",
        "edgesOff": "margini lăsate goale"
      }
    },
    "configured": {
      "title": "O adresă de relief din configurația acestei instalări are prioritate față de generarea aleasă",
      "body": "Configurația numește o adresă de relief proprie, iar ea câștigă: scena desenează acea piramidă, nu generarea aleasă aici ({{build}}…). Generarea aleasă se desenează doar după ce setarea de mai jos este scoasă din configurația instalării și aplicația repornită.",
      "setting": "Setarea de scos:"
    },
    "credit": {
      "title": "Relieful desenat nu poartă nicio mențiune a sursei",
      "configuredBody": "Scena desenează o adresă de relief numită în configurația acestei instalări, iar configurația nu precizează nicio mențiune a sursei pentru ea. Datele de altitudine trebuie aproape întotdeauna creditate — Copernicus și majoritatea celorlalte modele gratuite o cer — iar ceea ce se scrie în setarea de mai jos este ceea ce scena arată lângă teren.",
      "setting": "Setarea care o precizează:",
      "buildBody": "Scena desenează o generare ({{build}}…) care nu are înregistrată nicio mențiune a sursei: niciuna dintre sursele din care a fost făcută nu a declarat una. Datele de altitudine trebuie aproape întotdeauna creditate. Mențiunea se dă pentru fiecare sursă atunci când se pornește o generare și nu poate fi adăugată unei generări încheiate — pornește o generare peste același teren, cu sursele creditate, și alege-o pe aceea."
    }
  },
  "dashboard": {
    "title": "Panou de bord",
    "openOnStart": "Deschide la pornire",
    "counts": {
      "caves": "Peșteri",
      "features": "Obiecte",
      "trips": "Jurnale de tură",
      "geodata": "Fișiere geodate"
    },
    "recentActivity": "Activitate recentă",
    "quickActions": "Acțiuni rapide",
    "myViews": "Vederile mele salvate",
    "importFile": "Importă fișier",
    "noActivity": "Nu a fost adăugat nimic încă.",
    "loadFailed": "Panoul de bord nu a putut fi încărcat.",
    "noViews": "Nicio vedere salvată încă.",
    "untitled": "Fără titlu",
    "kind": {
      "cave": "Peșteră",
      "tripLog": "Jurnal de tură",
      "feature": "Obiect",
      "caveEntrance": "Intrare de peșteră",
      "centerline": "Drumuire",
      "expedition": "Tabără"
    },
    "comingUp": "Ce urmează",
    "comingUpFailed": "Turele tale nu au putut fi încărcate.",
    "noComingUp": "Nimic în program. O tură apare aici după ce cineva te invită sau te trece în echipă.",
    "allMyTrips": "Toate turele mele"
  },
  "auth": {
    "email": "Email",
    "password": "Parolă",
    "signIn": "Autentificare",
    "signOut": "Deconectare",
    "invalidCredentials": "Email sau parolă incorecte.",
    "lockedOut": "Cont blocat temporar. Încearcă din nou mai târziu.",
    "signingIn": "Autentificare în curs…",
    "mfaRequired": "Introdu codul pentru al doilea factor.",
    "mfaInvalid": "Codul de autentificare nu este valid.",
    "mfaCode": "Cod de autentificare",
    "or": "sau",
    "signInWith": "Autentificare cu {{provider}}",
    "externalFailed": "Autentificarea externă nu a fost finalizată. Încearcă din nou sau folosește parola.",
    "serverUnreachable": "Serverul nu poate fi contactat",
    "serverUnreachableHint": "Autentificarea nu a putut fi inițiată. Verifică dacă serverul funcționează, apoi încearcă din nou.",
    "mfaMethod": "Trimite codul prin",
    "mfaMethod_authenticator": "Aplicație de autentificare",
    "mfaMethod_email": "E-mail",
    "mfaMethod_sms": "SMS",
    "mfaResend": "Trimite codul din nou",
    "mfaCodeSent": "Cod trimis către {{destination}}.",
    "mfaSendFailed": "Codul nu a putut fi trimis. Încearcă altă metodă.",
    "mfaResendTooSoon": "Tocmai a fost trimis un cod. Așteaptă puțin înainte de a cere altul.",
    "mfaUseRecovery": "Folosește un cod de recuperare",
    "mfaUseMethod": "Folosește un cod obișnuit",
    "mfaRecoveryOnly": "Nicio metodă de al doilea factor nu este disponibilă acum. Introdu un cod de recuperare.",
    "mfaPendingExpired": "Autentificarea a așteptat prea mult codul. Începe din nou.",
    "mfaStartAgain": "Reîncepe autentificarea",
    "recoveryCode": "Cod de recuperare",
    "emailNotConfirmed": "Confirmă adresa de e-mail înainte de autentificare.",
    "resendConfirmation": "Retrimite e-mailul de confirmare",
    "confirmationResent": "Dacă adresa are un cont, e-mailul de confirmare este pe drum.",
    "passwordChangedSignIn": "Parola a fost schimbată și ai fost deconectat peste tot. Autentifică-te cu parola nouă.",
    "confirmEmailTitle": "Confirmă adresa",
    "confirmEmailWorking": "Se confirmă adresa",
    "confirmEmailDone": "Adresa este confirmată. Te poți autentifica.",
    "confirmEmailFailed": "Acest link este invalid sau a expirat. Cere unul nou din pagina de autentificare.",
    "resetPasswordTitle": "Alege o parolă nouă",
    "resetPasswordSubmit": "Setează parola",
    "resetPasswordDone": "Parola a fost schimbată.",
    "resetPasswordRejected": "Parola a fost respinsă. Folosește cel puțin 10 caractere.",
    "resetLinkInvalid": "Acest link de resetare este invalid sau a expirat.",
    "newPassword": "Parolă nouă",
    "confirmPassword": "Repetă parola",
    "passwordsDiffer": "Cele două parole nu coincid.",
    "passwordTooShort": "Folosește cel puțin 10 caractere.",
    "invitePasswordTitle": "Alege-ți parola",
    "invitePasswordIntro": "Ți-a fost deschis un cont. Alege parola cu care te vei autentifica.",
    "invitePasswordDone": "Parola a fost setată. Te poți autentifica acum.",
    "testLogins": {
      "title": "Instalație de test",
      "hint": "Oricine poate încerca această instalație cu conturile demonstrative de mai jos. Datele de aici sunt publice și sunt resetate periodic.",
      "about": "Ce poate face acest cont",
      "roleAdministrator": "Administrator",
      "roleEditor": "Editor",
      "roleViewer": "Vizualizator",
      "permsAdministrator": "Control deplin asupra instalației: vede și editează totul, inclusiv localizarea exactă a peșterilor protejate, conturile de utilizator, grupurile de permisiuni și setările.",
      "permsEditor": "Creează și editează conținut — peșteri, fenomene de suprafață, jurnale de tură, documente, vederi salvate — dar nu poate administra utilizatori sau permisiuni, iar localizarea exactă a peșterilor protejate rămâne ascunsă.",
      "permsViewer": "Nivelul de bază al unui cont autentificat: răsfoiește ce este partajat cu toate conturile și își păstrează propriile vederi salvate și liste de verificare, fără a edita conținut comun și fără a vedea localizări protejate."
    }
  },
  "common": {
    "loading": "Se încarcă…",
    "language": "Limbă",
    "save": "Salvează",
    "ok": "OK",
    "cancel": "Anulează",
    "edit": "Editează",
    "back": "Înapoi",
    "continue": "Continuă",
    "saved": "Salvat.",
    "saveFailed": "Operația a eșuat. Încearcă din nou.",
    "deleteFailed": "Ștergerea a eșuat. Încearcă din nou.",
    "languageSaveFailed": "Limba s-a schimbat aici, dar nu a putut fi salvată în cont. Mesajele care ți se trimit pot sosi în continuare în limba anterioară.",
    "deleted": "Șters.",
    "export": "Exportă",
    "retry": "Reîncearcă",
    "conflict": "Altcineva a modificat acest element de când l-ai încărcat. Reîncarcă și reaplică modificările.",
    "loadFailed": "Nu s-a putut încărca. Încearcă din nou.",
    "close": "Închide",
    "reset": "Resetează",
    "clearAnswer": "Șterge răspunsul",
    "configure": "Configurare"
  },
  "notFoundPage": {
    "title": "Nicio pagină la această adresă",
    "description": "Adresa poate fi greșită, sau pagina pe care o numea s-a mutat ori nu mai există. Venind aici nu s-a schimbat nimic.",
    "home": "Mergi la pagina de start"
  },
  "errorBoundary": {
    "title": "Ceva nu a funcționat pe acest ecran",
    "description": "Pagina nu a mai putut fi afișată. De obicei reîncărcarea o aduce înapoi.",
    "reload": "Reîncarcă pagina"
  },
  "map": {
    "baseLayers": "Hărți de bază",
    "tileOverlays": "Hărți suprapuse",
    "activeOverlays": "Straturi pe hartă",
    "declutterLabels": "Rărește etichetele aglomerate",
    "declutterLabelsHint": "Numele care s-ar suprapune se cedează reciproc. Marcajele sunt întotdeauna desenate — doar etichetele lor concurează pentru spațiu.",
    "changeBaseLayer": "Schimbă harta de bază",
    "entrances": "Intrări în peșteri",
    "searchPlaceholder": "Caută obiecte, ture sau locuri…",
    "caves": "Peșteri",
    "places": "Locuri",
    "zoomTo": "Centrează",
    "openCave": "Deschide peștera",
    "approximate": "Locație aproximativă — coordonatele exacte sunt protejate.",
    "noSelection": "Apasă pe un obiect de pe hartă pentru detalii.",
    "surfaceFeatures": "Fenomene de suprafață",
    "geofiles": "Fișiere importate",
    "rasterMaps": "Hărți raster",
    "centerlines": "Drumuiri peșteri",
    "showPanel": "Arată panoul",
    "hidePanel": "Ascunde panoul",
    "layersTitle": "Straturi",
    "detailsTitle": "Detalii",
    "tabSelection": "Selecție",
    "tabInView": "În vedere",
    "selectedCount": "{{count}} selectate",
    "zoomToSelected": "Zoom la selecție",
    "zoomInForEntrances": "Apropie harta pentru a lista intrările individuale.",
    "nothingInView": "Nimic încărcat în vederea curentă.",
    "locateMe": "Arată locația mea",
    "geolocationFailed": "Locația nu a putut fi determinată.",
    "clusterTitle": "{{count}} intrări în această zonă",
    "zoomHere": "Apropie aici",
    "approximateShort": "aprox.",
    "swipeCompare": "Compară rasterul cu harta de dedesubt (glisor)",
    "hideChrome": "Ascunde barele de instrumente ale hărții",
    "showChrome": "Arată barele de instrumente ale hărții",
    "showScene3d": "Arată scena 3D lângă hartă",
    "hideScene3d": "Ascunde scena 3D",
    "unsavedEdits": "{{count}} modificări nesalvate",
    "contextAdd": "Adaugă obiect",
    "contextNewCave": "Peșteră nouă aici",
    "contextNewEntrance": "Intrare nouă aici",
    "contextCopyCoords": "Copiază coordonatele",
    "coordsCopied": "Coordonate copiate.",
    "heatmap": "Hartă de căldură (intrări)",
    "karstIndex": {
      "layer": "Indice de carstificare (zone)",
      "loading": "Se citesc zonele din imagine…",
      "shown": "Zone în imagine: {{count}}.",
      "failed": "Indicele de carstificare nu a putut fi citit. Mutarea hărții întreabă din nou.",
      "refused": {
        "window": "Despre această imagine nu se poate întreba. Mută harta pentru a întreba din nou.",
        "other": "Indicele de carstificare a fost refuzat pentru această imagine."
      }
    },
    "karstLegend": {
      "band": "{{from}} – {{to}}",
      "bandAbove": "peste {{from}}",
      "scheme": {
        "relative": "Benzi relative la această imagine",
        "fixed": "Benzi fixe, aceleași în orice imagine"
      },
      "unit": {
        "density": "Peșteri pe km²",
        "kernel": "Peșteri pe km², netezit"
      },
      "hot": "Punct fierbinte (z ≥ {{z}})",
      "cold": "Punct rece (z ≤ −{{z}})",
      "noCaves": "Nu se numără nicio peșteră în această imagine.",
      "noAreas": "Nicio zonă carstică sau masiv de arătat în această imagine.",
      "truncated": "Unele zone din această imagine nu sunt arătate: o imagine cuprinde cel mult {{max}}. Mărește pentru a le vedea pe toate."
    },
    "karstDensity": {
      "layer": "Densitatea peșterilor (grilă)",
      "reading": "Ce arată celulele",
      "bands": {
        "label": "Benzi",
        "relative": "Relative la imagine",
        "fixed": "Fixe"
      },
      "mode": {
        "density": "Peșteri pe km²",
        "kernel": "Netezită",
        "hotSpot": "Zone fierbinți și reci"
      },
      "cell": "Celule de {{metres}} m (cea mai fină publicată aici este de {{floor}} m).",
      "loading": "Se citește grila…",
      "failed": "Grila de densitate nu a putut fi citită. Mutarea hărții o cere din nou.",
      "refused": {
        "tooWide": "Această vedere este prea largă pentru grila de densitate, chiar și la cea mai mare celulă. Mărește harta pentru a o vedea.",
        "tooFine": "Grila a fost cerută cu celule mai fine decât publică această instalare.",
        "window": "Pentru această vedere nu se poate întreba. Mută harta pentru a întreba din nou.",
        "other": "Grila de densitate a fost refuzată pentru această vedere."
      }
    },
    "baseOpacity": "Opacitatea stratului {{name}}",
    "photos": "Fotografii geolocalizate",
    "photosCutShort": "Nu sunt afișate toate fotografiile de aici — apropie harta pentru a le vedea pe celelalte.",
    "tripsLayer": "Ture",
    "tripsShown": "{{count}} tură/ture desenate",
    "tripsLoading": "Se încarcă turele…",
    "tripsFailed": "Turele nu au putut fi încărcate. Deplasarea hărții reîncearcă.",
    "tripsTruncated": "Sunt desenate doar primele {{count}} ture din acest interval — restrânge datele sau filtrele pentru a le vedea pe celelalte.",
    "tripsUnlocated": "{{count}} tură/ture din acest interval nu au localizare și nu apar pe hartă.",
    "tripsFilterUnapplied": "{{count}} filtru/filtre din lista de ture nu sunt filtre pe care acest strat le poate aplica, așa că harta arată mai mult decât lista.",
    "tripsFrom": "De la",
    "tripsTo": "Până la",
    "tripsTypeFilter": "Orice tip de tură",
    "tripsFilterHint": "O tură este desenată acolo unde spune că a mers, altfel unde s-a întâlnit echipa, altfel la o peșteră pe care o numește. O peșteră pe care o poți citi dar nu o poți localiza exact nu plasează nimic.",
    "centerlinesWithheld": "{{count}} drumuiri nu sunt afișate la această scară — apropie harta pentru a le încărca.",
    "centerlinesWithheldNotice": "{{count}} drumuiri ascunse la această scară — apropie harta sau deschide panoul de straturi",
    "centerlineDetailOn": "Se afișează detaliul complet al topografiei, inclusiv razele laterale.",
    "centerlineSkeletonOn": "Se afișează traseul galeriilor; razele către pereți apar când apropii harta.",
    "centerlineDetailZoom": "Detaliu de la nivelul",
    "centerlineMaxPaths": "Limită de linii",
    "centerlineLimitsHint": "Lasă gol pentru valorile implicite ale instalării. Detaliul mai mare costă mai mult la desenare.",
    "features": "Obiecte",
    "locationWithheld": "Localizare nedivulgată — geometria exactă este protejată.",
    "closestApproach": "Cea mai mică distanță",
    "overburdenHighlight": "Citirea rocii de deasupra",
    "georeferencedMaps": "Hărți georeferențiate",
    "popup": {
      "photo": "Fotografie",
      "photoNamed": "Fotografia {{name}}",
      "geofilePoint": "Punct dintr-un fișier importat",
      "geofilePointNamed": "Punct dintr-un fișier importat: {{name}}",
      "libraryPhoto": "Fotografie din {{library}}",
      "libraryPhotoUnnamed": "Fotografie dintr-o bibliotecă foto"
    },
    "scaleInvalid": "Scrie o scară, de exemplu 1:25000 sau 25000.",
    "overviewMap": "Hartă de ansamblu"
  },
  "dialog": {
    "dockToSide": "Andochează lângă hartă",
    "floatAsDialog": "Afișează ca dialog"
  },
  "caveRegistry": {
    "unreadableLink": "Filtrul din acest link nu a putut fi citit, așa că sunt afișate toate peșterile. Cere celui care l-a trimis un link nou.",
    "regionPlaceholder": "Regiune",
    "lengthPlaceholder": "Lungime (m): 300, >300, 300..500",
    "filterRefused": "Acest filtru nu poate fi rulat cu drepturile tale. Modifică sau golește câmpurile de mai sus.",
    "savedUnreadable": "Filtrul salvat nu poate fi citit cu drepturile tale, așa că nu a fost aplicat.",
    "savedNotAboutCaves": "Filtrul salvat nu se referă la peșteri.",
    "saved": "Salvat ca „{{name}}”.",
    "applySaved": "Aplică un filtru salvat…",
    "noSaved": "Niciun filtru salvat încă",
    "saveAs": "Salvează ca filtru…",
    "manage": "Filtre salvate",
    "forget": "Nu mai numi acest filtru salvat",
    "active": "Filtru salvat: {{name}}",
    "activeUnavailable": "Filtru salvat indisponibil pentru tine",
    "changed": "modificat între timp",
    "extra": "Acest filtru mai are condiții pe care aceste câmpuri nu le arată ({{count}}). Ele restrâng lista în continuare.",
    "clearExtra": "Elimină-le",
    "editExtra": "Editează-le",
    "advanced": "Filtru avansat…",
    "advancedTitle": "Filtru avansat",
    "saveTitle": "Salvează aceste condiții ca filtru"
  },
  "listFilters": {
    "savedUnreadable": "Filtrul salvat nu poate fi citit cu drepturile tale, așa că nu a fost aplicat.",
    "saved": "Salvat ca „{{name}}”.",
    "applySaved": "Aplică un filtru salvat…",
    "noSaved": "Niciun filtru salvat încă",
    "saveAs": "Salvează ca filtru…",
    "manage": "Filtre salvate",
    "forget": "Nu mai numi acest filtru salvat",
    "active": "Filtru salvat: {{name}}",
    "activeUnavailable": "Filtru salvat indisponibil pentru tine",
    "changed": "modificat între timp",
    "extra": "Acest filtru mai are condiții pe care aceste câmpuri nu le arată ({{count}}). Ele restrâng lista în continuare.",
    "clearExtra": "Elimină-le",
    "saveTitle": "Salvează aceste condiții ca filtru"
  },
  "featureList": {
    "unreadableLink": "Filtrul din acest link nu a putut fi citit, așa că sunt afișate toate obiectele. Cere celui care l-a trimis un link nou.",
    "filterRefused": "Acest filtru nu poate fi rulat cu drepturile tale. Modifică sau golește câmpurile de mai sus.",
    "savedNotAboutFeatures": "Filtrul salvat nu se referă la obiecte.",
    "searchLabel": "Caută obiecte după denumire",
    "kindLabel": "Felul obiectului",
    "typeLabel": "Tipul obiectului",
    "categoryLabel": "Categoria obiectului",
    "tagLabel": "Etichetă"
  },
  "tableMap": {
    "showOnMap": "Arată-le pe hartă",
    "listInView": "Listează peșterile din vedere",
    "savedFilterNotListable": "Filtrul salvat al hărții nu poate fi citit aici, așa că peșterile din vedere nu pot fi listate după el.",
    "inMapWindow": "Doar peșterile din vederea hărții",
    "clearWindow": "Arată peșterile de peste tot",
    "unreadableWindow": "Legătura numea o vedere a hărții care nu este o zonă validă, așa că lista arată peșterile de peste tot.",
    "highlightLayer": "Rândul indicat într-o listă"
  },
  "workingSet": {
    "selectAll": "Selectează pe hartă tot ce s-a găsit ({{count}})",
    "tookAll": "Selectate pe hartă: {{count}}.",
    "tookFirst": "Au fost selectate primele {{taken}} din {{total}} pe hartă — atâtea încap într-o selecție.",
    "firstOf": "Primele {{taken}} din {{total}} găsite de listă.",
    "failed": "Lista nu a putut fi citită din nou, așa că nu s-a selectat nimic.",
    "saveAsFilter": "Salvează ca filtru…",
    "saveTitle": "Salvează selecția ca filtru",
    "saveHint": "Se salvează filtrul care a găsit această selecție, nu obiectele din ea: rulat mai târziu, găsește ce se potrivește atunci, așa cum ai voie să vezi."
  },
  "savedFilters": {
    "title": "Filtre salvate",
    "intro": "Un filtru salvat este o întrebare pe care o păstrezi. Dacă îl partajezi cu un grup de speologie sau cu toți cei autentificați, aceștia o pot pune; fiecăruia i se răspunde cu ce are el însuși dreptul să vadă.",
    "toRegistry": "Registrul peșterilor",
    "empty": "Niciun filtru salvat. Salvează unul din registrul peșterilor.",
    "name": "Nume",
    "description": "Descriere",
    "nothingToSave": "Nu există nicio condiție de salvat — stabilește mai întâi cel puțin una.",
    "asks": "Caută",
    "cannotShow": "Nu poate fi afișat",
    "photographFilter": "Fotografii",
    "noScreenToOpen": "Acest ecran nu are o listă în care să deschidă acest fel de filtru. Aplică-l din ecranul pe care a fost făcut.",
    "audience": "Cine îl poate folosi",
    "private": "Doar eu",
    "someGroup": "Un grup de speologie",
    "author": "Salvat de",
    "byYou": "Tu",
    "someMember": "Un membru al clubului",
    "sharedWith": "Membrii {{name}}",
    "authenticated": "Toți cei autentificați",
    "explain": {
      "private": "Doar tu vezi acest filtru.",
      "cavingGroup": "Membrii {{name}} îl pot folosi — fiecăruia îi arată doar ce poate vedea deja.",
      "authenticated": "Toți cei autentificați îl pot folosi — fiecăruia îi arată doar ce poate vedea deja."
    },
    "changeDefault": "Schimbă alegerea implicită",
    "state": "Stare",
    "states": {
      "ready": "Pregătit",
      "stale": "Învechit",
      "unreadable": "Nu poate fi citit"
    },
    "staleHint": "Un tip sau o etichetă numită de acest filtru a fost ștearsă între timp, așa că acea condiție nu mai găsește nimic.",
    "unreadableHint": "Acest filtru întreabă ceva ce nu poți întreba cu drepturile tale sau a fost scris într-o formă pe care această versiune nu o poate citi.",
    "open": "Deschide în registrul peșterilor",
    "edit": "Redenumește, descrie sau partajează",
    "delete": "Șterge",
    "deleteConfirm": "Ștergi acest filtru salvat? Nimeni dintre cei cu care a fost partajat nu îl va mai putea folosi.",
    "notAvailable": "indisponibil pentru tine",
    "otherClubs": "Alte cluburi — e posibil să nu ai voie să partajezi cu ele",
    "groupNotAllowed": "Nu ai voie să partajezi filtre cu acest club. Alege unul dintre cluburile tale, „Doar eu” sau „Toți cei autentificați”.",
    "parts": {
      "search": "Numele conține „{{text}}”",
      "region": "Regiunea conține „{{text}}”",
      "length": "Lungime cartată {{comparison}}",
      "caveType": "Tip: {{name}}",
      "tag": "Etichetă: {{name}}",
      "more": "încă {{count}} condiții"
    }
  },
  "caves": {
    "title": "Peșteri",
    "newCave": "Peșteră nouă",
    "editCave": "Editare peșteră",
    "name": "Denumire",
    "type": "Tip",
    "region": "Regiune",
    "surveyedLength": "Lungime (m)",
    "depth": "Denivelare (m)",
    "entrances": "Intrări",
    "visibility": "Vizibilitate",
    "identificationCode": "Cod",
    "searchPlaceholder": "Caută denumire sau toponim…",
    "allTypes": "Toate tipurile",
    "edit": "Editează",
    "delete": "Șterge",
    "deleteConfirm": "Ștergi această peșteră?",
    "deleteRestorable": "Intrările ei pleacă odată cu ea. Nu se elimină nimic: poate fi restaurată, împreună cu ele, din Peșteri și obiecte șterse.",
    "openIn3d": "Deschide în 3D",
    "sections": {
      "identification": "Identificare",
      "localization": "Localizare",
      "geology": "Geologie",
      "morphometry": "Morfometrie",
      "status": "Stare",
      "discovery": "Descoperire",
      "access": "Acces",
      "clubFields": "Câmpurile clubului"
    },
    "fields": {
      "otherToponyms": "Alte toponime",
      "description": "Descriere",
      "website": "Site web",
      "hydrographicBasin": "Bazin hidrografic",
      "valley": "Vale",
      "tributaryRiver": "Afluent",
      "closestAddress": "Adresa cea mai apropiată",
      "landRegistryNumber": "Nr. carte funciară",
      "locationNotes": "Note de localizare",
      "rockType": "Tip de rocă",
      "rockAge": "Vârsta rocii",
      "surveyedLength": "Lungime cartată (m)",
      "estimatedLength": "Lungime estimată (m)",
      "realExtension": "Extensie reală (m)",
      "projectedExtension": "Extensie proiectată (m)",
      "positiveDepth": "Denivelare pozitivă (m)",
      "negativeDepth": "Denivelare negativă (m)",
      "potentialDepth": "Denivelare potențială (m)",
      "altitude": "Altitudine (m)",
      "volume": "Volum (m³)",
      "area": "Suprafață (m²)",
      "ramificationIndex": "Indice de ramificare",
      "caveAge": "Vârsta peșterii",
      "explorationStatus": "Stadiul explorării",
      "protectionClass": "Clasă de protecție",
      "isShowCave": "Peșteră turistică",
      "showCaveLength": "Lungime amenajată (m)",
      "discoveryDate": "Data descoperirii",
      "discoverer": "Descoperitor",
      "locationProtected": "Locație protejată",
      "locationProtectedHint": "Coordonatele exacte și câmpurile de localizare precisă sunt ascunse utilizatorilor fără permisiune explicită."
    },
    "visibilityValues": {
      "private": "Privată",
      "cavingGroup": "Grup de speologie",
      "authenticated": "Utilizatori autentificați",
      "public": "Publică"
    },
    "explorationValues": {
      "unknown": "Necunoscut",
      "ongoing": "În desfășurare",
      "finished": "Finalizată",
      "abandoned": "Abandonată"
    },
    "summary": {
      "entrances": "{{count}} intrări",
      "centerlines": "{{count}} drumuiri",
      "surveyModels": "{{count}} modele 3D",
      "attachments": "{{count}} atașamente",
      "tripLogs": "{{count}} jurnale de tură"
    },
    "tripLogsEmpty": "Nicio tură nu numește această peșteră.",
    "depthPlaces": {
      "title": "Locurile numite ale acestei peșteri",
      "help": "O adâncime singură nu este un loc: transformarea ei în poziție înseamnă căutarea celei mai apropiate stații, iar asta nu poate spune care dintre mai multe stații apropiate este locul la care se referă oamenii. Declară o dată aici și fiecare raport la acea adâncime ajunge unde spui — introdus, corectat sau importat — iar numele devine ceva prin care un speolog poate raporta, în loc de un număr. Un loc poate fi numit și fără adâncime — o sală sau o joncțiune pe care o numește lista clubului — cu câteva cuvinte lângă nume, dacă o singură adâncime nu spune destul; un astfel de loc apare și este publicat împreună cu locurile peșterii, iar nicio adâncime raportată nu este plasată după el.",
      "declare": "Declară un loc",
      "depth": "Adâncime",
      "noDepth": "Fără adâncime",
      "atDepth": "la {{depth}} m",
      "atStation": "la stația {{station}}, fără adâncime",
      "note": "Notă",
      "landmark": "Numit pe desen",
      "landmarkTag": "Pe desen",
      "labelRequiredWithoutDepth": "Un loc fără adâncime are nevoie de un nume: fără niciuna dintre ele nu declară nimic.",
      "metres": "{{depth}} m",
      "station": "Stație",
      "place": "Numele locului",
      "none": "Această peșteră nu declară încă nimic, așa că orice adâncime raportată în ea ajunge pe stația cea mai apropiată.",
      "stationRequired": "Spune care stație este acest loc.",
      "saved": "Declarat.",
      "saveFailed": "Nu s-a putut salva.",
      "stationNameless": "Stația aceasta nu are nume în fișierul topografiei, ci doar numărul la care a scris-o fișierul, iar următorul export al topografiei dă acel număr altei stații. Declară adâncimea la o stație care are nume.",
      "oldKept": "Declarat {{now}}, dar declarația {{old}} nu a putut fi retrasă, așa că locul este acum declarat de două ori. Retrage-o manual pe cea {{old}}.",
      "stationNotInSurvey": "Nu este în topografia curentă",
      "stationNotInSurveyHelp": "Un loc marcat „Nu este în topografia curentă” numește o stație pe care topografia curentă a acestei peșteri nu o are, așa că declarația nu este urmată acolo: un raport la acea adâncime ajunge pe stația cea mai apropiată. Corectează numele stației sau verifică care topografie este cea curentă a peșterii.",
      "withdraw": "Retrage",
      "withdrawConfirm": "Retragi declarația pentru {{depth}} m? Rapoartele deja înregistrate păstrează stația primită; cele noi vor reveni la stația cea mai apropiată.",
      "withdrawNamedConfirm": "Retragi numele „{{label}}” pentru stația {{station}}? Nicio adâncime raportată nu este plasată după el; doar iese din lista locurilor peșterii.",
      "unnamed": "Fără nume"
    }
  },
  "entrances": {
    "add": "Adaugă intrare",
    "edit": "Editare intrare",
    "deleteConfirm": "Ștergi această intrare?",
    "deleteRestorable": "Nu se elimină nimic. Poate fi restaurată din Peșteri și obiecte șterse.",
    "coordinates": "Coordonate",
    "showOnMap": "Arată pe hartă",
    "showOnMapApproximate": "Arată pe hartă — poziția este aproximativă",
    "longitude": "Longitudine",
    "latitude": "Latitudine",
    "main": "Principală",
    "positionQuality": "Calitatea poziției",
    "positionBlurred": "Nu ai acces la poziția exactă a acestei intrări, așa că valorile afișate sunt rotunjite la o grilă. Poziția, altitudinea și calitatea poziției sunt de aceea needitabile — serverul păstrează valorile înregistrate și ar ignora orice s-ar introduce aici. Restul formularului se salvează normal.",
    "qualityValues": {
      "unknown": "Necunoscută",
      "gps": "GPS",
      "map": "De pe hartă",
      "estimated": "Estimată"
    },
    "surveyedAt": "Cartată"
  },
  "features": {
    "title": "Obiecte",
    "name": "Denumire",
    "type": "Tip",
    "geometry": "Geometrie",
    "visibility": "Vizibilitate",
    "description": "Descriere",
    "updatedAt": "Actualizat",
    "unnamed": "Fără denumire",
    "linkedCave": "Peșteră asociată",
    "linkedCavePlaceholder": "Caută peșteri…",
    "typedProperties": "Proprietăți",
    "newFeature": "Obiect nou",
    "editFeature": "Editare obiect",
    "edit": "Editează",
    "delete": "Șterge",
    "deleteConfirm": "Ștergi acest obiect? Obiectele conținute se șterg odată cu el.",
    "deleteRestorable": "Nu se elimină nimic. Poate fi restaurat, cu tot ce conține, din Peșteri și obiecte șterse.",
    "deleted": {
      "link": "Peșteri și obiecte șterse",
      "title": "Peșteri și obiecte șterse",
      "intro": "Ștergerile pe care le poți anula, cele mai recente primele. Ștergerea unei peșteri îi ia și intrările, iar ștergerea unei zone ia tot ce conține: fiecare este un singur rând aici, iar restaurarea aduce înapoi tot ce a plecat odată cu ea. Ce a fost șters înaintea peșterii sau a zonei care îl conține apare în listă după ce aceasta revine.",
      "empty": "Nimic aici. O peșteră, o intrare sau un obiect pe care îl ștergi apare pe această pagină.",
      "loadFailed": "Peșterile și obiectele șterse nu au putut fi încărcate.",
      "columns": {
        "name": "Denumire",
        "kind": "Fel",
        "deletedAt": "Șters",
        "took": "Șterse odată cu el"
      },
      "tookEntranceOne": "1 intrare",
      "tookEntrances": "{{count}} intrări",
      "tookOtherOne": "1 alt obiect",
      "tookOthers": "{{count}} alte obiecte",
      "tookNothing": "—",
      "restore": "Restaurează",
      "restoreConfirm": "Restaurezi?",
      "restoreConfirmDetail": "Revine cu tot ce a fost șters odată cu el și se deschide după ce a revenit.",
      "restored": "A revenit.",
      "containerDeletedNamed": "Se află în {{name}}, care este șters. Restaurează-l mai întâi pe acela.",
      "containerDeleted": "Se află în ceva șters, care trebuie restaurat mai întâi.",
      "gone": "Nu mai este printre cele șterse.",
      "forbidden": "Nu ai dreptul să îl restaurezi."
    },
    "showOnMap": "Arată pe hartă",
    "searchPlaceholder": "Caută după denumire…",
    "allTypes": "Toate tipurile",
    "geometryTypes": {
      "Point": "Punct",
      "LineString": "Linie",
      "Polygon": "Poligon",
      "MultiPoint": "Multipunct",
      "MultiLineString": "Multilinie",
      "MultiPolygon": "Multipoligon"
    },
    "kind": "Fel",
    "allKinds": "Toate felurile",
    "kinds": {
      "generic": "Obiect",
      "cave": "Peșteră",
      "caveEntrance": "Intrare",
      "centerline": "Drumuire"
    },
    "category": "Categorie",
    "allCategories": "Toate categoriile",
    "categories": {
      "surface": "Suprafață",
      "underground": "Subteran",
      "area": "Areal",
      "structure": "Structură"
    },
    "locationWithheld": "Locație nedivulgată",
    "locationProtected": "Locație protejată",
    "open": "Deschide",
    "openTypedPage": "Deschide pagina completă",
    "summary": "Rezumat",
    "entranceCount": "Intrări",
    "isDefault": "Implicită",
    "hierarchy": "Ierarhie",
    "parent": "Părinte",
    "parents": "Părinți",
    "noParents": "Fără părinți",
    "editParents": "Editează părinții",
    "parentFixed": "O intrare sau o drumuire stă doar sub propria peșteră. Pentru a o proteja, protejează peștera sau pune peștera sub zona protejată.",
    "parentFixedNote": "O intrare sau o drumuire stă doar sub propria peșteră, așa că părintele ei nu poate fi schimbat aici. Pentru a o proteja, protejează peștera sau pune peștera sub zona protejată.",
    "addParent": "Adaugă părinte…",
    "parentSearchPlaceholder": "Caută obiecte…",
    "primary": "Principal",
    "children": "Obiecte conținute",
    "noChildren": "Niciun obiect conținut",
    "links": "Obiecte înrudite",
    "editLinks": "Editează legăturile",
    "addLink": "Adaugă",
    "linkKind": "Tip legătură",
    "linkTarget": "Obiect legat",
    "linkNote": "Notă",
    "noLinks": "Nicio legătură",
    "incoming": "Legătură de intrare",
    "outgoing": "Legătură de ieșire",
    "inaccessible": "Inaccesibil"
  },
  "attachments": {
    "locationRemoved": "Locație eliminată",
    "locationRemovedHint": "Copia pe care o primești este imaginea la dimensiune completă, fără datele de locație. Fișierul păstrat le are, pentru cei care au voie să le vadă.",
    "locationRemovedDownload": "Descarcă o copie fără datele de locație.",
    "inDeviceDefaultSet": "Include în descărcarea implicită a telefoanelor",
    "inDeviceDefaultSetHint": "Un telefon care cere fișierele obișnuite îl descarcă și pe acesta. Telefonul îl descarcă doar dacă cel care îl folosește alege asta și doar dacă are voie să îl citească.",
    "originalWithheld": "Nu poți descărca originalul acestei fotografii: el înregistrează unde a fost făcută, iar tu nu ai dreptul de a localiza ceea ce arată.",
    "title": "Fotografii și documente",
    "photos": "Fotografii",
    "documents": "Documente",
    "reportDocument": "Document raport",
    "uploadReport": "Apasă sau trage documentul raport completat aici",
    "noReport": "Niciun document raport încărcat încă.",
    "uploadPrompt": "Apasă sau trage fotografii și documente aici pentru a le atașa",
    "deleteConfirm": "Elimini acest atașament? Fișierul rămâne disponibil celui care l-a încărcat.",
    "empty": "Încă nu există fotografii sau documente.",
    "versions": "Versiuni",
    "uploadVersion": "Încarcă o versiune nouă",
    "currentVersion": "curentă",
    "noVersions": "Încă nu există versiuni.",
    "deleteVersionConfirm": "Ștergi această versiune? Conținutul ei este eliminat definitiv.",
    "details": "Detalii",
    "caption": "Legendă",
    "role": "Rol",
    "documentDate": "Data documentului",
    "tooLarge": "Acest fișier depășește limita de {{max}} pentru încărcări.",
    "roles": {
      "photoEntrance": "Fotografie intrare",
      "photoInterior": "Fotografie interior",
      "photoSurface": "Fotografie suprafață",
      "document": "Document",
      "report": "Document raport",
      "map2d": "Hartă 2D",
      "surveyData": "Date topografice",
      "other": "Altele"
    },
    "makePrimary": "Folosește ca fotografie reprezentativă",
    "clearPrimary": "Nu mai folosi ca fotografie reprezentativă"
  },
  "documents": {
    "deletion": {
      "delete": "Șterge",
      "confirm": "Ștergi acest document?",
      "restorableFor": "Nimic nu este eliminat: documentul dispare din liste, căutări și legături și poate fi restaurat din Documente șterse timp de {{period}}.",
      "restorable": "Nimic nu este eliminat: documentul dispare din liste, căutări și legături și poate fi restaurat din Documente șterse.",
      "done": "Documentul a fost șters.",
      "forbidden": "Nu poți șterge acest document.",
      "inUse": "O intrare din arhiva topografică, un model topo, o hartă georeferențiată sau un geofișier se sprijină pe acest document. Eliminați-le mai întâi.",
      "notFoundHint": "Dacă a fost șters, s-ar putea să fie încă printre documentele șterse.",
      "link": "Documente șterse",
      "title": "Documente șterse",
      "intro": "Documentele șterse pe care le poți restaura. Un document restaurat revine întreg: cu versiunile, observațiile, legăturile și locul în dosare.",
      "introWindow": "Un document șters este păstrat {{period}} și apoi eliminat definitiv.",
      "introKept": "Această instalație păstrează documentele șterse până când un administrator hotărăște altfel.",
      "empty": "Nimic aici. Un document pe care îl ștergi apare pe această pagină.",
      "loadFailed": "Documentele șterse nu au putut fi încărcate.",
      "columns": {
        "title": "Document",
        "deletedAt": "Șters",
        "deletedBy": "Șters de",
        "removed": "Eliminat definitiv"
      },
      "removedIn": "în {{period}}",
      "removedToday": "în mai puțin de o zi",
      "kept": "Neprogramat",
      "restore": "Restaurează",
      "restoreConfirm": "Restaurezi acest document?",
      "restoreConfirmDetail": "Revine cu tot ce avea și se deschide după ce este restaurat. Nimeni nu este anunțat.",
      "restored": "Documentul a fost restaurat.",
      "windowPassed": "Documentul a fost șters de prea mult timp pentru a mai putea fi restaurat.",
      "gone": "Documentul nu mai este printre cele șterse.",
      "restoreForbidden": "Nu poți restaura acest document."
    },
    "language": "Limbă",
    "languageUnknown": "Necunoscută",
    "languages": {
      "ro": "Română",
      "en": "Engleză"
    },
    "metadata": "Proprietăți document",
    "title": "Titlu",
    "type": "Tip de document",
    "noType": "Niciun tip ales",
    "visibility": "Cine îl poate citi",
    "cavingGroup": "Grup de speologie",
    "pickCavingGroup": "Alege un grup de speologie",
    "bindingForbidden": "Nu poți lega un document de un grup de speologie din care nu faci parte.",
    "metadataInvalid": "Detaliile nu corespund cu ce permite acest tip de document.",
    "cabinets": "Așezat în",
    "pickCabinets": "Neașezat nicăieri",
    "filingMovesAccess": "Un document poate sta în mai multe dulapuri; fiecare dulap numit de o regulă de acces îl cuprinde.",
    "notFiled": "Neașezat în niciun dulap.",
    "open": "Deschide documentul",
    "download": "Descarcă",
    "format": "Format",
    "size": "Mărime",
    "version": "Versiune",
    "author": "Autor",
    "updated": "Ultima modificare",
    "viewer": {
      "title": "Documentul",
      "notDisplayable": "Nimic de aici nu știe încă să afișeze acest format. Descarcă fișierul ca să-l deschizi cu ceva care poate.",
      "conversionPending": "Documentul se pregătește pentru citit aici. Între timp îl poți descărca sau poți reveni peste puțin timp.",
      "conversionUnavailable": "Această instalare nu poate pagina documente de birou, așa că nu are pagini de arătat. Fișierul în sine este în regulă — descarcă-l ca să-l deschizi într-un editor de text.",
      "conversionDeferred": "Copia care poate fi citită aici nu a putut fi făcută acum — serviciul care o face nu a răspuns. Fișierul este în regulă; descarcă-l sau roagă un administrator să pornească trecerea de conversie.",
      "conversionFailed": "Documentul nu a putut fi paginat pentru citit aici. Descarcă-l ca să-l deschizi într-un editor de text.",
      "pageAlt": "Pagina {{number}}",
      "pageFailed": "Această pagină nu a putut fi desenată. Restul documentului poate fi citit în continuare; fișierul în sine este neatins și poate fi descărcat.",
      "pdfFailed": "Documentul nu a putut fi paginat aici. Fișierul în sine este neatins — descarcă-l ca să-l deschizi într-un cititor de PDF.",
      "pdfSelectHint": "Selectează text în pagină ca să-l copiezi sau ca să legi ceva de acel pasaj.",
      "zoomIn": "Mărește",
      "zoomOut": "Micșorează",
      "pageOf": "Pagina {{number}} din {{count}}",
      "previousPage": "Pagina anterioară",
      "nextPage": "Pagina următoare",
      "mediaFailed": "Această înregistrare nu poate fi redată aici — formatul ei nu este unul pe care acest browser îl cunoaște, sau înregistrarea este mai lungă decât timpul cât rămâne valabil linkul care o aduce. Descarc-o ca s-o asculți sau s-o vezi cu altceva.",
      "textFailed": "Textul acestui document nu a putut fi încărcat.",
      "textTruncated": "Aici se văd doar primii {{kilobytes}} kB. Descarcă fișierul ca să citești restul."
    },
    "comments": {
      "title": "Discuție",
      "empty": "Încă nu s-a spus nimic despre acest document.",
      "placeholder": "Scrie o observație despre acest document",
      "replyPlaceholder": "Scrie un răspuns",
      "body": "Observație",
      "post": "Trimite",
      "reply": "Răspunde",
      "edit": "Modifică",
      "delete": "Șterge",
      "edited": "modificat",
      "deleteConfirm": "Ștergi această observație? Răspunsurile la ea dispar odată cu ea."
    },
    "text": "Text",
    "textStates": {
      "notApplicable": "Acest fel de fișier nu conține text de citit.",
      "pending": "Se citește textul…",
      "extracted": "Textul a fost citit.",
      "noText": "Documentul nu are strat de text: sunt poze ale paginilor, așa că nu există cuvinte de citit în el.",
      "failed": "Textul nu a putut fi citit.",
      "unsupported": "Nimic de aici nu știe încă să citească textul acestui format."
    }
  },
  "cabinets": {
    "title": "Dulapuri",
    "empty": "Niciun dulap încă.",
    "pickOne": "Alege un dulap pentru a vedea ce este clasat în el.",
    "new": "Nou",
    "edit": "Editează dulapul",
    "name": "Denumire",
    "description": "Descriere",
    "parent": "Se află în",
    "noParent": "La nivelul de sus",
    "size": "Mărime",
    "includeSubtree": "Include dulapurile din interior",
    "includeSubtreeHint": "Listează documentele clasate oriunde sub acest dulap, nu doar direct în el.",
    "filingMovesAccess": "Regulile de acces pot fi limitate la un dulap, așa că a clasa un document aici — sau a-l scoate — schimbă cine îl poate citi.",
    "noDocuments": "Nimic clasat aici pe care să îl poți citi.",
    "fileElsewhere": "Clasează și în altă parte",
    "fileElsewhereHint": "Un document poate sta în mai multe dulapuri deodată; fiecare dulap numit de o regulă îl atinge.",
    "pickCabinet": "Alege un dulap",
    "unfileConfirm": "Scoți acest document din acest dulap?",
    "deleteConfirm": "Ștergi acest dulap?",
    "inUse": "Există reguli care indică acest dulap; șterge-le mai întâi.",
    "notEmpty": "Dulapul încă mai conține dulapuri sau documente.",
    "holdsDeleted": "Dulapul încă mai conține documente șterse. Restaurați-le din Documente șterse și scoateți-le din dulap mai întâi.",
    "nameTaken": "Un dulap cu această denumire se află deja aici.",
    "cycle": "Un dulap nu poate fi mutat în el însuși.",
    "tooDeep": "Arborele de clasare nu poate coborî atât de adânc.",
    "filingForbidden": "Nu poți clasa acest document aici.",
    "unfiled": "Nedepuse",
    "unfiledHint": "Tot ce ai adăugat și nu se află încă într-un dulap. Depunerea este o decizie de mai târziu — alege ce ține împreună și depune dintr-o dată.",
    "unfiledEmpty": "Nu așteaptă nimic să fie depus.",
    "defaults": "Ce ajunge aici",
    "defaultsHint": "Se aplică la tot ce se încarcă în acest dulap. Lăsat gol, răspunsul vine de la dulapul de deasupra.",
    "defaultType": "Tipul documentului",
    "defaultVisibility": "Cine îl poate citi",
    "defaultInherit": "La fel ca dulapul de deasupra",
    "defaultTags": "Etichete",
    "defaultTagsHint": "Se aplică la tot ce se depune aici",
    "requiredMetadata": "Metadate așteptate aici",
    "requiredMetadataHint": "O listă de verificat, nu o regulă: încărcările nu sunt refuzate pentru lipsa lor, dar documentele care nu le conțin sunt marcate.",
    "expectsMetadata": "Documentele de aici trebuie să conțină: {{keys}}",
    "missingMetadata": "Încă lipsesc: {{keys}}",
    "incomplete": "Incomplet",
    "selected": "{{count}} selectate",
    "copyTo": "Depune și în…",
    "moveTo": "Mută în…",
    "copyHint": "Un document poate sta în mai multe dulapuri deodată, deci aceasta adaugă un dulap, nu mută nimic.",
    "moveHint": "Le depune în noul dulap și le scoate din acesta.",
    "bulkFiled": "{{count}} depuse.",
    "bulkPartly": "{{filed}} depuse; {{refused}} nu au putut fi."
  },
  "review": {
    "queueTitle": "Încărcări care așteaptă verificarea",
    "queueExplain": "Aici așteaptă încărcările conturilor aflate sub verificare. Nimic din ele nu a fost scris încă: ce accepți se scrie atunci, iar ce respingi nu se scrie niciodată.",
    "wholeView": "Aici schimbările care așteaptă sunt arătate în întregime, inclusiv pozițiile exacte ale peșterilor protejate și fotografiile peșterilor pe care altfel nu le-ai putea deschide.",
    "queueEmpty": "Nimic nu așteaptă verificarea.",
    "forbidden": "Nu ai voie să verifici încărcări.",
    "uploader": "Trimis de",
    "unknownUploader": "Cont necunoscut",
    "heldAt": "Așteaptă din",
    "contents": "Ce conține",
    "waiting": "În așteptare",
    "heldBytes": "Fișiere păstrate",
    "decidedBy": "Decis de",
    "backToQueue": "Înapoi la încărcările care așteaptă verificarea",
    "batchTitle": "Încărcare în verificare",
    "batchNotFound": "Această încărcare nu așteaptă verificarea sau nu ai voie să o vezi.",
    "batchNote": "Nota verificatorului: {{note}}",
    "ownBatch": "Aceasta este propria ta încărcare. O decide un verificator; poți citi ce așteaptă și ce s-a decis.",
    "readOnly": "Poți citi această încărcare, dar nu o poți decide.",
    "mine": {
      "title": "Încărcările tale în verificare",
      "explain": "Contul tău este ținut pentru verificare: ce trimiți așteaptă un verificator și se scrie doar când îl acceptă. Aici vezi unde se află fiecare încărcare.",
      "sentAt": "Trimisă",
      "decidedAt": "Decisă",
      "decidedBy": "de {{name}}",
      "outcome": "{{waiting}} în așteptare din {{total}}",
      "note": "Nota verificatorului",
      "open": "Deschide"
    },
    "source": {
      "label": "Sursă",
      "vectorFile": "Import de fișier (fișier vectorial)",
      "photos": "Import de fișier (fotografii)",
      "deviceSync": "Telefon",
      "externalCatalogue": "Import de fișier (catalog)",
      "tripCsv": "Import de fișier (foaie de ture)",
      "speleolocArchive": "Import de fișier (arhivă SpeleoLoc)"
    },
    "state": {
      "label": "Stare",
      "notHeld": "Nereținută",
      "pending": "În așteptare",
      "accepted": "Acceptată",
      "partlyAccepted": "Acceptată în parte",
      "rejected": "Respinsă"
    },
    "decision": {
      "pending": "În așteptare",
      "accepted": "Acceptat",
      "rejected": "Respins",
      "superseded": "Înlocuit de o încărcare mai nouă",
      "failed": "Nu a putut fi scris"
    },
    "candidate": {
      "line": "Linia",
      "action": "Decizie",
      "name": "Nume",
      "caveTypeCode": "Tip de peșteră",
      "createTrip": "Creează o ieșire",
      "yes": "Da",
      "no": "Nu",
      "actions": {
        "create": "Creează",
        "attach": "Atașează la un loc existent",
        "skip": "Omite",
        "update": "Actualizează",
        "record": "Înregistrează"
      }
    },
    "needsOther_one": "Depinde și de {{count}} linie dintr-o altă încărcare.",
    "needsOther": "Depinde și de {{count}} de linii din alte încărcări.",
    "pullInOther": "Unele dintre aceste linii depind de linii din alte încărcări, care se hotărăsc odată cu ele dacă încă așteaptă.",
    "acceptAllWhole": "Acceptă tot ia fiecare linie care așteaptă întreagă; pentru a alege câmpurile, acceptă linia separat.",
    "stoppedRest_one": "Oprit aici: încă {{count}} linie aleasă așteaptă.",
    "stoppedRest": "Oprit aici: încă {{count}} de linii alese așteaptă.",
    "section": {
      "none": "Altele",
      "rows": "Locuri",
      "people": "Utilizatori de telefon",
      "documents": "Fotografii și documente",
      "documentLinks": "Legături",
      "tripRecordings": "Înregistrări",
      "tripPoints": "Scanări",
      "rasterMaps": "Hărți raster",
      "rasterPins": "Repere pe hartă",
      "placeStations": "Stațiile locurilor",
      "vectorFile": "Fișier vectorial",
      "photos": "Fotografii",
      "tripSheet": "Fișă de ieșire",
      "catalogue": "Peșteri din catalog",
      "speleolocArchive": "Arhivă",
      "keptRecording": "Înregistrare păstrată"
    },
    "act": {
      "create": "Nou",
      "update": "Modificare",
      "delete": "Ștergere",
      "describe": "Descriere"
    },
    "field": {
      "label": "Câmp",
      "name": "Nume",
      "description": "Descriere",
      "properties": "Proprietăți",
      "position": "Poziție",
      "kind": "Tip de obiect",
      "type": "Tip",
      "altitude": "Altitudine",
      "title": "Titlu",
      "file": "Fișier nou",
      "log": "Jurnal",
      "times": "Început și sfârșit",
      "cave": "Peșteră",
      "notes": "Note",
      "place": "Loc",
      "time": "Ora scanării",
      "mapType": "Tip de hartă",
      "sortOrder": "Ordine",
      "caveArea": "Parte a peșterii"
    },
    "current": "Acum",
    "proposed": "Propus",
    "unchanged": "la fel",
    "acceptField": "Acceptă {{field}}",
    "acceptedFields": "Acceptat: {{fields}}",
    "changedSince": "Modificat după ce l-a citit telefonul",
    "needs": "Are nevoie de: {{names}}",
    "lineNote": "Notă: {{note}}",
    "untitled": "Fără nume",
    "groupOther": "Fără peșteră",
    "groupHiddenCave": "O peșteră pe care nu ai voie să o vezi",
    "positionWithheld": "Poziția acestui loc îți este ascunsă, deci nu este comparată.",
    "positionNotShown": "nu se arată",
    "positionShape": "o formă",
    "altitudeValue": "{{value}} m",
    "mainEntrance": "intrare principală",
    "removalExplain": "Telefonul cere ștergerea acestui loc.",
    "proposalHidden": "Ce propune această linie nu ți se arată.",
    "noPreviewHeld": "Fișierul este păstrat pe server până se decide linia.",
    "mapTypes": {
      "planView": "Plan",
      "projectedProfile": "Profil proiectat",
      "extendedProfile": "Profil desfășurat",
      "other": "Altul"
    },
    "currentWithheld": "Nu ți se arată",
    "currentPicture": "Imaginea pe care o are acum",
    "pictureAlt": "Imaginea {{name}}",
    "pictureFailed": "Imaginea nu a putut fi afișată.",
    "timeRange": "{{start}} până la {{end}}",
    "noDetail": "Nu mai este nimic de arătat pentru această linie.",
    "file": "Fișier",
    "size": "Mărime",
    "capturedAt": "Făcută la",
    "role": "Rol",
    "caption": "Legendă",
    "username": "Nume de utilizator",
    "linkedToCaver": "Legat de un speolog din registru.",
    "log": "Jurnal",
    "startedAt": "Început",
    "endedAt": "Sfârșit",
    "points": "Scanări",
    "scannedAt": "Scanat la",
    "notes": "Note",
    "mapType": "Tip de hartă",
    "pin": "Reper",
    "pinNotShown": "Locul acestui reper nu ți se arată.",
    "station": "Stația",
    "splay": "Viză laterală din stație (m est, nord, sus)",
    "stationNotShown": "Stația acestui loc nu ți se arată.",
    "accept": "Acceptă",
    "reject": "Respinge",
    "acceptAfterAll": "Acceptă totuși",
    "acceptAll": "Acceptă tot",
    "rejectAll": "Respinge tot",
    "rejectAllTitle": "Respingi tot ce așteaptă?",
    "rejectAllExplain": "Nimic din această încărcare nu se scrie. Cel care a încărcat este anunțat, cu nota ta.",
    "select": "Selectează",
    "selectAllWaiting": "Toate liniile în așteptare",
    "selectNone": "Nimic",
    "selectKind": "Tot ce e de un fel: {{kind}}",
    "selectGroup": "Selectează toate liniile în așteptare de sub această peșteră",
    "selectLine": "Selectează {{name}}",
    "acceptSelected": "Acceptă selecția ({{count}})",
    "rejectSelected": "Respinge selecția ({{count}})",
    "noteLabel": "Notă pentru cel care a încărcat (opțională, trimisă cu următoarea decizie)",
    "notePlaceholder": "De ce, sau ce să facă în loc",
    "showDecided": "Arată liniile deja decise",
    "waitingOfTotal": "{{waiting}} în așteptare din {{total}} linii",
    "noLines": "Această încărcare nu are linii.",
    "showDetails": "Arată detaliile pentru {{name}}",
    "hideDetails": "Ascunde detaliile pentru {{name}}",
    "decided": "Decizia a fost înregistrată.",
    "pullInTitle": "Se acceptă și ce are nevoie",
    "pullInExplain": "Aceste linii așteaptă, iar cele alese de tine depind de ele, deci sunt acceptate mai întâi:",
    "cascadeTitle": "Se respinge și ce depinde de ele",
    "cascadeExplain": "Aceste linii așteaptă și depind de cele alese de tine, deci sunt respinse odată cu ele:",
    "changedSinceTitle": "Unele locuri s-au schimbat după ce le-a citit telefonul",
    "changedSinceExplain": "Cineva a schimbat aceste locuri pe server după ce telefonul și-a trimis versiunea. Poți scrie câmpurile acceptate din versiunea telefonului peste versiunea de acum sau le poți respinge. Nu s-a decis încă nimic.",
    "writeOver": "Scrie peste versiunea de acum",
    "rejectThese": "Respinge-le",
    "problem": {
      "generic": "Decizia nu a putut fi luată.",
      "review_not_pending": "Ceva la care ajunge această decizie a fost deja decis sau nu mai poate fi schimbat. Pagina arată ultima stare.",
      "review_own_batch": "Încărcările sunt decise de altcineva decât contul care le-a trimis.",
      "review_batch_not_found": "Această încărcare nu așteaptă verificarea sau nu ai voie să o vezi.",
      "review_item_not_found": "Această linie nu mai există.",
      "review_fields_unsupported": "Doar o modificare a unui loc poate fi acceptată câmp cu câmp.",
      "review_source_unsupported": "Acest fel de încărcare nu poate fi încă decis de acest server."
    }
  },
  "uploads": {
    "title": "Încarcă",
    "titleInto": "Încarcă în {{cabinet}}",
    "upload": "Încarcă",
    "dropFiles": "Trage fișiere aici sau apasă pentru a le alege",
    "chooseFolder": "Alege un folder",
    "label": "Numele acestui lot",
    "labelHint": "Opțional. Tot ce se încarcă împreună poate fi regăsit după acest nume.",
    "tag": "Etichetează tot cu",
    "tagHint": "Opțional. Eticheta se creează dacă nu există încă.",
    "expandArchives": "Desfă arhivele ZIP pe server, păstrând folderele",
    "limitsTitle": "Înainte de a începe",
    "limitMaxSize": "Cel mai mare fișier acceptat: {{size}}",
    "limitRemaining": "Spațiu rămas pentru tine: {{size}}",
    "limitAccepted": "Tipuri acceptate: {{types}}",
    "limitAcceptsAnything": "Se acceptă orice tip de fișier.",
    "limitRefused": "Nu se acceptă: {{types}}",
    "expectsMetadata": "Documentele depuse aici trebuie să conțină:",
    "summary": "{{stored}} din {{total}} salvate · {{skipped}} sărite · {{failed}} eșuate",
    "retryFailed": "Reîncearcă {{count}} eșuate",
    "duplicateTitle": "Fișierul există deja",
    "duplicateKnown": "Un document cu exact acest conținut este deja salvat. Salvezi și această copie?",
    "duplicateUnknown": "Acest conținut este deja salvat. Salvezi și această copie?",
    "duplicateStoreAnyway": "Salvează oricum",
    "duplicateSkip": "Sari peste",
    "batches": "Încărcări",
    "batchesEmpty": "Nu s-a încărcat încă nimic în loturi.",
    "batchSource": "Sursă",
    "batchSourceValues": {
      "interactive": "Browser",
      "archive": "Arhivă",
      "serverDirectory": "Director pe server",
      "surveyUpload": "Dispozitiv de teren"
    },
    "batchStatus": "Stare",
    "batchStatusValues": {
      "open": "Deschis",
      "running": "În lucru",
      "completed": "Terminat",
      "failed": "Eșuat"
    },
    "batchCounts": "{{stored}} salvate · {{skipped}} sărite · {{failed}} eșuate",
    "batchReport": "Raport",
    "importDirectory": "Importă dintr-un director de pe server",
    "importDirectoryHint": "Copiază fișiere la care serverul are deja acces, fără a le trimite prin rețea. Folderele devin dulapuri.",
    "importPath": "Director",
    "importRoots": "Instalarea poate importa din:",
    "importNoRoots": "Nu este configurat niciun director de import, deci funcția este oprită. Un operator setează SILEXGIS__FILES__IMPORTROOTS la instalare.",
    "importStarted": "Importul a pornit; raportul se completează pe măsură ce rulează.",
    "reason": {
      "duplicate": "Deja salvat",
      "tooLarge": "Mai mare decât acceptă instalarea",
      "typeNotAccepted": "Acest tip de fișier nu este acceptat",
      "quotaExceeded": "Nu mai este spațiu suficient",
      "empty": "Fișierul este gol",
      "pathRefused": "Această cale de folder nu poate fi depusă",
      "filingRefused": "Nu ai voie să depui în acel dulap",
      "unreadable": "Fișierul nu a putut fi citit",
      "failed": "Încărcarea a eșuat"
    },
    "batchStarted": "Încărcat"
  },
  "gallery": {
    "filter": {
      "advanced": "Condiții…",
      "advancedTitle": "Condiții pentru fotografii",
      "on": "active",
      "applySaved": "Aplică o vizualizare salvată a galeriei…",
      "noSaved": "Încă nu există filtre salvate pentru fotografii",
      "saveAs": "Salvează ca vizualizare…",
      "manage": "Filtre salvate",
      "forget": "Nu mai numi această vizualizare salvată",
      "active": "Vizualizare salvată: {{name}}",
      "activeUnavailable": "Vizualizarea salvată nu îți este disponibilă",
      "changed": "modificată între timp",
      "saveTitle": "Salvează aceste condiții ca vizualizare a galeriei",
      "saved": "Salvată ca „{{name}}”.",
      "savedUnreadable": "Acel filtru salvat nu poate fi citit cu accesul tău, așa că nu a fost aplicat.",
      "savedNotAboutPhotographs": "Acel filtru salvat nu se referă la fotografii.",
      "unreadableLink": "Condițiile din acest link nu au putut fi citite, așa că au fost lăsate deoparte. Cere-i celui care l-a trimis un link nou.",
      "refused": "Aceste condiții nu au putut fi aplicate. Modifică-le sau nu mai numi vizualizarea salvată.",
      "unsavedControls": "O vizualizare salvată păstrează căutarea, eticheta, datele și condițiile. Fotograful, albumul, „fără poziție” și ce a deschis un link în galerie — o peșteră, o tură, o tabără, o zonă de pe hartă — nu sunt păstrate și se aleg din nou de fiecare dată."
    },
    "title": "Fotografii",
    "publicTitle": "Galerie",
    "albums": "Albume",
    "album": "Album",
    "newAlbum": "Album nou",
    "editAlbum": "Editează albumul",
    "albumTitle": "Titlu",
    "noAlbums": "Niciun album încă.",
    "albumCount": "{{count}} fotografii",
    "empty": "Nicio fotografie nu corespunde.",
    "publicEmpty": "Nu s-a publicat încă nimic.",
    "search": "Caută în descrieri și locuri",
    "photographer": "Fotograf",
    "place": "Loc",
    "licence": "Licență",
    "facts": "Despre această fotografie",
    "download": "Descarcă originalul",
    "previous": "Anterioara",
    "next": "Următoarea",
    "zoomIn": "Mărește",
    "zoomOut": "Micșorează",
    "select": "Selectează",
    "selected": "{{count}} selectate",
    "rotate": "Rotește",
    "rotated": "{{count}} rotite.",
    "addToAlbum": "Adaugă în album…",
    "addedToAlbum": "{{count}} adăugate.",
    "deleted": "{{count}} șterse.",
    "deleteConfirm": "Ștergi aceste fotografii?",
    "deleteHint": "Dispar din toate listele deodată și pot fi recuperate o vreme după aceea.",
    "deleteAlbumConfirm": "Ștergi acest album?",
    "deleteAlbumHint": "Fotografiile din el nu se șterg.",
    "bulkPartly": "{{changed}} modificate; {{refused}} nu au putut fi.",
    "unplaced": "Fără poziție",
    "placed": "Poziție",
    "mapExtent": "Se arată fotografiile din zona hărții de unde ai venit.",
    "mapExtentCutShort": "Nu sunt listate aici toate fotografiile din această zonă a hărții — sunt mai multe decât poate cuprinde o căutare. Apropie harta pentru a le vedea pe celelalte.",
    "shareTitle": "Link de partajare",
    "shareOnce": "Copiază-l acum — linkul se arată o singură dată și nu mai poate fi recuperat. Dacă se pierde, revocă-l și creează altul.",
    "revokeConfirm": "Revoci linkul de partajare al acestui album?",
    "linkNotFound": "Acest link nu deschide nimic. Este posibil să fi fost revocat.",
    "licences": {
      "cc0": "Domeniu public (CC0)",
      "cc-by": "CC BY",
      "cc-by-sa": "CC BY-SA",
      "cc-by-nc": "CC BY-NC",
      "cc-by-nc-sa": "CC BY-NC-SA",
      "cc-by-nd": "CC BY-ND",
      "cc-by-nc-nd": "CC BY-NC-ND",
      "all-rights-reserved": "Toate drepturile rezervate"
    },
    "delete": "Șterge",
    "editCredit": "Autor și licență",
    "caption": "Descriere",
    "fromRoster": "Un speolog",
    "someoneElse": "Altcineva",
    "photographerName": "Numele fotografului",
    "licenceUnsaid": "Nu s-a specificat",
    "inPublicGallery": "Arată în galeria publică",
    "inPublicGalleryHint": "Pune fotografia pe pagina la care poate ajunge oricine, fără autentificare. Separat de cine o poate vedea aici.",
    "published": "Publicată în galeria publică.",
    "unpublished": "Retrasă din galeria publică.",
    "moveEarlier": "Mută mai devreme",
    "moveLater": "Mută mai târziu",
    "makeCover": "Folosește ca și copertă",
    "removeFromAlbum": "Scoate din album",
    "removedFromAlbum": "Scoasă din album.",
    "openInGallery": "Deschide în galerie",
    "arrangeHint": "Trage o fotografie peste locul unde o vrei, sau mut-o cu săgețile.",
    "albumEmpty": "Încă nimic în acest album. Adaugă fotografii din galerie.",
    "albumPartial": "Se arată primele {{shown}} din {{total}} fotografii. Rearanjarea se aplică acestora."
  },
  "geodata": {
    "title": "Geodate",
    "name": "Denumire",
    "format": "Format",
    "status": "Stare",
    "features": "Obiecte",
    "edit": "Editare fișier geo",
    "deleteConfirm": "Ștergi acest fișier geo și obiectele importate?",
    "showOnMap": "Arată pe hartă",
    "exportList": "Exportă fișierele din listă",
    "exportListFailed": "Lista nu a putut fi exportată. O selecție foarte mare este refuzată în loc să fie tăiată: restrânge filtrul și exportă pe părți.",
    "searchPlaceholder": "Caută după denumire…",
    "uploadPrompt": "Apasă sau trage fișiere vectoriale aici pentru încărcare",
    "uploadHint": "GPX, KML, KMZ, GeoJSON, shapefile arhivat, CSV cu coloane de coordonate, WKT — importate în fundal.",
    "uploadQueued": "{{name}} încărcat — importul a fost programat.",
    "uploadFailed": "Încărcarea a eșuat. Verifică formatul fișierului și încearcă din nou.",
    "statusValues": {
      "uploaded": "În așteptare",
      "importing": "Se importă…",
      "imported": "Importat",
      "failed": "Eșuat"
    },
    "tabVector": "Fișiere vectoriale",
    "tabRaster": "Hărți raster",
    "mapKind": "Tip",
    "editRaster": "Editare hartă raster",
    "deleteRasterConfirm": "Ștergi această hartă raster?",
    "rasterUploadPrompt": "Apasă sau trage fișiere GeoTIFF georeferențiate aici",
    "rasterUploadHint": "Convertite în fundal în Cloud-Optimized GeoTIFF.",
    "defaultOpacity": "Opacitate implicită (0–1)",
    "attribution": "Atribuire",
    "mapKinds": {
      "geological": "Geologică",
      "topographic": "Topografică",
      "tourist": "Turistică",
      "caveMap": "Hartă de peșteră",
      "other": "Altele"
    },
    "rasterStatusValues": {
      "uploaded": "În așteptare",
      "processing": "Se procesează…",
      "ready": "Gata",
      "failed": "Eșuat"
    },
    "tabImports": "Importuri"
  },
  "mapEdit": {
    "featureType": "Tip de obiect",
    "draw": "Desenează",
    "modify": "Modifică (trage vârfurile; Alt+clic șterge)",
    "translate": "Mută geometria",
    "snap": "Aliniere la obiectele vizibile",
    "snapShort": "Aliniere",
    "undo": "Anulează",
    "redo": "Refă",
    "measureDistance": "Măsoară distanța",
    "measureArea": "Măsoară aria",
    "discard": "Renunță la editări",
    "finishDrawing": "Încheie",
    "finishDrawingHint": "Mai adaugă puncte înainte de a încheia forma.",
    "removeLastPoint": "Punct",
    "deleteVertex": "Șterge vârful",
    "deleteVertexHint": "Atinge întâi un vârf pe hartă, apoi Șterge vârful.",
    "clickToMeasure": "Clic pentru a măsura",
    "continueLine": "Clic pentru a continua linia — dublu-clic pentru a încheia",
    "continueArea": "Clic pentru a continua suprafața — dublu-clic pentru a încheia",
    "pickFeatureType": "Alege un tip de obiect",
    "pinType": "Fixează în bara de instrumente",
    "unpinType": "Scoate din bara de instrumente",
    "newCaveHere": "Peșteră nouă aici (clic pe hartă)",
    "newEntranceHere": "Intrare nouă aici (clic pe hartă)",
    "entranceType": "Tip intrare",
    "locationProtected": "Protejează locația exactă",
    "pickCaveForEntrance": "Alege peștera căreia îi aparține intrarea.",
    "groups": {
      "point": "Puncte",
      "line": "Linii",
      "polygon": "Suprafețe",
      "any": "Altele"
    },
    "shapes": {
      "Point": "Marcaj",
      "LineString": "Linie",
      "Polygon": "Contur"
    },
    "selectionNotEditable": "Nu ai dreptul să modifici obiectul selectat"
  },
  "trips": {
    "title": "Jurnale de tură",
    "titleField": "Titlu",
    "openTrip": "Deschide tura",
    "new": "Jurnal de tură nou",
    "edit": "Editare jurnal",
    "notFound": "Nicio astfel de tură",
    "notFoundDetail": "Fie nu există, fie nu o poți citi. Această pagină nu poate deosebi cele două cazuri și nici nu încearcă.",
    "tabReport": "Raport",
    "tabLinks": "Legături",
    "tabPhotos": "Fotografii",
    "tabFiles": "Fișiere",
    "tabHistory": "Istoric",
    "tabInvitations": "Cine vine",
    "invitations": {
      "title": "Cine vine",
      "invite": "Invită",
      "invitePlaceholder": "Cineva cunoscut clubului",
      "signUp": "Înscrie-mă",
      "signUpHint": "Nimeni nu te-a invitat încă, dar oricine poate citi asta se poate trece drept participant, în ordinea în care o spune.",
      "invited": "Adăugat pe listă.",
      "pickFromDirectory": "Alege pe cineva dintre sugestii. O persoană este invitată prin fișa ei din evidențele clubului, nu printr-un nume scris aici — un nume pe care nimeni nu îl poate identifica ar fi un nume pe care nimeni nu îl poate anunța.",
      "empty": "Nimeni nu a fost invitat în această tură încă.",
      "emptyWithheld": "Toți cei de pe lista acestei ture sunt persoane despre care nu ai dreptul să fii informat.",
      "unavailable": "Lista acestei ture nu a putut fi citită.",
      "limit": "{{attending}} din {{max}} locuri ocupate, {{waiting}} în așteptare.",
      "noLimit": "{{attending}} vin. Această tură nu are limită de participanți.",
      "place": "#{{place}}",
      "attending": "În tură",
      "waiting": "În așteptare",
      "selected": "Ales",
      "select": "Alege această persoană pentru tură",
      "deselect": "Pune persoana înapoi în ordine",
      "notePlaceholder": "O vorbă despre asta",
      "removeConfirm": "Ștergi complet această persoană de pe listă, cu răspuns cu tot?",
      "promote": "Trece aceste persoane în tură",
      "promoteConfirm": "Treci pe toată lumea care are un loc în lista de participanți a turei? Nimeni nu este anunțat: toți cei trecuți au fost anunțați când au fost invitați.",
      "promoted": "{{promoted}} trecuți în tură, {{alreadyNamed}} erau deja acolo.",
      "promoteTooEarly": "Tura nu a avut loc încă, deci nu are cine să fie trecut în ea.",
      "rosterChangedMeanwhile": "Altcineva a schimbat în același moment cine este în această tură, așa că nimeni nu a fost trecut în ea. Reîncarcă tura și trece din nou aceste persoane în tură.",
      "concurrentAnswer": "Altcineva a scris despre această persoană în același moment. Lista a fost citită din nou — repetă modificarea dacă mai este dorită.",
      "caverUnknown": "Evidențele clubului nu conțin pe nimeni cu acest nume.",
      "selectNotAttending": "Doar cineva care a spus că vine poate fi ales pentru tură.",
      "noteInvalid": "Această notă este prea lungă pentru a fi păstrată.",
      "withheld": "{{count}} pe listă, care nu îți sunt arătați",
      "withheldDetail": "Pe lista acestei ture se află cineva despre care nu ai dreptul să fii informat. Este numărat aici pentru ca cifrele de lângă listă să fie corecte, și nu este numit nicăieri.",
      "responseValues": {
        "pending": "Fără răspuns",
        "yes": "Vine",
        "no": "Nu vine",
        "maybe": "Poate"
      }
    },
    "type": "Tip de tură",
    "typeValues": {
      "exploration": "Explorare",
      "survey": "Cartare / topografie",
      "maintenance": "Întreținere / echipare",
      "training": "Instruire",
      "tourism": "Turism / vizită",
      "rescue": "Salvare",
      "science": "Știință",
      "other": "Altele"
    },
    "participantRoleValues": {
      "participant": "Participant",
      "proposer": "Propunător",
      "leader": "Responsabil de tură",
      "driver": "Șofer",
      "surveyor": "Topograf",
      "photographer": "Fotograf",
      "trainee": "Cursant",
      "instructor": "Instructor",
      "callout_contact": "Persoană de contact"
    },
    "date": "Data",
    "dates": "Perioada",
    "entryTime": "Ora de intrare",
    "exitTime": "Ora de ieșire",
    "duration": "Timp în subteran",
    "location": "Locație",
    "organizingClub": "Club organizator",
    "caves": "Peșteri",
    "cavesWithheld": "{{count}} nearătate ție",
    "cavesWithheldDetail": "Această tură menționează peșteri pe care nu le poți deschide sau a căror poziție nu îți poate fi comunicată — sunt numărate aici, nu enumerate, pentru că a le numi ar echivala cu a le arăta.",
    "participants": "Participanți",
    "participantName": "Nume participant",
    "participantRequired": "Introdu un nume",
    "participantTracked": "Cineva scos de pe listă are rapoarte în urmărirea acestei ture, iar urmărirea este încă pornită. Încheie întâi urmărirea sau păstrează persoana pe listă.",
    "rosterChangedMeanwhile": "Altcineva a schimbat în același moment cine este în această tură, așa că salvarea nu a fost scrisă. Reîncarcă tura și salvează din nou.",
    "participantRole": "Rol",
    "participantNote": "Notă",
    "participantDetails": "Rol, ore și notă",
    "removeParticipant": "Elimină din această tură",
    "participantTimesHint": "Lăsate goale, se aplică orele turei.",
    "addParticipant": "Adaugă participant",
    "proposers": "Propus de",
    "proposerName": "Nume propunător",
    "addProposer": "Adaugă propunător",
    "results": "Rezultate / observații",
    "weather": "Vreme / condiții",
    "depthReachedM": "Adâncime atinsă",
    "lengthSurveyedM": "Lungime cartată",
    "surveyStations": "Stații topografice",
    "ropeMetres": "Coardă folosită",
    "metres": "{{value, number}} m",
    "incident": "Incident",
    "hadIncidentYes": "S-a întâmplat ceva",
    "maxParticipants": "Locuri",
    "maxParticipantsHelp": "Câți oameni încap în tură. Lasă gol pentru fără limită; cine depășește limita așteaptă în ordinea în care a răspuns.",
    "sections": {
      "title": "Raportul turei",
      "measured": "Măsurători",
      "fieldData": "Date de teren",
      "logistics": "Logistică",
      "safety": "Siguranță",
      "noFields": "Scopul acestei ture nu cere nimic aici.",
      "invalid": "Secțiunea {{section}} nu corespunde cu ceea ce cere scopul acestei ture.",
      "safetyWithheld": "Nu ți se arată",
      "safetyWithheldDetail": "Ce a mers prost într-o tură numește oamenii cărora li s-a întâmplat, așa că relatarea este păstrată pentru cine poate modifica tura. Aceasta nu înseamnă că nu s-a întâmplat nimic.",
      "pickPerson": "Alege o persoană din registru",
      "yes": "Da",
      "no": "Nu"
    },
    "sectionValues": {
      "water_level": {
        "low": "Scăzut",
        "normal": "Normal",
        "high": "Ridicat",
        "flood": "Viitură"
      },
      "survey_grade": {
        "1": "1",
        "2": "2",
        "3": "3",
        "4": "4",
        "5": "5",
        "6": "6",
        "X": "X"
      },
      "incident_severity": {
        "near_miss": "La limită",
        "minor": "Minor",
        "serious": "Grav",
        "rescue": "Salvare"
      }
    },
    "sectionFields": {
      "conditions": "Condiții în subteran",
      "water_level": "Nivelul apei",
      "objective_reached": "Obiectiv atins",
      "leads_found": "Continuări găsite",
      "leads_remaining": "Continuări rămase deschise",
      "survey_grade": "Gradul topografiei",
      "instrument": "Instrument",
      "loops_closed": "Bucle închise",
      "sketch_completed": "Schiță finalizată",
      "new_passage_note": "Galerie nouă",
      "permit_reference": "Referința autorizației",
      "permit_holder_caver_id": "Titularul autorizației",
      "permit_holder_note": "Titularul autorizației, dacă nu este în registru",
      "key_holder_caver_id": "Deținătorul cheii",
      "key_holder_note": "Deținătorul cheii, dacă nu este în registru",
      "landowner_caver_id": "Contactul proprietarului terenului",
      "landowner_note": "Contactul proprietarului terenului, dacă nu este în registru",
      "access_notes": "Note despre acces",
      "cost_amount": "Cost",
      "cost_currency": "Monedă",
      "cost_note": "Ce a acoperit costul",
      "incident_summary": "Ce s-a întâmplat",
      "incident_severity": "Gravitate",
      "equipment_failure": "Echipament defect",
      "lessons_learned": "Ce s-a învățat",
      "reported_to": "Raportat către",
      "meeting_time": "Ora întâlnirii",
      "meeting_description": "Locul întâlnirii, descris",
      "transport_drivers": "Șoferi",
      "transport_seats": "Locuri disponibile",
      "transport_departure": "Puncte de plecare",
      "equipment_note": "Echipament și echipare",
      "permit_required": "Autorizație necesară",
      "permit_obtained": "Autorizație obținută",
      "callout_contact_caver_id": "Persoana de contact pentru alarmă",
      "callout_contact_note": "Persoana de contact pentru alarmă, dacă nu este în registru",
      "weather_note": "Notă meteo",
      "whatsapp_group_url": "Link către grupul de discuții"
    },
    "state": "Stare",
    "stateValues": {
      "draft": "Ciornă",
      "proposed": "Propusă",
      "planned": "Planificată",
      "confirmed": "Confirmată",
      "done": "Efectuată",
      "published": "Publicată",
      "cancelled": "Anulată",
      "delayed": "Amânată"
    },
    "publish": "Publică",
    "publishConfirm": "Publici această tură? Persoanele menționate în ea vor fi anunțate, iar acest lucru nu poate fi retras. Cine o poate citi nu se schimbă: rămâne vizibilă pentru {{audience}}. Lărgirea accesului este o modificare separată.",
    "publishAudience": {
      "private": "tu și persoanele pe care le-ai numit",
      "cavingGroup": "clubul tău speologic",
      "authenticated": "toți cei care au cont aici",
      "public": "oricine, inclusiv vizitatorii fără cont"
    },
    "publishSuccess": "Publicat. Persoanele menționate în această tură au fost anunțate.",
    "publishedAt": "Publicat la",
    "propose": "Propune ideea",
    "proposeSuccess": "Propusă ca idee.",
    "organise": "Începe organizarea",
    "organiseSuccess": "În curs de organizare.",
    "confirmGoing": "Se desfășoară",
    "confirmGoingSuccess": "Confirmată că se desfășoară.",
    "delay": "Amână",
    "delaySuccess": "Amânată. Stabilește o dată nouă când există una.",
    "reschedule": "Stabilește o dată nouă",
    "rescheduleSuccess": "Înapoi la organizare.",
    "markDone": "Marchează efectuată",
    "markDoneSuccess": "Marcată ca efectuată.",
    "callOff": "Anulează tura",
    "callOffConfirm": "Anulezi această tură? Se păstrează și poate fi readusă la ciornă.",
    "callOffSuccess": "Anulată.",
    "unpublish": "Înapoi la ciornă",
    "unpublishSuccess": "Înapoi la ciornă.",
    "draftNotice": "Aceasta este o ciornă. Nimeni nu a fost anunțat încă — publică-o când raportul este gata.",
    "deleteConfirm": "Ștergi acest jurnal de tură?",
    "deleted": {
      "link": "Ture șterse",
      "title": "Ture șterse",
      "intro": "Turele șterse pe care le poți restaura. O tură restaurată revine exact cum era: cu participanții ei, peșterile pe care le numește, fișierele și locul ei într-o tabără.",
      "introWindow": "O tură ștearsă este păstrată {{period}} și apoi eliminată definitiv.",
      "introKept": "Această instalație păstrează turele șterse până când un administrator hotărăște altfel.",
      "restorableFor": "Nimic din ea nu este eliminat. Poate fi restaurată din Ture șterse timp de {{period}}.",
      "restorable": "Nimic din ea nu este eliminat. Poate fi restaurată din Ture șterse.",
      "empty": "Nimic aici. O tură pe care o ștergi apare pe această pagină până când este eliminată definitiv.",
      "loadFailed": "Turele șterse nu au putut fi încărcate.",
      "columns": {
        "title": "Tură",
        "dates": "Perioada",
        "deletedAt": "Ștearsă",
        "deletedBy": "Ștearsă de",
        "removed": "Eliminată definitiv"
      },
      "removedIn": "în {{period}}",
      "removedToday": "în mai puțin de o zi",
      "kept": "Neprogramată",
      "restore": "Restaurează",
      "restoreConfirm": "Restaurezi această tură?",
      "restoreConfirmDetail": "Revine cu tot ce avea și se deschide după ce este restaurată. Nimeni nu este anunțat.",
      "restored": "Tura a fost restaurată.",
      "windowPassed": "Tura a fost ștearsă de prea mult timp pentru a mai putea fi restaurată.",
      "gone": "Tura nu mai este printre cele șterse.",
      "forbidden": "Nu poți restaura această tură.",
      "notFoundHint": "Dacă a fost ștearsă, s-ar putea să fie încă printre turele șterse."
    },
    "searchPlaceholder": "Caută după titlu…",
    "organizingCavingGroup": "Grupul organizator",
    "gallery": "Fotografii",
    "noPhotographs": "Nicio fotografie nu este atașată încă acestei ture.",
    "galleryVisibleToYou": "Fotografiile pe care le poți vedea. Altcineva poate vedea mai multe sau mai puține.",
    "report": {
      "open": "Vezi raportul",
      "backToTrip": "Înapoi la tură",
      "print": "Tipărește",
      "account": "Relatare",
      "whoWasThere": "Cine a participat",
      "peopleCount": "Persoane: {{count}}",
      "sketchPoint": "Schiță: un punct la {{position}}.",
      "sketchShape": "Schiță: {{shape}}, {{count}} puncte, centrată pe {{position}}.",
      "north": "N",
      "south": "S",
      "east": "E",
      "west": "V",
      "download": "Descarcă documentul",
      "keep": "Salvează la tură",
      "kept": "Documentul a fost atașat turei.",
      "documentFailed": "Documentul nu a putut fi generat.",
      "downloadPdf": "Descarcă PDF",
      "pdfNoAnswer": "Serviciul care produce PDF-ul nu a răspuns la timp. Încearcă din nou sau descarcă documentul Word.",
      "pdfRefused": "Serviciul care produce PDF-ul nu a putut așeza în pagină acest raport. Descarcă în schimb documentul Word.",
      "pdfUnavailable": "Această instalare nu mai oferă un PDF al raportului. Descarcă documentul Word sau tipărește în PDF din browser.",
      "template": "Machetă",
      "templateDefault": "Macheta standard",
      "audienceNotice": "Acest raport arată ceea ce poți vedea tu. Altcineva care citește aceeași tură poate vedea mai mult sau mai puțin.",
      "keepAudience": "Copia salvată la tură poate fi deschisă de toți cei care pot citi tura, așa că lasă deoparte ceea ce văd doar cei care pot modifica tura. Copia ta completă este descărcarea.",
      "meetingPoint": "Punct de întâlnire: un punct la {{position}}.",
      "meetingShape": "Punct de întâlnire: {{shape}}, {{count}} puncte, centrat pe {{position}}.",
      "map": {
        "legendSketch": "Unde a lucrat tura (schița ei)",
        "legendMeeting": "Punct de întâlnire",
        "legendCave": "Peșteră numită de tură",
        "background": "Hartă de bază: {{attribution}}",
        "noBackgroundNoneOffered": "Fără hartă de bază: această instalare nu oferă nicio sursă de hartă care poate fi copiată într-un document.",
        "noBackgroundNotDelivered": "Fără hartă de bază: sursa hărții nu a livrat toate dalele.",
        "noBackgroundTimedOut": "Fără hartă de bază: sursa hărții nu a răspuns la timp.",
        "noBackgroundNotCopyable": "Fără hartă de bază: browserul nu a permis copierea dalelor sursei într-o imagine.",
        "withoutBackground": "Harta din document nu are hartă de bază dedesubt. Rândul de sub hartă spune de ce.",
        "notMade": "Documentul a fost descărcat fără hartă: harta nu a putut fi desenată în acest browser.",
        "refused": "Documentul a fost descărcat fără hartă: serverul nu a acceptat imaginea."
      }
    },
    "geometry": "Schița turei",
    "geometryHint": "Alege o formă, apoi desenează pe hartă. O formă nouă o înlocuiește pe cea dinainte.",
    "drawHint": "Fă clic pe hartă pentru a pune puncte — dublu-clic încheie o linie sau o suprafață.",
    "drawPoint": "Punct",
    "drawLine": "Linie",
    "drawArea": "Suprafață",
    "clearGeometry": "Șterge forma",
    "geometryWarning": "Locație exactă — schița unei ture nu este niciodată aproximată.",
    "geometryWarningDetail": "Oricine poate citi această tură vede forma exact așa cum a fost desenată, indiferent de protecția peșterilor pe care le numește. O schiță pusă peste o intrare protejată dezvăluie astfel acea intrare.",
    "roleAdd": "Adaugă",
    "roleShowingFirst": "Se afișează primele {{count}} din {{total}} înregistrări.",
    "rolesTitle": "Ce a făcut tura",
    "roleOther": "Înregistrează altceva",
    "roleNoteEmpty": "Descrie",
    "roleNoteEdit": "Descrie ce a rămas",
    "roles": {
      "trip-work-area": "Zone de lucru",
      "trip-objective": "Obiecte principale",
      "trip-visited": "Vizitate",
      "trip-surveyed": "Cartate",
      "trip-discovered": "Descoperite",
      "trip-dug": "Săpate",
      "trip-photographed": "Fotografiate",
      "trip-searched-not-found": "Căutate, negăsite",
      "trip-lead": "Continuări lăsate",
      "trip-follows-on-from": "Continuă tura"
    },
    "mine": {
      "title": "Turele mele",
      "link": "Turele mele",
      "stateFilter": "Orice stare",
      "empty": "Nu ești încă în nicio tură. O tură apare aici după ce cineva te invită sau te trece în echipă.",
      "emptyFiltered": "Nicio tură de-a ta nu se potrivește cu aceste filtre.",
      "failed": "Turele tale nu au putut fi încărcate."
    },
    "track": {
      "import": "Importă traseul (GPX)",
      "imported": "Traseul înregistrat este acum schița turei.",
      "problems": {
        "file_empty": "Fișierul este gol.",
        "file_too_large": "Fișierul este mai mare decât poate fi traseul unei ture.",
        "format_unsupported": "Un traseu se importă dintr-un fișier GPX.",
        "file_unreadable": "Fișierul nu a putut fi citit ca GPX.",
        "no_track": "Fișierul nu conține niciun traseu — punctele de reper singure nu sunt un traseu.",
        "too_many_points": "Traseul are mai multe puncte decât poate purta schița unei ture; scurtează-l înainte de import."
      }
    },
    "plan": {
      "new": "Planifică o tură",
      "createMenu": "Alte moduri de a crea o tură",
      "audienceFromGroup": "Dacă nu alegi altfel, acest plan este vizibil grupului tău de speologie, {{group}} — un plan pe care îl poate citi doar autorul este un plan pentru nimeni.",
      "audiencePrivate": "Acest plan începe privat: nu ești într-un singur grup de speologie, așa că aplicația nu ghicește care club ar trebui să îl citească. Lărgește audiența aici dacă trebuie citit.",
      "audienceFromChosenGroup": "Dacă nu alegi altfel, acest plan este vizibil grupului de speologie căruia îi aparține — un plan pe care îl poate citi doar autorul este un plan pentru nimeni."
    },
    "owningGroup": {
      "label": "Grupul căruia îi aparține",
      "placeholder": "Alege un grup de speologie",
      "required": "Alege grupul de speologie căruia îi aparține această tură.",
      "only": "Înregistrezi ture pentru {{group}}; aceasta îi va aparține.",
      "several": "Înregistrezi ture pentru grupurile tale de speologie, așa că aceasta trebuie să aparțină unuia dintre ele.",
      "meaning": "Cine din grup o poate citi și corecta este hotărât de regulile grupului, nu de vizibilitatea aleasă aici."
    },
    "expectedReturnAt": "Ieșire estimată",
    "calloutAlarmAt": "Dă alarma la",
    "calloutAlarmHelp": "Dacă nimeni nu confirmă până la ora asta că echipa a ieșit, toți cei din tură sunt anunțați. Nu poate fi mai devreme decât ora la care estimezi ieșirea. Lasă ambele goale dacă nu vrei apel de urgență.",
    "calloutStatus": "Apel de urgență",
    "calloutStateValues": {
      "none": "Neprogramat",
      "armed": "În supraveghere",
      "overdue": "Întârziere",
      "stoodDown": "Echipa a ieșit"
    },
    "calloutLastChecked": "Ultima verificare",
    "calloutNeverChecked": "Niciodată",
    "calloutUncheckedTitle": "Nimic nu a verificat recent acest apel de urgență",
    "calloutUncheckedBody": "Alarma este programată, dar verificarea care ar declanșa-o nu a mai rulat de ceva vreme — deci nimeni nu a confirmat că echipa este în grafic. Tratează situația ca neverificată, nu ca sigură, și încearcă să iei legătura pe altă cale.",
    "calloutOverdueTitle": "Echipa are întârziere",
    "calloutOverdueBody": "A trecut ora alarmei și nimeni nu confirmase că echipa a ieșit. Toți cei din tură au fost anunțați.",
    "calloutStandDown": "Echipa a ieșit",
    "calloutStoodDownSuccess": "Înregistrat — apelul de urgență a fost oprit.",
    "calloutStandDownFailed": "Apelul de urgență nu a putut fi oprit. Încearcă din nou și ia legătura pe altă cale dacă eroarea persistă.",
    "calloutArrange": "Stabilește o alarmă",
    "calloutChange": "Modifică alarma",
    "calloutSaved": "Salvat — alarma este stabilită.",
    "calloutCleared": "Salvat — nu este stabilită nicio alarmă pentru această tură.",
    "calloutSaveFailed": "Alarma nu a putut fi salvată. Încearcă din nou.",
    "calloutAlarmBeforeReturn": "Alarma nu poate fi mai devreme decât ora la care te aștepți să ieși.",
    "meetingGeometry": "Punct de întâlnire",
    "meetingGeometryHint": "Unde se adună echipa și, dacă clubul o desenează, calea de acces spre el. Oricine poate citi această tură află această poziție exact, inclusiv cititorii cărora tura nu le spune ce peșteri numește.",
    "meetingGeometryWarning": "Poziție exactă — locul unde se adună echipa nu este niciodată aproximat.",
    "meetingGeometryWarningDetail": "Oricine poate citi această tură vede această poziție exact așa cum a fost pusă, inclusiv cititorii cărora tura nu le spune ce peșteri numește. Un punct de întâlnire aflat la câteva sute de metri de o intrare protejată arată astfel spre acea intrare.",
    "checklist": "Listă de verificare",
    "tabChecklist": "Listă de verificare",
    "tabTracking": "Urmărire",
    "tracking": {
      "setup": "Configurarea urmăririi",
      "state": "Urmărire",
      "stateValues": {
        "off": "Neurmărită",
        "armed": "În urmărire",
        "closed": "Urmărire încheiată"
      },
      "kinds": {
        "entered": "A intrat",
        "atStation": "La o stație",
        "atDepth": "La o adâncime",
        "note": "Notă",
        "exited": "A ieșit",
        "caveNote": "Despre peșteră"
      },
      "caveNote": {
        "who": "Peștera",
        "hint": "O notă despre peșteră nu este despre nimeni. Nu mută pe nimeni pe model sau în tabel, o poate citi oricine poate citi tura și nu apare niciodată pe o pagină publicată.",
        "words": "Ce este de spus despre peșteră",
        "wordsRequired": "Scrie ce este de spus — o notă despre peșteră înseamnă cuvintele ei.",
        "station": "Stația, dacă este într-un loc anume",
        "stationHelp": "Opțional. Lasă gol pentru ceva despre peșteră în întregul ei. Nimeni nu este așezat la această stație.",
        "record": "Înregistrează nota despre peșteră",
        "recorded": "Nota despre peșteră a fost înregistrată.",
        "placeLabel": "Despre peșteră, la"
      },
      "armedAt": "Urmărire începută",
      "closedAt": "Urmărire încheiată",
      "firstArmedAt": "Începută prima dată",
      "rearmedAt": "Începută din nou",
      "arm": "Pornește urmărirea",
      "rearm": "Pornește urmărirea din nou",
      "close": "Încheie urmărirea",
      "closeConfirm": "Închei urmărirea acestei ture?",
      "closeConfirmBody": "Echipa nu mai este urmărită. Nici o pagină publicată nu o mai urmărește — imediat sau, pe o instalare care păstrează o perioadă de grație după încheiere, când aceasta trece; până atunci pagina spune că tura s-a încheiat. Jurnalul rămâne însă deschis — rapoartele pot fi înregistrate, corectate sau șterse și după aceea, așa că nu trebuie terminat totul înainte.",
      "armedNotice": "Urmărirea este pornită. De acum se pot înregistra rapoarte.",
      "closedNotice": "Urmărirea este încheiată. Ce a fost înregistrat rămâne în jurnal.",
      "surveyModel": "Topografie",
      "surveyModelHelp": "Topografia în care sunt plasate pozițiile echipei. O peșteră a cărei poziție exactă nu îți poate fi comunicată nu oferă nicio topografie aici.",
      "surveyModelPlaceholder": "Alege o topografie",
      "referenceStation": "Adâncimea se măsoară de la",
      "referenceStationHelp": "Stația de la care coboară o adâncime raportată. Lăsat gol, se folosește cea mai înaltă stație de intrare a topografiei, iar în lipsa ei cea mai înaltă stație a ei.",
      "depthFilter": "Unde a spus echipa că merge",
      "depthFilterHelp": "Părțile peșterii în care echipa și-a propus să meargă — începutul unui nume de stație sau de topografie. O adâncime raportată este căutată doar în aceste părți, iar o stație raportată în afara lor este marcată în această filă. Lăsat gol, se caută în toată topografia și nu se marchează nimic.",
      "depthFilterPlaceholder": "Scrie un nume și apasă Enter",
      "configWithheldTitle": "Configurarea urmăririi nu îți este arătată",
      "configWithheldBody": "Pentru această tură pot fi stabilite o topografie, un reper de adâncime și un filtru, într-o peșteră a cărei poziție exactă nu îți poate fi comunicată — așa că nu îți sunt arătate, deși există. Câmpurile rămân închise pentru ca o salvare să nu poată înlocui ceea ce nu ți-a fost arătat. Deschide-le doar ca să stabilești totul din nou: asta înlocuiește topografia și șterge reperul și filtrul față de care au fost rezolvate toate adâncimile aflate deja pe jurnal.",
      "configReplace": "Stabilește din nou oricum",
      "teams": "Echipe",
      "teamsNone": "Nicio echipă pe această tură.",
      "teamAdd": "Adaugă",
      "teamRename": "Redenumește",
      "teamDelete": "Șterge",
      "teamDeleteConfirm": "Ștergi această echipă? Rapoartele pe care le etichetează își păstrează speologul și pierd doar eticheta.",
      "teamTitlePlaceholder": "Cum se numește echipa",
      "report": "Înregistrează un raport",
      "reportKind": "Ce se raportează",
      "reportStation": "Stație",
      "reportStationHelp": "O stație a topografiei alese, scrisă așa cum o scrie topografia.",
      "reportStationRequired": "Spune care stație.",
      "reportStationCorrect": "Topografia poate scrie această stație altfel decât desenul pe care l-ai apăsat. Corecteaz-o aici și înregistrează din nou.",
      "reportToStation": "A doua stație, dacă sunt între două",
      "reportToStationHelp": "Doar când vestea este că sunt undeva între două stații — au trecut de cea de mai sus, nu au ajuns încă la aceasta. Lasă gol pentru un raport la o singură stație.",
      "reportToStationSame": "Aceasta este stația de mai sus. Numește celălalt capăt al porțiunii sau lasă gol.",
      "stretch": "Între {{from}} și {{to}}",
      "reportPlaceLabel": "Se raportează la",
      "reportNoPlace": "Intrarea, ieșirea și o notă nu poartă niciun loc, așa că acest raport nu va spune că cineva este la {{station}}.",
      "reportPlace": "Loc",
      "reportPlaceHelp": "Locurile declarate de această peșteră, de la cel mai puțin adânc. Alegerea unuia raportează adâncimea lui, care ajunge pe stația declarată de peșteră pentru ea.",
      "reportPlacePlaceholder": "Numește locul în loc de o adâncime",
      "reportPlaceOption": "{{place}} — {{depth}} m",
      "reportPlaceOptionUnnamed": "{{station}} — {{depth}} m",
      "reportPlaceOptionMissing": "{{place}} — stația nu este în această topografie",
      "reportPlaceNone": "Această peșteră nu a declarat niciun loc, așa că un loc se raportează ca stație sau ca adâncime.",
      "reportPlaceNoneLink": "Declară-le pe pagina peșterii",
      "reportDepth": "Adâncimea față de reper (m)",
      "reportDepthHelp": "Metri în jos. Semnul nu contează: −120 și 120 înseamnă amândouă 120 de metri în jos.",
      "reportDepthRequired": "Spune ce adâncime.",
      "depthPreview": "Ce stație înseamnă?",
      "depthCandidates": "Stațiile pe care le-ar putea însemna acea adâncime, cea mai apropiată prima:",
      "depthCandidate": "{{depth, number}} m în jos · abatere {{delta, number}} m",
      "depthCandidatesNone": "Nicio stație a topografiei nu corespunde acelei adâncimi sub filtrul acestei ture.",
      "depthCandidateChoose": "Folosește stația",
      "depthGapTitle": "Acea adâncime este la {{gap, number}} m de cea mai apropiată stație",
      "depthGapBody": "Ai scris {{asked, number}} m în jos. Cea mai apropiată stație sub filtrul acestei ture este {{station}}, care se află la {{depth, number}} m în jos — o adâncime se înregistrează întotdeauna la stația cea mai apropiată, oricât de departe ar fi aceasta. Verifică numărul sau întreabă ce stație înseamnă și alege-o pe cea la care te-ai gândit.",
      "depthGapDeclaredTitle": "Această peșteră declară acea adâncime ca {{station}}, pe care topografia o pune la {{gap, number}} m de ea",
      "depthGapDeclaredBody": "Ai scris {{asked, number}} m în jos, iar această peșteră a declarat că acea adâncime înseamnă {{station}}, așa că acolo ajunge raportul. Măsurată de la reperul de adâncime al acestei ture însă, {{station}} se află la {{depth, number}} m în jos. Dacă acolo sunt, înregistrează raportul; dacă nu, verifică numărul sau declarația de la „Ce înseamnă adâncimile acestei peșteri”, pe pagina peșterii.",
      "depthChecking": "Se verifică ce stație înseamnă această adâncime…",
      "depthCheckFailed": "Această adâncime nu a fost verificată față de topografie",
      "depthCheckFailedBody": "Înregistrarea nu este blocată, iar adâncimea va fi trecută tot la cea mai apropiată stație din filtrul acestei ture, oricât de departe ar fi aceasta. Verifică singur numărul înainte de a-l înregistra sau încearcă din nou verificarea.",
      "reportTeam": "Echipă",
      "reportTeamNone": "Fără echipă",
      "reportNote": "Notă",
      "reportActivity": "Activitate",
      "reportActivityHint": "Ce făceau, cu vorbele echipei — echipare, topografie, somn. Opțional.",
      "reportAt": "Când s-a spus",
      "reportAtHelp": "Lăsat gol, raportul este marcat acum. Completează-l pentru un mesaj transmis mai târziu decât a fost spus; o oră din viitor este refuzată.",
      "reportAtHelpAfterClose": "Momentul în care s-a făcut raportul, în timpul turei. O oră din viitor este refuzată.",
      "reportWhenRequired": "Spune când s-a spus. Urmărirea este încheiată, așa că raportul nu poate fi marcat cu ora de acum.",
      "recordAfterCloseTitle": "Urmărirea acestei ture este încheiată — un raport adăugat acum este completat ulterior",
      "recordAfterCloseBody": "Intră în jurnal la momentul pe care îl dai, așa că spune când a fost făcut în timpul turei. Nimic nu este marcat cu ora de acum, nici marcarea cuiva ca ieșit.",
      "reportAtNow": "Acum",
      "reportAtMinutesAgo": "acum {{minutes}} min",
      "reportAtHoursAgo": "acum {{hours}} h",
      "recordFor": "Înregistrează pentru {{count}} selectați",
      "markOut": "Marchează {{count}} ca ieșiți",
      "selectNobody": "Bifează întâi oamenii despre care este raportul — se înregistrează un singur raport pentru toți deodată.",
      "selectEverybody": "Selectează pe toți ({{count}})",
      "silenceFirst": "Cea mai lungă tăcere întâi",
      "recorded": "Înregistrat pentru {{count}}.",
      "outbox": {
        "held": "Serverul nu a răspuns — raportul nu a fost încă trimis. Este păstrat în acest browser și se trimite singur când revine conexiunea.",
        "heldBusy": "Serverul este ocupat și nu a primit raportul — nu a fost încă trimis. Este păstrat în acest browser și se trimite singur puțin mai târziu.",
        "notKept": "Netrimis: serverul nu a răspuns, iar acest browser nu a putut păstra raportul ca să-l trimită mai târziu. Ce ai scris este încă aici — trimite-l din nou când revine conexiunea.",
        "heldSignedOut": "Nu mai ești autentificat — raportul nu a fost încă trimis. Este păstrat în acest browser și se trimite după ce te autentifici din nou: deschide rapoartele în așteptare din bara de sus ca să te autentifici.",
        "lapsedTitle": "Nu mai ești autentificat",
        "lapsedBody": "Aceste rapoarte nu pot fi trimise până nu te autentifici din nou. Autentificarea părăsește această pagină și revine la ea; între timp rapoartele rămân în acest browser și se trimit după ce te întorci.",
        "signInAgain": "Autentifică-te din nou",
        "people": "Persoane: {{count}}",
        "openTrip": "Deschide tura",
        "title": "Rapoarte în așteptare: {{count}}",
        "storedHere": "Aceste rapoarte nu au primit răspuns de la server. Textul lor este păstrat în acest browser, doar pentru acest cont, până când fiecare este trimis sau aruncat — se trimit singure când revine conexiunea.",
        "show": "Arată-le",
        "sendNow": "Trimite acum",
        "sendAgain": "Trimite din nou",
        "discard": "Aruncă",
        "discardConfirm": "Arunci acest raport?",
        "discardConfirmDetail": "Copia păstrată în acest browser se șterge și nu mai este trimisă. Este posibil ca raportul să fi ajuns deja la server — o trimitere rămasă fără răspuns poate să fi fost totuși scrisă — așa că uită-te apoi în jurnalul turei și șterge raportul de acolo dacă apare.",
        "discarded": "Raport aruncat: copia din acest browser a fost ștearsă și nu mai este trimisă. Dacă apare în jurnalul turei, ajunsese deja la server — șterge-l de acolo.",
        "refused": "Refuzat: {{reason}}",
        "refusedNoReason": "serverul a refuzat acest raport fără un motiv pe care pagina să-l poată spune în cuvinte.",
        "sent": "Rapoarte în așteptare trimise: {{count}}.",
        "alreadyRemoved": "Rapoarte în așteptare pe care serverul le avea deja și care au fost scoase din jurnal între timp: {{count}}. Nu s-a mai scris nimic.",
        "refusedSome": "Rapoarte în așteptare refuzate de server: {{count}}. Rămân păstrate în acest browser — deschide rapoartele în așteptare din bara de sus ca să le trimiți din nou sau să le arunci.",
        "stillNoAnswer": "Serverul tot nu răspunde. Rapoartele rămân în așteptare.",
        "signedOut": "Nu mai ești autentificat, așa că rapoartele în așteptare nu pot fi trimise. Rămân în acest browser și se trimit după ce te autentifici din nou — deschide rapoartele în așteptare din bara de sus ca să te autentifici.",
        "serverBusy": "Serverul nu poate primi rapoarte chiar acum. Rămân în așteptare — încearcă din nou peste câteva minute.",
        "everywhere": "Rapoarte în așteptare: {{count}} — păstrate în acest browser până sunt trimise. Arată-le."
      },
      "notArmedTitle": "Urmărirea nu a fost pornită pentru această tură",
      "notArmedBody": "Un raport numește un loc pe o topografie, iar o urmărire care nu a fost pornită niciodată nu are pe ce topografie să-l așeze. Pornește urmărirea mai sus: tot ce se raportează de atunci rămâne în jurnal, iar jurnalul poate fi completat și după ce urmărirea este încheiată.",
      "participantsNone": "Nimeni nu este încă pe lista acestei ture.",
      "columnCaver": "Speolog",
      "columnTeam": "Echipă",
      "columnLastKind": "Ultimul raport",
      "columnLastRecordedAt": "Când",
      "columnLastHeard": "Ultima veste",
      "neverHeard": "Nicio veste",
      "columnPosition": "Unde",
      "positionSince": "Raportată {{since}}",
      "positionAsked": "Raportat ca {{depth, number}} m în jos",
      "positionGap": "la {{gap, number}} m de adâncimea raportată",
      "positionGapDetail": "Raportul a spus {{asked, number}} m în jos. A fost înregistrat la {{station}}, care se află la {{depth, number}} m în jos — la {{gap, number}} m distanță. O adâncime se înregistrează la cea mai apropiată stație din filtrul turei, fără nicio toleranță, așa că o adâncime scrisă greșit ajunge tot undeva.",
      "positionGapDetailDeclared": "Raportul a spus {{asked, number}} m în jos, o adâncime pe care această peșteră o declară ca {{station}}, așa că acolo a fost înregistrat. Măsurată de la reperul de adâncime al turei, {{station}} se află la {{depth, number}} m în jos — la {{gap, number}} m distanță. Declarația l-a plasat acolo, nu stația cea mai apropiată, așa că dacă locul este greșit, declarația este cea de verificat.",
      "columnNote": "Notă",
      "columnActivity": "Activitate",
      "positionWithheld": "Nu îți este arătată",
      "positionWithheldDetail": "Această poziție există și nu îți poate fi comunicată — peștera în care este măsurată are o poziție exactă care nu îți poate fi dată. Este marcată, nu lăsată goală, pentru că un gol s-ar citi ca și cum nimeni nu ar ști unde se află acest speolog.",
      "positionMaybeWithheld": "Nu este arătată sau nu a fost raportată",
      "positionMaybeWithheldDetail": "Ultimul raport al acestui speolog nu a purtat niciun loc — intrarea, ieșirea și o notă nu poartă niciodată unul. Deci ori nimeni nu a raportat unde se află, ori a fost raportată o poziție care nu îți poate fi comunicată. Această pagină nu le poate deosebi și nu pretinde niciuna.",
      "modelMissingTag": "Topografie ștearsă",
      "modelMissingTitle": "Topografia pe care este armată această urmărire a fost ștearsă",
      "modelMissingBody": "Urmărirea este în continuare armată și primește în continuare intrări, ieșiri și note, dar nimeni nu poate fi plasat: modelul topo pe care a fost armată nu mai există pe acest server. Alege altă topografie pentru această tură ca să poți plasa iar oameni. Rapoartele deja din jurnal păstrează topografia față de care au fost făcute și nu sunt mutate.",
      "scopeTitle": "Urmărirea înregistrează rapoarte; nu dă alarma",
      "scopeBodyWithCallout": "Aici se ține evidența locului în care a fost raportat ultima dată fiecare om, pe măsură ce ajunge vestea. Nu se uită la ceas: dacă echipa nu iese, nimic de aici nu observă și nimeni nu este anunțat. Apelul de urgență stabilit pentru această tură, mai sus în pagină, este lucrul separat care ține ora alarmei și dă alarma când aceasta trece.",
      "scopeBodyNoCallout": "Aici se ține evidența locului în care a fost raportat ultima dată fiecare om, pe măsură ce ajunge vestea. Nu se uită la ceas: dacă echipa nu iese, nimic de aici nu observă și nimeni nu este anunțat. Pentru această tură nu este stabilit niciun apel de urgență — apelul de urgență este aranjamentul separat care ține ora alarmei și dă alarma când aceasta trece, iar el se stabilește pe tură, nu aici.",
      "scopeAtArming": "Pornirea urmăririi nu stabilește un apel de urgență, iar această tură nu are niciunul. Dacă cineva trebuie anunțat când echipa întârzie, stabilește și un apel de urgență pentru această tură.",
      "scopeAtArmingWithCallout": "Pornirea urmăririi nu schimbă apelul de urgență deja stabilit pentru această tură. Urmărirea înregistrează unde au fost raportați oamenii; apelul de urgență este cel care dă alarma.",
      "modelObstacleTag": {
        "notALinePlot": "Fără stații: doar pereți",
        "stillReading": "Încă fără stații",
        "importFailed": "Fără stații: import eșuat"
      },
      "modelObstacleTitle": {
        "notALinePlot": "Nimeni nu poate fi plasat pe un fișier cu pereții peșterii",
        "stillReading": "Deocamdată nu poate fi plasat nimeni — topografia este încă în curs de citire",
        "importFailed": "Nimeni nu poate fi plasat pe această topografie"
      },
      "modelObstacleBody": {
        "notALinePlot": "Topografia pe care merge această urmărire este un fișier cu pereții peșterii. Nu conține nicio stație — un fișier de pereți este transformat într-o imagine și nu produce niciodată stații, așa că un nou import nu schimbă nimic. Un loc raportat este numele unei stații, așa că niciun raport nu poate revendica unul aici și nimeni nu va apărea pe desen. Alege mai sus o topografie care este model de drumuire. Intrările, ieșirile și notele se înregistrează în continuare ca de obicei.",
        "stillReading": "Topografia pe care merge această urmărire este încă în curs de citire, așa că deocamdată nu conține stații și nimeni nu poate fi plasat pe ea. Un loc raportat este numele unei stații. Nu trebuie făcut nimic: când citirea se termină, locurile pot fi raportate ca de obicei. Intrările, ieșirile și notele se înregistrează între timp.",
        "importFailed": "Topografia pe care merge această urmărire nu conține nicio stație — importul ei nu a reușit. Un loc raportat este numele unei stații, așa că niciun raport nu poate revendica unul aici și nimeni nu va apărea pe desen. Importă din nou topografia din pagina peșterii sau alege altă topografie mai sus. Intrările, ieșirile și notele se înregistrează în continuare ca de obicei."
      },
      "modelObstacleOption": {
        "notALinePlot": "pereți de peșteră, fără stații",
        "stillReading": "încă în curs de citire",
        "importFailed": "importul nu a reușit"
      },
      "modelNothingToDrawTitle": "Nu există niciun desen de arătat",
      "modelNothingToDrawBody": "Topografia pe care merge această urmărire nu conține nicio stație, așa că nu este nimic de desenat și nimeni nu poate fi plasat pe ea. Ce se poate face scrie în configurarea urmăririi, în partea de sus a acestei file. Intrările, ieșirile și notele nu sunt afectate.",
      "noCaveNamedTitle": "Această tură nu spune în ce peșteră este",
      "noCaveNamedBody": "O urmărire pune oamenii la stații dintr-o topografie, iar o topografie aparține unei peșteri — așa că până când această tură nu numește una, nu este nimic de ales aici, oricâte topografii ar avea peștera însăși. Numește peștera în detaliile acestei ture, deasupra acestei file, iar topografiile ei apar în listă.",
      "noSurveyUploadedTitle": "Această peșteră nu are nicio topografie încărcată",
      "noSurveyUploadedBody": "Un loc raportat este numele unei stații, iar stațiile vin dintr-un fișier de topografie. Pentru această peșteră nu s-a încărcat încă nimic, deci nu există pe ce să fie plasat cineva. Încarcă un model de drumuire — un .lox Therion sau un .3d Survex — din pagina peșterii, iar el apare în lista de aici după ce este citit.",
      "surveysUnreadTitle": "Topografiile acestei peșteri nu au putut fi citite",
      "surveysUnreadBody": "Lista topografiilor nu a venit înapoi, așa că nu se poate spune dacă peștera are vreuna. Încearcă din nou; dacă eșuează în continuare, serverul este locul de verificat, nu pagina peșterii.",
      "surveysWithheldTitle": "Topografiile acestei peșteri nu îți sunt arătate",
      "surveysWithheldBody": "O topografie este un desen măsurat al peșterii, așa că este ținută departe de oricine nu poate afla poziția ei exactă — inclusiv de tine, pentru această peșteră. Poate avea topografii; configurarea urmăririi pe una dintre ele îi revine cuiva care le poate vedea.",
      "noPlaceableModelTitle": "Nicio topografie a acestei peșteri nu poate fi folosită aici",
      "noPlaceableModelBody": "Un loc raportat este numele unei stații, iar niciuna dintre topografiile încărcate pentru această peșteră nu conține stații: fiecare este fie un fișier cu pereții peșterii, care nu are stații, fie un fișier al cărui import nu a reușit. Importă din nou una din pagina peșterii, apoi alege-o aici.",
      "noPlaceableModelStillReadingTitle": "Topografiile acestei peșteri sunt încă în curs de citire",
      "noPlaceableModelStillReadingBody": "Un loc raportat este numele unei stații, iar o topografie nu conține stații până nu este citită în întregime. Cel puțin una dintre topografiile acestei peșteri este încă în curs de citire; va apărea în lista de aici imediat ce se termină. Între timp nu trebuie făcut nimic.",
      "positionsOnOtherModelTitle": "Unele locuri au fost raportate pe altă topografie",
      "positionsOnOtherModelBody": "Această urmărire folosește acum alt model topo decât cel față de care au fost făcute acele rapoarte. Un nume de stație înseamnă ceea ce spune topografia în care a fost măsurat, așa că acele locuri nu se desenează pe topografia în uz — sunt marcate ca raportate pe altă topografie, nu mutate pe ea. Raportează din nou un loc ca să pui pe cineva pe topografia folosită acum.",
      "positionOtherModel": "Pe altă topografie",
      "positionOtherModelDetail": "Acest loc a fost raportat față de alt model topo decât cel folosit acum de această urmărire — fie urmărirea a fost îndreptată în altă parte, fie topografia în care a fost măsurat a fost ștearsă. Un nume de stație înseamnă ceea ce spune topografia în care a fost măsurat, așa că aceasta este o consemnare adevărată a ceea ce s-a raportat, nu locul unde se află acest speolog pe topografia în vigoare. Raportează din nou un loc ca să îl pui pe ea.",
      "eventOtherModelDetail": "Acest loc a fost raportat față de altă topografie decât cea folosită acum de această urmărire — fie urmărirea a fost îndreptată spre altă topografie după acest raport, fie topografia în care a fost măsurat a fost ștearsă. Este o consemnare adevărată a ceea ce s-a raportat atunci; același nume de stație poate însemna alt loc pe topografia în vigoare. Dacă topografia aceea mai există, alege-o pe model, mai jos, ca să vezi raportul acolo unde a fost făcut.",
      "viewOnLabel": "Vezi rapoartele pe",
      "viewOnWatch": "{{name}} — topografia acestei urmăriri",
      "viewOnOther": "{{name}} — adăugată la {{date}}",
      "viewOnReadOnlyTitle": "Se arată rapoartele înregistrate pe {{name}}",
      "viewOnReadOnlyBody": "Aceasta este o altă topografie pe care s-au făcut rapoarte ale acestei ture, arătată doar pentru consultare. Cât timp este pe ecran nu se poate înregistra nimic — un raport este măsurat întotdeauna față de topografia folosită de această urmărire. Alege {{watch}} ca să înregistrezi din nou.",
      "positionNotOnModel": "Nu e pe desen",
      "positionNotOnModelDetail": "Acest loc a fost raportat față de topografia folosită de această urmărire, iar desenul ei deschis mai jos nu are nicio stație cu acel nume — deci nimeni nu poate fi marcat acolo, iar modelul nu îl arată nicăieri pe acest speolog. O topografie reexportată cu stațiile redenumite face asta fiecărui loc raportat înainte, sub aceeași topografie, fără ca nimeni să fi schimbat urmărirea. Ceea ce s-a raportat rămâne adevărat; locul de pe desen nu. Raportează din nou un loc ca să îl pui înapoi pe el.",
      "modelSwapClearsDatumTitle": "Salvarea va șterge reperul de adâncime și filtrul de stații",
      "modelSwapClearsDatumBody": "Amândouă numesc stații ale topografiei folosite acum, iar acele nume nu înseamnă nimic — sau înseamnă altceva — în altă topografie, așa că nu sunt duse mai departe. Până când se stabilește din nou o stație de referință, un raport de adâncime va fi refuzat: stabilește-o pe noua topografie imediat după salvare sau scrie una în câmpul de mai jos și salvează-le împreună. Locurile deja raportate păstrează topografia față de care au fost măsurate.",
      "modelSwapClearedDatumNotice": "Reperul de adâncime și filtrul de stații au fost șterse odată cu topografia. Stabilește o stație de referință pe noua topografie înainte de a raporta o adâncime.",
      "positionsWithheldTitle": "Unele poziții nu îți sunt arătate",
      "positionsWithheldBody": "Această tură este urmărită într-o peșteră a cărei poziție exactă nu îți poate fi comunicată, așa că numele stațiilor și adâncimile nu apar pe această pagină. Cine este înăuntru și cine a ieșit se vede așa cum stau lucrurile.",
      "standing": {
        "underground": "În peșteră",
        "out": "Ieșit",
        "unheard": "Fără nicio veste"
      },
      "unknownCaver": "Cineva care nu este pe listă",
      "notOnRoster": "Nu mai este pe listă",
      "outsideDeclaredParts": "În afara părților declarate",
      "outsideDeclaredPartsHelp": "Această stație nu se află în părțile peșterii în care echipa a spus că merge. Este un semn pentru cine citește această filă: nu se trimite nimic și nu se dă nicio alarmă.",
      "declaredOnly": "Arată doar părțile declarate",
      "declaredOnlyHelp": "Scoate din desen fiecare topografie în care nu se află nimic din ce a spus echipa că parcurge. Marcajele rămân.",
      "declaredOnlyHidden": "Topografii din afara părților declarate, ascunse: {{surveys}}. Cine este raportat acolo își păstrează marcajul, desenat fără galeria din jur.",
      "declaredOnlyNothing": "Toate topografiile acestui desen sunt în părțile declarate.",
      "declaredOnlyUnmatched": "Acest desen nu are nicio topografie numită: {{entries}}. Nu poate fi restrâns la părțile declarate.",
      "declaredOnlyWaiting": "Disponibil după încărcarea modelului.",
      "personActions": "Mai multe pentru {{name}}",
      "notOnRosterDetail": "A fost scos de pe lista turei după ce s-au înregistrat rapoarte despre el. Rapoartele rămân în jurnal; nu se mai poate înregistra nimic pentru el, iar o pagină publică nu îl arată.",
      "quiet": {
        "tagHours": "Nicio veste de peste {{amount}} h",
        "tagMinutes": "Nicio veste de peste {{amount}} min",
        "countHours": "Nicio veste de peste {{amount}} h: {{people}}",
        "countMinutes": "Nicio veste de peste {{amount}} min: {{people}}"
      },
      "plan": {
        "label": "Ieșire plănuită până la",
        "lateHours": "întârziere de {{amount}} h",
        "lateMinutes": "întârziere de {{amount}} min"
      },
      "marksNote": "Semnele pentru o tăcere lungă și pentru o întoarcere întârziată sunt pentru cine are această pagină deschisă. Nu se trimite nimic, nu se dă nicio alarmă și niciuna nu este oprită.",
      "modelTitle": "Echipa pe topografie",
      "modelShow": "Arată modelul",
      "modelHide": "Ascunde modelul",
      "modelHint": "Deschide {{name}} și marchează fiecare speolog acolo unde a fost raportat ultima dată. Cine nu are o poziție cunoscută sau nu îți este arătată apare totuși pe listă, nu este omis.",
      "modelLarger": "Model mai mare",
      "modelSmaller": "Model mai mic",
      "recordHere": "Înregistrează aici",
      "recordHereTitle": "Înregistrează un raport",
      "reportWho": "Despre cine este",
      "reportWhoPlaceholder": "Alege speologii",
      "reportWhoRequired": "Spune despre cine este acest raport.",
      "replay": {
        "open": "Reia tura",
        "leave": "Înapoi la direct",
        "reading": "Se citește tot jurnalul…",
        "logUnavailable": "Jurnalul nu a putut fi citit",
        "logUnavailableBody": "O reluare se construiește din toate rapoartele din jurnal, iar citirea nu s-a încheiat. Nu se reia nimic peste o parte de jurnal: rapoartele sosesc începând cu cel mai nou, așa că o reluare peste ce a venit ar începe cu echipa deja în peșteră, în locuri spre care nimic nu spune că a mers — și ar anima asta la fel de convingător ca orice altceva.",
        "nothingToReplay": "Nu este nimic de reluat: urmărirea acestei ture nu acoperă niciun interval de timp.",
        "play": "Redă",
        "pause": "Pauză",
        "speed": "{{value}}×",
        "scrub": "Momentul din tură",
        "note": "{{when}} · {{who}}: {{note}}",
        "caveNote": "{{when}} · Despre peșteră: {{note}}",
        "caveNoteAt": "{{when}} · Despre peșteră, la {{station}}: {{note}}",
        "noteNone": "Până în acest moment nu s-a spus nimic în cuvinte.",
        "notePrevious": "Nota anterioară",
        "noteNext": "Nota următoare"
      },
      "pictures": {
        "title": "Fotografii de la acest moment",
        "hint": "Fotografiile aparțin unui moment al turei, nu unui raport, așa că o corectură pe loc a unui raport, sau ștergerea unuia, nu ia niciodată fotografia cu ea. Momentul se ia din fișierul fiecărei poze, acolo unde acesta îl spune.",
        "attach": "Atașează fotografii ({{count}})",
        "attachHere": "Fotografie aici",
        "attached": "Atașate: {{count}}. Neatașate: {{refused}}.",
        "attachFailed": "Fotografiile nu au putut fi atașate.",
        "subject": "Despre",
        "subjectNobody": "Nimeni anume",
        "subjectHint": "O fotografie despre o persoană se desenează acolo unde era acea persoană în acel moment. Una despre nimeni anume apare pe cronologie și nu se plasează nicăieri — o echipă care s-a împărțit este în două locuri, iar o presupunere ar pune fotografia unde nu a fost nimeni.",
        "clockOffset": "Ceasul aparatului era înainte cu",
        "clockOffsetUnit": "minute (negativ dacă era în urmă)",
        "takenAt": "făcută {{at, datetime(dateStyle: short; timeStyle: short)}}",
        "noTakenAt": "fișierul nu spune ora",
        "none": "Tura nu are încă fotografii. Adaugă-le mai întâi în galeria turei.",
        "guessedTitle": "Fotografii al căror fișier nu spune când au fost făcute: {{count}}",
        "guessedBody": "Vor fi puse la acest moment, care este o presupunere, nu o citire — verifică-l înainte de a atașa.",
        "fallbackMoment": "Momentul pentru fotografiile fără oră proprie",
        "thumbnailAlt": "Fotografie de la acest moment",
        "panelTitle": "Fotografiile momentelor acestei ture",
        "panelHint": "Fiecare este pusă la momentul în care a fost făcută, nu la un raport — așa că o corectură pe loc a unui raport, sau ștergerea unuia, nu ia niciodată fotografia cu ea. Modelul topo nu este necesar nici pentru a le adăuga, nici pentru a le vedea.",
        "panelNone": "Încă nu a fost pusă nicio fotografie pe momentele acestei ture.",
        "panelAdd": "Adaugă fotografii",
        "panelUnavailable": "Fotografiile turei nu au putut fi citite. Asta nu spune nimic despre existența lor.",
        "aboutParty": "Despre echipă",
        "aboutCaver": "Despre {{name}}",
        "attachAtReport": "Fotografie la acest moment",
        "detach": "Scoate fotografia de pe tură",
        "detachConfirm": "Scoți fotografia de la acest moment? Fotografia rămâne în galeria turei.",
        "strayTitle": "Fotografii al căror fișier le pune mult în afara acestei ture: {{count}}",
        "strayBody": "Prima dintre ele spune {{at, datetime(dateStyle: short; timeStyle: short)}}, ceea ce înseamnă de obicei un ceas de aparat nesetat niciodată. Vor fi atașate la momentele afișate — corectează decalajul ceasului de mai sus dacă nu este așa.",
        "detached": "Fotografia a fost scoasă de la acel moment.",
        "detachFailed": "Fotografia nu a putut fi scoasă de la acel moment.",
        "subjectApplyAll": "Alegerea de aici se aplică tuturor fotografiilor alese; una care este despre altcineva se schimbă în lista de mai jos.",
        "previewTitle": "Unde va fi desenată fiecare",
        "previewHint": "Citit din rapoartele turei la momentul fiecărei fotografii, pe topografia pe care merge această urmărire. Urmează corecția ceasului și persoana aleasă.",
        "filedAt": "{{at, datetime(dateStyle: short; timeStyle: medium)}}",
        "rowSubject": "Despre cine este {{title}}",
        "willDrawAt": "Desenată la stația {{station}}",
        "onOtherSurvey": "Atunci era plasat(ă) pe altă topografie — doar pe cronologie",
        "placeWithheld": "Locul din acel moment nu îți este arătat — doar pe cronologie",
        "noPlaceThen": "Până atunci nu fusese raportată nicio stație pentru această persoană — doar pe cronologie",
        "noSurvey": "Tura nu are o topografie pe care să o poți vedea desenată — doar pe cronologie",
        "timelineOnly": "Doar pe cronologie — numește pe cineva ca să fie plasată",
        "placeReading": "Se citesc rapoartele turei…",
        "placeUnread": "Rapoartele turei nu au putut fi citite, așa că nu se știe unde va fi desenată. Poate fi atașată oricum."
      },
      "events": "Rapoarte",
      "eventsCorrection": "Un raport notat greșit se corectează pe loc — își păstrează locul în jurnal și tot ce e prins de el. Unul care nu ar trebui să existe deloc se șterge și poate fi pus înapoi din Rapoarte scoase, sub jurnal. Oricum, în jurnal rămâne ce a spus cineva la un moment dat.",
      "logReadOnlyTitle": "Aceste poziții vin dintr-un import și nu pot fi corectate una câte una",
      "logReadOnlyBody": "Urmărirea nu a fost pornită niciodată pentru această tură, așa că un raport din jurnalul ei nu poate fi nici corectat, nici șters aici. Pozițiile au fost puse pe tură prin importul unei înregistrări și se retrag, toate odată, anulând acel import din Geodate → Importuri.",
      "eventsNone": "Nu s-a raportat nimic încă.",
      "eventsNoneForCaver": "Nu s-a raportat nimic despre această persoană.",
      "eventsFilterCaver": "Restrânge jurnalul la o singură persoană",
      "eventsFilterEverybody": "Rapoartele tuturor",
      "eventsOlder": "Arată rapoartele mai vechi",
      "eventsNewer": "Arată rapoartele mai noi",
      "eventsShown": "Rapoarte afișate: {{from}}–{{to}} din {{total}}",
      "eventCorrectedMark": "Corectat",
      "eventCorrectedMarkHelp": "Acest raport a fost modificat după ce a fost notat prima dată.",
      "eventsUnavailable": "Rapoartele nu au putut fi citite. Ce se vede aici poate fi depășit și pot lipsi rapoarte din listă.",
      "eventDelete": "Șterge acest raport",
      "eventDeleteConfirm": "Ștergi acest raport? Iese din jurnal și se păstrează la Rapoarte scoase, sub jurnal, de unde poate fi pus înapoi. Un raport doar notat greșit se corectează în loc să fie șters, cu Corectează de lângă el.",
      "eventCorrected": "Raportul a fost corectat.",
      "eventEditTitle": "Corectează acest raport",
      "eventEditAbout": "Corectează raportul despre {{name}} din {{when}}",
      "eventEditBeforeArmedTitle": "Acest moment este înainte de pornirea urmăririi",
      "eventEditBeforeArmedBody": "Urmărirea a fost pornită la {{armed}}. Un raport dinaintea ei se salvează așa cum este scris — verifică mai întâi ziua și ora.",
      "eventEditSave": "Salvează corectura",
      "eventEditNoticeTitle": "Asta schimbă ce spune jurnalul că s-a întâmplat",
      "eventEditNoticeBody": "Raportul își păstrează locul în jurnal și tot ce este legat de el, iar reluarea, pagina publicată și orice altceva desenat din jurnal urmează corectura. Folosește asta când un raport a fost notat greșit; când nu ar trebui să existe deloc, șterge-l.",
      "eventEdit": "Corectează",
      "eventDeleted": "Raportul a fost scos din jurnal.",
      "eventDeleteUndo": "Anulează",
      "eventRestored": "Raportul este din nou în jurnal, așa cum era.",
      "removeReportsOf": {
        "action": "Șterge rapoartele ei din această tură",
        "actionCounted": "Șterge rapoartele ei din această tură: {{count}}",
        "confirmTitle": "Ștergi definitiv toate rapoartele despre {{name}} din această tură?",
        "confirmTitleCounted": "Ștergi definitiv toate rapoartele despre {{name}} din această tură? Rapoarte: {{count}}",
        "confirmBody": "Se distrug toate rapoartele pe care jurnalul de urmărire al acestei ture le are despre această persoană — cele din jurnal și cele deja scoase din el și păstrate. Acțiunea nu poate fi anulată și nu rămâne nimic de pus înapoi. Reluarea acestei ture și orice pagină publicată a ei se vor schimba. Ce rămâne: numele persoanei pe lista turei, până când tura este editată; și istoricul turei, care consemnează că rapoartele au fost șterse și păstrează ce spunea fiecare.",
        "confirmOk": "Șterge definitiv",
        "done": "Rapoarte șterse definitiv: {{count}}",
        "failed": "Rapoartele nu au putut fi șterse."
      },
      "rosterTimes": {
        "open": "Ore pe listă din jurnal",
        "openHint": "Ia ora de intrare și ora de ieșire a fiecărei persoane din acest jurnal și trece-le pe lista turei — după ce le-ai privit.",
        "title": "Orele de intrare și de ieșire din jurnalul de urmărire",
        "intro": "Jurnalul are momentul în care s-a raportat că fiecare persoană a intrat și a ieșit. Bifează persoanele ale căror ore de pe lista turei să devină acestea. Nu se scrie nimic până nu apeși butonul; fiecare oră scrisă este consemnată în istoricul turei.",
        "zone": "Fusul orar al orelor de pe listă",
        "zoneMine": "Fusul meu orar — {{zone}}",
        "zoneHelp": "O oră de pe listă este ce arăta un ceas, fără fus orar al ei. Alege fusul în care sunt ținute orele turei — de obicei cel în care se află peștera.",
        "zoneApplied": "Citite după ceasurile din {{zone}}.",
        "person": "Persoană",
        "fromLog": "Din jurnal",
        "onRoster": "Pe listă acum",
        "take": "Ia",
        "takeOf": "Ia orele pentru {{name}}",
        "none": "Niciuna proprie — rămân orele turei",
        "same": "Deja aceleași",
        "overwrites": "Înlocuiește o oră scrisă de cineva",
        "stays": "A intrat de mai multe ori (șederi: {{count}}). Lista păstrează prima intrare și ultima ieșire, așa că timpul petrecut la suprafață între ele este numărat.",
        "problem": {
          "notOnRoster": "Nu este pe listă, așa că nu există un rând care să țină o oră. Adaugă întâi persoana în formularul turei.",
          "noEntry": "Niciun raport nu spune că a intrat.",
          "noExit": "Niciun raport nu spune că a ieșit.",
          "exitBeforeEntry": "În jurnal iese înainte să fi intrat.",
          "entryOffTripDate": "A intrat într-o zi care nu este prima a turei, iar o oră de pe listă nu are o zi a ei.",
          "exitOffTripDate": "A ieșit într-o zi la care datele turei nu ajung. Corectează întâi datele turei.",
          "clockChanged": "Ora s-a schimbat cât timp a fost sub pământ, așa că cele două ore ar spune cu o oră mai mult sau mai puțin decât a trecut de fapt. Scrie-le de mână dacă sunt dorite."
        },
        "write": "Scrie pe listă: {{count}}",
        "written": "Ore scrise pe listă. Persoane: {{count}}",
        "nothingWritten": "Lista avea deja aceste ore; nu s-a scris nimic.",
        "failed": "Orele nu au putut fi scrise.",
        "unavailable": "Orele nu au putut fi citite."
      },
      "removed": {
        "title": "Rapoarte scoase: {{count}}",
        "help": "Rapoarte scoase din acest jurnal. Nu apar nicăieri altundeva — nici în tabelul echipei, nici pe topografie, nici într-o reluare sau pe o pagină publicată — și se păstrează cât timp există tura. Un raport pus înapoi revine exact cum era, cu locul și momentul lui. Unul șters definitiv nu mai poate fi adus înapoi.",
        "removedAt": "Scos din jurnal: {{when}}",
        "restore": "Pune înapoi",
        "destroy": "Șterge definitiv",
        "destroyConfirm": "Ștergi definitiv acest raport? Acțiunea nu poate fi anulată: nimic nu mai aduce raportul înapoi.",
        "destroyed": "Raportul a fost șters definitiv.",
        "unavailable": "Rapoartele scoase nu au putut fi citite. Ce se vede aici poate fi depășit."
      },
      "unavailable": "Urmărirea acestei ture nu a putut fi citită.",
      "staleTitle": "Urmărirea nu se mai împrospătează",
      "staleBody": "Tura nu a putut fi recitită acum — se poate să fi căzut conexiunea. Tot ce este mai jos este ultima veste primită de această filă, iar împrospătarea începe din nou singură de îndată ce se poate. Nimic din ce ai selectat sau scris nu s-a pierdut.",
      "problems": {
        "notWritable": "Urmărirea nu a fost pornită niciodată pentru această tură, așa că jurnalul ei nu poate fi modificat. Pornește-o întâi; o tură a cărei urmărire a fost încheiată poate fi în continuare corectată.",
        "notConfigured": "Această tură nu are nicio urmărire pe care să fie importate rapoarte. Alege o topografie și salvează configurarea urmăririi întâi; foaia poate fi citită din nou imediat după.",
        "csvZoneUnknown": "Serverul nu cunoaște acest fus orar, așa că foaia nu a fost citită. Alege la Setări fișier alt nume pentru același ceas — de obicei un oraș apropiat din aceeași țară.",
        "csvPlanChanged": "Nu s-a importat nimic. Tura sau jurnalul ei s-au schimbat după ce foaia a fost citită — un raport introdus de altcineva, o echipă sau un participant modificat, un loc declarat în peșteră — așa că importul nu ar mai fi făcut ce arăta tabelul. Foaia a fost citită din nou: verifică rândurile, bifează din nou suprascrierea dacă mai este dorită și apasă Importă.",
        "csvSheetUnreadable": "Foaia nu poate fi citită așa cum este, deci nu s-a importat nimic. Citește-o din nou aici: observațiile de deasupra tabelului spun ce trebuie schimbat.",
        "stateInvalid": "Urmărirea nu poate trece astfel. Citește pagina din nou și vezi unde a ajuns.",
        "modelMissing": "Urmărirea are nevoie de o topografie în care să plaseze oamenii. Alege una întâi.",
        "modelUnavailable": "Acea topografie nu poate fi folosită aici — nu mai există sau peștera ei are o poziție exactă care nu îți poate fi comunicată.",
        "modelOtherCave": "Acea topografie aparține altei peșteri. O urmărire armată însoțește o echipă dintr-o singură peșteră, iar peștera ei este și cea care protejează fiecare poziție din jurnal, așa că poate fi mutată doar pe altă topografie a aceleiași peșteri. Încheie mai întâi urmărirea dacă tura chiar este în altă parte.",
        "referenceUnknown": "Topografia nu are nicio stație cu acel nume de la care să se măsoare adâncimile.",
        "stationUnknown": "Topografia nu are nicio stație cu acel nume.",
        "toStationUnknown": "Topografia nu are nicio stație cu numele dat pentru a doua stație, capătul îndepărtat al porțiunii.",
        "stretchSameStation": "Ambele capete ale porțiunii sunt aceeași stație. Alege o altă a doua stație sau raportează la acea singură stație.",
        "reportSubjectFixed": "Un raport despre o persoană nu poate fi transformat într-o notă despre peșteră, nici o notă despre peșteră într-un raport despre o persoană. Scoate-l pe acesta din jurnal și înregistrează-l pe celălalt.",
        "stationReadingOutdated": "Stația aceasta nu are nume în fișierul topografiei, iar topografia a fost citită înainte ca astfel de stații să poată fi raportate. Citește din nou topografia — „Citește din nou”, la „Modele topo 3D” pe pagina peșterii — și apoi raportează aici.",
        "noStationAtDepth": "Nicio stație nu corespunde acelei adâncimi sub filtrul acestei ture. Lărgește filtrul sau raportează o stație pe nume.",
        "caverNotParticipant": "Toți cei despre care este un raport trebuie să fie mai întâi pe lista turei.",
        "recordedInFuture": "Un raport nu poate fi despre viitor. Verifică ora de pe el.",
        "teamNotFound": "Acea echipă nu mai este pe această tură.",
        "eventNotFound": "Acel raport nu mai este în jurnal — s-ar putea să îl fi scos altcineva.",
        "eventNotRemoved": "Acel raport este din nou în jurnal — l-a pus cineva înapoi. Scoate-l mai întâi, apoi șterge-l definitiv.",
        "noReportsOfPerson": "Această tură nu mai are niciun raport despre acea persoană — s-ar putea să le fi șters altcineva.",
        "rosterTimesZoneUnknown": "Serverul nu cunoaște acest fus orar, așa că nu a fost citită nicio oră. Alege alt nume pentru același ceas — de obicei un oraș apropiat din aceeași țară.",
        "rosterTimesChanged": "Nu s-a scris nimic. Jurnalul sau lista s-au schimbat după ce au fost citite aceste ore — un raport corectat, scos sau adăugat, o persoană scoasă din tură. Orele au fost citite din nou: privește-le, bifează din nou și apasă încă o dată.",
        "concurrentWrite": "Altcineva a scris în această urmărire în același moment. Pagina a fost citită din nou; mai încearcă o dată.",
        "tripNotFound": "Această tură nu mai există sau nu mai poate fi citită de tine.",
        "ifMatchRequired": "Pagina a pierdut versiunea pe care o modifica. A fost citită din nou; mai încearcă o dată.",
        "versionMismatch": "Altcineva a schimbat această urmărire în timp ce lucrai la ea. Pagina a fost citită din nou; uită-te la ea înainte să salvezi.",
        "shareNotFound": "Acel link de urmărire nu mai există — s-ar putea să îl fi retras deja cineva.",
        "publicationRefusedCave": "Publicarea acestei ture predă topografia peșterii, iar asta cere dreptul de a partaja peștera. Cere-l celui care se ocupă de ea.",
        "publicationRefusedProtected": "Peștera acestei ture are coordonate protejate, așa că tura nu poate fi publicată deloc. O pagină publicată spune unde se află echipa în peșteră, iar o variantă care ascunde poziția nu există.",
        "publicationNotArmed": "Un link de urmărire deschide pagina doar cât timp urmărirea este pornită. Pornește urmărirea, apoi publică tura.",
        "shareRevoked": "Acel link a fost deja retras, așa că nu mai este nimic de înlocuit. Publică tura din nou.",
        "notTracked": "Urmărirea nu a fost pornită niciodată pentru această tură, așa că nu are momente la care să fie pusă o fotografie. Pornește-o întâi; o tură a cărei urmărire a fost încheiată primește în continuare fotografii.",
        "pictureInFuture": "O fotografie nu poate fi pusă la un moment care nu a avut loc încă. Verifică decalajul ceasului aparatului sau momentul dat fotografiilor fără oră proprie.",
        "pictureNotImage": "Unul dintre fișierele alese nu este o imagine. La un moment pot fi puse doar fotografii.",
        "pictureAlreadyAttached": "O fotografie aleasă este deja la acel moment al turei, așa că nu a fost adăugată din nou.",
        "pictureRelationMissing": "Acestei instalări îi lipsește tipul de legătură care ține o fotografie de un moment al turei, așa că niciuna nu poate fi salvată. Anunță pe cel care administrează instalarea.",
        "pictureNotFound": "Acea fotografie nu mai este la acest moment — s-ar putea să o fi scos altcineva."
      },
      "publish": {
        "title": "Publică această tură",
        "explain": "Un link de urmărire lasă pe cineva fără cont să vadă echipa ieșind: numele turei, cine este în ea, unde a fost raportat ultima dată fiecare și topografia cu toți pe ea. O peșteră cu coordonate protejate nu poate fi publicată deloc.",
        "namesShown": "Această instalare publică numele reale. Toți cei din această tură sunt numiți pe pagină — și în orice bloc de site care o arată — cu numele pe care îl are lista pentru ei, în afară de cazul în care cuiva i s-a dat un nume propriu pentru pagina acestei ture, care se arată în locul lui.",
        "namesHidden": "Aici numele nu se publică. Toți cei din această tură apar ca un loc în echipă — Speolog 1, Speolog 2 — în afară de cazul în care cuiva i s-a dat un nume propriu pentru pagina acestei ture.",
        "mintedNamesShown": "Această adresă arată numele reale ale echipei.",
        "mintedNamesHidden": "Această adresă arată locuri în echipă, nu numele oamenilor.",
        "mint": "Creează un link de urmărire",
        "mintedTitle": "Linkul de urmărire este gata",
        "tokenOnce": "Copiază-l acum — este singurul moment în care este arătat.",
        "linkLabel": "Adresa de dat mai departe",
        "linkCopied": "Link de urmărire copiat.",
        "copy": "Copiază",
        "embedLabel": "Pentru un site",
        "embedHelp": "Lipește asta într-o pagină de pe site-ul tău ca să arăți acolo topografia. Se redimensionează singură după coloana în care stă. Legăturile din textul din jur o pot comanda — blocul explică cum. Site-ul tău trebuie să fie trecut și în setarea de încadrare a acestei instalări, altfel browserul refuză să afișeze cadrul.",
        "copyEmbed": "Copiază blocul pentru site",
        "embedCopied": "Bloc pentru site copiat.",
        "copyFailed": "Browserul nu a lăsat pagina să scrie în clipboard. Textul este selectat — copiază-l manual.",
        "none": "Această tură nu este publicată. Nimeni nu o poate urmări fără cont.",
        "statusActive": "Activ",
        "statusDormant": "Inactiv",
        "dormantUntil": "Acest link nu deschide nimic acum. Pagina răspunde cât timp urmărirea este pornită — și pe durata perioadei de grație de după încheierea ei, dacă instalarea păstrează una — și numai cât timp peștera turei poate fi publicată — dacă asta se schimbă la loc, linkul funcționează din nou până la {{when}}.",
        "createdAt": "Creat la {{when}}",
        "revoke": "Retrage-l",
        "revokeConfirm": "Retragi acest link de urmărire? Oricine îl are nu va mai putea deschide pagina.",
        "revoked": "Linkul de urmărire a fost retras.",
        "listUnavailable": "Linkurile de urmărire ale acestei ture nu au putut fi citite.",
        "expiresAt": "Funcționează până la {{when}}",
        "ends": "Un link de urmărire încetează singur să urmărească: când urmărirea este încheiată — sau, dacă instalarea păstrează o perioadă de grație după încheiere, când aceasta trece, timp în care pagina spune că tura s-a încheiat — și în orice caz la data de mai jos. Asta încheie urmărirea, nu publicarea: dacă turele trecute nu sunt oprite în această instalare, aceeași adresă deschide în continuare această tură printre turele trecute ale peșterii — cu echipa ei — până când linkul este retras. Retragerea le încheie pe amândouă imediat.",
        "mintedExpires": "Această adresă nu mai urmărește echipa după {{when}}, sau mai devreme: după ce încheii urmărirea (și după ce trece perioada de grație de după încheiere, dacă instalarea păstrează una). Dacă turele trecute nu sunt oprite aici, ea deschide apoi în continuare această tură printre turele trecute ale peșterii, până când o retragi.",
        "tellsParty": "Toți participanții la această tură care au cont sunt anunțați că a fost publicată.",
        "languageLabel": "Limba în care se deschide pagina",
        "languageDefault": "Nicio limbă precizată",
        "languageHelp": "O adresă care nu precizează nicio limbă se deschide în română sau în limba aleasă anterior de cititor pe acest site. Alegerea de aici rescrie adresa și blocul pentru site de mai jos — nu se creează nimic nou, același link răspunde în ambele cazuri, iar cititorul poate schimba limba și din pagină. O instalare care a oprit alegerea limbii pe paginile publicate ignoră limba din adresă: acolo, lasă prima opțiune.",
        "replace": "Înlocuiește linkul",
        "replaceConfirm": "Înlocuiești acest link de urmărire? Adresa veche nu mai răspunde din acest moment, oriunde a fost lipită. Una nouă este arătată aici, o singură dată; expiră atunci când ar fi expirat cea veche și nimeni din tură nu este anunțat.",
        "replacedTitle": "Adresa nouă este gata",
        "replacedOnce": "Copiaz-o acum — este singurul moment în care este arătată. Adresa veche nu mai răspunde.",
        "boundsWarning": "O peșteră protejată, sau una dintre intrările ei, se află în zona acoperită de topografia acestei ture. Verificarea se face doar după poziție și nu poate vedea în interiorul fișierului — se poate ca topografia să nu intre deloc în acea peșteră. Nimic nu a fost refuzat: uită-te la topografie și retrage linkul dacă arată ce nu ar trebui publicat.",
        "statusRanOut": "Expirat",
        "ranOutAt": "A expirat la {{when}}. Nu mai urmărește pe nimeni — dar cât timp nu îl retrage nimeni, poate ține în continuare această tură în lista de ture trecute a peșterii, iar adresa lui încă o deschide.",
        "revokeRanOutConfirm": "Retragi acest link de urmărire? Deja nu mai urmărește pe nimeni. Retragerea scoate și această tură din lista de ture trecute a peșterii, dacă nu mai rămâne alt link al turei."
      },
      "published": {
        "title": "Această tură este publicată",
        "since": "Din {{when}}, oricine are linkul poate deschide o pagină despre această tură fără cont. Pagina arată cine a fost în tură, cum îi numește pe fiecare și unde a fost raportat ultima dată fiecare.",
        "until": "Linkul nu mai urmărește echipa după {{when}}, sau mai devreme: după ce urmărirea este încheiată (și după ce trece perioada de grație de după încheiere, dacă instalarea păstrează una). Dacă turele trecute nu sunt oprite aici, el deschide apoi în continuare această tură printre turele trecute ale peșterii, până când este retras.",
        "whereToLook": "Lista de mai jos arată cum numește pagina fiecare persoană din această tură, inclusiv pe tine. O etichetă pusă cuiva este ceea ce tipărește pagina în locul numelui."
      },
      "publicName": {
        "column": "Pe pagina publică",
        "columnExplain": "Eticheta de lângă un nume este ce arată un link de urmărire în locul lui — înlocuiește numele acelei persoane pe pagina publică și în orice bloc de site care o arată, și are întâietate față de setarea de mai sus în ambele sensuri. Nimic altceva nu se schimbă: aici fiecare ecran îi spune tot pe numele lui.",
        "settingRealNames": "Această instalare publică numele reale.",
        "settingPlaces": "Această instalare publică locuri în echipă — Speolog 1, Speolog 2 — și niciun nume.",
        "placeInParty": "Un loc în echipă",
        "captionDetail": "O etichetă stabilită pentru această tură. Pagina publică o folosește în locul numelui acestei persoane, oricum ar sta setarea de nume a acestei instalări.",
        "realNameDetail": "Nu este stabilită nicio etichetă, iar această instalare publică numele, așa că pagina publică numește această persoană. O etichetă este ce îi ține numele departe de ea. Pagina tipărește numele din registrul clubului, care poate diferi de numele arătat aici dacă un cont și-a ales alt nume afișat.",
        "placeInPartyDetail": "Nu este stabilită nicio etichetă, iar această instalare nu publică numele, așa că pagina publică îi spune Speolog 1, Speolog 2 și așa mai departe. O etichetă este ce o face să îl numească.",
        "edit": "Stabilește cum îi spune pagina publică acestei persoane",
        "title": "Cum îi spune pagina publică lui {{name}}",
        "explain": "O etichetă este ce arată un link de urmărire în locul numelui acestei persoane — pe pagina în sine și în orice bloc de site care o arată. Nimic altceva nu se schimbă: această filă, jurnalul și orice alt ecran de aici îi spun tot pe numele lui.",
        "outranks": "Are întâietate față de setarea acestei instalări în ambele sensuri: o etichetă ține pe cineva departe de o pagină care altfel l-ar numi și numește pe cineva pe o pagină care altfel i-ar spune printr-un număr. O setare schimbată după aceea nu o poate anula.",
        "fieldLabel": "Etichetă",
        "placeholder": "Cum să îi spună pagina publică",
        "emptyClears": "Lasă câmpul gol și salvează ca să scoți eticheta.",
        "clear": "Scoate eticheta",
        "saved": "Pagina publică va folosi această etichetă.",
        "cleared": "Eticheta a fost scoasă. Pagina publică revine la ce publică această instalare.",
        "asCaption": "Pagina publică îi va spune „{{caption}}”.",
        "asRealName": "Pagina publică îi va spune {{name}}.",
        "asPlaceInParty": "Pagina publică îi va spune după locul din echipă — Speolog 1, Speolog 2 — și nu pe nume.",
        "rosterName": "Numele de aici sunt cele folosite de această aplicație. Pagina publică tipărește în schimb numele din registrul clubului, care diferă oriunde contul cuiva și-a ales alt nume afișat — pune o etichetă acolo unde trebuie să fie exact."
      },
      "refusedTitle": "Urmărirea nu mai poate fi citită",
      "refusedBody": "{{reason}} Tot ce este mai jos este ultima veste primită de această filă și nimic nu o va mai împrospăta — deschide tura din nou după ce se rezolvă.",
      "refusedSignedOut": "Nu mai ești autentificat, așa că această tură nu mai poate fi citită. Autentifică-te și deschide-o din nou.",
      "refusedUnknown": "Serverul nu a răspuns pentru această tură. S-ar putea să nu mai existe sau să nu mai poată fi citită de tine.",
      "csvExport": {
        "download": "Descarcă jurnalul (CSV)",
        "hint": "Tot jurnalul, ca foaia pe care o citește importul, cu cel mai vechi raport primul: corecteaz-o într-o foaie de calcul și import-o din nou. Un loc care nu îți poate fi comunicat lipsește din ea, iar rândul lui este marcat ca să nu poată fi importat."
      },
      "csvImport": {
        "open": "Importă o foaie",
        "title": "Importă rapoarte din foaie de calcul",
        "help": "Foaia unui coordonator — un rând per apel telefonic, cu ora, despre cine era și cât de adânc — citită în jurnalul acestei ture. Citirea nu scrie nimic: ce primești înapoi este exact ce ar face importul. Fiecare raport este identificat prin persoană și moment, așa că o foaie corectată, importată din nou, schimbă rândurile corectate în loc să le dubleze. O oră scrisă fără fus orar este înregistrată ca UTC, exact cum a fost scrisă: 14:30 din foaie devine 14:30 UTC, pe care această pagină îl arată apoi în fusul tău. Ca să fie citită după ceasul după care a fost scrisă, alege fusul orar al foii la Setări fișier sau scrie decalajul în celulă (2026-09-12T14:30+03:00).",
        "choose": "Alege un fișier CSV sau trage unul aici",
        "source": "De unde vine foaia",
        "sourceFile": "Un fișier",
        "sourcePaste": "Rânduri lipite",
        "pasteLabel": "Rândurile foii, cu rândul capetelor de coloană primul",
        "pastePlaceholder": "Selectează rândurile din foaia de calcul — cu tot cu rândul capetelor de coloană — copiază-le și lipește-le aici.",
        "pasteFromClipboard": "Lipește din clipboard",
        "pasteUnavailable": "Browserul nu a dat acces la clipboard. Lipește în casetă cu mâna.",
        "pastedAs": "coloane separate prin {{delimiter}}",
        "template": "Descarcă o foaie exemplu",
        "look": "Citește",
        "commit": "Importă",
        "columns": "Setări coloane",
        "columnsHelp": "Fiecare coloană este detectată din capul ei de tabel. Indică un câmp către o coloană doar acolo unde detecția a greșit — citește foaia o dată întâi, ca să ai capetele de coloană din care să alegi.",
        "detected": "Detectat",
        "shape": "Setări fișier",
        "shapeHelp": "Cum a fost salvat fișierul. Fiecare este dedusă din fișier și arătată aici; schimb-o doar acolo unde citirea de mai jos spune că a greșit.",
        "encoding": "Caractere",
        "encodingAuto": "Detectat",
        "readAs": "citit ca {{encoding}}, coloane separate prin {{delimiter}}",
        "encodings": {
          "utf-8": "UTF-8",
          "windows-1250": "Windows-1250, Europa Centrală",
          "iso-8859-2": "ISO-8859-2, Latin-2"
        },
        "delimiter": "Separator de coloane",
        "delimiterAuto": "Detectat",
        "delimiters": {
          "comma": "Virgulă",
          "semicolon": "Punct și virgulă",
          "tab": "Tab"
        },
        "dateOrder": "Zi și lună",
        "dateOrderAuto": "Din datele fișierului",
        "dateOrderDayFirst": "Ziua întâi (12.09.2026)",
        "dateOrderMonthFirst": "Luna întâi (09/12/2026)",
        "zone": "Fusul orar al foii",
        "zoneAsWritten": "Exact cum a fost scrisă (UTC)",
        "zoneMine": "Fusul meu orar — {{zone}}",
        "zoneHelp": "După al cui ceas au fost scrise orele din foaie. O oră care își scrie singură decalajul este citită cum spune, orice s-ar alege aici.",
        "depthsBelow": "Toate adâncimile sunt sub intrare",
        "depthsBelowHelp": "Bifează dacă foaia scrie adâncimile ca numere simple sau amestecă −40 cu 40: fiecare este citită atunci ca metri sub intrare. Las-o nebifată pentru o peșteră cu galerii deasupra intrării, unde −40 este alt loc decât 40.",
        "sheetDayTitle": "Foaia aceasta scrie ore fără date",
        "sheetDay": "Ziua în care a fost ținută foaia",
        "sheetDayHelp": "Fiecare oră care nu are data ei este pusă în această zi. Verific-o, apoi citește foaia din nou.",
        "fields": {
          "RecordedAt": "Când",
          "Date": "Doar data",
          "Time": "Doar ora",
          "Depth": "Adâncime",
          "Station": "Stație",
          "ToStation": "A doua stație (o porțiune)",
          "Place": "Loc",
          "Cavers": "Persoane",
          "Team": "Echipă",
          "Note": "Notă",
          "Details": "Detalii suplimentare",
          "State": "Intrare / ieșire"
        },
        "wentInWords": "Cuvinte pentru intrare",
        "cameOutWords": "Cuvinte pentru ieșire",
        "wentInPlaceholder": "intrare, intrat",
        "cameOutPlaceholder": "ieșire, ieșit",
        "notedWords": "Cuvinte pentru o notă",
        "notedPlaceholder": "notă",
        "stateWordsHelp": "Cuvinte separate prin virgulă. Cuvintele scrise aici le înlocuiesc pe cele obișnuite pentru partea respectivă, așa că scrie toate cuvintele pe care foaia le folosește pentru ea. Majusculele și diacriticele nu contează: ieșire și iesire sunt același cuvânt.",
        "rowsRead": "Rânduri citite",
        "creates": "Rapoarte noi",
        "replaces": "Deja în jurnal",
        "line": "Rând",
        "moment": "Când",
        "caver": "Persoană",
        "writtenAs": "scris ca {{written}}",
        "place": "Loc",
        "outcome": "Rezultat",
        "findings": "Observații",
        "momentsRule": "Orele scrise fără fus orar au fost citite ca UTC. Datele au fost citite {{order}}.",
        "momentsRuleZone": "Orele scrise fără fus orar au fost citite după ceasul din {{zone}} și sunt arătate mai jos așa cum le arăta acel ceas. Datele au fost citite {{order}}.",
        "momentsOnDay": "Orele fără dată au fost puse în ziua de {{day}}.",
        "datesDayFirst": "cu ziua întâi (12.09.2026)",
        "datesMonthFirst": "cu luna întâi (09/12/2026)",
        "datesByFile": "Datele din fișier o stabilesc singure.",
        "datesByDefault": "Nicio dată din fișier nu o stabilește, așa că s-a folosit citirea obișnuită; dacă e greșită, alege-o pe cealaltă la Setări fișier și citește foaia din nou.",
        "datesByChoice": "Nicio dată din fișier nu o stabilește, așa că s-a folosit alegerea de la Setări fișier.",
        "datesConflict": "Fișierul scrie datele în ambele ordini, așa că o singură citire a fost aplicată tuturor rândurilor; alege care la Setări fișier.",
        "chooseRowsHelp": "Se importă doar rândurile bifate. Un rând al foii care numește mai multe persoane este luat sau lăsat deoparte întreg.",
        "chooseRow": "Importă rândul {{line}}",
        "willCreate": "Nou",
        "willReplace": "Înlocuiește",
        "writtenAsHint": "Numele scris este arătat lângă cel potrivit oriunde diferă.",
        "unmatchedTitle": "Unele nume nu corespund nimănui din această tură",
        "unmatchedBody": "Rapoartele lor vor fi omise. Adaugă persoanele în lista turei sau corectează scrierea în foaie.",
        "unmappedTitle": "Coloane nerevendicate",
        "replaceExisting": "Suprascrie ce are deja jurnalul la aceste momente (rapoarte de suprascris: {{count}})",
        "problems": "Observații de citit: {{count}}",
        "atLine": "Rândul {{line}}",
        "problemNames": {
          "UnterminatedQuote": "Un semn de ghilimele a fost deschis și nu a mai fost închis, așa că restul fișierului a intrat într-o singură celulă.",
          "NoHeader": "Fișierul nu are rânduri, deci nu există un cap de tabel.",
          "TooManyColumns": "Mai multe coloane decât are plauzibil o foaie — probabil nu e fișierul dorit.",
          "NamedColumnMissing": "Ai indicat un câmp către un cap de coloană inexistent în fișier.",
          "UnmappedColumn": "Nimic nu a revendicat această coloană. Un cap de coloană scris greșit trece altfel neobservat.",
          "MomentColumnMissing": "Nicio coloană nu conține ora, fără care niciun rând nu poate fi plasat.",
          "CaverColumnMissing": "Nicio coloană nu conține persoanele, deci niciun rând nu este despre cineva.",
          "TimeColumnNeedsADay": "Foaia scrie orele fără date, așa că nu pot fi plasate până nu este numită ziua în care a fost ținută foaia.",
          "MomentUnreadable": "Este scris ceva în locul orei, dar nu este o oră.",
          "MomentWithoutTime": "O dată fără oră nu poate plasa un raport; puse la miezul nopții, rapoartele unei zile întregi s-ar suprapune într-un singur moment.",
          "MomentSkippedByClockChange": "Ora aceasta nu a existat în fusul orar al foii — ceasurile au fost date înainte peste ea. Corectează celula sau scrie decalajul lângă oră (de exemplu +02:00).",
          "MomentRepeatedByClockChange": "Ora aceasta a existat de două ori în fusul orar al foii — ceasurile au fost date înapoi peste ea. A fost citită ca prima dintre cele două; dacă era vorba de a doua, scrie decalajul lângă oră (de exemplu +02:00).",
          "MomentWithoutDate": "O oră fără dată. Data nu se preia de pe rândul de deasupra — scrie-o pe acest rând.",
          "MomentMissing": "Celula cu ora este goală.",
          "RaggedRow": "Rândul nu are lățimea capului de tabel; a fost aliniat cu el și citit oricum.",
          "NoCavers": "Rândul nu numește pe nimeni.",
          "NoPlaceAndNoState": "Rândul nu spune nici unde este cineva, nici că a intrat sau a ieșit.",
          "DepthUnreadable": "Adâncimea nu este un număr.",
          "DepthOutOfRange": "Este un număr, dar nu o adâncime pe care să o aibă vreo peșteră.",
          "StateWordUnknown": "Locul acestui rând nu i-a fost arătat celui care a scos foaia, iar foaia îl marchează cu acest cuvânt. Nu este citit ca intrare, ieșire sau activitate.",
          "NoteTooLong": "Nota este mai lungă decât poate purta un raport (2000 de caractere, nota și detaliile împreună). Scurteaz-o în foaie.",
          "StateOverridesPlace": "Rândul spune că cineva a intrat sau a ieșit și numește și un loc din interior; intrarea și ieșirea nu revendică o stație, așa că locul a fost ignorat.",
          "CaverNotOnRoster": "Nimeni din această tură nu răspunde la acest nume.",
          "CaverAmbiguous": "Mai multe persoane din această tură răspund la acest nume și doar tu poți spune care.",
          "TeamNotOnTrip": "Nu este una dintre echipele acestei ture, așa că raportul a fost păstrat fără echipă.",
          "TeamAmbiguous": "Mai multe echipe ale acestei ture au acest nume, deci nu se poate decide care este. Un raport aflat deja în jurnal își păstrează echipa; unul nou este creat fără echipă.",
          "PlaceLabelUnknown": "Peștera nu a declarat niciun loc cu acest nume.",
          "PlaceLabelAmbiguous": "Două declarații ale peșterii au acest nume, deci nu se poate decide care stație este.",
          "StationNotInModel": "Stația nu face parte din topografia pe care este această urmărire.",
          "ToStationNotInModel": "A doua stație, capătul îndepărtat al porțiunii, nu face parte din topografia pe care este această urmărire.",
          "StretchSameStation": "Rândul numește aceeași stație la ambele capete ale porțiunii.",
          "ToStationWithoutStation": "Rândul numește o a doua stație, dar nicio stație de la care să înceapă porțiunea.",
          "DepthReferenceUnknown": "Topografia nu are un reper de la care să se măsoare adâncimea.",
          "NoStationAtDepth": "Nicio stație permisă de filtrul de adâncime al turei nu se află la acea adâncime.",
          "ModelMissing": "Această urmărire nu are topografie, deci niciun rând care revendică un loc nu poate fi plasat.",
          "DuplicateInFile": "Un alt rând al acestui fișier este același raport — aceeași persoană, același moment.",
          "MomentInFuture": "Un raport nu poate fi despre viitor.",
          "ClockRunsBackwards": "Ora aceasta este mai devreme decât una aflată mai sus în foaie (rândul indicat), iar amândouă au fost citite în singura zi numită pentru foaie. Dacă foaia a trecut de miezul nopții, rândul ține de ziua următoare: lasă-l deoparte sau adaugă foii o coloană cu data.",
          "AlreadyRecorded": "Jurnalul conține deja acest raport, iar suprascrierea nu a fost permisă.",
          "AlreadyRecordedSeveralTimes": "Jurnalul conține mai multe rapoarte pentru această persoană la acest moment, așa că nu se poate decide pe care îl corectează rândul. Rezolvă-l mai întâi în fila de urmărire.",
          "DateOrderConflict": "Datele fișierului susțin ambele variante despre care număr este ziua; citirea afișată a fost aleasă pentru tot fișierul."
        },
        "done": "{{created}} înregistrate, {{updated}} corectate, {{unchanged}} deja așa cum spune foaia, {{skipped}} omise.",
        "placeNamed": "{{label}} → {{station}}",
        "noteQuoted": "„{{note}}”",
        "beforeLabel": "Acum în jurnal:",
        "afterLabel": "După import:",
        "deskTask": "Foaia este o treabă de birou: servește la trecerea unei ture în jurnal după notițe, este citită întreagă, verificată rând cu rând și apoi scrisă dintr-odată. Pentru un raport care sosește cât timp echipa este în peșteră, folosește formularul de raport al turei — primește câte un raport și nu suprascrie nimic.",
        "planChangedTitle": "Tura s-a schimbat cât timp era verificată foaia"
      }
    },
    "checklistNone": "Această tură nu parcurge nicio listă pe care o poți vedea.",
    "checklistReadiness": "{{ticked}} din {{total}} rezolvate",
    "checklistAdvisory": "Aceasta este o informare pentru echipă, nu o regulă. Nimic nu este refuzat pentru că o linie a rămas nerezolvată, iar gradul de pregătire nu schimbă niciodată cine poate citi tura.",
    "checklistTickedAt": "Confirmat la {{when}}",
    "checklistTickFailed": "Confirmarea nu a putut fi înregistrată.",
    "empty": "Nicio tură încă.",
    "emptyFiltered": "Nicio tură nu corespunde acestui filtru.",
    "listFailed": "Turele nu au putut fi încărcate.",
    "filters": {
      "showing": "Se afișează {{matching}} din {{overall}} ture pe care le poți vedea",
      "reset": "Șterge filtrele",
      "yourAccess": "Numerele sunt ale turelor pe care le poți vedea",
      "moreParticipants": "În aceste ture au mers mai multe persoane decât oferă această listă. Restrânge celelalte filtre ca să ajungi la ele.",
      "moreAreas": "În aceste ture au fost atinse mai multe zone decât oferă această listă. Restrânge celelalte filtre ca să ajungi la ele.",
      "incident": "Incident",
      "incidentYes": "Ceva nu a mers bine",
      "incidentNo": "Totul a mers bine",
      "participant": "Persoană",
      "area": "Zonă",
      "fromDate": "Ture de la",
      "toDate": "Ture până la",
      "showOnMap": "Arată pe hartă"
    },
    "grouping": {
      "groupBy": "Grupează după",
      "thenBy": "apoi după",
      "trips": "Ture",
      "span": "Zile",
      "topTypes": "În principal",
      "topPeople": "Cine",
      "unassigned": "Neînregistrat",
      "empty": "Nimic de grupat",
      "overlapping": "O tură se numără la fiecare valoare pe care o are, deci totalurile depășesc cele {{count}} ture afișate.",
      "truncated": "Grupare peste primele {{count}} ture găsite de filtru. Restrânge filtrul pentru a le cuprinde pe restul.",
      "dimensions": {
        "none": "Nimic",
        "year": "An",
        "type": "Scop",
        "state": "Stare",
        "visibility": "Audiență",
        "incident": "Incident",
        "area": "Zonă",
        "participant": "Persoană"
      }
    }
  },
  "expeditions": {
    "notFound": "Nicio astfel de tabără",
    "notFoundDetail": "Fie nu există, fie nu o poți citi. Această pagină nu poate deosebi cele două cazuri și nici nu încearcă.",
    "title": "Tabere",
    "searchPlaceholder": "Caută tabere",
    "nameField": "Nume",
    "state": "Stare",
    "stateFilter": "Orice stare",
    "date": "Ziua",
    "dates": "Zilele",
    "cavingGroup": "Club organizator",
    "tabTrips": "Ture",
    "tabWatch": "Cine e în peșteră",
    "tabMap": "Hartă",
    "tabLeads": "Continuări",
    "tabRoster": "Cine a fost",
    "tabFiles": "Fișiere",
    "tabHistory": "Istoric",
    "rosterPeople": "Persoane la această tabără: {{count}} — numărate o singură dată fiecare, oricâte roluri au înregistrate.",
    "rosterEmpty": "Încă nu a fost înregistrată nicio persoană ca fiind la această tabără.",
    "rosterWithheld": "Cine a fost la această tabără nu îți este arătat",
    "rosterWithheldDetail": "Poți citi această tabără, dar nu și persoanele din această instalare — așa că numele, zilele și numărul lor sunt reținute împreună. Afișarea șederilor cu numele tăiate ar spune tot câte persoane au fost și când.",
    "rosterUnavailable": "Cine a fost la această tabără nu a putut fi citit acum.",
    "stay": {
      "add": "Adaugă o ședere",
      "edit": "Editare ședere",
      "remove": "Șterge șederea",
      "removeConfirm": "Ștergi această ședere pentru {{name}}? Dispare doar consemnarea că a fost la această tabără în aceste zile — persoana rămâne în lista de speologi.",
      "hint": "O ședere înseamnă o persoană, într-un rol, pentru un interval de zile. Cine a gătit și a și cartat are două șederi, la fel și cine a plecat și s-a întors.",
      "person": "Cine",
      "personPlaceholder": "Cineva din lista de speologi sau un nume nou",
      "personRequired": "Spune cine a fost",
      "role": "Rol",
      "roleRequired": "Alege un rol",
      "daysHint": "Prima și ultima zi în care a fost acolo. Pentru o singură zi, alege-o de două ori.",
      "daysRequired": "Alege prima și ultima zi sau bifează „încă acolo”.",
      "firstDay": "Prima zi",
      "lastDay": "Ultima zi",
      "stillThere": "Încă acolo",
      "stillThereChoice": "Încă acolo — nu a plecat încă",
      "since": "din {{date}}, încă acolo",
      "note": "Notă",
      "notePlaceholder": "A sosit mai târziu, a plecat mai devreme, s-a întors…",
      "personGone": "Această persoană nu mai este în lista de speologi. Alege-o din nou sau scrie-i numele."
    },
    "mapEmpty": "Nu este nimic de desenat pentru această tabără: nu are o zonă de lucru, iar niciuna dintre turele pe care le poți citi nu a lăsat o schiță sau nu a numit o peșteră a cărei poziție o poți vedea.",
    "mapCaveat": "Desenat peste turele pe care le poți citi. Zona de lucru este forma trasată pe plan; schița unei ture este arătată exact așa cum a fost trasată, oricare ar fi protecția peșterilor pe care le numește; iar o intrare de peșteră apare doar acolo unde îi poți vedea poziția exactă.",
    "mapTruncated": "Această tabără numește mai multe intrări de peșteră decât poate purta o hartă, așa că nu toate intrările sunt desenate.",
    "noTripsVisible": "Nicio tură din această tabără pe care să o poți citi.",
    "tripsTruncated": "Se afișează {{shown}} din {{total}} ture.",
    "watch": {
      "intro": "Cine este în peșteră în turele acestei tabere, așa cum o spune urmărirea fiecărei ture — numărat peste turele pe care le poți citi. Înregistrează ce s-a raportat: nu urmărește niciun ceas și nu dă nicio alarmă.",
      "empty": "Nicio tură a acestei tabere nu este în urmărire și niciuna nu a avut urmărirea încheiată de curând — sau niciuna pe care să o poți citi. O tură apare aici după ce urmărirea este pornită din fila ei Urmărire și rămâne o vreme după ce urmărirea este încheiată.",
      "unavailable": "Numărătoarea nu a putut fi citită.",
      "truncated": "Tabăra are mai multe ture urmărite decât arată această listă. Turele aflate acum în urmărire sunt primele; lipsesc cele a căror urmărire a fost încheiată cel mai demult.",
      "expectedReturn": "Ieșire estimată",
      "neverHeard": "nicio veste încă",
      "closedAt": "Încheiată",
      "partyEmpty": "Nimeni nu este pe lista acestei ture.",
      "unnamed": "Persoană fără nume",
      "openTracking": "Deschide urmărirea acestei ture"
    },
    "albums": "Albume despre această tabără",
    "noAlbums": "Încă niciun album despre această tabără.",
    "rosterRoleValues": {
      "member": "Membru",
      "organiser": "Organizator",
      "cook": "Bucătar",
      "base_camp": "Tabăra de bază",
      "driver": "Șofer",
      "medic": "Sanitar",
      "equipment": "Echipament",
      "guest": "Invitat"
    },
    "leadsCount": "Continuări în această listă: {{count}} — numărate o singură dată, oricâte ture ale taberei le-au numit.",
    "leadsEmpty": "Turele acestei tabere nu au lăsat nimic deschis — sau nimic ce ți se poate arăta.",
    "leadsAsVisible": "Afișat așa cum îl vezi tu: continuări găsite pe turele pe care le poți citi și numai cele al căror loc ți se poate spune.",
    "leadsUnavailable": "Continuările nu au putut fi citite.",
    "leadsTruncated": "Tabăra are mai multe continuări decât arată lista.",
    "leadUnnamed": "Continuare fără nume",
    "leadGrade": "Promisiune {{grade}}",
    "leadStateUnrecorded": "Neînregistrată",
    "leadStates": {
      "open": "Deschisă",
      "checked": "Verificată",
      "dead-end": "Înfundătură",
      "continues": "Continuă"
    },
    "new": "Tabără nouă",
    "edit": "Editare tabără",
    "publicNote": "Notă pentru cititorii turelor publicate",
    "publicNoteHint": "Apare deasupra statisticilor pe care o pagină le calculează din turele publicate ale taberei — de exemplu cât de mult se poate conta pe ele cât timp înregistrările sunt încă în curs de completare. Spre deosebire de descriere, o citesc și persoane fără cont: oricine poate deschide o tură publicată a acestei tabere.",
    "workingArea": "Zonă de lucru",
    "workingAreaHint": "Aproximativ unde lucrează tabăra: forma trasată pe plan, nu o poziție după care navighează cineva și nu derivată din peșterile la care ajung turele taberei.",
    "workingAreaWarning": "Arătată exact tuturor celor care pot citi tabăra.",
    "workingAreaWarningDetail": "Zona de lucru nu are protecție de locație — este forma pe care a trasat-o cineva pe plan. Trasează-o aproximativ și niciodată strâns în jurul unei intrări care trebuie să rămână protejată.",
    "publishConfirm": "Anunți această tabără? Nimeni nu este notificat prin aceasta; marchează tabăra ca anunțată. Cine o poate citi nu se schimbă: rămâne vizibilă pentru {{audience}}. Lărgirea accesului este o modificare separată.",
    "publishSuccess": "Anunțată.",
    "callOff": "Anulează tabăra",
    "callOffConfirm": "Anulezi această tabără? Se păstrează și poate fi readusă la ciornă.",
    "deleteConfirm": "Ștergi această tabără? Turele adunate în ea rămân; dispare tabăra, cu regulile ei proprii și cu orice raport salvat la ea.",
    "draftNotice": "Aceasta este o ciornă. Nu a fost anunțată încă — anunț-o când planul este stabilit sau marcheaz-o efectuată după ce a avut loc.",
    "sharing": {
      "title": "Partajează tabăra",
      "button": "Partajează",
      "intro": "Partajarea unei tabere scrie câte o regulă pe fiecare tură adunată în ea, marcată ca fiind a taberei, astfel încât cel cu care este partajată poate citi ce a adunat tabăra. Fiecare tură răspunde pentru ea însăși: tabăra este partajată pe fiecare tură ale cărei permisiuni le poți gestiona, iar celelalte sunt sărite și enumerate. O tură care se alătură taberei mai târziu nu este acoperită până când partajarea este aplicată din nou.",
      "memberTrips": "Ture în această tabără: {{count}}.",
      "notAllowed": "Nu poți partaja această tabără.",
      "empty": "Această tabără nu este partajată încă cu nimeni.",
      "actions": "Drepturi",
      "coverage": "Ture acoperite",
      "covered": "{{trips}} din {{total}}",
      "behind": "Nu toate turele",
      "behindHint": "Nu toate turele din această tabără îi poartă partajarea. Unele s-au alăturat după ce a fost aplicată ultima dată; altele au fost sărite pentru că cel care a aplicat-o nu le putea gestiona permisiunile. Aplică din nou partajarea pentru a le acoperi pe cele pe care le poți.",
      "addTitle": "Partajează cu altcineva",
      "apply": "Aplică partajarea",
      "applyHint": "Scrie aceste reguli pe fiecare tură din tabără ale cărei permisiuni le poți gestiona și le enumeră pe cele sărite. Regulile deja aplicate se păstrează; nimic nu este eliminat.",
      "applied": "Tabăra este partajată.",
      "reapply": "Aplică din nou",
      "reapplied": "Partajarea acoperă acum fiecare tură din tabără.",
      "withdraw": "Retrage partajarea",
      "withdrawConfirm": "Retragi partajarea acestei tabere de pe fiecare tură adunată în ea? Regulile scrise pe fila de permisiuni a unei ture se păstrează.",
      "withdrawn": "Partajarea taberei a fost retrasă.",
      "incomplete": "Nepartajat: nu poți gestiona permisiunile niciuneia dintre turele acestei tabere ({{count}}) sau ai cerut să dai mai mult decât ai pe ele. Proprietarii lor trebuie să te lase mai întâi să le gestionezi permisiunile.",
      "noTrips": "Această tabără nu adună încă nicio tură, așa că nu este nimic de partajat.",
      "nothingShared": "Această tabără nu partajează nimic de aplicat din nou.",
      "inPart": "Ture partajate: {{shared}} din {{total}}. Restul au fost sărite — sunt enumerate în acest dialog.",
      "skippedTitle": "Ture partajate: {{shared}}. Ture sărite: {{skipped}}.",
      "skippedReason": {
        "notAdministered": "proprietarul ei trebuie să te lase să îi gestionezi permisiunile",
        "beyondHolding": "ai cerut să dai mai mult decât ai tu pe această tură"
      },
      "skippedNotNamed": "Ture sărite pe care nu le poți citi și care, de aceea, nu sunt numite aici: {{count}}. Proprietarii lor trebuie să te lase să le gestionezi permisiunile.",
      "skippedHint": "Pe o tură sărită nu s-a scris nimic. Aplică din nou partajarea după ce situația s-a schimbat, iar tura va fi preluată."
    },
    "report": {
      "open": "Raport",
      "backToCamp": "Înapoi la tabără",
      "keep": "Salvează la tabără",
      "kept": "Documentul a fost atașat taberei.",
      "keepAudience": "Copia salvată la tabără poate fi deschisă de toți cei care pot citi tabăra, așa că este construită din ce poate vedea orice cont din turele ei. Copia ta completă este descărcarea.",
      "audienceNotice": "Acest raport arată ceea ce poți vedea tu. Altcineva care citește aceeași tabără poate vedea mai mult sau mai puțin: turele din ea, persoanele, fotografiile.",
      "account": "Despre tabără",
      "trips": "Turele",
      "accounts": "Ce a scris fiecare tură",
      "accountsVisibleToYou": "Ce a scris fiecare tură despre ea însăși, pentru turele din această tabără pe care le poți citi. Altcineva poate vedea mai multe dintre ele sau mai mult din ce a scris una dintre ele.",
      "whoWasThere": "Cine a participat",
      "areaPoint": "Zonă de lucru: un punct la {{position}}.",
      "areaShape": "Zonă de lucru: {{shape}}, {{count}} puncte, centrată pe {{position}}."
    },
    "tabPhotos": "Fotografii",
    "noPhotographs": "Nicio fotografie nu este atașată acestei tabere sau turelor din ea pe care le poți citi.",
    "galleryVisibleToYou": "Fotografiile pe care le poți vedea, din tabără și din turele ei pe care le poți citi. Altcineva poate vedea mai multe sau mai puține."
  },
  "tags": {
    "title": "Etichete",
    "add": "Adaugă etichetă",
    "filterPlaceholder": "Filtrează după etichetă…"
  },
  "audit": {
    "title": "Istoric modificări",
    "at": "Când",
    "user": "Utilizator",
    "action": "Acțiune",
    "entityType": "Entitate",
    "entityId": "Id entitate",
    "entityTypePlaceholder": "Filtrează după tipul entității (ex. Cave)…"
  },
  "history": {
    "title": "Istoric",
    "empty": "Nicio modificare înregistrată încă.",
    "hidden": "Valoare ascunsă (locație protejată)",
    "geometrySummary": "Geometrie cu {{points}} puncte (prea mare pentru a fi înregistrată integral)",
    "systemUser": "Sistem",
    "restoreField": "Restaurează această valoare",
    "restoreAll": "Restaurează toate valorile dinaintea acestei modificări",
    "restored": "Valoare restaurată.",
    "restoredPartly_one": "O valoare a fost restaurată. Unele au rămas neschimbate:",
    "restoredPartly": "{{count}} valori au fost restaurate. Unele au rămas neschimbate:",
    "restoredNothing": "Nu s-a restaurat nimic:",
    "openBatch": "Vezi acest import",
    "changesInSet_one": "{{count}} modificare",
    "changesInSet": "{{count}} modificări",
    "source": {
      "web": "Modificat în browser",
      "fileImport": "Import din fișier",
      "deviceSync": "Încărcare de pe telefon",
      "speleolocArchive": "Import de arhivă de pe telefon",
      "restore": "Restaurat din istoric",
      "undo": "Anulare",
      "reviewDecision": "Decizie de revizuire",
      "job": "Sarcină în fundal",
      "tripConversion": "Tură convertită dintr-o înregistrare"
    },
    "skipReason": {
      "not_restorable": "istoricul nu poate restaura această valoare",
      "redacted": "valoarea anterioară îți este ascunsă, pentru că locația este protejată",
      "no_pre_image": "forma anterioară nu a fost păstrată, pentru că modificarea a fost înregistrată înainte ca formele mari să fie salvate integral",
      "forbidden": "poți modifica această trăsătură, dar nu poziția, altitudinea sau calitatea ei",
      "superseded": "a fost modificată de atunci"
    },
    "action": {
      "created": "Creat",
      "updated": "Modificat",
      "deleted": "Șters"
    },
    "entity": {
      "Cave": "Peșteră",
      "CaveEntrance": "Intrare",
      "SurfaceFeature": "Fenomen de suprafață",
      "TripLog": "Raport de tură",
      "CaveCenterline": "Drumuire",
      "SurveyModel": "Model topografic",
      "Attachment": "Atașament",
      "Tagging": "Etichetă",
      "TripLogParticipant": "Participant",
      "Expedition": "Expediție",
      "ExpeditionTrip": "Tură din expediție",
      "ExpeditionRosterEntry": "Participant la expediție",
      "TripInvitation": "Invitație",
      "Event": "Eveniment"
    },
    "rosterTimes": {
      "written": "Orele de intrare și de ieșire de pe listă au fost luate din jurnalul de urmărire.",
      "people": "Persoane: {{n}}",
      "rows": "Rânduri de pe listă: {{n}}",
      "zone": "Citite după ceasurile din {{zone}}."
    },
    "field": {
      "name": "Nume",
      "description": "Descriere",
      "geom": "Locație",
      "altitude": "Altitudine",
      "positionQuality": "Calitatea poziției",
      "closestAddress": "Cea mai apropiată adresă",
      "landRegistryNumber": "Număr cadastral",
      "locationNotes": "Note despre locație",
      "caveId": "Peșteră asociată",
      "visibility": "Vizibilitate",
      "caption": "Legendă",
      "title": "Titlu",
      "file": "Fișier",
      "role": "Rol",
      "sortOrder": "Poziția între fișiere"
    },
    "changesOf": "Modificări făcute la {{when}}"
  },
  "cavingGroups": {
    "title": "Grupuri de speologie",
    "new": "Grup de speologie nou",
    "name": "Denumire",
    "type": "Tip",
    "types": {
      "cavingClub": "Club de speologie",
      "group": "Grup",
      "organization": "Organizație"
    },
    "members": "Membri",
    "manage": "Administrează",
    "addMember": "Adaugă",
    "removeConfirm": "Elimini acest membru?",
    "announce": {
      "open": "Anunță",
      "title": "Anunț pentru {{name}}",
      "message": "Anunț",
      "placeholder": "Un singur rând — o schimbare de oră, un loc de întâlnire, o închidere.",
      "reaches": "Persoane la care ajunge: {{people}}",
      "reachesHint": "Membrii fără cont nu sunt numărați, iar propriul anunț nu îți este trimis niciodată. Fiecare dintre ceilalți îl primește așa cum a ales să fie anunțat.",
      "nobody": "Nimeni de pe această listă nu are cont, deci nu are cine să fie anunțat.",
      "confirm": "Pleacă acum către persoanele numărate mai sus. Nu poate fi retras.",
      "send": "Trimite",
      "done": "Trimis. Persoane anunțate: {{people}}",
      "queued": "Se trimite — clubul este destul de mare încât anunțurile se scriu în fundal. Persoane care vor fi anunțate: {{people}}",
      "failed": "Anunțul nu a fost trimis. Încearcă din nou."
    },
    "roles": {
      "member": "Membru",
      "admin": "Administrator",
      "owner": "Proprietar"
    }
  },
  "cavers": {
    "title": "Speologi",
    "new": "Speolog nou",
    "edit": "Editează speologul",
    "name": "Nume",
    "shortName": "Nume scurt",
    "shortNameHint": "Cum i se spune în echipă — numele cu care este scris un jurnal de suprafață. Apare la turele publicate în locul numelui întreg și este recunoscut la importul unei foi de rapoarte.",
    "email": "Email",
    "phone": "Telefon",
    "notes": "Observații",
    "notesHint": "Vizibile doar celor care administrează lista.",
    "search": "Caută după nume…",
    "pick": "Caută un speolog…",
    "noAccount": "Fără cont",
    "cavingGroups": "Grupuri de speologie",
    "cavingGroupsHint": "Grupurile din care face parte persoana. Intră ca membru obișnuit; cine conduce un grup se stabilește pe pagina grupului.",
    "cavingGroupsWarningTitle": "Aceasta schimbă ce poate face contul persoanei",
    "cavingGroupsWarning": "Apartenența la un grup este cea care dă contului unei persoane drepturile grupului: membrii citesc și modifică ce împarte grupul și văd poziția exactă a peșterilor pe care acesta le protejează, și sunt anunțați când sunt adăugați. Scoaterea cuiva îi retrage imediat aceste drepturi. Nimic din ce s-a înregistrat despre persoană — ture, ore, rapoarte — nu se schimbă.",
    "cavingGroupsRefused": "Persoana a fost salvată, dar aceste grupuri nu au putut fi schimbate: {{names}}. Pentru a schimba cine face parte dintr-un grup este nevoie de dreptul de a modifica acel grup.",
    "phoneUsers": "Utilizatori de telefon",
    "merge": "Unifică",
    "mergeInto": "Unifică în {{name}}",
    "mergeHint": "Alege înregistrarea duplicat. Turele și grupurile sale trec la aceasta, iar duplicatul este eliminat.",
    "deleteConfirm": "Elimini această persoană din listă?",
    "deleteRefused": "Persoana nu a putut fi eliminată.",
    "deleteRefusedCamp": "Persoana este pe lista unei tabere și nu poate fi eliminată cât timp rămâne acolo. Dacă este o înregistrare duplicat, unific-o în loc.",
    "rosterProblems": {
      "grantsFullAdmin": "Doar un administrator deplin poate face asta: contul acestei persoane ar deveni administrator deplin.",
      "revokesFullAdmin": "Doar un administrator deplin poate face asta: un cont și-ar pierde drepturile de administrator deplin.",
      "exceedsOwnRights": "Nu poți face asta: contul acestei persoane ar primi drepturi pe care tu nu le ai.",
      "memberRaced": "Altcineva a adăugat această persoană în grup în același moment. Reîncarcă grupul și încearcă din nou.",
      "lastFullAdmin": "Instalarea ar rămâne fără un administrator deplin care se poate autentifica."
    },
    "heldByTrips": {
      "title": "{{name}} nu poate fi eliminat(ă) încă",
      "intro": "Persoana apare încă în ture, așa că înregistrarea ei nu poate fi eliminată. Fiecare tură de mai jos arată ce o ține acolo.",
      "onRoster": "Pe listă",
      "onRosterHelp": "Deschide tura și scoate persoana de pe lista ei.",
      "reports": "Rapoarte de urmărire: {{count}}",
      "notRemovable": "Rapoartele ei nu pot fi șterse de aici: este nevoie de dreptul de a edita această tură și de un jurnal de urmărire care a fost pornit.",
      "elsewhere": "Persoana este ținută și de ceva ce nu apare aici — o tură pe care nu o poți deschide, o tură ștearsă sau mai multe ture decât cuprinde această listă. Întreabă un administrator.",
      "nothingLeft": "Nimic din ce apare aici nu mai ține această persoană.",
      "deleteNow": "Elimină persoana",
      "deleted": "{{name}} a fost eliminat(ă) din listă.",
      "stillHeld": "Ceva ține încă această persoană. Lista a fost citită din nou.",
      "merge": "Unifică un duplicat în loc",
      "mergeHint": "Dacă aceasta este a doua înregistrare a cuiva pe care lista îl are deja, unific-o în loc: turele și rapoartele ei trec la înregistrarea care rămâne."
    },
    "picker": {
      "picked": "Din lista de speologi.",
      "typed": "Nu a fost ales din listă, așa că se salvează ca nume: înseamnă persoana pe care lista de speologi o are deja exact sub acest nume, iar dacă nu este nimeni, o adaugă."
    }
  },
  "recordings": {
    "title": "Înregistrări de pe telefon",
    "intro": "Turele înregistrate cu aplicația SpeleoLoc în această peșteră. O înregistrare este ce a văzut un telefon, nu încă raportul de tură al clubului: se transformă singură în raport când este închisă și nimic din ea nu e în dubiu, iar altfel așteaptă aici o persoană.",
    "columns": {
      "recording": "Înregistrare",
      "started": "Început",
      "scans": "Scanări",
      "standing": "Stare"
    },
    "scanCount": "{{count}}",
    "stillOpen": "Încă deschisă pe telefon",
    "standing": {
      "waiting": "În așteptare",
      "converted": "Transformată în tură",
      "needsAttention": "Necesită atenție"
    },
    "standingHint": {
      "waiting": "Din această înregistrare nu s-a făcut încă niciun raport de tură. O înregistrare încă deschisă pe telefon așteaptă ca telefonul s-o închidă; una pe care instalația a fost instruită să n-o transforme cu probleme te așteaptă pe tine.",
      "converted": "Transformată în raport de tură.",
      "needsAttention": "Transformată într-un raport de tură pe care trebuie încă să-l verifice cineva."
    },
    "openTrip": "Deschide tura",
    "convert": "Transformă în tură",
    "convertHint": "Deschide verificarea acestei înregistrări, unde alegi ridicarea topografică și tura pe care merge și stabilești fiecare scanare."
  },
  "tripAttention": {
    "title": "Această tură a fost făcută dintr-o înregistrare de pe telefon și are nevoie să fie verificată",
    "titleCleared": "Această tură a fost făcută dintr-o înregistrare de pe telefon care a avut nevoie de verificare",
    "intro": "Tura a fost făcută automat. Ce urmează nu a putut fi stabilit de la sine, așa că în tură pot lipsi poziții sau persoane. Îndreaptă ce poți cu uneltele care există deja, apoi spune că ai terminat.",
    "clearedAt": "Marcată ca rezolvată pe {{when}}. Motivele rămân aici pentru cine se uită după tine.",
    "reasons": {
      "place_unknown": "scanări fără niciun loc sau la un loc pe care această instalație nu-l mai ține ca loc marcat",
      "unresolved_station": "scanări al căror loc nu dă o singură stație de ridicare",
      "unmapped_person": "scanări făcute de un utilizator de telefon care nu este încă asociat unui speolog; asociază-l în pagina Utilizatori de telefon",
      "recorded_in_future": "scanări datate mai târziu decât acum, ceea ce nicio poziție nu poate fi",
      "recording_changed_after_conversion": "modificări făcute înregistrării pe un telefon după ce a fost făcută această tură; tura nu a fost rescrisă"
    },
    "unknownReason": "altceva care a avut nevoie de verificare",
    "markResolved": "Marchează ca rezolvată",
    "resolved": "Marcată ca rezolvată.",
    "errors": {
      "changed": "Semnalul a primit un motiv în timp ce îl citeai. Citește-l din nou înainte să-l marchezi ca rezolvat.",
      "forbidden": "Poți citi această tură, dar nu o poți modifica, așa că n-o poți marca ca rezolvată.",
      "failed": "Semnalul nu a putut fi șters."
    }
  },
  "phoneUsers": {
    "title": "Utilizatori de telefon",
    "backToCavers": "Înapoi la speologi",
    "intro": "Toți cei care au folosit aplicația SpeleoLoc cu această instalare, câte un rând pentru fiecare autentificare de pe un telefon. O autentificare de pe telefon nu este o persoană: spune ce speolog este fiecare, ca ceea ce înregistrează să fie trecut pe numele potrivit. Nimeni nu este asociat în locul tău, iar cine apare aici nu devine speolog sau cont.",
    "unmappedTitle": "Unii utilizatori de telefon nu sunt încă asociați unui speolog",
    "unmappedBody": "Până când un utilizator de telefon este asociat, ce înregistrează apare sub numele dat de telefon, marcat ca neasociat, iar o tură înregistrată de el este semnalată pentru verificare sau, dacă această instalare nu face ture din înregistrări cu probleme, așteaptă pe pagina peșterii să fie convertită manual.",
    "columns": {
      "user": "Utilizator de telefon",
      "lastSeen": "Văzut ultima dată",
      "caver": "Speolog",
      "linkedBy": "Asociat de"
    },
    "firstSeen": "Văzut prima dată {{when}}",
    "deviceAccount": "contul {{id}}",
    "noName": "Telefonul nu a trimis niciun nume",
    "notDescribed": "Încă nedescris de telefon",
    "sentBy": "Trimis de {{name}}",
    "chooseCaver": "Spune ce speolog este",
    "unnamedCaver": "Cineva pe care pagina nu îl poate numi",
    "notMapped": "Neasociat",
    "sourceDevice": "Telefonul",
    "sourceArchiveImport": "Un import de arhivă",
    "sourceAdministrator": "Cineva care ține evidența speologilor",
    "unlink": "Elimină asocierea",
    "unlinkConfirm": "Elimini această asociere?",
    "unlinkConfirmBody": "Utilizatorul de telefon rămâne în listă, ca neasociat. Ce a fost înregistrat sub numele lui nu se schimbă, iar telefonul poate spune din nou cine este.",
    "linked": "Asociat.",
    "unlinked": "Asociere eliminată.",
    "empty": "Niciun telefon nu a trimis încă nimic.",
    "forbidden": "Lista utilizatorilor de telefon este deschisă conturilor care pot citi lista speologilor.",
    "loadFailed": "Utilizatorii de telefon nu au putut fi încărcați.",
    "errors": {
      "caverNotFound": "Acest speolog nu mai este în listă.",
      "userNotFound": "Acest utilizator de telefon nu mai este listat."
    }
  },
  "statistics": {
    "title": "Statistici din ture",
    "open": "Statistici",
    "asVisibleToYou": "Numărate peste turele pe care le poți citi. Cineva cu alt acces vede alte totaluri pentru același subiect, iar amândouă sunt corecte.",
    "hoursPartial": "Orele acoperă {{counted}} din {{total}} participări în care au fost notate ora intrării și ora ieșirii.",
    "span": "Din {{from}} până în {{to}}.",
    "trips": "Ture",
    "people": "Persoane",
    "places": "Locuri",
    "firstVisits": "Primele vizite",
    "hoursUnderground": "Ore în subteran",
    "hours": "{{value, number}} h",
    "metresSurveyed": "Cartat",
    "metresOfRope": "Coardă",
    "surveyStations": "Puncte topografice",
    "incidents": "Ture cu incident",
    "photographs": "Fotografii",
    "trackedTrips": "Ture urmărite",
    "watchHoursUnderground": "Ore în subteran, din urmărire",
    "watchNote": "Orele din urmărire sunt o a doua numărătoare, luată din intrările și ieșirile din jurnalele de urmărire ale turelor. Nu se adună la orele în subteran de mai sus: unde o tură le are pe amândouă, sunt aceleași ore. Participări acoperite: {{counted}}.",
    "orientation": {
      "rose": "Roza direcțiilor galeriilor",
      "weighting": "Ponderare",
      "byLength": "După lungime",
      "byCount": "După număr",
      "north": "N",
      "east": "E",
      "south": "S",
      "west": "V",
      "ringLabel": "{{value}}%",
      "meanAxis": "Direcția medie {{value}}°",
      "roseDescriptionLength": "Direcțiile galeriilor pe {{sectors}} sectoare de {{width}}°, cu nordul în sus, ponderate după lungimea cartată. Fiecare direcție este desenată pe ambele părți ale diagramei, pentru că o galerie parcursă într-un sens și aceeași galerie cartată dinspre celălalt capăt sunt o singură direcție, nu două. Cea mai puternică este {{from}}–{{to}}°, cu {{percent}}% din lungime.",
      "roseDescriptionCount": "Direcțiile galeriilor pe {{sectors}} sectoare de {{width}}°, cu nordul în sus, ponderate după numărul de vize topografice. Fiecare direcție este desenată pe ambele părți ale diagramei, pentru că o galerie parcursă într-un sens și aceeași galerie cartată dinspre celălalt capăt sunt o singură direcție, nu două. Cea mai puternică este {{from}}–{{to}}°, cu {{percent}}% din vize.",
      "title": "Orientarea galeriilor",
      "dipAxis": "Înclinare",
      "legs": "Vize topografice",
      "countAxis": "Axa numărului",
      "linearCount": "Liniară",
      "logCount": "Logaritmică",
      "degrees": "{{value}}°",
      "loading": "Se calculează valorile.",
      "meanSteepness": "Înclinarea medie {{value}}° față de orizontală, indiferent dacă viza urcă sau coboară.",
      "dipRefusedTitle": "Înclinarea nu poate fi calculată",
      "dipRefusedReason": "Aceste trasee nu au altitudini, deci nimic din ele nu spune dacă o galerie urcă sau coboară. Desenarea lor oricum ar arăta peștera ca fiind orizontală peste tot, ceea ce este o afirmație despre peșteră pe care acest desen nu o poate face.",
      "noTrendTitle": "Nu se poate calcula nicio direcție",
      "noTrendReason": "Nimic din aceste trasee nu se deplasează pe hartă: fiecare viză fie coboară vertical, fie urcă vertical, fie este marcată ca galerie deja cartată într-o altă tură. O peșteră formată numai din puțuri este cazul obișnuit pentru aceasta. Nu există nicio direcție de desenat aici, ceea ce este o afirmație despre trasee și nu despre peșteră — lungimile de alături au fost măsurate din aceeași cartare și rămân valabile."
    },
    "cave": {
      "title": "Statistici din cartare",
      "nothingMeasured": "Această peșteră nu are trasee de măsurat. Nimic de aici nu este calculat dintr-o cartare.",
      "totalLength": "Lungime cartată",
      "planLength": "Lungime în plan",
      "verticalExtent": "Denivelare",
      "maximumExtent": "Cea mai mare desfășurare",
      "verticality": "Verticalitate",
      "horizontality": "Orizontalitate",
      "linearity": "Liniaritate",
      "sinuosity": "Sinuozitate",
      "segments": "Segmente",
      "paths": "Trasee",
      "highest": "Punctul cel mai înalt",
      "lowest": "Punctul cel mai jos",
      "lengthToDepth": "Lungime raportată la denivelare",
      "pathSinuosityTitle": "Sinuozitatea celor mai lungi galerii",
      "path": "Galerie",
      "pathNumber": "#{{value}}",
      "pathLength": "Lungime",
      "straightLine": "Linie dreaptă",
      "lengthAgainstRecord": "Lungimea față de fișă",
      "depthAgainstRecord": "Denivelarea față de fișă",
      "notComputed": "Nu poate fi calculată din traseele acestei peșteri.",
      "notDeclared": "{{computed}} calculat; nimic scris în fișă cu care să fie comparat.",
      "against": "{{computed}} calculat, {{declared}} în fișă, o diferență de {{difference}}.",
      "disagreementTitle": "Cartarea și fișa nu sunt de acord",
      "disagreementBody": "O valoare calculată din traseele acestei peșteri diferă de cea scrisă în fișa ei. Niciuna nu este automat cea greșită: o morfometrie scrisă de mână este adesea mai veche decât cartarea cu care este comparată, iar o cartare poate fi incompletă. Verifică care este mai recentă înainte de a modifica vreuna.",
      "basisSurveyFlags": "Măsurat din cartarea compilată, folosind marcajele topografului pentru a decide care vize sunt galerie. Aceasta este definiția acestor valori.",
      "hasAltitudes": "Aceste trasee au altitudini, deci valorile verticale de mai sus sunt măsurate din ele, nu presupuse.",
      "noAltitudes": "Aceste trasee nu au altitudini — planul unei peșteri nu înseamnă o peșteră orizontală. De aceea fiecare valoare verticală de mai sus este lăsată goală în loc să fie arătată ca zero: nimic de aici nu spune cât de mult coboară peștera, ceea ce este o afirmație despre desen și nu despre peșteră.",
      "measuredFromModel": "Măsurat din cartarea „{{name}}”. O peșteră poate avea mai multe cartări încărcate, iar valorile luate din două cartări diferite nu sunt aceeași măsurătoare.",
      "basisSkeletonHeuristic": "Aproximat din traseul stocat, pentru că această peșteră nu are o cartare compilată cu marcaje pe fiecare viză. Forma traseului ține locul marcajelor topografului: păstrează cea mai mare parte din lungimea cartată, dar pierde vizele razante dintr-un punct și, odată cu ele, ultimii metri ai fiecărui fund de sac. Aceste valori nu ar trebui puse alături de cele ale unei peșteri măsurate din cartarea ei ca și cum ar fi aceeași măsurătoare."
    },
    "topology": {
      "title": "Rețeaua de galerii",
      "sizeTitle": "Rețeaua așa cum a fost cartată",
      "nodes": "Puncte topografice din rețea",
      "nodesGloss": "Puncte topografice atinse de cel puțin o vizare de galerie.",
      "edges": "Vizări de galerie",
      "edgesGloss": "Perechi de puncte unite prin galerie. O galerie cartată de două ori se numără o singură dată.",
      "components": "Bucăți separate",
      "componentsGloss": "Părți ale cartării care nu se leagă între ele în subteran.",
      "junctions": "Intersecții",
      "junctionsGloss": "Locuri unde se întâlnesc trei sau mai multe galerii.",
      "extremities": "Fundături",
      "extremitiesGloss": "Locuri unde cartarea se oprește — un colmataj, un sifon sau pur și simplu locul de unde s-au întors cartatorii.",
      "cyclomatic": "Bucle independente",
      "cyclomaticGloss": "Câte trasee cu adevărat diferite există prin rețea. Zero înseamnă că fiecare loc se atinge pe un singur drum.",
      "reducedTitle": "Rețeaua cu tronsoanele drepte contractate",
      "reducedNodes": "Intersecții și fundături",
      "reducedNodesGloss": "Ce rămâne după ce fiecare tronson de galerie dintre două dintre ele este tratat ca o singură legătură.",
      "reducedEdges": "Legături între ele",
      "reducedEdgesGloss": "Câte una pentru fiecare tronson de galerie. Cei trei indici de mai jos se calculează pe acestea, nu pe vizările brute.",
      "reducedComponents": "Bucăți separate, contractate",
      "reducedComponentsGloss": "Părțile în care se împarte rețeaua contractată.",
      "alpha": "Gradul de buclare (alfa)",
      "alphaGloss": "Buclele existente față de câte ar putea avea cel mult o rețea de această mărime. Zero este o peșteră fără nicio buclă.",
      "beta": "Legături per intersecție (beta)",
      "betaGloss": "Sub unu este o peșteră ramificată; peste unu înseamnă că se închide în ea însăși.",
      "gamma": "Gradul de conectare (gama)",
      "gammaGloss": "Legăturile existente față de câte ar putea avea cel mult o rețea de această mărime.",
      "degreeTitle": "Cum se întâlnesc galeriile",
      "meanDegree": "Galerii la o intersecție sau fundătură obișnuită",
      "meanDegreeGloss": "Sub doi este o peșteră ramificată; mult peste doi este un labirint.",
      "degreeSpread": "Împrăștierea acestei valori",
      "degreeSpreadGloss": "Cât de mult variază numărul de galerii care se întâlnesc, de la un loc la altul.",
      "degreeVariation": "Împrăștierea față de medie",
      "degreeVariationGloss": "Aceeași împrăștiere ca proporție, ca să poată fi comparate peșteri de mărimi diferite.",
      "degreeCorrelation": "Se leagă intersecțiile de intersecții?",
      "degreeCorrelationGloss": "Pozitiv înseamnă că locurile aglomerate se leagă între ele; negativ înseamnă că intersecțiile au mai ales fundături atârnate de ele.",
      "branchesTitle": "Tronsoane de galerie",
      "branches": "Tronsoane",
      "branchesGloss": "Porțiuni de galerie de la o intersecție sau fundătură până la următoarea.",
      "loopingBranches": "Tronsoane care se întorc de unde au plecat",
      "loopingBranchesGloss": "Acestea nu au o linie dreaptă față de care să fie măsurate, deci nu intră în valoarea de sinuozitate de mai jos.",
      "meanBranchLength": "Lungimea medie a unui tronson",
      "meanBranchLengthGloss": "Cât este de obicei de la o intersecție la următoarea.",
      "shortestBranch": "Cel mai scurt tronson",
      "shortestBranchGloss": "Cea mai scurtă porțiune de galerie dintre două intersecții sau fundături.",
      "longestBranch": "Cel mai lung tronson",
      "longestBranchGloss": "Cea mai lungă astfel de porțiune.",
      "branchLengthVariation": "Împrăștierea lungimilor tronsoanelor",
      "branchLengthVariationGloss": "Față de media lor. O valoare mare înseamnă câteva galerii lungi printre multe scurte.",
      "shapeTitle": "Cum se desfășoară rețeaua",
      "lengthEntropy": "Uniformitatea lungimilor tronsoanelor",
      "lengthEntropyGloss": "De la zero la unu. Mare înseamnă tronsoane de toate lungimile în egală măsură; mic înseamnă că sunt mai toate de o singură lungime.",
      "orientationEntropy": "Uniformitatea direcțiilor galeriilor",
      "orientationEntropyGloss": "De la zero la unu, ponderată cu lungimea galeriilor. Mic înseamnă că peștera urmează una sau două direcții, de obicei diaclazele din rocă; mare înseamnă că merge în toate direcțiile.",
      "tortuosity": "Sinuozitate",
      "tortuosityGloss": "Cât de lung este un tronson de galerie față de linia dreaptă dintre capetele lui. Unu înseamnă perfect drept.",
      "averagePath": "Tronsoane între două locuri",
      "averagePathGloss": "Prin câte porțiuni de galerie treci, în medie, ca să ajungi de la o intersecție la alta.",
      "centralPointDominance": "Dependența de o singură intersecție",
      "centralPointDominanceGloss": "De la zero la unu. Mare înseamnă că mai toate traseele prin peșteră trec printr-un singur loc.",
      "clustering": "Galerii care se închid între ele",
      "clusteringGloss": "Cât de des două galerii care pleacă din aceeași intersecție sunt ele însele legate una de alta.",
      "completenessWhole": "Toate vizările din fișierul de cartare s-au legat de rețeaua de puncte și nu au existat două puncte în aceeași poziție. Valorile de mai sus acoperă întregul fișier.",
      "completenessPartial": "{{dropped}} vizări din fișierul de cartare nu au putut fi legate de rețeaua de puncte, iar {{merged}} puncte au avut aceeași poziție cu altele și au devenit un singur nod. Valorile de mai sus au fost calculate pe ce a rămas.",
      "completenessUnknown": "Nu este consemnat ce anume ar fi putut lăsa deoparte citirea acestei cartări, deci valorile de mai sus ar putea acoperi mai puțin decât conține fișierul.",
      "measuredFromModel": "Măsurat din cartarea „{{name}}”. O peșteră poate avea mai multe cartări încărcate, iar valorile luate din două cartări diferite nu sunt aceeași măsurătoare."
    }
  },
  "permissions": {
    "title": "Permisiuni",
    "button": "Permisiuni",
    "subject": "Subiect",
    "user": "Utilizator",
    "cavingGroup": "Grup de speologie",
    "pickUser": "Caută utilizatori…",
    "pickCavingGroup": "Alege un grup de speologie…",
    "addRule": "Adaugă regulă",
    "notManager": "Nu poți administra permisiunile acestui obiect.",
    "scope": "Se aplică la",
    "scopeObject": "Doar acest obiect",
    "scopeSubtree": "Acest obiect și tot ce conține",
    "viaExpedition": "Din tabără",
    "viaExpeditionHint": "Unele dintre aceste reguli au fost scrise de o tabără din care face parte această tură și se modifică acolo, nu aici. Sunt afișate pentru ca lista completă a celor care pot citi tura să fie într-un singur loc.",
    "denyHint": "O interdicție cântărește mai greu decât orice permisiune de la același nivel, iar o regulă pusă direct pe obiect cântărește mai greu decât una moștenită. Verifică ce efect are înainte de a salva.",
    "reviewRightWarning": {
      "title": "Cine verifică încărcările vede în întregime tot ce așteaptă verificarea",
      "body": "Dreptul de a verifica încărcările arată fiecare schimbare care așteaptă verificarea așa cum a fost trimisă, inclusiv pozițiile exacte ale peșterilor protejate și fotografiile peșterilor pe care verificatorul altfel nu le-ar putea deschide. Acordă-l doar persoanelor de încredere pentru toate peșterile. În afara verificării, un verificator vede în continuare doar ce îi permit celelalte drepturi."
    },
    "viaNamedExpedition": "Acordată prin tabăra {{name}}",
    "proposed": "propusă",
    "proposedHint": "Dialogul a fost deschis dintr-o legătură despre {{name}}. În rândul marcat „propusă” i se propune Citire pe acest obiect și nimic mai mult. Nimic nu se acordă până nu apeși OK.",
    "proposedAlready": "Dialogul a fost deschis dintr-o legătură despre {{name}}, care are deja aici o regulă ce include Citire. Nu s-a adăugat nimic."
  },
  "access": {
    "whyTitle": "Accesul tău aici și motivul lui",
    "allowed": "Permis",
    "denied": "Refuzat",
    "effect": "Efect",
    "effects": {
      "allow": "Permite",
      "deny": "Interzice"
    },
    "domain": "Se aplică la",
    "actionsColumn": "Acțiuni",
    "scope": "Domeniu de aplicare",
    "scopes": {
      "all": "Tot",
      "own": "Obiectele proprii",
      "cavingGroup": "Conținutul unui grup de speologie",
      "subtree": "Un obiect și tot ce conține",
      "featureSet": "Un set de obiecte",
      "cabinet": "Un dulap și tot ce este clasat sub el",
      "object": "Un singur obiect"
    },
    "levels": {
      "object": "obiect",
      "collection": "colecție",
      "global": "global"
    },
    "actions": {
      "read": "Citire",
      "write": "Scriere",
      "create": "Creare",
      "delete": "Ștergere",
      "share": "Partajare",
      "execute": "Rulare",
      "managePermissions": "Administrare permisiuni",
      "viewExactLocation": "Locație exactă"
    },
    "domains": {
      "features": "Obiecte",
      "tripLogs": "Jurnale de tură",
      "geofiles": "Fișiere geodate",
      "georeferencedMaps": "Hărți georeferențiate",
      "mapViews": "Vederi de hartă salvate",
      "files": "Depozitul de fișiere",
      "documents": "Documente",
      "expeditions": "Expediții",
      "mapLayers": "Straturi de hartă",
      "tags": "Etichete",
      "hierarchies": "Ierarhii",
      "taxonomies": "Taxonomii",
      "cavers": "Speologi",
      "cavingGroups": "Grupuri de speologie",
      "users": "Conturi de utilizator",
      "permissionGroups": "Grupuri de permisiuni",
      "featureSets": "Seturi de obiecte",
      "settings": "Setările instalării",
      "messageTemplates": "Texte mesaje",
      "audit": "Istoricul de audit",
      "jobs": "Sarcini",
      "terrain": "Relief",
      "checklists": "Liste de verificare",
      "events": "Evenimente din calendar",
      "uploadReview": "Revizuirea încărcărilor"
    },
    "sources": {
      "fullAdministrators": "Administrare deplină: apartenența decide înainte de orice regulă.",
      "ownership": "Acordat prin proprietatea asupra obiectului.",
      "visibility": "Acordat prin vizibilitatea obiectului.",
      "none": "Nicio regulă nu acordă acest drept."
    },
    "decidedByRule": "Decis la nivelul de {{level}} de „{{rule}}”.",
    "decidedByHiddenRule": "Decis la nivelul de {{level}} de o regulă pe care nu o poți vedea.",
    "decidedByDirectRule": "Decis de o regulă scrisă direct pe acest obiect."
  },
  "permissionGroups": {
    "title": "Grupuri de permisiuni",
    "intro": "Seturi de reguli cu membri. O regulă trăiește aici sau direct pe un obiect — niciodată într-un grup de speologie, care poate fi doar membru și le transmite oamenilor săi ce deține.",
    "new": "Grup de permisiuni nou",
    "name": "Denumire",
    "description": "Descriere",
    "membersColumn": "Membri",
    "rulesColumn": "Reguli",
    "manage": "Administrează",
    "deleteConfirm": "Ștergi acest grup de permisiuni și regulile lui? Membrii pierd doar ce acorda el.",
    "protected": "Protejat",
    "seeded": "Predefinit",
    "nameTaken": "Există deja un grup de permisiuni cu această denumire.",
    "nameInvalid": "Denumirea trebuie să conțină litere sau cifre.",
    "lastFullAdmin": "Refuzat: nu ar mai rămâne niciun administrator deplin activ care să se poată autentifica.",
    "exceedsOwnRights": "Refuzat: o regulă nu poate acorda drepturi pe care nu le deții tu.",
    "rulesTab": "Reguli",
    "membersTab": "Membri",
    "previewTab": "Previzualizare",
    "addRule": "Adaugă regulă",
    "fullAdminNoRules": "Administratorii deplini nu au reguli: apartenența însăși este dreptul, decisă înaintea oricărei reguli — de aceea nicio interdicție nu îi poate atinge.",
    "previewRequired": "Acest set de reguli conține o interdicție. Deschide previzualizarea și uită-te ce ar deține cineva afectat înainte de a salva — o interdicție salvată orbește poate bloca oameni.",
    "openPreview": "Deschide previzualizarea",
    "addMember": "Adaugă",
    "noMembers": "Încă niciun membru.",
    "removeMemberConfirm": "Elimini acest membru?",
    "runPreview": "Previzualizează",
    "previewIntro": "Alege un utilizator sau un grup de speologie pentru a vedea drepturile pe care le-ar deține.",
    "previewLegend": "Extinde un rând pentru a vedea ce regulă a decis fiecare acțiune.",
    "noRights": "nimic",
    "narrowKind": "Restrânge la un fel…",
    "narrowType": "Restrânge la un tip…",
    "pickCavingGroupAnchor": "Alege un grup de speologie…",
    "pickFeatureSetAnchor": "Alege un set de obiecte…",
    "pickCabinetAnchor": "Alege un dulap…",
    "pickFeatureAnchor": "Caută obiecte…",
    "pickPermissionGroupAnchor": "Alege un grup de permisiuni…",
    "anchorIdPlaceholder": "Id-ul obiectului (copiază-l din pagina lui)"
  },
  "featureSets": {
    "title": "Seturi de obiecte",
    "intro": "Seturi denumite de obiecte la care se pot raporta regulile de acces — felul de a spune „exact aceste peșteri” când nicio zonă a ierarhiei nu le conține exact.",
    "new": "Set de obiecte nou",
    "edit": "Editează setul de obiecte",
    "name": "Denumire",
    "description": "Descriere",
    "membersColumn": "Obiecte",
    "membersTitle": "Obiectele din „{{name}}”",
    "editMembers": "Editează obiectele",
    "membershipMovesAccess": "Regulile se pot raporta la acest set, deci schimbarea obiectelor lui mută drepturi de acces. Fiecare modificare rămâne în istoricul de audit.",
    "searchFeature": "Caută obiecte…",
    "addFeature": "Adaugă",
    "noMembers": "Niciun obiect în acest set.",
    "deleteConfirm": "Ștergi acest set de obiecte?",
    "inUse": "Există reguli care se referă la acest set; elimină-le mai întâi.",
    "nameTaken": "Există deja un set de obiecte cu această denumire."
  },
  "cavingGroupPicker": {
    "create": "Creează «{{name}}»",
    "created": "{{name}} a fost adăugat la grupurile de speologie.",
    "noMatch": "Niciun grup de speologie cu acest nume.",
    "nameTaken": "Există deja un grup de speologie cu acest nume. Alege-l din listă.",
    "nameInvalid": "Numele unui grup de speologie trebuie să conțină litere sau cifre.",
    "nameTooLong": "Numele este prea lung pentru un grup de speologie.",
    "forbidden": "Nu ai dreptul să adaugi grupuri de speologie.",
    "createFailed": "Grupul de speologie nu a putut fi adăugat."
  },
  "security": {
    "title": "Securitatea contului",
    "password": {
      "title": "Parolă",
      "intro": "Schimbă parola cu care te autentifici. Ai nevoie de cea pe care o folosești acum.",
      "current": "Parola actuală",
      "currentRequired": "Introdu parola pe care o folosești acum.",
      "incorrect": "Aceasta nu este parola ta actuală.",
      "rejected": "Această parolă nu este acceptată. Folosește cel puțin 10 caractere.",
      "notSet": "Acest cont se autentifică fără parolă.",
      "signsOut": "Schimbarea parolei te deconectează peste tot, inclusiv aici. Apoi te autentifici din nou cu cea nouă.",
      "revokeKeys": "Revocă și cheile mele de acces",
      "revokeKeysHint": "Dispozitivele care încarcă folosind una dintre cheile tale nu mai funcționează până le dai o cheie nouă. Lasă oprit ca să funcționeze în continuare.",
      "submit": "Schimbă parola",
      "changed": "Parola a fost schimbată."
    },
    "mfa": "Autentificare în doi pași",
    "statusOn": "Activă",
    "statusOff": "Inactivă",
    "intro": "Cere o a doua dovadă a identității la autentificare. O aplicație de autentificare este cea mai sigură; un cod trimis este mai ușor de configurat.",
    "enable": "Configurează doi pași",
    "enterKey": "Dacă nu îl poți scana, adaugă manual această cheie:",
    "codePlaceholder": "Cod din 6 cifre",
    "confirm": "Confirmă",
    "codeInvalid": "Codul nu este valid.",
    "lockedOut": "Prea multe coduri greșite. Contul este blocat pentru un timp; așteaptă, apoi încearcă din nou.",
    "enabled": "Autentificarea în doi pași este activă.",
    "disabled": "Autentificarea în doi pași este inactivă.",
    "disable": "Dezactivează",
    "disableConfirm": "Dezactivezi autentificarea în doi pași?",
    "recoveryLeft": "Coduri de recuperare rămase: {{count}}",
    "recoveryTitle": "Salvează aceste coduri de recuperare acum — sunt afișate o singură dată.",
    "linkedAccounts": "Conturi asociate",
    "linkedIntro": "Autentifică-te cu un furnizor extern, pe lângă parolă.",
    "linkWith": "Asociază {{provider}}",
    "linkAdded": "Cont asociat.",
    "linkFailed": "Contul nu a putut fi asociat. Este posibil să fie deja asociat în altă parte.",
    "unlink": "Dezasociază",
    "unlinkConfirm": "Elimini acest cont asociat?",
    "unlinked": "Cont dezasociat.",
    "unlinkFailed": "Contul nu a putut fi dezasociat.",
    "method_authenticator": "Aplicație de autentificare",
    "method_email": "Cod prin e-mail",
    "method_sms": "Cod prin SMS",
    "methodHint_authenticator": "Un cod de șase cifre dintr-o aplicație de pe telefon. Funcționează fără semnal.",
    "methodHint_email": "Un cod trimis la adresa ta confirmată.",
    "methodHint_sms": "Un cod trimis la numărul tău confirmat.",
    "methodNotAllowed": "Nu este activată pe această instalare.",
    "methodEmailNotReady": "Confirmă mai întâi adresa de e-mail.",
    "methodSmsNotReady": "Confirmă mai întâi un număr de telefon.",
    "methodUnusable": "Indisponibilă acum",
    "methodDisabled": "Metoda este dezactivată.",
    "turnOn": "Activează",
    "turnOff": "Dezactivează",
    "makeDefault": "Setează implicit",
    "default": "Implicit",
    "disableMethodConfirm": "Dezactivezi această metodă?",
    "scanTitle": "Configurează aplicația de autentificare",
    "codeSent": "Cod trimis către {{destination}}.",
    "resendCode": "Trimite din nou",
    "challengeFailed": "Codul nu a putut fi trimis.",
    "phoneTitle": "Număr de telefon",
    "phoneVerified": "Verificat",
    "phoneAdd": "Adaugă numărul",
    "phoneChange": "Schimbă numărul",
    "phoneRemove": "Șterge",
    "phoneRemoveConfirm": "Ștergi numărul? Codurile prin SMS vor fi dezactivate odată cu el.",
    "phoneRemoveLastFactorTitle": "Ștergi singurul factor secundar?",
    "phoneRemoveLastFactor": "Codurile prin SMS sunt singurul factor secundar al acestui cont. Ștergerea numărului dezactivează autentificarea în doi pași: de atunci contul va fi protejat doar de parolă. Vei primi un e-mail care te anunță acest lucru.",
    "phoneRemoveLastFactorOk": "Șterge și dezactivează",
    "phoneRemoved": "Numărul a fost șters.",
    "phoneConfirmed": "Numărul este confirmat.",
    "phoneNumber": "Număr de telefon",
    "phonePending": "Se așteaptă codul trimis la {{number}}.",
    "phoneSendFailed": "Codul nu a putut fi trimis la acel număr.",
    "phoneTaken": "Alt cont folosește deja acel număr.",
    "phoneHint": "Folosit doar pentru codurile de autentificare. Introdu-l în format internațional, de exemplu +40712345678.",
    "smsNotConfigured": "Această instalare nu are un gateway SMS, deci codurile prin SMS nu sunt disponibile.",
    "scanHint": "Scanează acest cod cu aplicația de autentificare, apoi introdu codul afișat.",
    "scanAlt": "Cod QR pentru aplicația de autentificare"
  },
  "workspace": {
    "menu": "Spațiul de lucru: aranjări",
    "presetsTitle": "Aranjări",
    "preset": {
      "map": "Hartă",
      "map3d": "Hartă + 3D",
      "survey": "Verificarea topografiilor",
      "trip": "Planificarea turei",
      "twoScreens": "Două ecrane"
    },
    "presetHint": {
      "map": "Harta între cele două panouri",
      "map3d": "Scena 3D lângă hartă",
      "survey": "Modelul topo al unei peșteri lângă hartă",
      "trip": "Sub hartă: ce este în vedere și relieful în 3D",
      "twoScreens": "Harta aici, scena 3D într-o fereastră separată"
    },
    "savedTitle": "Aranjări salvate",
    "saveCurrent": "Salvează aranjarea curentă…",
    "saveTitle": "Salvează aranjarea curentă",
    "saveHint": "Păstrează sub un nume panourile, panourile din jurul hărții și dacă scena 3D este deschisă. Aranjările salvate îți urmează contul.",
    "tableToggle": "Tabel sub hartă",
    "swapDocks": "Inversează panourile laterale",
    "maximiseMap": "Extinde harta pe tot spațiul de lucru",
    "mapName": "harta",
    "scene3dName": "Scena 3D",
    "surveyName": "Model topo",
    "tableName": "tabelul",
    "move": "Mută: {{name}}",
    "maximise": "Extinde pe tot spațiul de lucru: {{name}}",
    "restore": "Readu la mărimea proprie: {{name}}",
    "restoreShort": "Readu",
    "close": "Închide: {{name}}",
    "place": {
      "left": "În stânga hărții",
      "right": "În dreapta hărții",
      "bottom": "Sub hartă",
      "window": "Într-o fereastră separată"
    },
    "pickedTab": "Alese ({{count}})",
    "pickedEmpty": "Nu ai ales nimic. Ține apăsat Ctrl sau Shift când dai clic pe hartă ca să alegi mai multe obiecte.",
    "surveyPickCave": "Alege o peșteră pe hartă: modelele ei topo apar aici.",
    "surveyNone": "Peștera aceasta nu are niciun model topo care să poată fi deschis aici.",
    "surveyChoose": "Deschide aici unul dintre modelele topo ale peșterii:",
    "resizePanes": "Redimensionează panourile de o parte și de alta",
    "resizeBottom": "Redimensionează harta și banda de sub ea",
    "shortcutMaximise": "Extinde panoul în care te afli pe tot spațiul de lucru sau readu toate panourile la mărimea lor",
    "admin": {
      "tab": "Spațiul de lucru",
      "intro": "Aranjarea cu care pornește un cont nou pe hartă. Se aplică o singură dată, prima dată când un cont deschide harta fără să fi aranjat ceva; după aceea aranjarea este a membrului.",
      "preset": "Aranjarea de pornire",
      "builtIn": "Hartă (ca la livrare)",
      "saved": "Salvat.",
      "unreadable": "Aranjarea de pornire a instalării nu a putut fi citită, așa că nu a fost schimbată. Corecteaz-o întâi prin API-ul de setări."
    }
  },
  "views": {
    "title": "Vederi salvate",
    "namePlaceholder": "Nume vedere…",
    "save": "Salvează vederea curentă",
    "filterHoldsPosition": "Filtrul acestei vederi conține un punct introdus, un poligon lipit sau locul de la care se ordonează „cel mai apropiat”, iar o vedere salvată nu le păstrează niciodată. Măsoară în schimb de la un obiect sau de la o zonă numită, ori aplică un filtru salvat.",
    "share": "Link de partajare",
    "linkCopied": "Linkul de partajare a fost copiat.",
    "exportImage": "Exportă imaginea hărții",
    "sharedNotFound": "Această vedere partajată nu există sau a fost revocată.",
    "sharedClusterHint": "{{count}} intrări aici — apropie harta pentru a le vedea pe rând.",
    "sharedNoBackground": "Nicio hartă de fundal nu este disponibilă pentru vederile partajate în această instalare.",
    "sharedUnnamed": "Fără nume",
    "sharedClose": "Închide",
    "sharedProtectedNote": "Peșterile protejate nu sunt afișate niciodată pe o hartă partajată.",
    "exportUnreadable": "Harta nu poate fi pusă într-o imagine: unul dintre straturile ei vine de la un furnizor care nu permite asta.",
    "exportUnreadableLayers": "Harta nu poate fi pusă într-o imagine cât timp arată {{layers}}: furnizorul nu permite asta.",
    "exportUnreadableTry": "Alege un fundal permis în documente, de exemplu {{name}}, oprește celelalte straturi numite aici și exportă din nou.",
    "exportUnreadableNone": "Niciunul dintre fundalurile acestei instalări nu poate fi pus într-o imagine.",
    "shareTitle": "Partajează vederea {{name}}",
    "shareExplain": "Oricine are acest link poate deschide vederea fără cont. Arată zona spre care privește vederea, peste un fundal public, cu straturile pe care vederea le avea pornite — doar ce este public în sine, iar peșterile și obiectele protejate lipsesc cu totul.",
    "shareWithoutData": "Această vedere este restrânsă de un filtru salvat sau de un filtru venit dintr-un link, pe care un link nu îl poate aplica — așa că linkul arată zona și fundalul ei, fără peșteri și obiecte. Nici straturile desenate din filtre salvate nu apar vreodată printr-un link.",
    "shareWithoutFilterLayers": "Straturile desenate din filtre salvate nu apar niciodată printr-un link; linkul arată celelalte straturi ale vederii.",
    "shareQr": "Linkul către vederea {{name}} ca cod QR"
  },
  "panel": {
    "unknown": "Panou necunoscut.",
    "registryTitle": "Registrul peșterilor",
    "popOut": "Deschide registrul într-o fereastră separată",
    "popOut3d": "Deschide fereastra 3D",
    "popOutScene3d": "Deschide scena 3D într-o fereastră separată",
    "viewer3dTitle": "Vizualizator 3D",
    "viewer3dEmpty": "Selectează o peșteră cu model 3D pentru a-l afișa aici.",
    "viewer3dUnavailable": "Acest model topografic nu mai este disponibil sau nu ai acces la el.",
    "scene3dTitle": "Scena 3D",
    "sections": {
      "details": "Detalii",
      "tags": "Etichete",
      "attachments": "Fișiere",
      "links": "Legături",
      "history": "Istoric",
      "permissions": "Permisiuni",
      "text": "Text"
    },
    "reorder": "Mută {{section}}",
    "reorderHint": "Trage pentru a reordona sau ține Alt și apasă săgețile sus și jos",
    "hideSection": "Ascunde secțiunea",
    "hideSectionNamed": "Ascunde {{section}}",
    "showSection": "Arată din nou secțiunea",
    "hiddenSections": "Ascunse:",
    "restoreSections": "Revino la aranjarea implicită",
    "allHidden": "Toate secțiunile sunt ascunse.",
    "back": "Înapoi la selecția anterioară",
    "forward": "Înainte",
    "pin": "Împinge harta lateral",
    "unpin": "Plutește peste hartă",
    "density": "Spațiere",
    "layouts": "Aranjări salvate",
    "layoutName": "Denumește aranjarea",
    "deleteLayout": "Șterge {{name}}",
    "layoutKeptHere": "Doar în acest browser",
    "layoutKeptHereWhy": "Preferințele salvate ale contului erau pline când a fost salvată această aranjare, așa că ea este păstrată doar în acest browser și nu va apărea în altul. Șterge o aranjare pe care n-o mai folosești, iar aceasta ajunge în cont odată cu acea schimbare.",
    "deleteLayoutConfirm": "Ștergi aranjarea {{name}}?",
    "selectionTitle": "Selecție",
    "popOutSelection": "Deschide panoul de selecție într-o fereastră proprie",
    "multiTitle_one": "{{count}} selectat",
    "multiTitle": "{{count}} selectate",
    "multiReadable": "Lizibile aici",
    "multiMixed": "Amestecate",
    "multiHint": "Ține Ctrl sau Shift în timp ce dai clic pe hartă pentru a adăuga la selecție.",
    "multiNothingReadable": "Niciunul dintre obiectele selectate nu poate fi citit aici.",
    "clearSelection": "Golește selecția",
    "zoomToAll": "Încadrează-le pe toate",
    "bulkTag": "Etichetează-le pe toate",
    "bulkTagHint": "Etichetarea în masă vine odată cu filtrul comun."
  },
  "scene3d": {
    "unsupportedTitle": "Acest browser nu poate afișa vizualizarea 3D",
    "unsupportedHint": "Vizualizarea 3D are nevoie de WebGL 2, pe care acest browser sau driverul său grafic nu îl oferă. Încearcă un browser actualizat sau folosește în continuare harta 2D.",
    "openFlatMap": "Deschide harta 2D",
    "startFailed": "Vizualizarea 3D nu a putut fi pornită",
    "centerlinesFlat": "{{count}} drumuiri desenate la suprafață — pentru ele nu au fost disponibile adâncimi topografiate.",
    "surfaceTitle": "Terenul de deasupra peșterii",
    "surfaceOverlay": "Arată peștera prin el",
    "surfaceOverlayHint": "Drumuirea este desenată peste teren și rămâne vizibilă din orice unghi. Cât de adâncă este o galerie se vede din culoarea liniei, nu din ce o acoperă.",
    "surfaceCutaway": "Decupează-l",
    "surfaceCutawayHint": "Terenul de deasupra peșterii este decupat, astfel încât drumuirea se vede printr-o deschidere în suprafață.",
    "cutawayUnsupported": "Acest browser nu poate decupa terenul. Peștera este arătată prin el.",
    "cutawayNoCave": "Nu este încărcată nicio drumuire în jurul căreia să se decupeze. Peștera este arătată prin teren.",
    "cutawayPaused": "De aici deschiderea se vede din profil — înclină vederea în jos spre peșteră pentru a privi în ea.",
    "cutawayUnderground": "Vederea este sub suprafață, unde nu mai există teren între tine și peșteră. Urcă înapoi deasupra ei pentru a privi în jos, prin deschidere.",
    "meshLayer": "Pereții peșterilor",
    "meshNoCave": "Alege o peșteră pentru a vedea pereții cartați pentru ea.",
    "meshOff": "Pereții nu sunt încărcați și nu ocupă memorie grafică.",
    "meshLooking": "Se caută un model de pereți pentru această peșteră…",
    "meshAsk": "Acești pereți au {{size}} de descărcat.",
    "photosLayer": "Fotografii la stațiile lor",
    "photosNoCave": "Selectează o peșteră ca să fie marcate locurile în care s-au făcut fotografiile ei.",
    "photosOff": "Nu sunt afișate.",
    "photosLooking": "Se caută fotografiile legate de stațiile peșterii…",
    "photosFailed": "Fotografiile nu au putut fi căutate.",
    "photosNone": "Nicio fotografie a acestei peșteri nu este legată de o stație a topografiei ei.",
    "photosDrawn": "Fotografii: {{count}} · stații: {{places}} — apasă o cameră ca să le deschizi.",
    "meshAskDownload": "Descarcă-i",
    "meshLoading": "Se încarcă pereții…",
    "meshLoadingSized": "Se încarcă pereții — {{triangles}} triunghiuri.",
    "meshDrawn": "Pereții sunt desenați.",
    "meshDrawnSized": "Pereții sunt desenați — {{triangles}} triunghiuri.",
    "meshConverting": "Modelul încărcat este încă în conversie. Apare aici imediat ce este gata.",
    "meshNone": "Pentru această peșteră nu a fost încărcat niciun model de pereți.",
    "meshFailed": "Pereții acestei peșteri nu au putut fi desenați.",
    "meshFailedBecause": "Pereții nu au putut fi desenați: {{reason}}",
    "meshPrecisionLost": "Fișierul încărcat pierduse deja detalii înainte de a ajunge aici. Reexportarea lui în jurul unei origini locale le recuperează.",
    "terrainUnreachable": "Datele de altitudine ale acestei instalări nu au putut fi accesate, așa că terenul este afișat ca un glob neted. Verifică dacă directorul cu teren este servit la adresa configurată.",
    "terrainUnreachableFellBack": "Datele de altitudine ale acestei instalări nu au putut fi accesate la adresa configurată, așa că terenul este desenat din piramida generată de instalare. Verifică dacă directorul cu teren este servit acolo unde spune configurația sau elimină acea setare.",
    "terrainMalformed": "Adresa configurată pentru datele de altitudine nu conține un set de dale de teren, așa că terenul este afișat ca un glob neted. Verifică dacă piramida generată, împreună cu layer.json, este servită acolo.",
    "terrainMalformedFellBack": "Adresa configurată pentru datele de altitudine nu conține un set de dale de teren, așa că terenul este desenat din piramida generată de instalare. Verifică dacă piramida generată, împreună cu layer.json, este servită acolo sau elimină acea setare.",
    "terrainEncodingMismatch": "Dalele de altitudine sunt servite cu o compresie care nu corespunde conținutului lor, așa că terenul este afișat ca un glob neted. Serverul web trebuie să declare exact codificarea în care sunt fișierele de pe disc și nimic altceva.",
    "terrainEncodingMismatchFellBack": "Dalele de altitudine de la adresa configurată sunt servite cu o compresie care nu corespunde conținutului lor, așa că terenul este desenat din piramida generată de instalare. Serverul web trebuie să declare exact codificarea în care sunt fișierele de pe disc și nimic altceva.",
    "depthLegend": "Adâncimea sub partea de sus a peșterii",
    "depthLegendBand": "{{meters}} m",
    "showingElsewhere": "Scena 3D este deschisă în alt panou al acestei ferestre.",
    "fitCave": "Încadrează peștera din vedere",
    "cameraTitle": "Cameră",
    "closeCallout": "Închide",
    "projectionOrthographic": "Elimină perspectiva",
    "projectionOrthographicHint": "Elimină perspectiva, astfel încât distanțele să se citească la fel aproape și departe",
    "projectionPerspectiveHint": "Reactivează perspectiva",
    "coupleToMap": "Mișcă odată cu harta",
    "coupleToMapHint": "Mișcă din nou odată cu harta plană, aducând camera unde se uită ea",
    "uncoupleFromMapHint": "Nu mai mișca odată cu harta plană, ca fiecare să poată fi mutată separat",
    "presetGlyph": {
      "top": "⌖",
      "north": "N",
      "south": "S",
      "east": "E",
      "west": "V"
    },
    "preset": {
      "top": "Privire verticală (plan)",
      "north": "Vedere dinspre nord",
      "south": "Vedere dinspre sud",
      "east": "Vedere dinspre est",
      "west": "Vedere dinspre vest"
    },
    "contextLostTitle": "Vizualizarea 3D s-a oprit",
    "contextLostHint": "Browserul a eliberat resursele grafice folosite de această vizualizare, de două ori la scurt timp. De obicei, reîncărcarea paginii o restabilește.",
    "contextLostReload": "Reîncarcă",
    "rasterOverlayHint": "Pe glob fiecare planșă este aplatizată într-o singură imagine, așa că devine mai neclară la apropiere. Harta plană citește fișierul în sine și rămâne clară.",
    "geofileTracksHint": "Traseele și contururile din aceste fișiere sunt desenate ca linii, în culorile folosite pe harta plană. Un traseu care nu a înregistrat altitudini este așezat pe teren.",
    "catalogueLayer": {
      "unavailable": "Nedesenat în 3D",
      "cog_unreadable": "Acest GeoTIFF nu a putut fi citit, așa că vederea 3D nu îl desenează.",
      "cog_not_georeferenced": "Acest GeoTIFF nu spune unde se află pe teren, așa că vederea 3D nu îl desenează.",
      "cog_projection_unusable": "Sistemul de coordonate al acestui GeoTIFF nu poate fi folosit aici, așa că vederea 3D nu îl desenează.",
      "cog_band_missing": "Acestui GeoTIFF îi lipsește o bandă pe care intrarea lui o cere, așa că vederea 3D nu îl desenează.",
      "cog_short_pyramid": "Acest GeoTIFF nu conține copii micșorate ale sale, așa că vederea 3D îl desenează doar de aproape.",
      "vector_unreadable": "Stilul sau datele acestui fundal nu au putut fi încărcate, așa că vederea 3D nu îl desenează.",
      "vector_stand_in": "Desenat în 3D ca {{name}}."
    },
    "terrainTitle": "Terenul",
    "terrainBuildsHint": "Fiecare generare acoperă o zonă la un nivel de detaliu. Schimbarea recitește terenul și mută topografiile pe noua suprafață.",
    "terrainConfiguredEntry": "Modelul de altitudine configurat",
    "terrainBuildLevel": "Nivelul {{level}}",
    "terrainBuildSize": "{{width}} × {{height}} km",
    "terrainFinerOffer": "Un relief mai fin acoperă această zonă — îl desenăm?",
    "terrainFinerDraw": "Desenează-l",
    "terrainFinerDismiss": "Nu acum",
    "meshLoadingBytes": "Se încarcă pereții — {{size}}.",
    "meshDrawnBytes": "Pereții sunt desenați — {{size}}.",
    "meshDrawnBytesTriangles": "Pereții sunt desenați — {{size}}, {{triangles}} triunghiuri.",
    "meshMode": "Pereții căror peșteri sunt desenați",
    "meshModeSelected": "Peștera selectată",
    "meshModeInView": "Toate peșterile din vedere",
    "meshesInViewZoomIn": "Apropie vederea pentru a vedea pereții peșterilor din ea.",
    "meshesInViewLooking": "Se caută pereții peșterilor din vedere…",
    "meshesInViewFailed": "Pereții peșterilor din vedere nu au putut fi listați.",
    "meshesInViewNone": "Nicio peșteră din vedere nu are pereți de desenat.",
    "meshesInViewShown": "Peșteri din vedere cu pereții desenați: {{shown}} din {{total}} — {{size}}.",
    "meshesInViewOverBytes": "Peșteri din vedere cu pereții desenați: {{shown}} din {{total}} — restul ar depăși {{limit}}.",
    "meshesInViewOverCount": "Peșteri din vedere cu pereții desenați: {{shown}} din {{total}} — restul sunt peste cele {{limit}} desenate deodată.",
    "meshesInViewLoading": "Încă se încarcă: {{count}}.",
    "meshesInViewUnreadable": "Nu au putut fi citite: {{count}}.",
    "meshesInViewLimitsLink": "Schimbă aceste limite în Setări › Avansat",
    "surfaceFeaturesCapped": "Se arată primele {{limit}} fenomene de suprafață din această vedere, atât cât permite această instalare; apropie vederea pentru a le vedea pe celelalte.",
    "entrancesCapped": "Se arată primele {{limit}} intrări în peșteri din această vedere, atât cât permite această instalare; apropie vederea pentru a le vedea pe celelalte.",
    "saveImage": "Salvează imaginea",
    "saveImageHint": "Salvează această vedere ca imagine",
    "saveImageFailed": "Această vedere nu a putut fi salvată ca imagine."
  },
  "caveview": {
    "dankezCaveView": {
      "tab": "LochViewer (de probă)",
      "trialNotice": "Un al doilea vizualizator, de probă, care arată același fișier. Este o aplicație separată: setările, măsurătorile și partajarea lui sunt ale lui și nu se salvează aici. Dacă rama de mai jos rămâne goală, această instalare nu permite încadrarea lui: deschide-l într-o fereastră nouă.",
      "openWindow": "Deschide într-o fereastră nouă",
      "sending": "Se predă topografia vizualizatorului…",
      "loaded": "Stații încărcate: {{count}}",
      "station": "Stație aleasă: {{name}}"
    },
    "loadError": "Modelul 3D nu a putut fi încărcat",
    "linkThisPart": "Leagă asta…",
    "notInThisModel": "Acel punct nu se află în acest model",
    "labelSize": "Mărimea numelor de stații",
    "labelSizeValue": "{{percent}}%",
    "stationPicture": "Fotografie la această stație",
    "compare": {
      "open": "Compară cu…",
      "overlaid": "Suprapuse",
      "sideBySide": "Alăturate",
      "mode": "Cum sunt arătate cele două modele",
      "stop": "Oprește compararea",
      "linkViews": "Leagă vederile",
      "linkViewsHint": "Rotirea, înclinarea sau apropierea unui model face același lucru cu celălalt",
      "sync": "Sincronizare",
      "syncHint": "Arătarea sau ascunderea unei topografii face același lucru cu topografia cu același nume din celălalt model",
      "surveys": "Topografii",
      "surveysOf": "Topografiile din {{model}}",
      "showAll": "Arată tot",
      "noSurveys": "Acest model nu are topografii denumite care să poată fi arătate sau ascunse.",
      "legend": "Care model este care",
      "apart": {
        "title": "Aceste două modele nu sunt în aceleași coordonate",
        "body": "Nu pot fi suprapuse. Unul poate fi măsurat față de un punct propriu, iar celălalt într-o proiecție națională, sau fiecare față de alt punct. Alăturate, fiecare este încadrat separat și pot fi comparate în continuare.",
        "sideBySide": "Compară alăturat"
      }
    },
    "picked": {
      "modelStation": "Stația {{name}}",
      "modelStationRange": "Galeria de la {{name}}",
      "modelSurvey": "Topografia {{name}}"
    },
    "tracking": {
      "people": "Speologi ({{count}})",
      "caveNotes": "Despre peșteră: {{count}}",
      "caveNoteMark": "Peșteră: {{note}}",
      "showLabels": "Arată numele pe model",
      "showTimes": "Arată când a fost raportată poziția",
      "markerNameTime": "{{name}} · {{when}}",
      "markerNameOut": "{{name}} (ieșit)",
      "close": "Închide",
      "out": "Ieșit",
      "noTeam": "Fără echipă",
      "cardTeam": "Echipă",
      "cardEntered": "A intrat",
      "cardPosition": "Unde",
      "cardPositionAt": "Poziție raportată la",
      "cardLastHeard": "Ultima veste",
      "positionWithheld": "Nu îți este arătată",
      "positionWithheldDetail": "Această poziție există și nu îți poate fi comunicată — peștera aceasta are o poziție exactă care nu îți poate fi dată. Este marcată, nu lăsată goală, pentru că un gol s-ar citi ca și cum nimeni nu ar ști unde se află acest om.",
      "positionMaybeWithheld": "Nu este arătată sau nu a fost raportată",
      "positionMaybeWithheldDetail": "Ultimul raport al acestui om nu a purtat niciun loc — intrarea, ieșirea și o notă nu poartă niciodată unul. Deci ori nimeni nu a raportat unde se află, ori a fost raportată o poziție care nu îți poate fi comunicată.",
      "positionOtherModel": "Pe altă topografie",
      "positionOtherModelDetail": "Cineva chiar a raportat unde se află acest om, dar a fost plasat pe altă topografie a acestei peșteri decât cea desenată aici. Același nume de stație poate însemna alt loc într-o altă topografie, așa că nu se desenează niciun marcaj în loc de unul care ar putea fi greșit. Raportul în sine se află în jurnalul turei.",
      "positionNotOnModel": "Nu e pe desen",
      "positionNotOnModelDetail": "Cineva a raportat acest om la {{station}}, chiar pe topografia desenată aici — dar acest desen nu are nicio stație cu acel nume, așa că nu are unde să fie marcat. Asta face o topografie reexportată cu stațiile redenumite fiecărui loc raportat înainte, fără ca nimeni să fi schimbat ceva. Raportul în sine rămâne în jurnalul turei, iar stația de mai sus este ceea ce a spus.",
      "positionStretch": "Între {{from}} și {{to}}",
      "positionStretchShort": "{{from}} – {{to}}",
      "stretchNotDrawn": "Pentru această porțiune nu este desenată nicio linie",
      "stretchToNotOnModelDetail": "Acest om a fost raportat între {{from}} și {{to}}. Marcajul stă la {{from}}; acest desen nu are nicio stație numită {{to}}, așa că nu este desenată nicio linie până la ea. Raportul în sine rămâne în jurnalul turei.",
      "stretchUnroutableDetail": "Acest om a fost raportat între {{from}} și {{to}}. Marcajul stă la {{from}}; topografia desenată aici nu are vize care să lege cele două stații, așa că nu este desenată nicio linie între ele. Raportul în sine rămâne în jurnalul turei.",
      "positionNotOnMap": "Fără punct pe această hartă",
      "positionNotOnMapDetail": "Cineva a raportat acest om la {{station}}, iar această hartă nu are niciun punct definit pentru acea stație — așa că nu are unde să fie marcat pe această planșă. Topografia în sine are stația în continuare, iar vederea 3D îl poate arăta. Definirea unui punct pentru stație pe această hartă, din vizualizatorul de modele, este ceea ce îl aduce pe ea.",
      "positionUnreported": "Nicio poziție raportată"
    },
    "movie": {
      "legendTripTeam": "{{trip}} · {{team}}",
      "legendMore": "și încă {{count}}",
      "legendTripColoursRepeat": "Culorile turelor se repetă",
      "legendTeamColoursRepeat": "Culorile echipelor se repetă",
      "noteBy": "{{name}}: {{note}}",
      "clockElapsed": "Timp scurs {{time}}",
      "clockSpeed": "{{clock}} · ×{{factor}}",
      "previewLoading": "Se încarcă modelul pentru previzualizare…",
      "previewError": "Modelul nu a putut fi încărcat pentru previzualizare.",
      "opening": "Se deschide realizarea filmului…",
      "openFailed": "Realizarea filmului nu s-a putut deschide.",
      "openFailedStale": "Aplicația a fost actualizată după ce ai deschis această pagină, iar pagina cere încă fișierele versiunii vechi. Reîncarcă pagina ca să folosești versiunea nouă.",
      "previewLoadingSoFar": "Se încarcă modelul pentru previzualizare… {{received}} până acum",
      "previewLoadingOf": "Se încarcă modelul pentru previzualizare… {{received}} din {{total}}",
      "previewStalled": "Din fișierul topografiei nu a mai sosit nimic timp de {{seconds}} de secunde, așa că descărcarea a fost abandonată. Serverul sau conexiunea pot fi lente; încearcă din nou.",
      "previewRetry": "Încearcă din nou",
      "make": "Fă un film",
      "makeHelp": "Exportă un film al acestui model, cu turele urmărite deplasându-se prin el",
      "title": "Film al urmăririi",
      "titleOf": "Film pe {{model}}",
      "groups": {
        "trips": "Ture",
        "output": "Fișier",
        "motion": "Mișcare",
        "cavers": "Speologi",
        "view": "Vedere",
        "captions": "Texte",
        "pictures": "Fotografii"
      },
      "tripsHint": "Bifează turele pe care le arată filmul. Fiecare își păstrează culoarea în ordinea în care le bifezi.",
      "tripReports": "Rapoarte: {{reports}}",
      "tripLive": "Încă în desfășurare · rapoarte noi de la deschidere: {{count}}",
      "whoAppears": "Cine apare: {{shown}} din {{total}}",
      "whoAppearsHelp": "Cine este debifat nu are marcaj și nici traseu în acest film, iar o notă spusă de acea persoană nu este scrisă peste imagine. Alegerea este doar pentru acest film; nu este reținută.",
      "noTrackedTrips": "Nicio tură nu a fost urmărită încă pe acest model.",
      "trackedLoadError": "Turele urmărite pe acest model nu au putut fi citite.",
      "tripsLoadError": "Urmărirea unei ture alese nu a putut fi citită.",
      "stretchNote": "Unele rapoarte ale acestor ture spun că un speolog era între două stații. Filmul îl desenează pe fiecare la prima dintre cele două și nu desenează nicio linie până la a doua.",
      "tripLoadError": "Această tură nu a putut fi citită.",
      "tripsFailedHint": "O tură aleasă nu a putut fi citită. Debifeaz-o sau închide și încearcă din nou.",
      "tripsLoading": "Se citesc turele alese…",
      "chooseTrip": "Alege cel puțin o tură pentru a previzualiza și exporta un film.",
      "format": "Format",
      "formats": {
        "gif": "GIF",
        "webm": "WebM",
        "mp4": "MP4"
      },
      "formatHelp": {
        "gif": "Se repetă și se deschide aproape oriunde; devine mare la dimensiuni și durate mari.",
        "webm": "Un video pe care îl redă orice browser; mic pentru calitatea lui.",
        "mp4": "Un video pe care îl deschid aplicațiile de mesagerie, prezentările și telefoanele."
      },
      "formatChecking": "Se verifică ce formate poate scrie acest browser…",
      "formatUnsupported": "Acest browser nu poate scrie {{format}} la {{size}}, cu {{fps}} cadre/s.",
      "formatNoVideoEncoder": "Acest browser nu are un codor video, așa că aici se poate face doar un GIF.",
      "size": "Dimensiunea cadrului",
      "aspects": {
        "16x9": "Lat (16:9)",
        "4x3": "Standard (4:3)",
        "9x16": "Vertical (9:16) — Reels, TikTok, Shorts, Stories",
        "1x1": "Pătrat (1:1) — postări Instagram, Facebook",
        "4x5": "Portret (4:5) — fluxul Instagram și Facebook",
        "3x4": "Portret (3:4)"
      },
      "sizeGifLimit": "Un GIF are cel mult {{width}} de pixeli lățime.",
      "fps": "Cadre pe secundă",
      "fpsGifHelp": "Un GIF păstrează exact doar aceste ritmuri.",
      "duration": "Durată (secunde)",
      "durationGifLimit": "Un GIF are cel mult {{frames}} de cadre, așa că la acest ritm redarea durează cel mult {{seconds}} s.",
      "holdEnd": "Imagine fixă la sfârșit (secunde)",
      "quality": "Calitate",
      "qualities": {
        "low": "Scăzută",
        "medium": "Medie",
        "high": "Ridicată"
      },
      "qualityHelpGif": "Culori în paletă: 64, 128 sau 256.",
      "qualityHelpVideo": "Biți pe cadru: mai mult înseamnă mai clar și mai mare.",
      "summary": "Cadre: {{frames}} · aproximativ {{size}}",
      "summaryCalibrated": "Cadre: {{frames}} · aproximativ {{size}}, după ultimul GIF făcut aici",
      "gifTooLarge": "La aproximativ {{size}}, acest GIF este mai mare decât acceptă majoritatea aplicațiilor de mesagerie. Scurtează-l, micșorează-l sau rărește-l, scade-i calitatea, oprește rotirea sau fă un video.",
      "rotation": "Rotește modelul",
      "rotationMode": "Cât",
      "rotationModes": {
        "speed": "Cu o viteză dată",
        "fullTurn": "O rotație completă pe durata filmului"
      },
      "degreesPerSecond": "Grade pe secundă",
      "direction": "Sens, văzut de sus",
      "clockwise": "În sensul acelor de ceasornic",
      "counterClockwise": "Invers acelor de ceasornic",
      "transition": "Alunecarea marcajului (secunde)",
      "transitionHelp": "Cât îi ia marcajului unui speolog să ajungă la stația următoare.",
      "timelineMode": "Mai multe ture",
      "timelineModes": {
        "calendar": "Pe același calendar",
        "together": "Una lângă alta"
      },
      "timelineHelp": {
        "calendar": "Turele se redau în ordinea reală a timpului; ceasul arată data și ora.",
        "together": "Toate turele pornesc în același moment, pentru comparație; ceasul arată timpul scurs."
      },
      "shortenQuiet": "Scurtează perioadele liniștite",
      "shortenQuietHelp": "Unde nicio tură aleasă nu raportează nimic, filmul sare înainte: imaginea nu stă nemișcată mai mult decât atât și nu redă mai mult de o jumătate de oră din timpul turelor fără să se întâmple nimic. Ceasul arată saltul.",
      "quietGap": "Cea mai lungă așteptare",
      "secondsShort": "s",
      "labels": "Etichetele speologilor",
      "labelsHelp": "Prenumele este primul cuvânt al numelui din listă; două persoane care s-ar citi la fel primesc o inițială.",
      "caverLabels": {
        "first": "Prenume",
        "full": "Nume complet",
        "initials": "Inițiale",
        "off": "Fără etichete"
      },
      "labelSize": "Mărimea etichetei",
      "labelSizeHelp": "În pixeli ai filmului.",
      "labelPlate": "Fundal sub etichete",
      "showTimes": "Ora ultimului raport în etichetă",
      "colourBy": "Culoarea marcajelor",
      "colourByValues": {
        "auto": "Automat",
        "trip": "După tură",
        "team": "După echipă",
        "single": "O singură culoare"
      },
      "colourByHelp": {
        "auto": "După echipă pentru o tură, după tură pentru mai multe.",
        "trip": "Fiecare tură în culoarea ei.",
        "team": "Fiecare echipă în culoarea ei.",
        "single": "Toți cei aflați în subteran într-o singură culoare."
      },
      "showOut": "Arată speologii care au ieșit",
      "trails": "Traseul parcurs",
      "layers": {
        "legs": "Linii centrale",
        "stations": "Stații",
        "stationLabels": "Numele stațiilor",
        "stationComments": "Comentariile stațiilor",
        "entrances": "Numele intrărilor",
        "entrance_dots": "Punctele intrărilor",
        "splays": "Vize laterale",
        "walls": "Pereți",
        "scraps": "Schițe",
        "duplicateLegs": "Vize duplicate",
        "surfaceLegs": "Vize de suprafață",
        "traces": "Trasări cu colorant",
        "warnings": "Avertismente de topografie",
        "fog": "Ceață",
        "HUD": "Busola și afișajul de altitudine",
        "box": "Cutia de încadrare",
        "grid": "Grilă"
      },
      "layerMissing": "Acest model nu are așa ceva.",
      "hudWarning": "Busola și afișajul de altitudine scriu altitudini și un azimut în fiecare cadru.",
      "shading": "Colorare",
      "shadings": {
        "default": "Așa cum o desenează vizualizatorul",
        "height": "După altitudine",
        "length": "După lungimea vizei",
        "inclination": "După înclinare",
        "single": "O singură culoare",
        "survey": "După topografie",
        "depth": "După adâncimea sub suprafață",
        "depthCursor": "Cursor de adâncime"
      },
      "shadingNeedsTerrain": "necesită relief",
      "camera": "Cameră",
      "cameras": {
        "perspective": "Perspectivă",
        "orthographic": "Ortografică"
      },
      "viewDirection": "Vederea de pornire",
      "viewDirections": {
        "plan": "Plan (de sus)",
        "north": "Profil N — privind spre nord",
        "south": "Profil S — privind spre sud",
        "east": "Profil E — privind spre est",
        "west": "Profil V — privind spre vest"
      },
      "viewDirectionHelp": "Cum privește camera întregul model când începe filmul: de sus, sau la orizontală, într-o direcție. Rotirea sau apropierea previzualizării după aceea se păstrează.",
      "viewDirectionAgain": "Revino la ea",
      "linewidth": "Grosimea liniilor",
      "zScale": "Scara verticală",
      "captionTitle": "Titlu",
      "titleText": "Textul titlului",
      "titlePlaceholder": "Titlurile turelor",
      "captionClock": "Ceas",
      "captionSpeed": "Factor de accelerare",
      "captionSpeedHelp": "După ceas, de câte ori mai repede decât în realitate rulează filmul: ×240. Lipsește când filmul rulează aproximativ în timp real.",
      "captionLegend": "Legendă",
      "captionProgress": "Bară de progres",
      "captionNote": "Ultima notă",
      "captionNoteHelp": "Notele sunt text liber și pot conține detalii de siguranță.",
      "captionSize": "Mărimea textelor",
      "pictureMode": "Fotografiile de pe momentele turelor",
      "pictureModes": {
        "off": "Nu apar",
        "corner": "Într-un colț",
        "full": "Pe tot cadrul"
      },
      "pictureModeHelp": {
        "off": "Filmul arată doar modelul și echipa.",
        "corner": "Fiecare fotografie apare într-un colț al cadrului când filmul ajunge la momentul de care a fost prinsă.",
        "full": "Fiecare fotografie umple cadrul pentru o clipă când filmul ajunge la momentul de care a fost prinsă; ceasul și bara rămân deasupra."
      },
      "pictureSeconds": "Secunde pentru fiecare",
      "pictureSecondsHelp": "Secunde din film, nu din tură. Fotografiile care s-ar suprapune apar una după alta.",
      "pictureFade": "Apare și dispare treptat",
      "pictureCorner": "Colț",
      "pictureCorners": {
        "bottomRight": "Dreapta jos",
        "bottomLeft": "Stânga jos",
        "topRight": "Dreapta sus",
        "topLeft": "Stânga sus"
      },
      "pictureCaptions": "Legendele lor",
      "picturesNone": "Nicio fotografie nu este prinsă de un moment al acestor ture. Prinde-le din jurnalul de urmărire al turei.",
      "picturesCount": "Fotografii pe momentele acestor ture: {{count}}.",
      "picturesLoading": "Fotografii pe momentele acestor ture: {{count}}; încă se încarcă: {{loading}}.",
      "picturesFailed": "Fotografii pe momentele acestor ture: {{count}}; nu au putut fi încărcate și vor lipsi: {{failed}}.",
      "position": "Momentul din film",
      "playPreview": "Redă previzualizarea",
      "stopPreview": "Oprește previzualizarea",
      "previewHint": "Trage de model pentru a alege vederea de la care pornește filmul; camera se rotește de acolo.",
      "preview": "Previzualizarea filmului",
      "keysHint": "Cu previzualizarea sau cursorul selectat, Spațiu redă și oprește; Home și End duc la început și la sfârșit.",
      "saveStill": "Salvează acest moment ca imagine",
      "stillFailed": "Imaginea nu a putut fi făcută.",
      "presetsTitle": "Presetări",
      "presets": {
        "chat": "Pentru chat",
        "hd": "Video HD",
        "vertical": "Reels / TikTok",
        "feed": "Flux Instagram",
        "square": "Postare pătrată"
      },
      "presetHelp": {
        "chat": "Un GIF mic: 480 × 270, 10 cadre pe secundă, 15 secunde, calitate medie.",
        "hd": "Un video de 1280 × 720 la 30 de cadre pe secundă, calitate ridicată: MP4 unde acest browser îl poate scrie, WebM unde nu.",
        "vertical": "Video vertical pe tot ecranul pentru Reels, TikTok, YouTube Shorts și Stories: MP4 1080 × 1920, 30 de cadre pe secundă, 30 de secunde. Textele stau departe de butoanele pe care aceste aplicații le desenează peste video.",
        "feed": "O postare portret pentru fluxul Instagram și Facebook: MP4 1080 × 1350 (4:5), 30 de cadre pe secundă, 30 de secunde.",
        "square": "O postare pătrată pentru Instagram, Facebook sau X: MP4 1080 × 1080, 30 de cadre pe secundă, 30 de secunde."
      },
      "presetsHelp": "O presetare schimbă doar fișierul — niciodată cine apare, vederea sau textele.",
      "presetHdUnavailable": "Acest browser nu poate scrie un video de 1280 × 720, așa că nu s-a schimbat nimic.",
      "presetMp4Unavailable": "Acest browser nu poate scrie un MP4 de {{size}}, formatul cerut de rețelele sociale, așa că nu s-a schimbat nimic.",
      "reset": "Revino la valorile implicite",
      "resetHelp": "Readuce fiecare setare la ce arată o primă deschidere — textele, etichetele și vederea, nu doar fișierul, așa că titlul scris pe imagine și fișierul numit după el revin. Turele și persoanele alese rămân cum sunt.",
      "privacy": "Filmul arată topografia peșterii și unde a fost echipa. Trimite-l doar celor care au voie să le vadă pe amândouă.",
      "export": "Exportă {{format}}",
      "cancelExport": "Anulează exportul",
      "progress": {
        "starting": "Se pornește…",
        "sampling": "Se aleg culorile: {{done}} din {{total}}",
        "rendering": "Cadrul {{done}} din {{total}}",
        "finishing": "Se scrie fișierul…"
      },
      "progressElapsed": "{{elapsed}} scurs",
      "progressTimes": "{{elapsed}} scurs · încă aproximativ {{remaining}}",
      "saved": "S-a salvat {{name}}",
      "fileNamed": "Fișierul se va salva ca {{name}}",
      "fileAsked": "Un video atât de lung este scris în fișier pe măsură ce este făcut. La export se întreabă unde să fie salvat, ca {{name}} dacă nu se alege alt nume.",
      "closeWhileExporting": {
        "title": "Oprești exportul filmului?",
        "body": "Exportul încă rulează. Dacă închizi acum, cadrele desenate până acum se pierd și nu se salvează niciun fișier.",
        "stop": "Oprește și închide",
        "keep": "Continuă exportul"
      },
      "exportFailed": "Filmul nu a putut fi făcut.",
      "frameUncomposed": "Browserul nu a dat o suprafață de desen pe care să fie alcătuit cadrul. De obicei înseamnă că a rămas fără memorie grafică: închiderea altor file sau reîncărcarea paginii poate ajuta.",
      "videoTooLong": "Acest video își randează fiecare cadru, prin software pe un calculator fără placă grafică, și exportul poate dura mult. O durată mai scurtă, mai puține cadre pe secundă sau o dimensiune mai mică merg mai repede.",
      "layersMissing": "Straturile gri: acest model nu le are.",
      "shadingTerrainHelp": "Colorările după adâncime au nevoie ca modelul să stea pe relief real, iar acesta nu stă.",
      "terrain": "Relieful de deasupra peșterii",
      "terrainHelp": "Desenează suprafața pe care o conține fișierul modelului. Oprit până îl pornești: o peșteră arătată sub dealurile ei poate fi așezată pe hartă de oricine primește fișierul.",
      "terrainNoneHelp": "Fișierul acestui model nu conține relief propriu, deci nu este nimic de desenat.",
      "pixels": "{{value}} px",
      "times": "×{{value}}",
      "percent": "{{value}} %",
      "zScaleHelp": "×1, la marcaj, este înălțimea reală."
    }
  },
  "surveyModels": {
    "title": "Modele topo 3D",
    "stationSearchMore": "Alte stații: {{count}} — scrie mai mult din nume",
    "upload": "Încarcă model",
    "uploaded": "Model încărcat",
    "takeOverLinePlot": "Fă-l modelul de drumuire curent după ce a fost citit, în locul lui „{{name}}”",
    "takeOverMesh": "Fă-i pereții curenți după ce au fost convertiți, în locul lui „{{name}}”",
    "takeOverLinePlotHint": "Modelul de drumuire curent este cel pe care îl desenează harta și peste care se măsoară cifrele peșterii. Până când acest fișier a fost citit, „{{name}}” rămâne curent. Dacă între timp cineva alege alt model, alegerea lui rămâne.",
    "takeOverMeshHint": "Pereții curenți sunt cei pe care îi desenează scena 3D. Până când acest fișier a fost convertit, „{{name}}” rămâne curent. Dacă între timp cineva alege alt model, alegerea lui rămâne.",
    "uploadedTakingOver": "Model încărcat. Devine cel curent după ce a fost citit.",
    "uploadFailed": "Încărcarea a eșuat",
    "deleteFailed": "Modelul nu a putut fi șters",
    "trackingArmedNamed": "Urmărirea în direct a unei ture este armată pe acest model topo: {{trips}}. Ștergerea lui ar lăsa acea tură fără posibilitatea de a plasa pe cineva. Deschide urmărirea acelei ture și încheie-o sau îndreapt-o către altă topografie, apoi șterge-l pe acesta.",
    "format": "Format",
    "surveyedAt": "Cartat la",
    "view": "Vezi în 3D",
    "openBesideMap": "Deschide lângă hartă",
    "openInWindow": "Deschide în altă fereastră",
    "openOverlay": "Deschide peste toată fereastra",
    "deleteConfirm": "Ștergi acest model topo?",
    "empty": "Niciun model 3D încă",
    "uploadTitle": "Încarcă un model topo",
    "chooseFile": "Alege un fișier sau trage-l aici",
    "acceptHint": "Therion .lox, Survex .3d sau pereții peșterii ca .stl binar — până la 100 MB.",
    "status": "Stare",
    "statusValues": {
      "ready": "Gata",
      "pending": "Așteaptă la rând",
      "processing": "În curs",
      "failed": "Nu a putut fi procesat"
    },
    "formats": {
      "lox": "Therion .lox",
      "survex3d": "Survex .3d",
      "stl": "Pereți .stl"
    },
    "converting": "Pereții sunt pregătiți pentru scena 3D. Lista se actualizează singură când sunt gata.",
    "conversionFailed": "Pereții nu au putut fi convertiți.",
    "triangles": "{{count}} triunghiuri",
    "wallsBuilt": "Pereți construiți din schițele și dimensiunile de galerie ale acestei topografii",
    "current": "Curent",
    "makeCurrent": "Setează ca model curent",
    "makeCurrentFailed": "Modelul nu a putut fi setat ca model curent",
    "readAgain": "Citește din nou",
    "readAgainConfirm": "Citești din nou acest fișier?",
    "readAgainHint": "Fișierul păstrat pentru acest model este citit din nou, iar ce a produs ultima citire este înlocuit cu ce produce aceasta. Nu trebuie încărcat nimic. Folosește acțiunea după o actualizare care citește mai bine topografiile sau când o citire a eșuat dintr-un motiv care între timp a dispărut.",
    "readAgainStarted": "Citirea a fost pusă la rând. Lista se actualizează singură când s-a încheiat.",
    "readAgainFailed": "Citirea nu a putut fi pornită",
    "readingAgain": "Se citește din nou",
    "convertingAgain": "Se convertește din nou",
    "currentHint": "Modelul de drumuire curent este cel pe care îl citesc harta și măsurătorile; pereții curenți sunt cei pe care îi desenează scena 3D. Primul model de fiecare fel rămâne curent până când alegi altul aici; alegerea unui model de drumuire face și din drumuirea lui forma peșterii pe hartă.",
    "precisionLost": "Fișierul a pierdut precizie înainte să ajungă aici",
    "precisionLostHint": "Coordonatele din acest fișier au fost prea mari pentru numerele în care sunt stocate, așa că topografia este mai grosieră decât a fost cartată. Reexportă fișierul față de o origine locală ca să recuperezi detaliul.",
    "meshDeclaration": "Unde se află acești pereți în lume",
    "meshDeclarationHint": "Un fișier .stl este doar triunghiuri: nimic din el nu spune în ce sistem de coordonate sunt numerele, iar citit ca zona vecină același fișier ajunge la sute de kilometri distanță. Spune ce înseamnă numerele lui.",
    "coordinatesLocal": "Metri față de un punct",
    "coordinatesLocalHint": "Exportul obișnuit: numerele sunt metri spre est, spre nord și în sus față de un singur punct. Dă poziția acelui punct.",
    "coordinatesProjected": "Un sistem de coordonate proiectat",
    "coordinatesProjectedHint": "Numerele sunt coordonate est/nord într-o proiecție națională sau UTM. Dă codul acelei proiecții.",
    "sourceEpsg": "Cod EPSG",
    "originLongitude": "Longitudinea originii",
    "originLatitude": "Latitudinea originii",
    "originFromEntrance": "Completat din intrarea principală a peșterii, de unde pornește de obicei un export local.",
    "originObfuscated": "Poziția arătată acestui cont pentru această peșteră este aproximativă în mod deliberat, deci nu poate fi folosită ca origine. Introdu poziția reală a punctului zero al fișierului.",
    "originNoEntrance": "Pentru această peșteră nu este înregistrată nicio poziție a intrării, deci nu există de unde completa. Introdu poziția punctului zero al fișierului.",
    "originHeightM": "Altitudinea nivelului zero al fișierului (m)",
    "originHeightHint": "Înălțimile din aceste fișiere sunt măsurate față de originea exportului, nu față de nivelul mării. Dă altitudinea la care se află nivelul zero — pentru un export care pornește de la intrare, altitudinea intrării.",
    "problems": {
      "formatUnsupported": "Încarcă un Therion .lox, un Survex .3d sau pereții peșterii ca .stl binar.",
      "sizeInvalid": "Fișierul este gol sau mai mare de 100 MB.",
      "crsInvalid": "Dă sistemul de coordonate ca un cod EPSG — un număr pozitiv.",
      "heightInvalid": "Dă altitudinea, în metri, la care se află nivelul zero al fișierului.",
      "originInvalid": "Un fișier în coordonate locale are nevoie de poziția punctului său zero.",
      "notFound": "Acest model topo nu mai există.",
      "trackingArmed": "Urmărirea în direct a unei ture este armată pe acest model topo, iar ștergerea lui ar lăsa acea tură fără posibilitatea de a plasa pe cineva. Acest cont nu poate citi acea tură, așa că roagă echipa ei — sau un administrator, care poate citi orice tură — să încheie urmărirea sau să o îndrepte către altă topografie. Apoi șterge-l pe acesta.",
      "notReady": "Modelul este încă în curs de citire sau nu a putut fi citit. Numai un model terminat poate fi setat ca model curent.",
      "readingInProgress": "Modelul este deja în curs de citire. Așteaptă încheierea acelei citiri înainte să ceri alta.",
      "caveNotFound": "Această peșteră nu mai există.",
      "forbidden": "Nu ai voie să modifici modelele topo ale acestei peșteri."
    },
    "reading": "Topografia este citită în stațiile și vizele ei. Planul poate fi deja vizualizat; lista se actualizează singură când citirea s-a încheiat.",
    "readingFailed": "Topografia nu a putut fi citită.",
    "plotDeclaration": "Unde se află această topografie în lume",
    "plotDeclarationRequiredHint": "Un fișier .lox nu are câmp pentru un sistem de coordonate, deci nu spune niciodată unde se află. Spune ce înseamnă numerele din el — fără asta topografia nu poate fi poziționată și nimic nu poate fi citit din ea.",
    "plotDeclarationOptionalHint": "Un fișier .3d își declară sistemul de coordonate doar dacă topografia a fost compilată cu unul. Dacă acesta îl declară, el este folosit și ce scrii aici este ignorat; dacă nu, doar asta îl poate poziționa."
  },
  "centerlines": {
    "title": "Drumuiri",
    "upload": "Încarcă drumuire",
    "uploaded": "Drumuire încărcată",
    "uploadFailed": "Încărcarea a eșuat",
    "length": "Lungime",
    "source": "Sursă",
    "sourceValues": {
      "uploaded": "Încărcată",
      "extracted": "Extrasă"
    },
    "deleteConfirm": "Ștergi această drumuire?",
    "empty": "Nicio drumuire încă",
    "default": "Implicită",
    "makeDefault": "Setează ca formă implicită",
    "promoted": "Drumuirea a devenit forma implicită a peșterii",
    "paths": "Trasee"
  },
  "settings": {
    "title": "Setări",
    "nav": {
      "profile": "Profil",
      "account": "Cont",
      "emails": "E-mail",
      "notifications": "Notificări",
      "security": "Securitate",
      "accessibility": "Accesibilitate",
      "filters": "Filtre salvate",
      "coordinates": "Coordonate",
      "sync": "Sincronizare",
      "access-keys": "Chei de acces",
      "survey-uploads": "Încărcări de topografii",
      "advanced": "Avansat"
    },
    "visibility": {
      "label": "Cine poate vedea",
      "tooltip": "Vizibil pentru: {{audience}}",
      "legend": "Pictograma de lângă un câmp stabilește cine îl vede: doar tu, cei din grupurile tale de speologie sau orice membru autentificat."
    },
    "visibilityValues": {
      "private": "Doar eu",
      "cavingGroup": "Grupurile mele",
      "authenticated": "Membrii autentificați"
    },
    "profile": {
      "identity": "Identitate",
      "about": "Despre tine",
      "username": "Nume de utilizator",
      "email": "Adresă de e-mail",
      "manageElsewhere": "Modifică",
      "firstName": "Prenume",
      "lastName": "Nume",
      "displayName": "Nume afișat",
      "displayNameHint": "Apare lângă tot ce adaugi. Fără el apari sub un nume generat.",
      "bio": "Descriere",
      "phone": "Telefon",
      "phoneNone": "Nesetat",
      "phoneManagedInSecurity": "Modifică-l în Securitate — un cod este trimis prin SMS la noul număr mai întâi.",
      "cavingClub": "Club de speologie",
      "avatar": "Poză de profil",
      "addresses": "Adrese",
      "addressesHint": "Unde poți fi găsit. Fiecare adresă poate avea un punct pe hartă.",
      "locationAudience": "Puncte pe hartă:",
      "noAddresses": "Nicio adresă încă.",
      "addAddress": "Adaugă o adresă",
      "editAddress": "Modifică adresa",
      "removeAddress": "Șterge adresa",
      "removeAddressConfirm": "Ștergi această adresă?",
      "addressLabel": "Etichetă",
      "country": "Țară",
      "city": "Oraș",
      "addressText": "Strada și restul",
      "location": "Punct pe hartă",
      "noLocation": "Niciun punct",
      "pickLocation": "Alege pe hartă",
      "changeLocation": "Schimbă punctul",
      "clearLocation": "Șterge punctul"
    },
    "avatar": {
      "upload": "Încarcă o imagine",
      "preset": "Alege una predefinită",
      "choosePreset": "Imagini predefinite",
      "remove": "Șterge",
      "tooLarge": "Alege o imagine sub 5 MB.",
      "uploadFailed": "Imaginea nu a putut fi folosită.",
      "presetNames": {
        "bat": "Liliac",
        "helmet": "Cască",
        "lamp": "Frontală",
        "rope": "Coardă",
        "karst": "Carst",
        "stalactite": "Stalactită",
        "compass": "Busolă",
        "sump": "Sifon"
      }
    },
    "emails": {
      "current": "Adresă de e-mail",
      "confirmed": "Confirmată",
      "unconfirmed": "Neconfirmată",
      "verify": "Trimite un link de confirmare",
      "verifySent": "Verifică-ți căsuța.",
      "change": "Schimbă adresa",
      "changeHint": "Trimitem un link la noua adresă. Nimic nu se schimbă până nu îl deschizi.",
      "newEmail": "Adresa nouă",
      "sendLink": "Trimite linkul",
      "requested": "Dacă adresa este liberă, un link este pe drum către ea.",
      "requestFailed": "Adresa nu a putut fi folosită.",
      "pending": "Se așteaptă confirmarea pentru {{email}}",
      "pendingHint": "Deschide linkul trimis la acea adresă. Până atunci te autentifici cu cea curentă.",
      "resend": "Trimite din nou",
      "resent": "Trimis din nou.",
      "tooSoon": "Așteaptă un minut înainte de a cere din nou.",
      "cancelChange": "Anulează schimbarea",
      "cancelled": "Schimbare anulată.",
      "confirmSuccess": "Adresa a fost schimbată.",
      "confirmFailed": "Linkul este invalid sau a expirat."
    },
    "account": {
      "usernameSection": "Nume de utilizator",
      "usernameHint": "Te autentifici întotdeauna cu adresa de e-mail, deci aceasta schimbă doar felul în care apari în listă.",
      "changeUsername": "Schimbă numele",
      "usernameConfirm": "Schimbi numele de utilizator?",
      "usernameChanged": "Nume schimbat.",
      "usernameTaken": "Numele este deja folosit.",
      "usernameInvalid": "Numele nu poate fi folosit.",
      "usernameCharacters": "Folosește doar litere, cifre și . _ @ + -",
      "noDeletion": "Conturile nu se șterg de aici. Ce ai adăugat rămâne la club, așa că adresează-te unui administrator.",
      "export": {
        "heading": "Exportă-ți datele",
        "intro": "O copie a profilului, adreselor, setărilor și o listă a ce ai adăugat.",
        "request": "Pregătește un export",
        "requested": "Se pregătește exportul.",
        "download": "Descarcă",
        "status": {
          "queued": "În așteptare",
          "running": "Se pregătește…",
          "ready": "Gata",
          "failed": "Eșuat"
        }
      },
      "calendarFeed": {
        "heading": "Flux de calendar",
        "intro": "Abonează-te la propriul calendar dintr-o aplicație de calendar de pe telefon sau de pe calculator. Un flux poartă titlul și datele turelor, taberelor și evenimentelor la care participi, plus o legătură înapoi către fiecare — nimic altceva.",
        "label": "Nume pentru această adresă",
        "labelPlaceholder": "Telefon, laptopul de la serviciu…",
        "mint": "Creează o adresă de flux",
        "mintedTitle": "Noua adresă a fluxului — copiaz-o acum, se afișează o singură dată.",
        "mintedHint": "Oricine deține această adresă îți poate citi calendarul, așa că trateaz-o ca pe o parolă. Dacă ajunge la altcineva, revoc-o aici și creează alta.",
        "mintFailed": "Adresa nu a putut fi creată.",
        "unlabelled": "Adresă fără nume",
        "createdOn": "Creată {{when}}",
        "active": "Activă",
        "revoked": "Revocată",
        "revoke": "Revocă",
        "revokeConfirm": "Revoci această adresă? Un calendar care o folosește încă nu se va mai actualiza.",
        "revokedMessage": "Adresă revocată."
      }
    },
    "notifications": {
      "categories": "Despre ce să fiu anunțat și unde",
      "category": "Anunță-mă despre",
      "channels": {
        "inApp": "În aplicație",
        "email": "E-mail",
        "sms": "SMS"
      },
      "choices": {
        "off": "Oprit",
        "immediate": "Pe măsură ce se întâmplă",
        "daily": "Rezumat zilnic"
      },
      "alwaysOn": "Se trimit mereu — acestea nu pot fi oprite.",
      "reachesNobody": "Acest lucru nu va ajunge la tine nicăieri.",
      "notOffered": "Nu se trimite astfel",
      "notConfigured": "neconfigurat",
      "notConfiguredHere": "Această instalare nu are configurat: {{channels}}. Alegerile de acolo sunt salvate și vor fi folosite imediat ce va exista.",
      "events": {
        "cavingGroupMembership": "Schimbări în grupurile de speologie",
        "permissionGranted": "Cineva îmi dă acces la ceva",
        "tripParticipation": "Sunt adăugat la o tură",
        "tripPublished": "O tură la care particip a fost publicată ca pagină pe care o poate citi oricine are linkul",
        "tripNeedsAttention": "O tură înregistrată pe un telefon are nevoie să fie verificată de cineva, sau nu a putut fi transformată în raport de tură",
        "uploadAwaitingReview": "Un cont ale cărui încărcări sunt verificate a trimis ceva ce așteaptă un verificator",
        "uploadReviewed": "Un verificator a decis asupra a ceva ce am încărcat",
        "expeditionUpdate": "O expediție pe lista căreia mă aflu este modificată sau anulată",
        "tripPlanning": "Sunt invitat la o tură sau la un eveniment de club, se schimbă o tură la care particip, o tură are nevoie de un acces pe care îl pot acorda sau se apropie o tură ori un eveniment de club la care am răspuns",
        "commentReply": "Cineva răspunde la un comentariu scris de mine",
        "commentOnMine": "Cineva comentează la ceva ce îmi aparține",
        "groupAnnouncement": "Cineva scrie unui grup din care fac parte",
        "jobCompleted": "Fișierele mele termină de procesat",
        "securityAlerts": "Alerte de securitate",
        "tripCallout": "O tură la care particip a întârziat și nimeni nu a confirmat că echipa a ieșit"
      },
      "delivery": "Livrare",
      "masterEmail": "Anunță-mă pe e-mail",
      "digest": "Cât de des",
      "digestValues": {
        "immediate": "Pe măsură ce se întâmplă",
        "daily": "Un rezumat zilnic"
      },
      "alwaysOnReasons": {
        "securityAlerts": "Se trimit mereu — acestea te avertizează despre propriul cont.",
        "tripCallout": "Se trimit mereu și nu se amână pentru rezumatul zilnic — o echipă întârziată nu mai este o noutate a doua zi dimineața."
      },
      "noDelivery": "Această instalare nu are un server de e-mail configurat, deci nu se trimite nimic încă. Alegerile sunt salvate și vor fi folosite când va exista unul."
    },
    "filters": {
      "heading": "Filtre salvate",
      "intro": "Un filtru pe care îl salvezi este partajat la început cu cei aleși aici. Poți alege altfel de fiecare dată când salvezi unul, iar mai târziu în lista filtrelor salvate. Partajarea le dă celorlalți doar întrebarea — fiecăruia i se răspunde cu ce are el însuși dreptul să vadă.",
      "defaultAudience": "Partajează filtrele noi cu",
      "groupGone": "Grupul de speologie ales aici nu mai este unul cu care poți partaja, așa că filtrele noi pornesc private până alegi din nou.",
      "manage": "Filtrele tale salvate"
    },
    "accessibility": {
      "heading": "Aspect",
      "intro": "Acestea te urmează pe orice dispozitiv pe care te autentifici.",
      "theme": "Temă",
      "themeValues": {
        "system": "Ca sistemul",
        "light": "Luminoasă",
        "dark": "Întunecată"
      },
      "density": "Densitate",
      "densityValues": {
        "comfortable": "Confortabilă",
        "compact": "Compactă"
      },
      "reduceMotion": "Reduce animațiile",
      "reduceMotionHint": "Oprește animațiile și deplasarea hărții.",
      "highContrast": "Contrast mărit",
      "highContrastHint": "Text mai închis, contururi vizibile la fiecare câmp și un contur de focus mai puternic — în tema luminoasă și în cea întunecată.",
      "deviceOnly": "Doar în acest browser",
      "deviceOnlyIntro": "Acestea rămân pe acest dispozitiv — un telefon și o stație de lucru cer răspunsuri diferite.",
      "landingPage": "Deschide aplicația pe",
      "landingValues": {
        "map": "Hartă",
        "dashboard": "Panou"
      },
      "mapChrome": "Ascunde controalele de pe hartă",
      "reset": "Resetează",
      "resetDone": "Resetat.",
      "overviewMap": "Hartă de ansamblu pe hartă"
    },
    "advanced": {
      "wallsHeading": "Pereții peșterilor în vizualizarea 3D",
      "wallsSelectedHeading": "Pereții peșterii selectate",
      "wallsSelectedIntro": "Selectarea unei peșteri în vederea 3D îi descarcă imediat pereții, în afară de cazul în care sunt mai mari decât atât — atunci vederea spune cât de mari sunt și așteaptă până alegi să-i descarci. 0 întreabă de fiecare dată.",
      "wallsAskAboveMegabytes": "Întreabă peste (MB)",
      "wallsIntro": "Când vizualizarea 3D desenează pereții tuturor peșterilor din vedere, trei numere o limitează: zoom-ul de la care începe, câte peșteri desenează deodată și cât descarcă și păstrează pentru ele. Ce stabilești aici rămâne doar în acest browser — un telefon și o stație de lucru cer răspunsuri diferite.",
      "wallsMinZoom": "Arată de la zoom-ul",
      "wallsMaxCaves": "Peșteri cel mult",
      "wallsMaxMegabytes": "Megaocteți cel mult",
      "wallsCeilings": "Această instalare permite cel mult {{caves}} peșteri și {{megabytes}} MB.",
      "centerlinesHeading": "Drumuirile de pe hartă",
      "centerlinesIntro": "Două numere limitează drumuirile pe care le desenează harta plană: nivelul de zoom de la care apare detaliul complet al topografiei, inclusiv razele laterale, și câte linii poate conține o vedere. Lista de straturi a hărții le arată pe aceleași două cât timp stratul „Drumuiri peșteri” este afișat. Ca tot ce se află pe această pagină, se păstrează doar pentru acest browser.",
      "centerlinesDetailZoom": "Detaliu de la nivelul",
      "centerlinesMaxPaths": "Limită de linii",
      "centerlinesCeiling": "Această instalare permite o limită de linii de cel mult {{paths, number}}.",
      "emptyHint": "Un câmp gol urmează valoarea implicită a acestei instalări, afișată cu gri.",
      "useDefaults": "Folosește valorile implicite ale instalării"
    },
    "pointPicker": {
      "title": "Alege un punct",
      "hint": "Fă clic pe hartă sau scrie coordonatele.",
      "use": "Folosește punctul"
    },
    "surveyUploads": {
      "loadFailed": "Setările pentru încărcarea topografiilor nu au putut fi încărcate.",
      "outputsTitle": "Produce întotdeauna",
      "outputsIntro": "Când o topografie este încărcată de pe un dispozitiv, aceste rezultate sunt produse în plus față de cele cerute de dispozitiv. Dacă nu se cere nimic, instalația produce: {{defaults}}.",
      "linksTitle": "Legături publice",
      "linksIntro": "Fiecare încărcare poate primi o legătură care arată rezultatele celui care o deține — oricui sau doar conturilor autentificate ale acestei instalări. Nu include niciodată fișierele topografiei, echipa sau numele stațiilor. O peșteră cu locație protejată primește una doar dacă o ceri explicit pentru acea încărcare.",
      "linksSwitch": "Legături publice pentru încărcările mele",
      "audienceTitle": "Publicul implicit al legăturii",
      "audienceIntro": "Pentru cine se deschide legătura unei încărcări noi, dacă încărcarea nu cere altceva. O legătură doar pentru conturile autentificate îi cere celui care o deschide să se autentifice."
    },
    "sync": {
      "intro": "Alege peșterile pe care un telefon le poartă offline. O selecție doar numește peșteri — nu le preia — deci încheierea ei aici oprește cererile unui dispozitiv și nu schimbă nimic despre peșterile în sine.",
      "serverTitle": "Ce vorbește acest server",
      "contractVersion": "Versiunea protocolului",
      "limits": "Limite",
      "limitsValue": "{{pageSize}} rânduri pe pagină descărcată, {{uploadRows}} rânduri pe încărcare",
      "served": "Disponibil",
      "servedNone": "Doar selecții — acest server nu transferă încă rânduri.",
      "setsTitle": "Selecții",
      "newSet": "Selecție nouă",
      "editSet": "Editează selecția",
      "noSets": "Nicio selecție încă. Nimic nu este purtat offline.",
      "name": "Nume",
      "caves": "Peșteri",
      "cavesPlaceholder": "Caută peșteri după nume",
      "caveCount": "Peșteri purtate: {{total}}",
      "unnamedCave": "O peșteră pe care nu o mai poți citi",
      "uploadVisibility": "Înregistrările noi sunt vizibile pentru",
      "uploadVisibilityHelp": "Ce primesc înregistrările proprii ale unui dispozitiv când le trimite înapoi. Doar tu, până când extinzi.",
      "uploadsAs": "Încarcă ca: {{visibility}}",
      "cavingGroup": "Grup de speologie",
      "noCavingGroup": "Fără grup de speologie",
      "noCavingGroupsHere": "Această instalare nu are grupuri de speologie.",
      "cavingGroupRequired": "Alege grupul de speologie căruia îi aparțin aceste înregistrări. Fără unul, înregistrările vizibile unui grup de speologie nu sunt vizibile nimănui.",
      "notInCavingGroup": "Nu ești membru al acelui grup de speologie, deci un dispozitiv nu poate crea înregistrări pentru el.",
      "caveUnreadable": "Una dintre peșterile alese nu mai poate fi citită de tine. Elimin-o și salvează din nou.",
      "changedElsewhere": "Această selecție a fost schimbată în altă parte — pe un dispozitiv sau în altă filă. Redeschide-o și refă modificarea.",
      "revoke": "Revocă",
      "revokeConfirm": "Revoci această selecție? Un dispozitiv nu va mai putea cere aceste peșteri. Nimic din ce are deja nu este șters.",
      "revoked": "Selecție revocată."
    }
  },
  "admin": {
    "forbidden": "Ai nevoie de drepturi de administrator pentru această pagină.",
    "users": {
      "title": "Conturi",
      "intro": "Toți cei care se pot autentifica în această instalare. Invită pe cineva pentru a-i deschide un cont, blochează un cont pentru a-l ține afară până îl deblochezi, sau șterge unul — persoana rămâne în registru și pe turele la care a participat.",
      "search": "Caută conturi",
      "searchPlaceholder": "Nume sau adresă de e-mail",
      "invite": "Invită pe cineva",
      "name": "Nume",
      "email": "Adresă de e-mail",
      "status": "Stare",
      "createdAt": "Deschis",
      "actions": "Acțiuni",
      "you": "tu",
      "statusActive": "Se poate autentifica",
      "statusLocked": "Blocat",
      "statusNoPassword": "Fără parolă încă",
      "statusAdministrator": "Administrator deplin",
      "lock": "Blochează",
      "unlock": "Deblochează",
      "locked": "Contul {{name}} este blocat.",
      "unlocked": "{{name}} se poate autentifica din nou.",
      "sendAgain": "Trimite din nou invitația",
      "delete": "Șterge",
      "deleteConfirm": "Ștergi contul {{name}}?",
      "deleteConfirmDetail": "Nu se va mai putea autentifica. Înregistrarea din registru și turele la care a participat rămân.",
      "deleted": "Contul {{name}} a fost șters.",
      "inviteTitle": "Invită pe cineva",
      "inviteIntro": "Pentru această adresă se deschide un cont. Titularul primește un link pentru a-și alege singur parola; tu nu o afli.",
      "inviteName": "Nume",
      "inviteNameRequired": "Spune pentru cine este contul.",
      "inviteEmail": "Adresă de e-mail",
      "inviteEmailRequired": "Introdu adresa cu care se va autentifica.",
      "inviteEmailInvalid": "Aceasta nu este o adresă de e-mail.",
      "inviteSubmit": "Deschide contul",
      "invitationSent": "O invitație a fost trimisă la {{email}}.",
      "handOverTitle": "Predă acest link",
      "handOverIntro": "Invitația pentru {{name}} ({{email}}) nu a putut fi trimisă prin e-mail, fiindcă această instalare nu are server de e-mail sau trimiterea a eșuat. Dă-i chiar tu acest link; cu el își alege parola.",
      "handOverOnce": "Copiază-l acum: este afișat doar de data aceasta. Funcționează o singură dată și timp de {{hours}} ore; după aceea, trimite din nou invitația.",
      "handOverDone": "L-am copiat",
      "statusTwoFactor": "Al doilea factor activ",
      "statusUploadReview": "Încărcările necesită verificare",
      "uploadReviewMark": "Ține încărcările pentru verificare",
      "uploadReviewClear": "Nu mai ține încărcările",
      "uploadReviewSet": "Tot ce încarcă {{name}} va aștepta acum un verificator.",
      "uploadReviewCleared": "Ce încarcă {{name}} nu mai este ținut pentru verificare.",
      "resetTwoFactor": "Resetează al doilea factor",
      "resetTwoFactorConfirm": "Resetezi al doilea factor al contului {{name}}?",
      "resetTwoFactorConfirmDetail": "Toți factorii secundari configurați sunt dezactivați — aplicația de autentificare, codurile prin e-mail sau SMS — iar codurile de recuperare nu mai funcționează. Titularul este deconectat de pe toate dispozitivele și este anunțat prin e-mail. Apoi se poate autentifica doar cu parola și poate configura din nou un al doilea factor din setările de securitate.",
      "twoFactorReset": "Al doilea factor al contului {{name}} a fost resetat.",
      "groupsTitle": "Grupuri de permisiuni",
      "groupsIntro": "Grupurile din care face parte acest cont. Apartenența se schimbă pe pagina grupurilor de permisiuni, nu aici.",
      "groupsNone": "Doar grupul din care face parte orice cont.",
      "groupsFailed": "Grupurile de permisiuni nu au putut fi citite.",
      "groupDirect": "membru",
      "groupThrough": "prin {{groups}}",
      "problems": {
        "lastAdministrator": "Acesta este ultimul administrator deplin care se poate autentifica. Fă mai întâi pe altcineva administrator deplin, altfel instalarea nu ar mai avea cine s-o administreze.",
        "cannotLockSelf": "Nu îți poți bloca propriul cont.",
        "cannotDeleteSelf": "Nu îți poți șterge propriul cont.",
        "deleteBlocked": "Acest cont deține încă înregistrări: {{owned}}. Predă-le sau șterge-le mai întâi; ștergerea contului le-ar lăsa fără proprietar.",
        "deleteBlockedKinds": {
          "albums": "albume foto",
          "cave_level_bands": "benzi de nivel confirmate",
          "cave_qr_publications": "coduri QR de peșteră publicate",
          "checklists": "liste de verificare",
          "documents": "documente",
          "events": "evenimente",
          "expeditions": "expediții",
          "features": "peșteri și alte obiecte de pe hartă",
          "feature_shares": "linkuri de partajare a obiectelor",
          "geofiles": "fișiere de geodate",
          "georeferenced_maps": "hărți georeferențiate",
          "import_batches": "importuri confirmate",
          "raster_maps": "hărți scanate",
          "survey_uploads": "încărcări de topografii",
          "survey_upload_public_links": "linkuri publice de încărcare a topografiilor",
          "trips": "ieșiri",
          "trip_recordings": "înregistrări de ieșire",
          "trip_tracking_shares": "linkuri de urmărire a ieșirilor",
          "upload_batches": "loturi de încărcare"
        },
        "emailTaken": "Există deja un cont cu această adresă.",
        "alreadyEnterable": "Acest cont se poate deja autentifica. Titularul își resetează singur parola.",
        "notFound": "Acest cont nu mai există.",
        "invalid": "Verifică numele și adresa.",
        "forbidden": "Nu ai dreptul să faci acest lucru.",
        "cannotChangeOwnReviewMark": "Dacă încărcările tale au nevoie de verificare decide un alt administrator.",
        "cannotResetOwnTwoFactor": "Propriul al doilea factor îl gestionezi din setările de securitate.",
        "twoFactorNotEnabled": "Acest cont nu are activ niciun al doilea factor, deci nu este nimic de resetat.",
        "fullAdministratorAccount": "Doar un administrator deplin poate bloca, debloca, șterge sau reseta al doilea factor al contului unui administrator deplin."
      }
    },
    "messaging": {
      "title": "Mesagerie",
      "intro": "Unde ajung e-mailurile și SMS-urile și ce necesită autentificarea. Acestea pot fi setate și din mediul de instalare; ce salvezi aici înlocuiește acele valori.",
      "mailTab": "E-mail",
      "smsTab": "SMS",
      "policyTab": "Politică de autentificare",
      "protectionTab": "Protecția locației",
      "protectionIntro": "Documentele atașate unei peșteri protejate sunt întotdeauna servite — nu sunt niciodată ascunse și nu li se elimină textul. Această setare stabilește doar dacă cineva care nu are voie să vadă unde se află peștera află care documente trimit la ea.",
      "revealAssociations": "Arată atașamentele peșterilor protejate tuturor celor care le pot citi",
      "revealAssociationsHint": "Activarea nu dezvăluie niciodată o poziție: urmărirea legăturii duce tot la vizualizarea protejată. O fotografie care poartă propriul punct de captură rămâne neasociată cu o peșteră protejată în ambele cazuri, pentru că împerecherea celor două ar localiza peștera.",
      "calendarFeedEnabled": "Permite membrilor să se aboneze la calendarul lor din exterior",
      "calendarFeedEnabledHint": "Fiecare membru poate crea apoi adrese secrete pe care un calendar de pe telefon sau de pe calculator le citește fără autentificare. Un flux poartă doar titlurile, datele și legăturile a ceea la care participă membrul — niciodată un loc sau o poziție — și este citit prin permisiunile proprii ale membrului la fiecare interogare. Dezactivat implicit; dezactivarea ulterioară oprește toate adresele deja distribuite.",
      "keepLocationInPhotoFiles": "Păstrează locația în fișierele foto",
      "keepLocationInPhotoFilesHint": "Activat: cine are voie să vadă unde a fost făcută o fotografie o poate descărca exact cum a fost încărcată, cu tot cu poziția GPS. Dezactivat: toată lumea descarcă imaginea la mărime întreagă, fără datele de locație (GPS, XMP, numele locurilor din IPTC); detaliile camerei rămân. În ambele cazuri, cine nu are voie să vadă unde a fost făcută o fotografie primește doar copia fără locație. Filmele, înregistrările audio și imaginile care nu pot fi rescrise (orice în afară de JPEG, PNG și WebP) îi sunt oferite unei asemenea persoane doar ca previzualizări — iar când opțiunea e dezactivată, nimănui altfel decât ca previzualizări, dacă opțiunea următoare nu e activată. Poziția arătată pe hartă și lângă fotografie urmează regulile de locație ca până acum.",
      "serveUnstrippableOriginalsToLocationReaders": "Cu opțiunea de locație dezactivată, permite totuși celor care au voie să vadă locația să descarce filmele, înregistrările și imaginile care nu pot fi rescrise",
      "serveUnstrippableOriginalsToLocationReadersHint": "Contează doar cât timp „Păstrează locația în fișierele foto” e dezactivată. Filmele, înregistrările audio și imaginile în formate care nu pot fi rescrise (orice în afară de JPEG, PNG și WebP) nu au o copie fără locație, așa că, având acea opțiune dezactivată, nimeni nu le poate descărca — se văd doar previzualizările lor, iar filmele și înregistrările nu au niciuna. Activat: cine are voie să vadă unde a fost făcut un asemenea fișier îl poate descărca exact cum a fost încărcat, cu tot cu locația. Cine nu are voie să vadă locația tot nu îl primește niciodată. Dezactivat implicit.",
      "describeLocationFreeCopies": "Spune telefoanelor mărimea și amprenta fotografiilor trimise fără locație",
      "describeLocationFreeCopiesHint": "Când aplicația SpeleoLoc cere să descarce o fotografie pe care o va primi fără locație, serverul face copia pe loc și îi spune aplicației mărimea ei și amprenta SHA-256, ca aplicația să poată arăta mărimea și să verifice că descărcarea a ajuns întreagă. Aceste cereri devin mai lente — într-una singură pot fi rescrise până la 200 de fotografii — iar fiecare copie ocupă spațiu pe disc de îndată ce este cerută. Dezactivat: aplicației nu i se spune mărimea acestor fotografii și verifică descărcarea după lungimea ei. Fotografiile pe care aplicația le primește exact cum au fost încărcate sunt descrise oricum. Dezactivat implicit.",
      "enabled": "Activat",
      "host": "Server",
      "port": "Port",
      "security": "Securitatea conexiunii",
      "securityAuto": "Automat",
      "securitySsl": "TLS la conectare (465)",
      "securityNone": "Fără (text simplu)",
      "username": "Utilizator",
      "password": "Parolă",
      "secretStored": "Există o parolă salvată. Lasă gol pentru a o păstra.",
      "secretNone": "Nicio parolă salvată.",
      "fromAddress": "Adresa expeditorului",
      "fromName": "Numele expeditorului",
      "replyTo": "Adresă de răspuns",
      "timeout": "Timp de așteptare (secunde)",
      "acceptInvalidCertificate": "Acceptă un certificat invalid",
      "acceptInvalidCertificateHint": "Doar pentru un releu intern cu certificat autosemnat. Elimină protecția parolei de mai sus.",
      "mailWorking": "E-mailul este configurat",
      "mailInactive": "Niciun server de e-mail configurat. Mesajele nu sunt livrate; jurnalul serverului păstrează doar destinatarul și care mesaj era. Linkul unei invitații este afișat administratorului în loc.",
      "smsWorking": "Gateway-ul SMS este configurat",
      "smsInactive": "Niciun gateway SMS configurat. SMS-urile nu sunt livrate; jurnalul serverului păstrează doar destinatarul și care mesaj era.",
      "smsIntro": "Orice gateway care acceptă o cerere HTTP funcționează. Folosește {to}, {text} și {from} în URL sau în corp; fiecare este escapat automat.",
      "smsUrl": "URL gateway",
      "smsMethod": "Metodă",
      "smsContentType": "Tip de conținut",
      "smsBody": "Corpul cererii",
      "smsBodyHint": "De exemplu: To={to}&From={from}&Body={text}",
      "smsAuthHeader": "Antet Authorization",
      "smsAuthHint": "Trimis ca antet Authorization, de exemplu „Basic ...” sau „Bearer ...”.",
      "smsFrom": "Număr sau identificator expeditor",
      "testTitle": "Trimite un test",
      "testRecipient": "Destinatar de test",
      "sendTest": "Trimite testul",
      "testSent": "Mesajul de test a fost trimis.",
      "testFailed": "Trimiterea a eșuat: {{error}}",
      "testNotConfigured": "Configurează și salvează mai întâi canalul.",
      "sendConfirmation": "Trimite un mesaj de confirmare la crearea unui cont",
      "requireConfirmed": "Cere o adresă confirmată pentru autentificare",
      "requireConfirmedHint": "Conturile care nu și-au confirmat adresa vor fi refuzate la autentificare și li se va oferi un nou mesaj de confirmare.",
      "requireConfirmedInert": "Nu are efect până când nu este configurat un server de e-mail — altfel nimeni nu ar putea confirma.",
      "allowAuthenticator": "Permite aplicații de autentificare",
      "allowEmail": "Permite coduri prin e-mail",
      "allowSms": "Permite coduri prin SMS",
      "needsMail": "Necesită un server de e-mail înainte de a putea fi folosit.",
      "needsSms": "Necesită un gateway SMS înainte de a putea fi folosit.",
      "smsWeakest": "Cea mai slabă dintre cele trei: un număr poate fi mutat pe altă cartelă convingând operatorul de telefonie.",
      "codeLifetime": "Valabilitatea codului (minute)",
      "resendInterval": "Pauză între coduri (secunde)",
      "importTab": "Import vectorial",
      "importIntro": "Un fișier importat este verificat înainte să se creeze ceva. Aici acest pas poate fi eliminat și tot aici se stabilește cât de departe caută implicit detectarea duplicatelor.",
      "allowWithoutReview": "Permite unui utilizator de încredere să creeze obiecte fără verificare",
      "allowWithoutReviewHint": "Dezactivat implicit. Regulile sunt o presupunere despre obiceiurile de denumire ale cuiva, iar primul import cu un set pe care nimeni nu l-a ajustat este exact momentul în care presupunerea este cea mai slabă. Activarea nu lărgește cine poate crea — cel care importă are în continuare nevoie de dreptul de a crea obiecte — ci doar elimină pasul intermediar.",
      "duplicateRadius": "Caută ceva deja existent pe o rază de",
      "duplicateRadiusHint": "Raza de pornire pentru o verificare nouă; cel care importă o poate schimba. Se măsoară doar față de obiectele a căror poziție exactă o poate vedea.",
      "duplicateSimilarity": "Numele se consideră identice peste",
      "duplicateSimilarityHint": "Cât de asemănătoare trebuie să fie două nume, de la 0 la 1, pentru ca un obiect din apropiere să fie considerat același lucru, nu doar aproape.",
      "syncTab": "Sincronizare cu telefonul",
      "syncIntro": "Ce face această instalare cu aplicația SpeleoLoc de pe telefon. O modificare se aplică imediat tuturor telefoanelor care se sincronizează; salvarea înlocuiește toate cele cinci setări împreună.",
      "syncPeopleDirectoryEnabled": "Dă telefoanelor lista de persoane",
      "syncPeopleDirectoryEnabledHint": "Activat: un telefon poate descărca o listă de speologi, doar nume, niciodată o adresă sau un număr de telefon, ca utilizatorul lui să poată spune cine este și cine a fost într-o tură. Dezactivat: telefoanele nu primesc lista și nu pot spune ce speolog este unul dintre utilizatorii lor. Asocierile făcute deja pe pagina Utilizatori de telefon rămân, iar ce înregistrează un telefon despre utilizatorii lui se păstrează în continuare.",
      "syncPeopleDirectoryScope": "Ale cui nume sunt în listă",
      "syncPeopleDirectoryScopeHint": "Un telefon poate spune că utilizatorul lui este doar cineva care i-a fost arătat, așa că aceasta stabilește și pe cine poate numi un telefon.",
      "syncScopeMyGroups": "Speologii din grupurile de speologie ale contului telefonului și speologul propriu al contului",
      "syncScopeEveryone": "Toți speologii din listă",
      "syncScopeEveryoneWarning": "Toată lista este arătată fiecărui cont care sincronizează un telefon, indiferent de grup. Alege aceasta doar dacă lista speologilor nu este un secret față de cei care se autentifică.",
      "syncConvertTripsWithProblems": "Fă ture din înregistrări cu probleme",
      "syncConvertTripsWithProblemsHint": "O tură înregistrată pe telefon este transformată singură într-un raport de tură. Activat: asta se întâmplă și când o parte nu a putut fi potrivită, de exemplu o stație pe care nimeni nu o poate plasa sau un utilizator de telefon neasociat unui speolog. Tura este semnalată pentru verificare și spune de ce. Dezactivat: o astfel de înregistrare așteaptă pe pagina peșterii până când cineva o convertește manual.",
      "syncStagedUploadRetentionDays": "Păstrează fotografiile trimise înaintea unei încărcări (zile)",
      "syncStagedUploadRetentionDaysHint": "Un telefon trimite octeții unei fotografii înaintea încărcării care îi folosește. Dacă nicio încărcare nu îi preia în acest număr de zile, sunt șterși. O modificare se aplică fișierelor sosite după ea. Fișierele care așteaptă se numără în spațiul contului care le trimite, așa că lasă loc pentru fotografiile unui telefon pe cam atâtea zile. De la 1 la 365.",
      "syncRejectedHeldBytesRetentionDays": "Păstrează fișierele unei încărcări respinse (zile)",
      "syncRejectedHeldBytesRetentionDaysHint": "Când o încărcare ținută pentru verificare este hotărâtă fără ca fișierele ei să fie folosite, pentru că a fost respinsă, înlocuită de una ulterioară sau acceptată fără ele, fișierele sunt șterse după acest număr de zile. Cât timp o încărcare așteaptă un verificator, fișierele ei se păstrează oricât durează. De la 1 la 365.",
      "notificationsTab": "Notificări",
      "notificationsIntro": "Cât timp păstrează această instalare ce le-a spus oamenilor. Ce se salvează aici înlocuiește setarea din configurația de instalare; dacă nu o atingi, aceea rămâne în vigoare.",
      "retentionDays": "Păstrează notificările (zile)",
      "retentionDaysHint": "O notificare este ștearsă după acest interval, citită sau nu, și indiferent dacă a plecat vreodată un e-mail pentru ea. Evidența felului în care a fost trimisă dispare odată cu ea.",
      "announcementsIntro": "Cât poate costa această instalare un anunț către un club speologic întreg. Mesajele SMS se taxează pe segmente și nu mai pot fi retrase după trimitere, așa că nu ajung la nimeni până când aceasta nu este activată și se opresc pentru toată ziua când se atinge limita de mai jos.",
      "paidChannelsEnabled": "Permite anunțuri pe canale care se taxează pentru ce trimit",
      "paidChannelsEnabledHint": "Oprit înseamnă oprit: cât timp este oprit, nimeni nu poate alege un astfel de canal, nicio preferință salvată pentru el nu are vreun efect și nu se creează nicio copie de trimis pe el.",
      "dailyPaidMessageCap": "Segmente de mesaj taxate pe zi",
      "dailyPaidMessageCapHint": "Un operator taxează un mesaj SMS pe segmente, nu pe mesaj: 160 de caractere din alfabetul latin simplu încap într-un singur segment, dar o singură literă cu diacritice recodifică tot mesajul în segmente de 70, așa că aceeași formulare costă de două ori mai mult în română decât în engleză. Un anunț care ar depăși această limită este refuzat în întregime, nu trimis către jumătate din listă. Segmentele deja angajate azi contează, inclusiv cele care încă așteaptă să plece.",
      "photoLibrariesTab": "Fototeci",
      "surveyUploadsTab": "Încărcări de topografii",
      "surveyUploadsIntro": "Alegeri despre topografiile trimise de pe un dispozitiv de teren, cum ar fi TopoDroid.",
      "firstModelOfCreatedCave": "O peșteră creată de o încărcare primește primul ei model",
      "firstModelOfCreatedCaveHint": "Când o încărcare creează o peșteră, primul model adus devine modelul curent al peșterii, iar drumuirea lui forma peșterii. Oprit: un model dintr-o încărcare nu devine niciodată curent singur; cineva alege pe web.",
      "surveyUploadsEnvironmentNote": "Câte versiuni ale unei topografii își păstrează rezultatele (SILEXGIS__SurveyUploads__KeepArtefactVersions) și mărimea de la care paginile avertizează (SILEXGIS__SurveyUploads__OlderVersionsWarnMegabytes) se setează în mediul serverului.",
      "photoLibrariesIntro": "Aceste comutatoare opresc folosirea unei fototeci pe care instalarea o are deja și o pornesc la loc. Ele nu pot conecta una: ce fototeci are această instalare se decide prin implementarea care le-a dat adresele și credențialele."
    },
    "basemap": {
      "tab": "Hartă de bază proprie",
      "title": "Harta de bază a acestei instalări",
      "intro": "O hartă de bază vectorială OpenStreetMap, servită numai de această instalare: descarcă o regiune dintr-o versiune Protomaps a planetei, iar fundalurile desenate din ea sunt oferite pe hartă de atunci încolo. Etichetele ei urmează limba cititorului. Plăcile nu conțin curbe de nivel, așa că păstrează fundalurile topografice pentru relief.",
      "off": "Această instalare nu servește o hartă de bază proprie: găzduirea proprie este oprită din configurare (SILEXGIS__Basemap__SelfHosted) sau extensia pentru harta de bază nu rulează.",
      "none": "Nu a fost descărcată încă nicio hartă de bază.",
      "waiting": "Aceste fundaluri de hartă sunt oferite după ce descarci o regiune: {{entries}}.",
      "noEntry": "Niciun fundal din catalogul hărții nu este desenat încă din ea: adaugă unul cu {basemap} în adresă.",
      "current": "Servită acum",
      "build": "Versiune",
      "size": "Mărime",
      "downloadedAt": "Descărcată",
      "region": "Regiune (V, S, E, N)",
      "maxZoom": "Ultimul nivel de zoom",
      "newDownload": "Descarcă o regiune",
      "preset": {
        "romania": "România",
        "apuseni": "Apuseni (regiune carstică)",
        "custom": "Un dreptunghi ales de mine"
      },
      "side": {
        "west": "Vest",
        "south": "Sud",
        "east": "Est",
        "north": "Nord"
      },
      "latest": "Cea mai nouă versiune",
      "buildsFailed": "Lista versiunilor nu a putut fi citită; se folosește cea mai nouă.",
      "estimate": "Estimează mărimea",
      "download": "Descarcă",
      "estimated": "Aproximativ {{size}}, din versiunea {{build}}.",
      "source": "Decupată din {{source}}. Cea mai mare descărcare acceptată este de {{limit}}.",
      "replaceTitle": "Înlocuiești harta de bază servită acum?",
      "replaceBody": "Noua regiune o înlocuiește pe cea de acum după ce descărcarea ei s-a terminat. Până atunci, cea de acum este servită în continuare.",
      "latestDownload": "Ultima descărcare:",
      "cancel": "Anulează descărcarea",
      "loadFailed": "Starea hărții de bază nu a putut fi citită.",
      "state": {
        "queued": "în așteptare",
        "running": "în curs",
        "succeeded": "terminată",
        "failed": "eșuată",
        "cancelled": "anulată"
      },
      "refusal": {
        "too_large": "Prea mare pentru această instalare: alege un dreptunghi mai mic sau un ultim nivel de zoom mai mic.",
        "disk_full": "Nu este destul loc pe disc pentru ea lângă harta de bază de acum.",
        "source_unreachable": "Sursa nu a putut fi contactată. Încearcă din nou mai târziu.",
        "build_not_found": "Sursa nu are această versiune.",
        "cancelled": "Descărcarea a fost anulată; harta de bază servită a rămas aceeași.",
        "extract_failed": "Descărcarea a eșuat; harta de bază servită a rămas aceeași.",
        "download_running": "O descărcare este deja în curs.",
        "self_hosting_off": "Găzduirea proprie este oprită."
      }
    },
    "mapBackgrounds": {
      "tab": "Hărți în documente",
      "intro": "Ce fundaluri de hartă pot fi copiate într-un document. Raportul descărcat al unei ture conține o hartă desenată peste un singur fundal: cel implicit, dacă este pornit aici, altfel primul care este.",
      "reason": "Copierea plăcilor unei surse într-un document trebuie să fie permisă de termenii acelei surse. Afișarea unei hărți pe ecran și punerea ei într-un fișier care apoi este trimis și tipărit sunt utilizări diferite, iar fiecare furnizor o hotărăște separat pe a doua — pornește deci un fundal doar după ce i-ai citit termenii. Instalarea vine cu un răspuns pentru fiecare; ce hotărăști aici se păstrează la reporniri și actualizări.",
      "loadFailed": "Fundalurile de hartă nu au putut fi încărcate.",
      "noneOn": "Niciun fundal nu este pornit, deci harta dintr-un raport este desenată pe un fond simplu și spune acest lucru.",
      "columns": {
        "background": "Fundal",
        "inDocuments": "În documente",
        "shipped": "Livrat"
      },
      "switchLabel": "Copiază {{name}} în documente",
      "shippedOn": "Livrat: pornit",
      "shippedOff": "Livrat: oprit",
      "decidedHere": "Hotărât aici",
      "useShipped": "Folosește răspunsul livrat",
      "noCredit": "Pentru această sursă nu este consemnată nicio mențiune de drepturi, deci nu poate fi copiată într-un document.",
      "needsCredit": "Sursa nu are o mențiune de drepturi de scris sub imagine, deci nu poate fi copiată într-un document."
    },
    "documentTypes": {
      "title": "Tipuri de documente",
      "intro": "Tipurile de document recunoscute de această instalare și detaliile cerute de fiecare tip. Rescrierea detaliilor unui tip nu modifică documentele deja înregistrate: acestea păstrează versiunea cu care au fost verificate și sunt reverificate abia la următoarea editare.",
      "add": "Adaugă un tip",
      "edit": "Editare tip de document",
      "editAction": "Editează",
      "name": "Denumire",
      "code": "Cod",
      "codeHint": "Litere mici, cifre și liniuțe de subliniere. Instalările schimbă documente după acest cod, deci păstrează-l neschimbat.",
      "description": "Descriere",
      "sortOrder": "Ordine de sortare",
      "fields": "Detalii cerute",
      "noSchema": "Niciun detaliu",
      "schema": "Schema detaliilor (JSON Schema)",
      "schemaHint": "Lasă gol pentru un tip care nu cere nimic. Pe formular apar doar câmpuri simple: text, număr, da/nu și alegere.",
      "schemaVersion": "Versiune schemă",
      "schemaInvalid": "Textul nu este o schemă JSON Schema utilizabilă.",
      "codeTaken": "Acest cod este deja folosit de alt tip.",
      "seeded": "Vine cu produsul",
      "seededImmutable": "Un tip de document care vine cu produsul își păstrează codul.",
      "preview": "Câmpurile pe care le va oferi formularul documentului",
      "noFields": "Niciunul — nimic din această schemă nu poate fi afișat ca un câmp.",
      "kinds": {
        "string": "text",
        "number": "număr",
        "integer": "număr întreg",
        "boolean": "da/nu",
        "enum": "alegere"
      }
    },
    "featureTypes": {
      "title": "Tipuri de obiecte",
      "intro": "Tipurile de obiecte pe care această instalare le înregistrează pe hartă — cele livrate cu produsul și cele adăugate de voi — cu formele în care poate fi desenat fiecare și felul în care unul protejat este arătat celor fără vedere exactă. Tipurile livrate își păstrează codul, categoria, afișarea protejată și nevoia de părinte; denumirea, simbolul, ordinea și detaliile lor sunt ale voastre. Odată ce există obiecte de un tip, categoria lui rămâne, nicio formă nu mai poate fi scoasă și nu poate începe să ceară un părinte, pentru că obiectele salvate n-ar mai fi în acord cu el.",
      "add": "Adaugă un tip",
      "edit": "Editează tipul de obiect",
      "editAction": "Editează",
      "delete": "Șterge",
      "deleteConfirm": "Ștergi tipul „{{name}}”? Poate fi șters doar un tip pe care nu-l folosește niciun obiect.",
      "name": "Denumire",
      "code": "Cod",
      "codeHint": "Litere mici, cifre și liniuțe de subliniere. Instalările schimbă obiecte după acest cod, deci păstrează-l stabil.",
      "description": "Descriere",
      "sortOrder": "Ordine",
      "category": "Categorie",
      "categories": {
        "surface": "Suprafață",
        "underground": "Subteran",
        "area": "Zonă",
        "structure": "Structură"
      },
      "shapes": "Forme în care poate fi desenat",
      "shapesHint": "O formă poate fi adăugată oricând; odată ce există obiecte de acest tip, niciuna nu mai poate fi scoasă.",
      "shapesRequired": "Alege cel puțin o formă.",
      "shapeNames": {
        "point": "Punct",
        "lineString": "Linie",
        "polygon": "Contur",
        "multiPoint": "Mai multe puncte",
        "multiLineString": "Mai multe linii",
        "multiPolygon": "Mai multe contururi"
      },
      "protectedDisplay": "Când este protejat",
      "displays": {
        "snapPoint": "Arătat aliniat la grilă (doar punctele)",
        "withhold": "Nu este arătat deloc"
      },
      "requiresParent": "Doar în interiorul altui obiect",
      "requiresParentHint": "Pentru tipuri care n-au sens singure, cum este un loc din interiorul unei peșteri.",
      "symbol": "Simbol pe hartă",
      "noSymbol": "Fără simbol",
      "style": "Ajustări de stil pe hartă (obiect JSON)",
      "styleHint": "Opțional. Lasă gol pentru stilul implicit.",
      "schema": "Schema detaliilor (JSON Schema)",
      "schemaHint": "Lasă gol pentru un tip care nu cere nimic. În formular apar doar câmpuri simple de text, număr, da/nu și alegere.",
      "schemaVersion": "Versiunea schemei",
      "seeded": "Livrat cu produsul",
      "shippedNote": "Acest tip este livrat cu produsul: codul, categoria, afișarea protejată și nevoia de părinte rămân cum au fost livrate, iar el păstrează toate formele cu care vine.",
      "preview": "Câmpurile pe care le va oferi formularul obiectului",
      "noFields": "Niciunul — nimic din această schemă nu poate fi afișat ca un câmp.",
      "schemaInvalid": "Aceasta nu este o JSON Schema utilizabilă.",
      "styleInvalid": "Stilul trebuie să fie un obiect JSON.",
      "codeTaken": "Un alt tip folosește deja acest cod.",
      "seededImmutable": "Un tip livrat cu produsul își păstrează codul, categoria, afișarea protejată, nevoia de părinte și formele, și nu poate fi șters.",
      "boundToCaves": "Toate peșterile",
      "boundNote": "Fiecare peșteră are acest tip și nimic altceva nu-l poate avea. Adaugă în schema lui câmpurile proprii ale clubului pentru peșteri; câmpurile cu care vine sunt cele scrise de importuri și rămân cum sunt.",
      "boundSchemaLocked": "Schema acestui tip își păstrează câmpurile cu care vine, rămâne deschisă altor câmpuri și nu poate face un câmp obligatoriu.",
      "inUse": "Există obiecte de acest tip, așa că categoria, formele și nevoia de părinte pot fi doar relaxate, iar tipul nu poate fi șters."
    },
    "tripTypes": {
      "title": "Scopuri de tură",
      "intro": "Pentru ce sunt înregistrate turele la această instalare și ce cere fiecare scop să fie consemnat într-un raport. Scopurile care vin odată cu produsul sunt afișate în limba ta și își păstrează codurile — alte instalări citesc turele după ele — însă formularea, ordinea și întrebările lor îți aparțin. Rescrierea a ceea ce cere un scop nu modifică rapoartele deja scrise: fiecare păstrează versiunea față de care a fost verificat și este verificat din nou abia când cineva îl editează.",
      "add": "Adaugă un scop",
      "edit": "Editare scop de tură",
      "editAction": "Editare",
      "delete": "Șterge",
      "deleteConfirm": "Ștergi acest scop? Turele deja înregistrate cu el îl păstrează, așa că poate fi șters abia când nu mai există niciuna.",
      "name": "Denumire",
      "code": "Cod",
      "codeHint": "Litere mici, cifre și liniuțe de subliniere. Instalările schimbă ture după acest cod, așa că păstrează-l neschimbat.",
      "description": "Descriere",
      "sortOrder": "Ordine",
      "source": "De unde provine",
      "seeded": "Vine cu produsul",
      "custom": "Adăugat aici",
      "fieldDataSchema": "Schema datelor de teren (JSON Schema)",
      "logisticsSchema": "Schema logisticii (JSON Schema)",
      "safetySchema": "Schema de siguranță (JSON Schema)",
      "schemaHint": "Lasă gol pentru o secțiune care nu cere nimic. În formular apar doar câmpuri simple de tip text, număr, da/nu și alegere.",
      "schemaInvalid": "Acesta nu este un JSON Schema utilizabil.",
      "codeTaken": "Un alt scop folosește deja acest cod.",
      "seededImmutable": "Un scop care vine cu produsul își păstrează codul și nu poate fi șters.",
      "inUse": "Există ture care înregistrează acest scop; mută-le mai întâi.",
      "sections": "Secțiuni cerute",
      "noSchema": "Nu se cere nimic",
      "preview": "Câmpurile pe care le va oferi formularul turei",
      "noFields": "Niciunul — nimic din această schemă nu poate fi afișat ca un câmp.",
      "requiredWarning": "Un câmp marcat ca obligatoriu (afișat cu albastru) este cerut de fiecare dată când secțiunea este salvată, însă o tură este creată înainte ca raportul ei să fie scris și nimic din formularul de creare nu îl poate completa — așa că un scop cu un câmp obligatoriu refuză orice tură nouă înregistrată cu el și refuză mutarea unei ture existente la el. Lasă câmpurile opționale dacă rapoartele nu sunt completate în alt mod.",
      "kinds": {
        "string": "text",
        "number": "număr",
        "integer": "număr întreg",
        "boolean": "da/nu",
        "enum": "alegere"
      },
      "defaultChecklist": "Listă de verificare",
      "defaultChecklistHint": "Lista pe care o parcurg turele cu acest scop. Numirea ei aici nu conferă nimic: un cititor care nu poate deschide lista este informat că tura nu are niciuna."
    },
    "participantRoles": {
      "title": "Roluri în tură",
      "intro": "Ce a făcut cineva într-o tură. Rolurile care vin odată cu produsul sunt afișate în limba ta și își păstrează codurile — alte instalări citesc turele după ele — însă formularea și ordinea lor îți aparțin. Adaugă aici un rol pentru o sarcină pe care clubul tău o are și la care nu s-a gândit nimeni.",
      "add": "Adaugă un rol",
      "edit": "Editare rol în tură",
      "editAction": "Editare",
      "delete": "Șterge",
      "deleteConfirm": "Ștergi acest rol? Persoanele deja înregistrate cu el îl păstrează, așa că poate fi șters abia când nu mai există niciuna.",
      "name": "Denumire",
      "nameHint": "Cum se citește această sarcină pe lista participanților.",
      "code": "Cod",
      "codeHint": "Litere mici, cifre și liniuțe de subliniere. Instalările schimbă ture după acest cod, așa că păstrează-l neschimbat.",
      "description": "Descriere",
      "sortOrder": "Ordine",
      "source": "De unde provine",
      "seeded": "Vine cu produsul",
      "custom": "Adăugat aici",
      "codeTaken": "Un alt rol folosește deja acest cod.",
      "seededImmutable": "Un rol care vine cu produsul își păstrează codul și nu poate fi șters.",
      "inUse": "Există persoane înregistrate cu acest rol; mută-le mai întâi."
    },
    "campRosterRoles": {
      "title": "Roluri în tabără",
      "intro": "Ce a fost cineva într-o tabără. Rolurile care vin odată cu produsul sunt afișate în limba ta și își păstrează codurile — alte instalări citesc taberele după ele — însă formularea și ordinea lor îți aparțin. Adaugă aici un rol pentru o sarcină pe care clubul tău o are în tabără și la care nu s-a gândit nimeni. Lista este separată de rolurile în tură: a găti pentru treizeci de oameni sau a ține tabăra de bază nu este o sarcină în subteran, iar un rol adăugat aici nu este oferit niciodată într-o tură.",
      "add": "Adaugă un rol",
      "edit": "Editare rol în tabără",
      "editAction": "Editare",
      "delete": "Șterge",
      "deleteConfirm": "Ștergi acest rol? Persoanele deja înregistrate cu el îl păstrează, așa că poate fi șters abia când nu mai există niciuna.",
      "name": "Denumire",
      "nameHint": "Cum se citește acest rol pe lista unei tabere.",
      "code": "Cod",
      "codeHint": "Litere mici, cifre și liniuțe de subliniere. Instalările schimbă tabere după acest cod, așa că păstrează-l neschimbat.",
      "description": "Descriere",
      "sortOrder": "Ordine",
      "source": "De unde provine",
      "seeded": "Vine cu produsul",
      "custom": "Adăugat aici",
      "codeTaken": "Un alt rol folosește deja acest cod.",
      "seededImmutable": "Un rol care vine cu produsul își păstrează codul și nu poate fi șters.",
      "inUse": "Există persoane înregistrate cu acest rol; mută-le mai întâi."
    },
    "reportTemplates": {
      "title": "Modele de raport",
      "intro": "Modelele în care este scris raportul unei ture sau al unei tabere. Descarcă modelul standard pentru felul dorit, editează-l într-un editor de text — își explică singur, în comentarii, ce poți pune în el — și adu-l înapoi aici. Modelul marcat ca implicit este cel folosit pentru acel fel când nimeni nu alege altul.",
      "downloadShipped": "Descarcă modelul standard",
      "downloadFailed": "Modelul standard nu a putut fi descărcat.",
      "add": "Adaugă un model",
      "edit": "Editare model",
      "editAction": "Editare",
      "delete": "Șterge",
      "deleteConfirm": "Ștergi acest model? Rapoartele revin la cel standard.",
      "none": "Încă niciun model propriu. Rapoartele sunt scrise în modelul standard.",
      "name": "Nume",
      "kind": "Descrie",
      "kindTrip": "O tură",
      "kindExpedition": "O tabără",
      "kindHint": "Modelul unei ture și modelul unei tabere sunt scrise în cuvinte diferite, iar fiecare fel are propriul model folosit când nimeni nu alege.",
      "used": "Folosit implicit",
      "isDefault": "Folosit când nimeni nu alege",
      "isDefaultHint": "Un singur model poate fi implicit, iar marcarea acestuia îl scoate pe celălalt.",
      "tripType": "Scopul turei",
      "tripTypeHint": "O tură cu acest scop este redactată în acest model dacă nu se alege altul, înaintea modelului folosit pentru orice altceva. Un singur model pe scop; lasă gol pentru un model pe care îl poate folosi orice tură.",
      "tripTypeAny": "Orice scop",
      "body": "Model",
      "fromFile": "Dintr-un fișier",
      "fromFileHint": "Fișierul este citit aici și pus în caseta de mai jos; nimic nu este salvat până nu confirmi.",
      "chooseFile": "Alege un fișier",
      "invalid": "Modelul nu a putut fi citit."
    },
    "relationTypes": {
      "title": "Relații între obiecte",
      "intro": "Formulările cu care sunt înregistrate legăturile dintre elemente. Relațiile care vin odată cu produsul sunt afișate în limba ta și nu pot fi modificate — alte instalări citesc legăturile după ele. Ce adaugi aici aparține acestei instalări și este afișat exact așa cum îl scrii.",
      "add": "Adaugă o relație",
      "edit": "Editare relație",
      "delete": "Șterge",
      "deleteConfirm": "Ștergi această relație? Legăturile deja înregistrate cu ea o păstrează, așa că poate fi ștearsă abia când nu mai există niciuna.",
      "name": "Se citește ca",
      "nameHint": "Cum se citește relația dinspre elementul de la care pornește, de exemplu „Conține” sau „Cartat de”.",
      "code": "Cod",
      "codeHint": "Numele scurt sub care este stocată și schimbată această relație. Păstrează-l neschimbat odată ce legăturile o folosesc.",
      "directed": "Se citește într-un singur sens",
      "directedHint": "Activat când cele două capete spun lucruri diferite — unul îl conține pe celălalt, unul îl documentează pe celălalt. Dezactivat când ambele capete se citesc la fel, ca „Vecin cu”.",
      "inverseName": "În sens invers",
      "inverseNameHint": "Cum se citește relația dinspre celălalt capăt, de exemplu „Conținut în”.",
      "bothWays": "Se citește la fel din ambele capete",
      "description": "Descriere",
      "sortOrder": "Ordine",
      "source": "De unde provine",
      "seeded": "Vine cu produsul",
      "custom": "Adăugată aici",
      "seededReadOnly": "Nu poate fi editată"
    },
    "templates": {
      "title": "Texte mesaje",
      "intro": "Textul a tot ce trimite aplicația. Dacă îl lași neschimbat, urmează produsul; dacă îl rescrii, se folosește versiunea ta.",
      "email": "E-mail",
      "sms": "SMS",
      "customised": "Rescris",
      "usingDefault": "Acesta este textul livrat împreună cu produsul.",
      "placeholders": "Substituenți disponibili",
      "subject": "Subiect",
      "body": "Mesaj",
      "reset": "Revino la textul implicit",
      "resetConfirm": "Renunți la versiunea ta și folosești textul implicit?",
      "resetDone": "Textul implicit a fost restabilit.",
      "name_email_confirm_address": "Confirmarea adresei",
      "name_email_change_address": "Confirmarea unei adrese noi",
      "name_email_password_reset": "Resetarea parolei",
      "name_email_account_invitation": "Invitație la un cont nou",
      "name_email_two_factor_code": "Cod de autentificare prin e-mail",
      "name_sms_two_factor_code": "Cod de autentificare prin SMS",
      "name_sms_verify_phone": "Cod de verificare a telefonului",
      "name_notify_caving_group_joined": "Adăugat într-un grup speologic",
      "name_notify_caving_group_role_changed": "Rol schimbat într-un grup speologic",
      "name_notify_caving_group_removed": "Scos dintr-un grup speologic",
      "name_notify_permission_granted": "Acces primit la o înregistrare",
      "name_notify_trip_participation": "Trecut într-un raport de tură",
      "name_notify_trip_published": "O tură a fost publicată ca pagină publică",
      "name_notify_trip_needs_attention": "O tură creată dintr-o înregistrare de pe telefon are nevoie de atenție",
      "name_notify_trip_recording_waiting": "O înregistrare de pe telefon nu a devenit tură",
      "name_notify_upload_awaiting_review": "O încărcare așteaptă un verificator",
      "name_notify_upload_reviewed": "Un verificator a decis asupra unei încărcări",
      "name_notify_trip_plan_invitation": "Invitat la o tură planificată",
      "name_notify_trip_plan_changed": "O tură planificată s-a schimbat",
      "name_notify_trip_plan_cancelled": "O tură planificată a fost anulată",
      "name_notify_trip_invitee_cannot_open_cave": "Un invitat nu poate deschide o peșteră",
      "name_notify_trip_plan_reminder": "O tură planificată se apropie",
      "name_notify_event_reminder": "Un eveniment de club se apropie",
      "name_notify_event_invitation": "Invitat la un eveniment de club",
      "name_notify_expedition_update": "O expediție de pe lista mea a fost modificată",
      "name_notify_expedition_cancelled": "O expediție de pe lista mea a fost anulată",
      "name_notify_expedition_participation": "Am fost trecut pe lista unei expediții",
      "name_notify_trip_callout_overdue": "O tură a depășit termenul și echipa nu s-a anunțat",
      "name_notify_trip_callout_overdue_sms": "O tură a depășit termenul și echipa nu s-a anunțat, prin SMS",
      "name_notify_job_completed": "Procesarea s-a încheiat",
      "name_notify_job_failed": "Procesarea a eșuat",
      "name_notify_survey_upload_succeeded": "O topografie trimisă de tine a fost procesată",
      "name_notify_survey_upload_failed": "O topografie trimisă de tine nu a putut fi procesată",
      "name_notify_security_password_changed": "Parola a fost schimbată",
      "name_notify_security_email_changed": "Adresa de e-mail a fost schimbată",
      "name_notify_security_two_factor_disabled": "Autentificarea în doi pași a fost oprită",
      "name_notify_comment_reply": "Un răspuns la un comentariu",
      "name_notify_comment_on_mine": "Un comentariu la ceva al tău",
      "name_notify_group_announcement": "Un anunț către un club speologic",
      "name_notify_group_announcement_sms": "Un anunț către un club speologic, prin SMS",
      "name_notify_digest": "Rezumat zilnic"
    },
    "importSection": "Import vectorial"
  },
  "notifications": {
    "bell": "Notificări",
    "title": "Notificări",
    "markAllRead": "Marchează tot ca citit",
    "allCategories": "Toate categoriile",
    "scopeAll": "Toate",
    "scopeUnread": "Necitite",
    "what": "Ce s-a întâmplat",
    "about": "Despre",
    "when": "Când",
    "empty": "Nu ai nimic de citit.",
    "withheld": "Lucrul la care se referă aceasta nu îți mai este disponibil.",
    "unrenderable": "Această notificare nu mai poate fi afișată."
  },
  "unsubscribe": {
    "title": "Setări notificări",
    "working": "Se aplică alegerea ta…",
    "done": "Nu vei mai primi e-mailuri despre: {{category}}.",
    "theseMessages": "aceste mesaje",
    "changeAnyTime": "Poți reactiva oricând sau modifica oricare dintre celelalte setări de notificare.",
    "failed": "Linkul nu mai este valid. Poți modifica setările de notificare după autentificare.",
    "doneDigest": "Rezumatul zilnic a fost oprit, iar odată cu el orice alt e-mail de notificare.",
    "alertsStillSent": "Alertele despre propriul cont se trimit în continuare — te avertizează când cineva îl modifică.",
    "manage": "Gestionează setările de notificare",
    "inboxUntouched": "Nimic altceva nu s-a schimbat: aceste notificări apar în continuare în inboxul din aplicație, unde le poți citi oricând."
  },
  "featureKinds": {
    "generic": "Obiect",
    "cave": "Peșteră",
    "caveEntrance": "Intrare de peșteră",
    "centerline": "Drumuire"
  },
  "search": {
    "features": "Obiecte",
    "trips": "Jurnale de tură",
    "expeditions": "Tabere",
    "documents": "În textul documentelor",
    "moreDocuments": "Se afișează {{shown}} din {{total}} documente găsite",
    "noTextLayerHint": "Niciun text de document nu se potrivește. Paginile scanate nu conțin text care să poată fi căutat până când nu sunt transcrise.",
    "supersededVersion": "versiunea {{number}}, înlocuită",
    "divisions": {
      "page": "pagina {{number}}",
      "sheet": "foaia {{number}}",
      "slide": "diapozitivul {{number}}"
    },
    "openFailed": "Înregistrarea nu a putut fi deschisă."
  },
  "shares": {
    "title": "Linkuri de partajare",
    "button": "Partajează",
    "create": "Creează link",
    "mode": "Acces",
    "modes": {
      "public": "Public",
      "requiresLogin": "Necesită autentificare"
    },
    "includeSubtree": "Include înregistrările conținute",
    "linkReady": "Link de partajare creat",
    "tokenOnce": "Copiază-l acum — linkul este afișat o singură dată.",
    "linkCopied": "Link de partajare copiat.",
    "copy": "Copiază",
    "createdAt": "Creat",
    "status": "Stare",
    "statusActive": "Activ",
    "statusRevoked": "Revocat",
    "revoke": "Revocă",
    "revokeConfirm": "Revoci acest link de partajare?",
    "revoked": "Link de partajare revocat.",
    "empty": "Niciun link de partajare încă",
    "notAllowed": "Nu poți partaja această înregistrare.",
    "readOnly": "Vizualizare partajată, doar citire",
    "childrenTitle": "Înregistrări incluse",
    "sharedNotFound": "Acest link partajat nu există sau a fost revocat.",
    "loginRequired": "Autentifică-te pentru a vedea această înregistrare partajată.",
    "signIn": "Autentificare",
    "qrLabel": "Linkul de partajare ca cod QR"
  },
  "publicSurvey": {
    "notFound": "Acest link nu funcționează. Poate a fost retras sau poate nu a existat niciodată.",
    "signInRequired": "Acest link se deschide doar pentru conturile autentificate ale acestei instalări.",
    "signInRequiredHint": "Cine l-a făcut a ales să arate aceste rezultate doar conturilor instalării. Autentifică-te și revii la această pagină.",
    "signIn": "Autentificare",
    "loadFailed": "Rezultatul nu a putut fi încărcat.",
    "caveAndVersion": "{{cave}} — încărcat {{when}}",
    "downloadLog": "Descarcă tot jurnalul",
    "logDownloadFailed": "Jurnalul nu a putut fi descărcat. Încearcă din nou."
  },
  "publicTrip": {
    "notFoundTitle": "Nimic de arătat pentru acest link",
    "notFoundBody": "Acest link nu deschide nicio tură. Se poate să nu fi existat niciodată, să fi fost retras sau tura să nu mai fie publicată.",
    "caverOrdinal": "Speolog {{ordinal}}",
    "noTeam": "Fără echipă",
    "state": {
      "off": "Neurmărită",
      "armed": "În peșteră acum",
      "closed": "Încheiată"
    },
    "standing": {
      "underground": "În peșteră",
      "out": "Ieșit",
      "unheard": "Încă neraportat"
    },
    "columnPosition": "Ultima poziție raportată",
    "positionSince": "Raportată {{since}}",
    "positionAt": "Raportată la {{clock}}",
    "columnLastHeard": "Ultima veste",
    "positionMaybeWithheld": "Nearătată sau neraportată",
    "positionUnreported": "Nicio poziție raportată",
    "positionOtherModel": "Raportat pe altă topografie",
    "otherModelTitle": "Unele locuri nu sunt arătate pe acest desen",
    "otherModelBody": "Cineva a raportat unde se află acești speologi, dar locul a fost măsurat pe altă topografie a acestei peșteri decât cea desenată aici. Același nume de stație poate însemna alt loc în altă topografie, așa că este lăsat în afara desenului, nu arătat undeva unde poate nu este. Asta nu înseamnă că nimeni nu știe unde se află.",
    "positionNotOnModel": "Nu e pe desen",
    "notOnModelTitle": "Desenul nu conține unele dintre aceste stații",
    "notOnModelBody": "Acești speologi au fost raportați la stații chiar ale topografiei desenate mai sus, iar desenul nu are nicio stație cu acele nume — topografia a fost redesenată între timp, iar numele s-au mutat odată cu ea. Locurile lor sunt scrise aici în cuvinte, în loc să fie marcate pe desen. Asta nu înseamnă că nimeni nu știe unde se află: cineva i-a raportat pe fiecare, iar ceea ce s-a raportat este scris lângă numele lor.",
    "closedTitle": "Această tură s-a încheiat",
    "closedBody": "Urmărirea a fost încheiată, așa că pagina nu se mai schimbă. Ce arată este ultimul cuvânt despre fiecare.",
    "withheldTitle": "Unele poziții nu sunt arătate aici",
    "withheldBody": "Cel puțin o poziție din această tură a fost raportată într-o peșteră care nu este publicată. Acei oameni sunt pe listă, dar nu sunt plasați.",
    "staleTitle": "Pagina nu se mai împrospătează",
    "staleBody": "Tura nu a putut fi citită acum — se poate să fi căzut conexiunea. Mai jos este ultima veste primită de pagină, iar aceasta începe să se împrospăteze singură din nou de îndată ce poate.",
    "staleBodySince": "Tura nu a putut fi citită acum — se poate să fi căzut conexiunea. Mai jos este ultima veste primită de pagină, {{since}}, iar aceasta începe să se împrospăteze singură din nou de îndată ce poate.",
    "staleLine": "Nu se împrospătează — citită ultima dată {{since}}",
    "camp": "Tabără: {{name}}",
    "unreachableTitle": "Tura nu a putut fi citită acum",
    "unreachableBody": "Acest telefon sau calculator nu a putut ajunge la server — verifică conexiunea și încearcă din nou. Nimic de aici nu spune ceva despre link în sine.",
    "retry": "Încearcă din nou",
    "endedTitle": "Acest link nu mai răspunde",
    "endedBody": "Se poate să fi fost retras sau publicarea turei să se fi încheiat. Mai jos este ultima veste primită de pagină și nu va mai fi împrospătată.",
    "endedBodyAt": "Se poate să fi fost retras sau publicarea turei să se fi încheiat. Mai jos este ultima veste primită de pagină, la {{clock}}, și nu va mai fi împrospătată.",
    "since": {
      "running": "Urmărită de la {{clock}} · {{duration}}",
      "started": "Urmărirea a pornit la {{clock}}",
      "span": "Urmărită {{span}}"
    },
    "planned": {
      "ahead": "Ieșire plănuită până la {{clock}}",
      "passed": "Ieșirea era plănuită până la {{clock}}"
    },
    "updated": {
      "running": "Pagină împrospătată {{since}}",
      "settled": "Citită ultima dată la {{clock}}"
    },
    "about": {
      "line": "Fiecare loc de mai jos este acolo unde cineva a fost raportat ultima dată, la ora de alături — vestea este transmisă din peșteră și introdusă de un om. Nu este o poziție în timp real.",
      "title": "Cum funcționează pagina",
      "body": "Nimeni nu este urmărit de un aparat în peșteră. Un loc apare aici când o echipă transmite o veste la suprafață și cineva o introduce, așa că arată unde era un om la ora aceea, nu unde este în acest minut. Pauzele lungi sunt normale: în peșteră nu există semnal, iar veștile ies doar de la un punct de telefon sau de la intrare. O pauză înseamnă că încă nu a transmis nimeni nimic. Nu înseamnă că s-a întâmplat ceva."
    },
    "language": {
      "name": "Română",
      "short": "RO",
      "switchTo": "Afișează pagina în română"
    },
    "embedNoModel": "Nu există nicio topografie de arătat pentru această tură.",
    "past": {
      "sectionTitle": "Ture trecute în această peșteră",
      "none": "Nu a fost publicată nicio tură trecută a acestei peșteri.",
      "rowWhen": "{{dates}} · {{count}} în echipă",
      "play": "Redă",
      "playing": "Se redă",
      "pause": "Pauză",
      "notPlayable": "Nimic de redat",
      "more": "Există ture mai vechi decât acestea.",
      "otherTrips": "Alte ture din această peșteră",
      "listFailedTitle": "Turele trecute nu au putut fi citite",
      "listFailedBody": "Acest link deschide tura de mai sus, iar acum nu a putut citi și turele anterioare ale peșterii. Lista poate fi deschisă din nou.",
      "listNotOfferedTitle": "Turele trecute nu sunt oferite prin acest link",
      "listNotOfferedBody": "Această instalație nu deschide vizitatorilor turele anterioare ale peșterii, așa că nu este nimic de citit aici.",
      "listLinkEndedTitle": "Turele trecute nu mai pot fi citite prin acest link",
      "listLinkEndedBody": "Acest link nu mai răspunde, iar turele anterioare ale peșterii sunt refuzate odată cu el: linkul poate să fi fost retras sau să fi expirat, ori această instalație nu deschide vizitatorilor arhiva sa. O nouă încercare nu schimbă asta.",
      "tag": "Tură trecută",
      "bannerTitle": "Aceasta este o tură trecută",
      "bannerWhat": "{{title}} — {{dates}}. Ce este desenat mai jos este felul în care a fost raportată această tură la momentul de pe ceas. Nimeni nu este urmărit aici, iar nimic din această pagină nu arată unde se află cineva acum.",
      "bannerWhatShort": "{{title}} — {{dates}}. Nu unde se află cineva acum.",
      "bannerLoading": "Se citește această tură…",
      "truncated": "Această tură a raportat mai mult decât poate cuprinde o citire a ei, așa că reluarea se oprește la ultimul raport pe care îl conține — echipa a continuat după acel moment.",
      "truncatedShort": "Înregistrarea se termină înaintea turei — echipa a continuat.",
      "unknownTrip": "O tură din trecut",
      "backToNow": "Înapoi la echipa din peșteră acum",
      "backToThisTrip": "Înapoi la tura acestui link",
      "backToNowShort": "Acum",
      "backToThisTripShort": "Înapoi",
      "controls": "Comenzile reluării și alte ture",
      "switchTrip": "Redă altă tură din această peșteră",
      "noLiveParty": "Și tura acestui link s-a încheiat, așa că nu există nicio echipă în peșteră la care să se poată reveni.",
      "following": "Se ține pasul cu {{who}}.",
      "stopFollowing": "Nu mai urmări",
      "followNobody": "Nu urmări pe nimeni",
      "followNotInTrip": "Nu e în această tură",
      "followLabel": "Pe cine urmărește vederea",
      "reading": "Se citește această tură…",
      "trackFailedTitle": "Această tură nu a putut fi citită",
      "trackFailedBody": "Se poate să nu mai fie publicată sau să fi depășit intervalul în care această instalare păstrează turele lizibile.",
      "nothingToPlay": "Pe această tură nu s-a înregistrat nimic pe care o reluare să îl poată arăta.",
      "speed": "{{value}}×",
      "scrub": "Momentul din tură",
      "reportPrevious": "Raportul anterior",
      "reportNext": "Raportul următor",
      "reportPreviousOf": "Raportul anterior despre {{who}}",
      "reportNextOf": "Raportul următor despre {{who}}",
      "reportPreviousFollowed": "Raportul anterior despre cei urmăriți",
      "reportNextFollowed": "Raportul următor despre cei urmăriți",
      "copyMoment": "Copiază linkul către acest moment",
      "copyPlaying": "Copiază linkul care redă de aici",
      "copiedMoment": "Link copiat. Deschide această tură la {{when}}.",
      "copiedPlaying": "Link copiat. Deschide această tură la {{when}} și pornește redarea.",
      "copyRefused": "Browserul nu a permis copierea. Linkul este mai jos: selectează-l și copiază-l manual.",
      "copyByHand": "Linkul către acest moment",
      "pictures": {
        "heading": "Fotografii de la {{when}}",
        "of": "Fotografie cu {{who}}",
        "ofMoment": "Fotografie din acest moment"
      }
    },
    "live": {
      "heading": "Urmărite acum",
      "underground": "În peșteră acum",
      "justFinished": "Abia încheiată",
      "thisLink": "Tura acestui link",
      "none": "Nicio echipă din această peșteră nu este urmărită acum.",
      "failedTitle": "Turele urmărite nu au putut fi citite",
      "failedBody": "Acest link deschide tura de mai sus, iar acum nu a putut citi și cine mai este urmărit în peșteră. Încearcă să deschizi lista din nou.",
      "linkEndedTitle": "Turele urmărite nu mai pot fi citite prin acest link",
      "linkEndedBody": "Acest link nu mai răspunde, iar lista celor care mai sunt urmăriți în peșteră este refuzată odată cu el. O nouă încercare nu schimbă asta.",
      "pastOnlyTitle": "Acest link nu mai arată cine este astăzi în peșteră",
      "pastOnlyBody": "Acest link a încetat să mai arate echipele urmărite acum în peșteră, iar redeschiderea listei nu schimbă asta. Turele trecute ale peșterii sunt în continuare aici, pot fi citite și redate.",
      "pastOnlyWatchBody": "Mai jos este ultima veste primită de pagină despre această echipă și nu va mai fi împrospătată. Turele trecute ale peșterii sunt în continuare aici.",
      "pastOnlyWatchBodyAt": "Mai jos este ultima veste primită de pagină despre această echipă, la {{clock}}, și nu va mai fi împrospătată. Turele trecute ale peșterii sunt în continuare aici.",
      "more": "Sunt urmărite mai multe echipe decât acestea.",
      "sectionTitle": "Tot în această peșteră, acum",
      "standingCount": "{{standing}}: {{number}}",
      "watch": "Vezi echipa",
      "watching": "Pe ecran acum",
      "backToOwn": "Înapoi la tura acestui link",
      "watchBannerTitle": "Privești o altă echipă din această peșteră",
      "watchBannerWhat": "{{title}} — {{dates}}. Aceasta nu este tura pentru care a fost publicat linkul: este o altă echipă urmărită în aceeași peșteră, desenată pe topografia acestui link.",
      "watchBannerLoading": "Se citește cine este urmărit în această peșteră…",
      "watchClosedTitle": "Tura acestei echipe s-a încheiat",
      "watchClosedBody": "Urmărirea ei a fost încheiată, așa că nimic despre ea nu se mai schimbă. Mai rămâne o vreme în lista echipelor urmărite, apoi iese din ea.",
      "watchEndedTitle": "Echipa pe care o priveai nu mai este în listă",
      "watchEndedBody": "{{title}} nu mai este printre echipele urmărite în această peșteră pe care le arată acest link, așa că pagina arată din nou tura acestui link.",
      "watchEndedClose": "Închide această notă",
      "watchLine": "Altă echipă din această peșteră: {{title}}",
      "watchEndedLine": "{{title}} nu mai este în lista echipelor urmărite. Aceasta este din nou tura acestui link."
    }
  },
  "qr": {
    "button": "Coduri tipărite",
    "title": "Coduri tipărite la această peșteră",
    "cardTitle": "Cod tipărit",
    "explainTitle": "Ce face publicarea",
    "explainBody": "Un cod tipărit pe o etichetă de aici răspunde unui vizitator fără cont: confirmă că acel cod este înregistrat la această instalare și nu spune nimic altceva. Publicarea nu dezvăluie niciun nume, nicio poziție și nicio fotografie, iar peștera nu apare pe nicio hartă publică. Până publici, o etichetă scanată nu răspunde deloc.",
    "statusPublished": "Codurile răspund oricui",
    "statusUnpublished": "Codurile nu răspund nimănui",
    "publish": "Publică",
    "published": "Codurile tipărite la această peșteră răspund acum.",
    "revoke": "Oprește publicarea",
    "revokeConfirm": "Oprești răspunsul codurilor tipărite ale acestei peșteri? Etichetele aflate deja pe teren nu vor mai răspunde nimic.",
    "revoked": "Codurile tipărite la această peșteră nu mai răspund.",
    "publishedAt": "Publicat",
    "revokedAt": "Retras",
    "notAllowed": "Nu poți decide acest lucru pentru această peșteră.",
    "noCodeHere": "Această peșteră nu are un cod tipărit propriu. Locurile din interiorul ei au codurile lor, iar fiecare dintre ele răspunde pe baza deciziei de mai sus — deschide un loc pentru a-i vedea pătratul.",
    "copyUrl": "Copiază adresa",
    "urlCopied": "Adresă copiată.",
    "codeNotScannableTitle": "Acest cod nu poate fi tipărit pe o etichetă",
    "codeNotScannableBody": "Conține caractere pe care adresa trebuie să le escapeze, iar scanerul de pe telefon citește adresa exact așa cum este scrisă, fără a o decoda. Un browser ar deschide totuși pătratul de mai jos, dar aplicația de speologie nu l-ar rezolva. Schimbă codul sau separatorul din care a fost asamblat, astfel încât să conțină doar litere și cifre.",
    "landingFoundTitle": "Acest cod este înregistrat",
    "landingFoundBody": "Codul scanat este înregistrat la {{instance}} și atât spune această pagină: nicio peșteră, niciun loc și nicio poziție. Un cont nu schimbă nimic aici — răspunsul este același pentru toată lumea.",
    "landingUnknownTitle": "Nimic de arătat pentru acest cod",
    "landingUnknownBody": "Acest cod nu este înregistrat aici sau peștera căreia îi aparține nu este publicată. Verifică caracterele de pe etichetă sau întreabă cine a pus-o acolo.",
    "address": "Adresă",
    "squareFor": "Cod QR pentru {{code}}"
  },
  "resLinks": {
    "titleCount": "Elemente legate ({{count}})",
    "incomplete": "Incompletă",
    "incompleteHint": "Doar un element al acestei legături îți este vizibil. O legătură spune ceva abia când unește două sau mai multe — adaugă încă un element, dacă există unul de adăugat.",
    "addAction": "Leagă…",
    "moreMembers": "+{{count}}",
    "rowActions": "Acțiuni pentru legătură",
    "openPage": "Deschide pagina legăturii",
    "copyUrl": "Copiază adresa legăturii",
    "urlCopied": "Adresa legăturii a fost copiată",
    "edit": "Editează legătura",
    "delete": "Șterge legătura",
    "deleteConfirm": "Ștergi această legătură? Nimic din ce leagă nu se șterge odată cu ea.",
    "restricted": "Element restricționat",
    "restrictedHint": "Legătura numește ceva ce nu ai voie să citești.",
    "mainMember": "Membru principal",
    "mainMemberPlaceholder": "Elementul din care se citește relația",
    "showingFirst": "Se afișează primele {{count}} din {{total}}.",
    "targetTypes": {
      "feature": "Obiect",
      "document": "Document",
      "tripLog": "Jurnal de tură",
      "caver": "Speolog",
      "cavingGroup": "Grup de speologie",
      "mapView": "Vedere salvată",
      "surveyModel": "Model topo 3D",
      "geofile": "Fișier de geodate",
      "cabinet": "Dulap",
      "expedition": "Expediție",
      "unknown": "Element"
    },
    "anchors": {
      "part": "parte",
      "quote": "citat",
      "quoteOnPage": "citat, p. {{page}}",
      "page": "p. {{page}}",
      "pageRange": "p. {{from}}–{{to}}",
      "region": "regiune",
      "station": "stația {{station}}",
      "splayFrom": "viză laterală din {{station}}",
      "stationRange": "stațiile {{from}}→{{to}}",
      "survey": "drumuirea {{survey}}",
      "surveyRange": "drumuirile {{from}}→{{to}}",
      "modelPoint": "punct",
      "waypoint": "punctul {{index}}",
      "waypointNamed": "punctul {{name}}",
      "waypointRange": "punctele {{from}}–{{to}}",
      "tripMoment": "la {{at, datetime(dateStyle: short; timeStyle: short)}}",
      "regionShapes": {
        "rect": "dreptunghi",
        "circle": "cerc",
        "polygon": "contur",
        "point": "punct"
      }
    },
    "anchorStates": {
      "reanchored": "Măsurat pe o versiune mai veche, regăsit în cea curentă",
      "degraded": "Măsurat pe o versiune mai veche — arătat pe întreaga resursă",
      "unresolvable": "Această parte nu mai există în resursă"
    },
    "relations": {
      "unspecified": "În legătură cu",
      "same-object": {
        "name": "Același obiect cu"
      },
      "related-to": {
        "name": "În legătură cu"
      },
      "contains": {
        "name": "Conține",
        "inverse": "Conținut în"
      },
      "documents": {
        "name": "Documentat de",
        "inverse": "Documentează"
      },
      "derived-from": {
        "name": "Sursă pentru",
        "inverse": "Derivat din"
      },
      "adjacent-to": {
        "name": "Adiacent cu"
      },
      "duplicate-of": {
        "name": "Original al",
        "inverse": "Duplicat al"
      },
      "needs-clarification": {
        "name": "Necesită clarificare"
      },
      "trip-work-area": {
        "name": "A lucrat în",
        "inverse": "Zonă de lucru a turei"
      },
      "trip-objective": {
        "name": "A vizat",
        "inverse": "Obiectiv al turei"
      },
      "trip-visited": {
        "name": "A vizitat",
        "inverse": "Vizitat în tură"
      },
      "trip-surveyed": {
        "name": "A cartat",
        "inverse": "Cartat în tură"
      },
      "trip-discovered": {
        "name": "A descoperit",
        "inverse": "Descoperit în tură"
      },
      "trip-dug": {
        "name": "A săpat la",
        "inverse": "Săpat în tură"
      },
      "trip-photographed": {
        "name": "A fotografiat",
        "inverse": "Fotografiat în tură"
      },
      "trip-searched-not-found": {
        "name": "A căutat, fără rezultat",
        "inverse": "Căutat în tură, negăsit"
      },
      "trip-lead": {
        "name": "A lăsat continuare",
        "inverse": "Continuare lăsată în tură"
      },
      "trip-follows-on-from": {
        "name": "Continuă tura",
        "inverse": "Urmată de"
      },
      "text-of": {
        "name": "Textul lui",
        "inverse": "Are textul"
      },
      "map-plan-of": {
        "name": "Planul lui",
        "inverse": "Are planul"
      },
      "map-profile-of": {
        "name": "Profilul lui",
        "inverse": "Are profilul"
      },
      "map-other-of": {
        "name": "Hartă (altă vedere) a lui",
        "inverse": "Are hartă (altă vedere)"
      },
      "map-station-point": {
        "name": "Marchează stația",
        "inverse": "Marcat pe hartă"
      },
      "map-place-point": {
        "name": "Marchează locul",
        "inverse": "Marcat pe hartă"
      },
      "place-at-station": {
        "name": "La stația",
        "inverse": "Stația locului"
      }
    },
    "members": "Elemente",
    "noVisibleMembers": "Nimic din această legătură nu îți este vizibil.",
    "memberType": "Tipul elementului",
    "memberSource": "Care element",
    "pickExisting": "Alege ceva ce există deja",
    "newPointOnMap": "Marchează un punct nou pe hartă",
    "target": "Element",
    "searchPlaceholder": "Scrie cel puțin două litere pentru căutare…",
    "anchorKind": "Spre ce arată",
    "anchorKindPending": "Indicarea acestui tip de fragment vine odată cu vizualizatorul care îl poate selecta.",
    "note": "Notă",
    "notePlaceholder": "De ce stau împreună (opțional)",
    "markAsMain": "Acesta este elementul din care se citește relația",
    "mainNeedsDirected": "Doar o relație care se citește într-un singur sens are un element de pornire.",
    "mainAlreadySet": "Această legătură se citește deja dintr-unul din elementele ei; schimbă asta în pagina legăturii.",
    "newMember": "elementul nou",
    "thisItem": "acest element",
    "createTitle": "Înregistrează o legătură",
    "addMemberTitle": "Adaugă un element",
    "relation": "Relație",
    "relationPlaceholder": "Cum sunt legate (opțional)",
    "directionNeedsMain": "Această relație se citește într-un singur sens; marchează elementul din care pornește.",
    "directionPreview": "De la {{main}}: {{forward}} · în sens invers: {{inverse}}",
    "description": "Descriere",
    "descriptionPlaceholder": "Ce consemnează această legătură (opțional)",
    "editDetails": "Editează legătura",
    "doneEditing": "Gata",
    "linkAddress": "Adresă",
    "created": "Consemnată",
    "createdByYou": "{{when}}, de tine",
    "createdBy": "{{when}}, de {{who}}",
    "openTarget": "Deschide",
    "setMain": "Citește relația din acesta",
    "moveUp": "Mută mai sus",
    "moveDown": "Mută mai jos",
    "removeMember": "Scoate din legătură",
    "removeMemberConfirm": "Scoți acest element din legătură?",
    "anchorKinds": {
      "whole": "Întregul",
      "textRange": "Un fragment de text",
      "page": "O pagină",
      "pageRange": "Un interval de pagini",
      "imageRegion": "O regiune dintr-o imagine",
      "timePoint": "Un moment din înregistrare",
      "timeRange": "Un interval din înregistrare",
      "modelStation": "O stație topografică",
      "modelStationRange": "Un șir de stații topografice",
      "modelSurvey": "O topografie",
      "modelSurveyRange": "Un șir de topografii",
      "modelPoint": "Un punct din model",
      "waypoint": "Un punct de traseu",
      "waypointRange": "Un șir de puncte de traseu",
      "tripMoment": "Un moment al turei"
    },
    "anchorEditors": {
      "page": "Pagina",
      "fromPage": "Prima pagină",
      "toPage": "Ultima pagină",
      "seconds": "Secunde",
      "start": "De la (secunde)",
      "end": "Până la (secunde)",
      "textHint": "Deschide documentul de mai jos și trage cu mouse-ul peste pasajul la care te referi. Se păstrează pasajul în sine, așa că legătura îl regăsește și după ce documentul este citit din nou.",
      "textCaptured": "Pagina {{page}}: „{{quote}}”",
      "textNotFound": "Cuvintele acelea nu se află în textul citit de pe această pagină, așa că nimic de aici nu poate spune unde sunt. Selectarea unui pasaj care este text adevărat — nu parte dintr-o imagine — îl înregistrează exact.",
      "textPageNotRead": "Această pagină nu a fost citită încă, deci nu există text în care să fie așezat pasajul. Încearcă din nou după ce documentul a fost citit.",
      "textNeedsDocument": "Alege întâi documentul; pasajul se selectează în el.",
      "textNotSelectable": "Cuvintele acestui document nu pot fi selectate aici. Se poate în schimb indica o pagină din el.",
      "textRequired": "Selectează un pasaj în document.",
      "textEmpty": "Selecția este goală.",
      "pageRequired": "Dă un număr de pagină de cel puțin 1.",
      "pageRangeRequired": "Dă ambele numere de pagină, fiecare de cel puțin 1.",
      "pageRangeBackwards": "Ultima pagină nu poate fi înaintea primei.",
      "timeRequired": "Dă un timp în secunde, cel puțin 0.",
      "timeRangeRequired": "Dă ambele timpuri în secunde, fiecare cel puțin 0.",
      "timeRangeBackwards": "Sfârșitul trebuie să fie după început; pentru o clipă folosește un singur moment.",
      "regionShape": "Formă",
      "regionShapes": {
        "rect": "Dreptunghi",
        "circle": "Cerc",
        "polygon": "Contur",
        "point": "Punct"
      },
      "regionHelp": {
        "rect": "Trage peste imagine ca să încadrezi partea la care te referi. De la tastatură: mută-te cu săgețile (Shift pentru pași mai mari), apasă Enter într-un colț și din nou în colțul opus.",
        "circle": "Apasă în centru și trage spre exterior. De la tastatură: mută-te cu săgețile, apasă Enter în centru și din nou pe margine.",
        "polygon": "Dă clic pe fiecare colț pe rând, apoi dublu-clic ca să închizi conturul. De la tastatură: mută-te cu săgețile și apasă Enter în fiecare colț; apasă Enter de două ori pe ultimul colț ca să închizi conturul, Backspace ca să renunți la un colț.",
        "point": "Dă clic pe locul la care te referi. De la tastatură: mută-te cu săgețile și apasă Enter."
      },
      "regionDrawn": "Partea desenată",
      "regionSurface": "Desenează pe {{name}}: săgețile mută cursorul, Enter îl fixează, Escape renunță la formă",
      "regionUnnamed": "Regiunea {{number}}",
      "regionClear": "Desenează din nou",
      "regionRequired": "Desenează partea din imagine la care te referi.",
      "regionNeedsDocument": "Alege întâi imaginea, apoi desenează pe ea.",
      "regionNotAPicture": "Acest document nu este o imagine, deci nu are regiuni către care să arate. Alege altă parte.",
      "regionNoRendering": "Această imagine nu poate fi afișată aici, deci nu există pe ce desena."
    },
    "point": {
      "title": "Punct nou",
      "name": "Nume",
      "namePlaceholder": "Nume pentru acest punct (opțional)",
      "altitude": "Altitudine (m)",
      "altitudePlaceholder": "Altitudinea în metri (opțional)",
      "visibility": "Cine îl poate vedea",
      "visibilityDefault": "Implicit",
      "audienceDefaultGroup": "Implicit, acest punct va fi vizibil membrilor {{group}}. Poți schimba asta aici, sau mai târziu editând punctul.",
      "audienceDefaultAuthenticated": "Implicit, acest punct va fi vizibil tuturor utilizatorilor autentificați. Poți schimba asta aici, sau mai târziu editând punctul.",
      "audienceUnknown": "Nu s-a putut afla cui i-ar fi vizibil implicit acest punct. Alege mai sus o audiență pentru a fi sigur.",
      "audience": {
        "private": "Doar tu vei putea vedea acest punct.",
        "cavingGroup": "Membrii clubului tău speologic vor vedea acest punct — asta funcționează dacă faci parte din exact un club; altfel doar tu îl vei vedea până când numești un club editând punctul.",
        "authenticated": "Toți utilizatorii autentificați vor putea vedea acest punct.",
        "public": "Oricine va putea vedea acest punct, inclusiv vizitatorii neautentificați."
      }
    },
    "problems": {
      "signedOut": "Sesiunea ta s-a încheiat. Autentifică-te și încearcă din nou.",
      "forbidden": "Nu ai voie să faci asta.",
      "createForbidden": "Nu ai voie să creezi obiecte aici.",
      "validationFailed": "Ceva din formular nu este acceptat. Verifică valorile și încearcă din nou.",
      "placePointFixed": "Un punct de pe harta unui telefon se mută sau se șterge pe hartă, nu se editează ca legătură.",
      "placeStationFixed": "Stația unui loc se stabilește pe telefoane și nu se editează ca legătură; poate fi ștearsă.",
      "placePointMapNotFound": "Această imagine nu este o hartă de pe telefon.",
      "placePointPlaceNotFound": "Acest loc nu este în peștera hărții sau nu ai voie să vezi unde se află.",
      "placePointPlacePinned": "Acest loc are deja un punct pe această hartă.",
      "placePointNotCurrentFile": "Imaginea hărții s-a schimbat între timp. Deschide din nou harta și încearcă din nou.",
      "placePointFrameUnknown": "Dimensiunea acestei imagini nu este cunoscută, așa că telefoanele nu ar putea folosi un punct pe ea.",
      "linkGone": "Această legătură nu mai există.",
      "codeUnresolved": "Această adresă de legătură nu duce nicăieri.",
      "typeUnknown": "Aplicația a cerut un tip de element pe care serverul nu îl cunoaște.",
      "targetGone": "Acel element nu poate fi găsit, sau nu ai dreptul să îl citești.",
      "targetInvalid": "Acel element nu poate face parte dintr-o legătură.",
      "typeNotLinkable": "Acest tip de element nu poate face parte dintr-o legătură.",
      "anchorKindNotAllowed": "Acel tip de element nu poate fi indicat în acest fel.",
      "anchorInvalid": "Fragmentul indicat nu este descris într-un fel acceptat de server.",
      "anchorFileInvalid": "Fișierul spre care arată nu aparține acelui element.",
      "anchorPinRequired": "Indicarea unei regiuni are nevoie de fișierul față de care este măsurată.",
      "memberLimit": "Această legătură are deja atâtea elemente câte poate ține.",
      "lastMember": "O legătură păstrează cel puțin un element; șterge legătura în schimb.",
      "mainRequired": "O relație care se citește într-un singur sens are nevoie de elementul din care pornește.",
      "mainNotSingle": "Exact un element poate fi cel din care se citește relația.",
      "mainNotAllowed": "Această relație se citește la fel în ambele sensuri, deci niciun element nu este cel de pornire.",
      "mainNotAMember": "Elementul din care ar trebui citită relația nu face parte din această legătură.",
      "memberGone": "Acel element nu mai face parte din această legătură.",
      "relationUnknown": "Acea relație nu este una oferită de această instalare.",
      "relationGone": "Acea relație nu mai există.",
      "duplicateWhole": "Această legătură numește deja acel element în întregime.",
      "geoPointUnavailable": "Punctele nu pot fi create aici: tipul generic de obiect nu este instalat.",
      "relationCodeTaken": "O altă relație folosește deja acest cod.",
      "relationSeededImmutable": "O relație care vine cu produsul își păstrează codul și felul în care se citește.",
      "relationSeededUndeletable": "O relație care vine cu produsul nu poate fi ștearsă.",
      "relationInUse": "Există deja legături înregistrate cu această relație, așa că nu poate fi modificată astfel și nici ștearsă."
    }
  },
  "importReview": {
    "held": "Importurile contului tău așteaptă un recenzent. Nu s-a creat nimic încă; se va crea după ce un recenzent le acceptă."
  },
  "vectorImport": {
    "title": "Verifică și importă",
    "reviewAndImport": "Verifică și importă în registru",
    "mapPreview": "Previzualizare pe hartă",
    "dryRun": "Ce revendică fiecare regulă",
    "optionsRules": "Reguli și denumire",
    "optionsCreated": "Ce se creează",
    "optionsUnmatched": "Puncte nerecunoscute de nicio regulă",
    "unmatched": "Ce se face cu ele",
    "unmatchedHint": "Un set de reguli recunoaște numele pe care le scrie grupul tău; un GPS golit la finalul unui sezon conține mai ales WPT0142. Punctele pe care nu le recunoaște nimic nu propun nimic, iar un rând care nu propune nimic nu poate fi bifat — așa că lăsând această opțiune pe „lasă pentru verificare”, selectarea tuturor selectează doar rândurile numite de reguli.",
    "unmatchedIgnore": "Lasă-le pentru verificare, unul câte unul",
    "unmatchedAsFeature": "Propune un fenomen de suprafață",
    "unmatchedAsEntrance": "Propune o intrare de peșteră",
    "unmatchedKind": "De acest tip",
    "optionsTracks": "Trasee și rute",
    "optionsMapping": "Ce câmp este ce",
    "ruleSet": "Set de reguli",
    "languages": "Limbi",
    "languagesAll": "Tot ce conține setul",
    "languagesHint": "Participă doar termenii din aceste limbi. Termenii marcați ca aparținând niciunei limbi participă întotdeauna.",
    "namePrefix": "Prefix pentru nume",
    "duplicateRadius": "Caută ceva deja existent pe o rază de",
    "duplicateRadiusHint": "Se măsoară doar față de obiectele a căror poziție exactă o poți vedea. Despre o peșteră protejată pe care nu o poți localiza nu se răspunde.",
    "elevation": "Altitudinea GPS",
    "elevationKeep": "Păstrează ce spune fișierul",
    "elevationDiscard": "Lasă gol",
    "locationProtected": "Marchează tot ce se creează ca locație protejată",
    "tracks": "Trasee și rute",
    "tracksIgnore": "Lasă-le în fișier",
    "tracksAsLine": "Importă ca obiect liniar",
    "trackKind": "Tipul obiectului liniar",
    "mappingAuto": "Determină automat",
    "mapping": {
      "nameField": "Nume",
      "descriptionField": "Descriere",
      "codeField": "Cod de identificare",
      "elevationField": "Altitudine"
    },
    "selectAll": "Toate",
    "selectAllPages": "Selectează toate cele {{count}} de pe toate paginile",
    "selectInvertPages": "Inversează pe toate paginile ({{count}})",
    "selectNone": "Niciuna",
    "selectInvert": "Inversează",
    "selectedCount": "{{count}} din {{total}} selectate",
    "searchPlaceholder": "Caută în nume…",
    "filterByRule": "După regulă",
    "filterByKind": "După tip",
    "onlyWithNearby": "Doar cele cu ceva în apropiere",
    "geometryAll": "Toate",
    "geometry": {
      "point": "Punct",
      "line": "Traseu",
      "area": "Suprafață",
      "other": "Altele"
    },
    "fileSummary": "{{candidates}} puncte · {{matched}} revendicate de o regulă · {{unmatched}} nerevendicate · {{tracks}} trasee · {{areas}} suprafețe",
    "columns": {
      "name": "Nume",
      "kind": "Devine",
      "type": "Tip",
      "rule": "Regulă",
      "position": "Poziție",
      "nearby": "Deja existent",
      "decision": "Decizie"
    },
    "kinds": {
      "cave": "Peșteră",
      "caveEntrance": "Intrare de peșteră",
      "surfaceFeature": "Fenomen de suprafață"
    },
    "kindNone": "Nimic",
    "actions": {
      "create": "Creează",
      "attach": "Există deja",
      "skip": "Omite"
    },
    "noRule": "Nicio regulă nu a revendicat-o",
    "conflict": "Două reguli au revendicat-o",
    "conflictHint": "Revendicată și de: {{rules}}. Câștigă regula aflată mai sus în set.",
    "nothingNearby": "Nimic în apropiere",
    "metresAway": "la {{distance}} m",
    "itIsThisOne": "Este chiar aceasta",
    "secondEntranceOf": "A doua intrare la {{cave}}",
    "unnamed": "Fără nume",
    "createSelected": "Creează {{count}} obiecte",
    "createWithoutReview": "Creează tot ce au revendicat regulile",
    "commitFailed": "Nu s-a creat nimic. Verifică mesajul și încearcă din nou.",
    "fileNotFound": "Fișierul nu este disponibil.",
    "truncatedTitle": "Fișierul este mai mare decât citește o verificare",
    "truncated": "Sunt afișate primele {{scanned}} din {{total}} rânduri. Confirmă-le, apoi deschide verificarea din nou pentru restul.",
    "resultTitle": "Ce a făcut importul",
    "created": "Create",
    "attached": "Recunoscute",
    "skipped": "Omise",
    "someFailedTitle": "{{count}} rânduri nu au putut fi create",
    "someFailed": "Restul au fost create. Corectează-le pe acestea și confirmă-le separat.",
    "failureReason": "De ce",
    "viewBatches": "Vezi importurile",
    "batchFile": "Fișier",
    "batchFromPhotos": "Fotografii",
    "batchFromDevice": "Încărcare de pe telefon",
    "batchMode": "Cum",
    "batchDetail": "Ce a creat acest import",
    "confirmedAt": "Confirmat",
    "modes": {
      "reviewed": "Verificat",
      "autoCreated": "Fără verificare"
    },
    "upload": {
      "intro": "Un telefon a trimis aceste modificări. Deschide o linie ca să vezi ce a schimbat în rândul respectiv. Anularea readuce fiecare valoare cum era înainte de încărcare; o valoare schimbată de altcineva între timp rămâne cum este.",
      "undo": "Anulează această încărcare",
      "undoConfirm": "Anulezi această încărcare?",
      "undoLeaves": "Peșterile și obiectele create de ea sunt șterse, ce a șters revine, iar fiecare valoare schimbată de ea se întoarce. O valoare schimbată din nou între timp rămâne cum este, iar rezultatul spune care.",
      "undoAnyway": "Anulează oricum",
      "undoAnywayConfirm": "Anulezi această încărcare, chiar și valorile schimbate între timp?",
      "undoAnywayRowConfirm": "Anulezi acest rând, chiar și valorile schimbate între timp?",
      "undoAnywayExplain": "Modificările de după sunt înlocuite cu valoarea de dinaintea încărcării. Rămân în istoric, deci pot fi readuse de acolo. O poziție pe care nu ai voie să o vezi exact nu este niciodată readusă.",
      "undoRow": "Anulează acest rând",
      "undoRowConfirm": "Anulezi doar acest rând?",
      "lineUndone": "Anulat",
      "supersededHint": "Un câmp pe care cineva l-a modificat din nou după încărcare este lăsat de „Anulează acest rând”; rezultatul spune care. „Anulează oricum” îl readuce și pe acesta.",
      "createdRow": "Încărcarea a creat acest rând.",
      "noRecordedChange": "Istoricul nu are nicio modificare a acestui rând din această încărcare.",
      "undone": "Încărcarea a fost anulată.",
      "undoneWithLeft_one": "Anulat, în afară de {{count}} linie. Vezi mai jos.",
      "undoneWithLeft": "Anulat, în afară de {{count}} linii. Vezi mai jos.",
      "fieldLeft": "{{field}} a rămas: {{reason}}",
      "outcome": {
        "undone": "Anulat",
        "partly": "Anulat în parte",
        "not_undone": "Neanulat"
      },
      "reason": {
        "already_undone": "deja anulat",
        "purged": "rândul a fost șters definitiv",
        "container_deleted": "peștera căreia îi aparține este încă ștearsă",
        "superseded": "a fost șters din nou după încărcare",
        "fields_left": "alte modificări ale lui au rămas",
        "no_history": "această încărcare e mai veche decât istoricul care spune ce a schimbat",
        "forbidden": "nu ai voie să schimbi acest rând",
        "trip_changed": "cineva a lucrat la raportul de tură făcut din ea, așa că raportul rămâne",
        "converted_elsewhere": "raportul ei de tură a fost făcut de un import de arhivă, așa că raportul rămâne"
      }
    },
    "revert": "Anulează",
    "reverted": "Importul a fost anulat.",
    "revertedTag": "Anulat",
    "reviewPendingTag": "Așteaptă verificarea",
    "reviewRejectedTag": "Respins la verificare",
    "reviewPartlyTag": "Acceptat în parte la verificare",
    "reviewPendingExplain": "Un verificator nu a decis încă acest import. Nimic din el nu a fost scris; ce se acceptă se scrie atunci și poate fi anulat după aceea.",
    "revertConfirm": "Ștergi toate cele {{count}} obiecte create de acest import?",
    "revertTripsRestorableFor": "Fiecare tură creată de el poate fi restaurată din Ture șterse timp de {{period}}.",
    "revertTripsRestorable": "Fiecare tură creată de el poate fi restaurată din Ture șterse.",
    "tripDeletedRestore": "Restaurează-o din Ture șterse",
    "revertFeaturesRestorable": "Fiecare peșteră și obiect creat de el poate fi restaurat din Peșteri și obiecte șterse.",
    "featureDeletedRestore": "Restaurează-l din Peșteri și obiecte șterse",
    "fileGone": "Fișierul a fost șters",
    "notCreated": "Nu s-a creat nimic",
    "deletedTag": "Șters",
    "elevationPerCandidate": "Decide pentru fiecare candidat",
    "elevationHint": "Fișierul este singura sursă. Nu se preia nimic dintr-un model de elevație: o grilă publică lângă un perete — adică exact acolo unde sunt intrările — greșește cu o sută de metri, fără nimic pe ecran care să o spună.",
    "keepAltitude": "Păstrează {{altitude}} m",
    "batchFromCatalogue": "Din catalogul peșterilor",
    "batchFromTrips": "Dintr-un tabel de ture",
    "batchFromSpeleoloc": "Dintr-o tură înregistrată pe telefon",
    "creating": "Se creează {{count}} obiecte. Procesul rulează pe server și continuă dacă părăsești această pagină.",
    "creatingHint": "Lotul apare la Loturi de import când s-a terminat și se anulează ca un întreg.",
    "progress": "{{done}} din {{total}} rânduri parcurse",
    "retrying": "Ultima încercare nu s-a încheiat; se reia în scurt timp.",
    "saving": "Toate cele {{total}} rânduri au fost parcurse; se salvează"
  },
  "photoImport": {
    "title": "Obiecte din fotografii",
    "openFromGeodata": "Din fotografii",
    "openFromTrip": "Creează obiecte din fotografiile turei",
    "filedUnderTrip": "Atașat acestei ture",
    "mapPreview": "Previzualizare pe hartă",
    "dropTitle": "Trage aici fotografiile unei ture",
    "dropHint": "Pozele care rețin unde au fost făcute sunt grupate pe locuri. Cele care nu rețin pot fi potrivite după un traseu sau așezate pe hartă manual.",
    "uploading": "Se încarcă… {{count}} rămase",
    "uploadFailed": "Fotografiile nu au putut fi încărcate.",
    "commitFailed": "Nu s-a putut crea nimic din selecție.",
    "createSelected": "Creează {{count}} selectate",
    "unreadable": "{{count}} dintre fișierele alese nu au putut fi citite și nu apar în revizuire.",
    "unplacedTitle": "{{count}} dintre fotografii nu au poziție",
    "unplacedHint": "Alege un traseu față de care să fie potrivite după ora capturii sau selectează un rând și așază-l manual pe hartă.",
    "placingTitle": "Dă clic pe hartă pentru a așeza fotografia. Se scrie în revizuire, niciodată înapoi în fișier.",
    "placeOnMap": "Așază pe hartă",
    "unnamed": "Fără nume",
    "typePlaceholder": "Alege un tip",
    "nothingNearby": "Nimic în apropiere",
    "nearbyCount": "{{count}} în apropiere",
    "nearbyOption": "{{name}} · {{distance}} m",
    "createNew": "Creează unul nou",
    "altitude": "{{value}} m",
    "bearing": "Orientat {{value}}°",
    "bearingMagnetic": "Orientat {{value}}° (magnetic)",
    "optionsPlaces": "Locuri și grupare",
    "optionsCreated": "Ce se creează",
    "optionsClock": "Fotografii fără poziție",
    "defaultKind": "Fiecare loc devine",
    "namePrefix": "Prefix de nume",
    "clusterRadius": "Două fotografii sunt același loc în limita a",
    "clusterRadiusHint": "Douăsprezece fotografii ale aceleiași intrări sunt un singur candidat cu galerie. Un aven fotografiat de pe buză și de pe fundul dolinei are treizeci de metri între poze și rămâne o singură gaură.",
    "proximityRadius": "Caută ceva deja existent în limita a",
    "proximityRadiusHint": "Se măsoară doar față de obiectele a căror poziție exactă o poți vedea. Despre o peșteră protejată pe care nu o poți localiza nu se răspunde.",
    "elevation": "Altitudinea capturii",
    "elevationHint": "Altitudinea GPS a unui telefon este cel mai nesigur dintre cele trei numere pe care le raportează, așa că este lăsată deoparte dacă nu o ceri.",
    "clockIntro": "O fotografie fără poziție proprie poate fi așezată potrivind ora capturii cu un traseu parcurs.",
    "track": "Potrivește cu traseul",
    "trackNone": "Nu potrivi după oră",
    "trackHasNoTimes": "Fișierul acela nu reține ore, deci nu se poate potrivi nimic cu el.",
    "trackFixes": "Traseul conține {{count}} poziții înregistrate.",
    "clockOffset": "Decalajul ceasului aparatului",
    "clockOffsetHint": "Se adaugă la ora fiecărei fotografii înainte de comparare. Ceasurile aparatelor derivează, iar unul lăsat pe alt fus orar greșește cu ore întregi părând perfect plauzibil.",
    "matchTolerance": "Potrivește în limita a",
    "matchToleranceHint": "Cât de departe de o poziție înregistrată mai poate fi așezată o fotografie. Dincolo de asta, traseul nu spune nimic despre unde era fotograful.",
    "seconds": "s",
    "trackMatchGap": "{{seconds}} s față de o înregistrare",
    "trackMatchHint": "Cât de departe stă poziția aceasta de una înregistrată. Câteva secunde înseamnă o așezare; două minute înseamnă o presupunere despre cineva care mergea.",
    "confidenceHint": "Cât valorează fixul satelitar din spatele acestei fotografii, așa cum l-a raportat aparatul.",
    "columns": {
      "pictures": "Fotografii",
      "name": "Nume",
      "becomes": "Devine",
      "type": "Tip",
      "position": "Poziție",
      "nearby": "Deja existent",
      "decision": "Decizie"
    },
    "sources": {
      "none": "Neașezată",
      "noneHint": "Nici aparatul, nici un traseu nu au așezat-o. Trage-o pe hartă ca să îi dai o poziție.",
      "exif": "De la aparat",
      "exifHint": "Poziția pe care aparatul însuși a înregistrat-o când s-a făcut fotografia.",
      "trackMatch": "Dintr-un traseu",
      "trackMatchHint": "Dedusă potrivind ora capturii cu un traseu înregistrat.",
      "manual": "Așezată manual",
      "manualHint": "Cineva a pus-o pe hartă. Se păstrează în evidență și nu se scrie niciodată înapoi în fișier."
    },
    "confidence": {
      "unknown": "Calitate necunoscută",
      "excellent": "Fix excelent",
      "good": "Fix bun",
      "moderate": "Fix moderat",
      "poor": "Fix slab"
    },
    "actions": {
      "create": "Creează",
      "createHint": "Se creează aici un obiect nou, cu aceste fotografii atașate.",
      "attach": "Atașează la",
      "attachHint": "Nu se creează nimic nou; fotografiile se atașează obiectului deja existent.",
      "skip": "Omite",
      "skipHint": "Lăsat în afara acestei confirmări."
    }
  },
  "photoFacts": {
    "title": "Fotografie",
    "takenAt": "Făcută",
    "camera": "Aparat",
    "lens": "Obiectiv",
    "exposure": "Expunere",
    "dimensions": "Dimensiune",
    "orientation": "Orientare",
    "position": "Poziție",
    "altitude": "Altitudine",
    "direction": "Orientat spre",
    "nothingRecorded": "Fotografia nu reține nimic despre felul în care a fost făcută.",
    "usePosition": "Folosește poziția fotografiei",
    "usePositionTitle": "Muți obiectul unde a fost făcută fotografia?",
    "usePositionHint": "O modificare obișnuită, înregistrată în istoricul obiectului și anulabilă acolo. Fotografia în sine nu este modificată.",
    "usePositionOk": "Mută-l",
    "positionApplied": "Obiectul a fost mutat la poziția fotografiei.",
    "positionApplyFailed": "Obiectul nu a putut fi mutat.",
    "orientations": {
      "1": "Dreaptă",
      "2": "Oglindită",
      "3": "Răsturnată",
      "4": "Oglindită, răsturnată",
      "5": "Oglindită, rotită la stânga",
      "6": "Rotită la dreapta",
      "7": "Oglindită, rotită la dreapta",
      "8": "Rotită la stânga"
    }
  },
  "termRules": {
    "title": "Reguli de detectare",
    "intro": "Ce se propune să devină un punct numit Peștera, P., aven, izbuc, ponor sau dolină. Ordinea decide: când două reguli revendică același candidat, câștigă prima.",
    "name": "Nume",
    "scope": "Aparține",
    "ruleCount": "Reguli",
    "newSet": "Set nou",
    "edit": "Editează setul",
    "editCopy": "Editează o copie proprie",
    "copyOf": "Copie a {{name}}",
    "export": "Salvează ca fișier",
    "importFile": "Încarcă dintr-un fișier",
    "imported": "Fișierul a fost încărcat ca un set propriu.",
    "importFailed": "Fișierul nu a putut fi citit ca set de reguli.",
    "promote": "Fă implicit",
    "makeInstallationDefault": "Fă din acesta punctul de plecare al oricărui import",
    "promoted": "Orice import pornește acum de la acest set.",
    "promoteFailed": "Doar un administrator poate schimba ce moștenesc toți.",
    "deleteConfirm": "Ștergi acest set de reguli?",
    "default": "Implicit",
    "shipped": "Livrat",
    "invalid": "Setul nu poate fi salvat așa cum este scris",
    "orderHint": "Ordinea decide. Când două reguli revendică același candidat, câștigă cea de mai sus.",
    "ruleName": "Numele regulii",
    "enabled": "Activă",
    "addRule": "Adaugă o regulă",
    "matchMode": "Compară prin",
    "target": "Propune",
    "proposedType": "Tip",
    "strip": "Scoate termenul din nume",
    "readName": "Citește numele",
    "readDescription": "Citește descrierea",
    "termsPlaceholder": "Scrie un termen și apasă Enter",
    "scopes": {
      "installation": "Întreaga instalare",
      "cavingGroup": "Un club",
      "user": "Tu"
    },
    "matchModes": {
      "contains": "Conține",
      "wholeWord": "Cuvânt întreg",
      "prefix": "Începe cu",
      "regex": "Expresie regulată"
    },
    "stripModes": {
      "none": "Păstrează-l",
      "leading": "Doar de la început",
      "trailing": "Doar de la sfârșit",
      "anywhere": "Oriunde s-ar afla"
    },
    "languages": {
      "ro": "Termeni în română",
      "en": "Termeni în engleză",
      "any": "Termeni fără limbă"
    }
  },
  "filters": {
    "typed": {
      "understood": "Înțeles ca: {{text}}",
      "unreadable": "Textul nu a putut fi citit, așa că nu se aplică nimic. Scrie un număr, de exemplu 300, sau o comparație, de exemplu >300, <=30, !=300 sau 300..500.",
      "unreadableDay": "Textul nu a putut fi citit, așa că nu se aplică nimic. Scrie o zi, de exemplu 2024-05-01 sau 1.5.2024, sau o comparație, de exemplu >2024-05-01, !=2024-05-01 sau 2024-05-01..2024-06-30.",
      "notOffered": "Acest câmp nu poate fi comparat astfel, așa că nu se aplică nimic.",
      "hint": "de ex. >300, 300..500",
      "hintDay": "sau scrie >2024-05-01",
      "number": {
        "equals": "egal cu {{value}}",
        "notEquals": "diferit de {{value}}",
        "greaterThan": "mai mare decât {{value}}",
        "greaterOrEqual": "cel puțin {{value}}",
        "lessThan": "mai mic decât {{value}}",
        "lessOrEqual": "cel mult {{value}}",
        "between": "între {{low}} și {{high}}"
      },
      "day": {
        "equals": "pe {{value}}",
        "notEquals": "nu pe {{value}}",
        "greaterThan": "după {{value}}",
        "greaterOrEqual": "pe {{value}} sau după",
        "lessThan": "înainte de {{value}}",
        "lessOrEqual": "pe {{value}} sau înainte",
        "between": "de la {{low}} până la {{high}}"
      }
    },
    "editor": {
      "wholeRefusal": {
        "malformed": "Filtrul nu a putut fi citit. Reîncarcă pagina sau reconstruiește condiția și aplic-o din nou.",
        "unreadable": "Filtrul salvat nu poate fi citit cu accesul tău, deci nu a fost aplicat."
      },
      "sort": "Ordine",
      "descending": "Descrescător",
      "ascending": "Crescător",
      "spatial": {
        "radius": "Distanța în metri",
        "metres": "m",
        "of": "de",
        "anchorKind": "Măsurat de la",
        "anchorKinds": {
          "selection": "obiectul selectat",
          "object": "un obiect",
          "point": "un punct",
          "savedFilter": "rezultatele unui filtru salvat"
        },
        "selectionNamed": "Se măsoară de la obiectul selectat pe hartă.",
        "noSelection": "Selectează mai întâi un obiect pe hartă.",
        "outlineKind": "Contur",
        "outlineKinds": {
          "view": "vederea hărții",
          "draw": "un contur desenat pe hartă",
          "area": "o zonă numită",
          "polygon": "un poligon lipit"
        },
        "draw": "Desenează pe hartă…",
        "drawAgain": "Desenează din nou…",
        "takeViewAgain": "Ia din nou vederea",
        "outlineSet": "Contur stabilit: {{count}} colțuri.",
        "object": "Obiectul de la care se măsoară",
        "area": "Zonă",
        "areas": "Zone",
        "savedFilter": "Filtrul salvat de la care se măsoară",
        "longitude": "Longitudine",
        "latitude": "Latitudine",
        "polygon": "Poligon ca GeoJSON",
        "polygonHint": "Lipește un Polygon GeoJSON sau un Feature care conține unul",
        "polygonProblems": {
          "notJson": "Acesta nu este GeoJSON.",
          "notPolygon": "Acesta nu este un singur poligon.",
          "offGlobe": "O poziție nu este o longitudine și o latitudine valide.",
          "notClosed": "Fiecare inel trebuie să se încheie unde începe.",
          "tooLarge": "Un contur are cel mult 2000 de poziții."
        },
        "needsAnchor": "„Cel mai apropiat” are nevoie de un loc de la care să măsoare: introdu un punct sau alege un obiect.",
        "refused": {
          "notFound": "Locul de la care măsoară această condiție nu îți este disponibil.",
          "notAnArea": "Obiectul ales nu este o zonă cu contur.",
          "nested": "Un filtru salvat de la care se măsoară nu poate măsura el însuși de la un filtru salvat.",
          "tooLarge": "Filtrul salvat găsește prea multe obiecte pentru a măsura de la ele."
        },
        "notSaved": "Un punct introdus, o vedere a hărții, un contur desenat sau lipit ori locul de la care se ordonează „cel mai apropiat” nu se salvează niciodată. Folosește în schimb un obiect sau o zonă numită."
      },
      "apply": "Aplică",
      "count": "Rezultate: {{count}}",
      "rowRefused": "Serverul nu poate folosi această condiție. Verifică comparația și valorile ei sau elimin-o.",
      "refused": "Serverul a refuzat acest filtru. Verifică condițiile sau elimină-le pe cele de care nu ai nevoie.",
      "problems": {
        "newer_version": "Acest filtru a fost salvat de o versiune mai nouă a aplicației și nu poate fi citit aici.",
        "unreadable": "Acestui filtru îi lipsește o parte și nu poate fi citit.",
        "no_scope": "Filtrul nu spune la ce se referă.",
        "too_many_worlds": "Un filtru cuprinde cel mult {{limit}} tipuri de obiecte.",
        "world_repeated": "Un tip de obiect este numit de două ori.",
        "unknown_world": "Unul dintre tipurile de obiecte nu poate fi filtrat aici.",
        "sort_unsupported": "Niciunul dintre tipurile de obiecte alese nu poate fi sortat astfel.",
        "too_many_nodes": "Un filtru conține cel mult {{limit}} condiții și grupuri.",
        "too_deep": "Grupurile pot fi imbricate pe cel mult {{limit}} niveluri.",
        "empty_group": "Un grup are nevoie de cel puțin o condiție.",
        "unknown_field": "Acest câmp nu poate fi folosit aici.",
        "op_unsupported": "Acest câmp nu admite această comparație.",
        "takes_no_value": "Această comparație nu primește nicio valoare.",
        "value_count": "Număr greșit de valori pentru această comparație: primește {{limit}}.",
        "value_missing": "Această condiție are nevoie de cel puțin o valoare.",
        "too_many_values": "O condiție primește cel mult {{limit}} valori.",
        "value_kind": "O valoare nu este de tipul potrivit pentru acest câmp.",
        "text_too_long": "O valoare are mai mult de {{limit}} caractere.",
        "number_out_of_range": "Un număr de aici este prea mare pentru a fi comparat.",
        "range_reversed": "Intervalul se termină înainte să înceapă.",
        "anchor_not_stored": "Un filtru salvat nu păstrează niciodată un loc de la care se măsoară.",
        "radius_out_of_range": "O distanță de aici este în afara intervalului: poate fi de cel mult {{limit}} de metri.",
        "point_off_globe": "Un punct de aici nu se află pe glob.",
        "outline_invalid": "Un contur de aici nu este un poligon simplu de cel mult {{limit}} de poziții.",
        "anchor_kind": "Distanța nu poate fi măsurată de la acest fel de loc sau obiect.",
        "anchor_missing": "„Cel mai apropiat” are nevoie de un loc de la care să măsoare."
      },
      "allOf": "Toate acestea (ȘI)",
      "anyOf": "Oricare dintre acestea (SAU)",
      "combinator": "Cum se combină condițiile",
      "not": "Nu",
      "addCondition": "Adaugă condiție",
      "addGroup": "Adaugă grup",
      "removeCondition": "Elimină condiția",
      "removeGroup": "Elimină grupul",
      "tooDeep": "Grupurile pot fi imbricate pe cel mult {{max}} niveluri.",
      "field": "Câmp",
      "chooseField": "Alege un câmp",
      "operator": "Comparație",
      "value": "Valoare",
      "yes": "Da",
      "no": "Nu",
      "unavailableField": "un câmp care nu îți este accesibil",
      "needsType": "Se poate cere doar împreună cu tipul său de obiect, în același grup ȘI.",
      "propertyField": "Proprietate: {{label}}",
      "ops": {
        "equals": "este",
        "in": "este unul dintre",
        "contains": "conține",
        "startsWith": "începe cu",
        "lessThan": "mai mic decât",
        "lessOrEqual": "cel mult",
        "greaterThan": "mai mare decât",
        "greaterOrEqual": "cel puțin",
        "between": "între",
        "isEmpty": "este gol",
        "isNotEmpty": "nu este gol",
        "within": "în raza",
        "inside": "în interiorul"
      },
      "values": {
        "featureKinds": {
          "generic": "Generic",
          "cave": "Peșteră",
          "caveEntrance": "Intrare de peșteră",
          "centerline": "Drumuire"
        },
        "featureCategories": {
          "surface": "Suprafață",
          "underground": "Subteran",
          "area": "Zonă",
          "structure": "Structură"
        },
        "visibilities": {
          "private": "Privat",
          "cavingGroup": "Club",
          "authenticated": "Conturi autentificate",
          "public": "Public"
        },
        "activityStates": {
          "draft": "Ciornă",
          "proposed": "Propusă",
          "planned": "Planificată",
          "confirmed": "Confirmată",
          "done": "Încheiată",
          "published": "Publicată",
          "cancelled": "Anulată",
          "delayed": "Amânată"
        },
        "mapKinds": {
          "geological": "Geologică",
          "topographic": "Topografică",
          "tourist": "Turistică",
          "caveMap": "Hartă de peșteră",
          "other": "Altele"
        },
        "surveyModelFormats": {
          "lox": "Therion (.lox)",
          "survex3d": "Survex (.3d)",
          "stl": "Plasă de pereți (.stl)"
        },
        "geofileFormats": {
          "gpx": "GPX",
          "kml": "KML",
          "geoJson": "GeoJSON",
          "shapefile": "Shapefile",
          "wkt": "WKT",
          "wkb": "WKB",
          "kmz": "KMZ",
          "csv": "CSV"
        }
      }
    },
    "worlds": {
      "feature": "Obiecte",
      "tripLog": "Jurnale de tură",
      "mapView": "Vizualizări de hartă",
      "document": "Documente",
      "georeferencedMap": "Hărți georeferențiate",
      "cabinet": "Dulapuri",
      "surveyModel": "Modele topografice",
      "photograph": "Fotografii",
      "geofile": "Fișiere de geodate",
      "savedFilter": "Filtre salvate"
    },
    "fields": {
      "position": "Poziție",
      "name": "Nume",
      "title": "Titlu",
      "kind": "Fel",
      "category": "Categorie",
      "type": "Tip",
      "tag": "Etichetă",
      "owner": "Proprietar",
      "cavingGroup": "Club",
      "organizingGroup": "Club organizator",
      "visibility": "Vizibilitate",
      "protected": "Locație protejată",
      "created": "Creat",
      "updated": "Ultima modificare",
      "tripType": "Tip de tură",
      "tripDate": "Data turei",
      "hadIncident": "A avut incident",
      "state": "Stare",
      "language": "Limbă",
      "region": "Regiune",
      "rockType": "Tip de rocă",
      "surveyedLength": "Lungime cartată (m)",
      "depth": "Denivelare (m)",
      "caveType": "Tip de peșteră",
      "otherToponyms": "Alte denumiri",
      "names": "Nume, alte denumiri sau cod",
      "property": "Proprietate",
      "mapKind": "Tip de hartă",
      "surveyFormat": "Format topografie",
      "surveyedAt": "Topografiat la",
      "isCurrent": "Model curent",
      "cave": "Peșteră",
      "takenAt": "Fotografiat la",
      "caption": "Descriere",
      "placeName": "Nume de loc",
      "datedAt": "Datată (fotografiată, altfel încărcată)",
      "fileFormat": "Format fișier"
    },
    "problems": {
      "noWorlds": "Alege cel puțin un fel de obiect de căutat.",
      "tooManyWorlds": "Un filtru acoperă cel mult {{max}} feluri de obiecte.",
      "worldTwice": "Fiecare fel de obiect apare o singură dată.",
      "tooLarge": "Filtrul are mai mult de {{max}} părți. Încearcă să îl împarți.",
      "tooDeep": "Condițiile sunt imbricate pe mai mult de {{max}} niveluri.",
      "tooManyValues": "O condiție are cel mult {{max}} valori.",
      "textTooLong": "Textul dintr-o condiție are cel mult {{max}} caractere.",
      "sortUnavailable": "Nimic din ce se caută nu poate fi ordonat astfel."
    },
    "selector": {
      "placeholder": "Caută",
      "typeToSearch": "Scrie cel puțin {{count}} caractere",
      "noMatches": "Nu se potrivește nimic",
      "nothingChosen": "Nimic ales",
      "chosen": "{{count}} alese",
      "restricted": "{{count}} neafișate — dispărute sau nu îți sunt vizibile",
      "placeable": "Ți se poate arăta unde este",
      "mapPlaceholder": "Mergi la…",
      "noDestination": "Încă nu se poate deschide nimic pentru asta.",
      "savedFilterNotForMap": "Filtrul salvat nu se referă la obiecte sau nu poate fi rulat cu accesul tău, așa că nu a fost aplicat hărții.",
      "clear": "Renunță la alegere",
      "matchedOtherToponyms": "alte denumiri: {{text}}",
      "matchedCode": "cod {{text}}"
    },
    "sorts": {
      "created": "Adăugat",
      "updated": "Modificat",
      "title": "Nume",
      "owner": "Proprietar",
      "occurred": "Data",
      "proximity": "Cel mai apropiat"
    },
    "scopes": {
      "caves": "Peșteri",
      "entrances": "Intrări",
      "features": "Toate obiectele",
      "documents": "Documente",
      "trips": "Ture",
      "views": "Vizualizări",
      "photographs": "Fotografii",
      "savedFilters": "Filtre salvate"
    }
  },
  "notificationHealth": {
    "title": "Trimiterea mesajelor",
    "intro": "Dacă mesajele ies din această instalare. Fiecare rând de aici este unul pe care cineva trebuia să îl primească: un canal pe care o persoană l-a oprit nu produce niciun rând, deci o coadă rămasă în urmă este întotdeauna o problemă.",
    "stalled": "Nu s-a mai trimis nimic de {{age}}.",
    "stalledHint": "Cel mai vechi mesaj care încă așteaptă a fost pus la coadă atunci. Verifică setările serverului de e-mail și trimiterea de probă din pagina de mesagerie.",
    "oldestPending": "Cel mai vechi în așteptare",
    "nothingWaiting": "Nimic în așteptare",
    "paidToday": "Segmente de mesaj taxate astăzi",
    "paidTodayValue": "{{spent}} din {{cap}}",
    "byChannel": "Pe canale",
    "noDeliveries": "Nu s-a trimis încă nimic.",
    "anyStatus": "Orice stare",
    "attentionOnly": "Doar ce are nevoie de atenție",
    "refresh": "Reîmprospătează",
    "createdAt": "Pus la coadă",
    "recipient": "Pentru",
    "unknownRecipient": "Contul nu mai există",
    "category": "Despre",
    "templateKey": "Mesaj",
    "channel": "Canal",
    "status": "Stare",
    "attempts": "Încercări",
    "error": "Ce nu a mers",
    "retry": "Trimite din nou",
    "retryTitle": "Trimiți din nou acest mesaj?",
    "retryConfirm": "Aceasta trimite „{{template}}” persoanei căreia îi era destinat. Răspunsul ei de acum este citit din nou întâi, deci dacă între timp a cerut să nu mai fie anunțată despre asta, nu se trimite nimic.",
    "retryOk": "Trimite din nou",
    "retryFailed": "Nu a putut fi pus înapoi.",
    "ageMinutes": "{{count}} minute",
    "ageHours": "{{count}} ore",
    "ageDays": "{{count}} zile",
    "statuses": {
      "pending": "În așteptare",
      "deferred": "Reținut pentru rezumatul zilnic",
      "sent": "Trimis",
      "dead": "Renunțat"
    },
    "outcomes": {
      "notFound": "Nu mai există un astfel de mesaj.",
      "notDead": "Acela nu a renunțat, deci nu este nimic de pus înapoi.",
      "templateUnknown": "Nimic nu știe să scrie acest mesaj, deci ar eșua la fel. Textul trebuie refăcut întâi.",
      "unreachable": "Nu există unde să fie trimis: contul a dispărut sau nu mai are o adresă.",
      "suppressed": "Persoana căreia îi era destinat a cerut între timp să nu mai fie anunțată despre asta, deci nu s-a trimis. Îl poate citi în continuare în lista ei.",
      "queued": "Înapoi la coadă."
    }
  },
  "calendar": {
    "title": "Calendar",
    "when": "Când",
    "what": "Ce",
    "kind": "Tip",
    "state": "Stare",
    "postponed": "Dată nestabilită",
    "togglePast": "Trecute",
    "toggleTrips": "Ture",
    "toggleCamps": "Tabere",
    "toggleEvents": "Evenimente",
    "kindFilter": "Orice tip de eveniment",
    "kindFilterOff": "Evenimentele sunt dezactivate, așa că un tip nu are ce să restrângă. Activează Evenimente ca să alegi.",
    "kindFilterNote": "Tipurile restrâng doar evenimentele. Turele și taberele nu au tip, așa că rămân afișate — dezactivează-le alături ca să vezi doar evenimentele.",
    "toggleCancelled": "Anulate",
    "toggleMine": "Doar ale mele",
    "groupFilter": "Orice grup",
    "omitted": "În aceste zile mai sunt {{count}} rânduri decât poate purta această pagină. Cere mai puține zile.",
    "empty": "Nu este nimic înregistrat în aceste zile.",
    "emptyFiltered": "Nimic din aceste zile nu corespunde cererii.",
    "emptyNoKind": "Nu este selectat niciun tip de înregistrare.",
    "failed": "Calendarul nu a putut fi citit.",
    "views": {
      "record": "Listă",
      "month": "Lună",
      "week": "Săptămână",
      "year": "An",
      "agenda": "Agendă"
    },
    "weekPrevious": "Săptămâna precedentă",
    "weekNext": "Săptămâna următoare",
    "weekToday": "Săptămâna aceasta",
    "weekDayEmpty": "Nimic",
    "monthCount": "{{count}} înregistrări",
    "spanDay": "ziua {{day}} din {{count}}",
    "grouping": {
      "groupBy": "Grupează după",
      "unassigned": "Neînregistrat",
      "unlistedGroup": "Un grup pe care nu-l poți lista",
      "dimensions": {
        "none": "Nimic",
        "month": "Lună",
        "week": "Săptămână",
        "kind": "Tip",
        "state": "Stare",
        "cavingGroup": "Grup de speologie"
      }
    },
    "today": "Azi",
    "todayLine": "Azi · {{date}}",
    "todayNoPlace": "Aranjată așa, lista nu are un singur loc care să fie „azi”. Ordoneaz-o după Când și grupeaz-o după nimic, lună sau săptămână.",
    "mapToggle": "Hartă",
    "mapEmpty": "Nicio tură și nicio tabără din câmpul vizual nu are o poziție înregistrată. Deplasează sau apropie harta ca să cauți în altă parte.",
    "mapFailed": "Harta acestor zile nu a putut fi citită, așa că nu este desenat nimic pe ea — ceea ce nu înseamnă că nu este nimic acolo. Încearcă din nou peste un moment.",
    "mapDrawn": "{{count}} dintre turele și taberele din aceste zile sunt desenate aici.",
    "mapTruncated": "În acest câmp vizual intră mai multe ture decât poate purta un răspuns, așa că nu toate turele sunt desenate. Apropie harta ca să le vezi pe celelalte.",
    "mapCaveat": "Sunt desenate doar turele și taberele, și doar cele din acest câmp vizual: datele clubului nu au nicio formă, o tabără este zona ei de lucru și nimic mai mult, iar o înregistrare din afara câmpului vizual apare după ce te deplasezi la ea. Un inel gol este locul de întâlnire, unul plin este locul unde s-a lucrat.",
    "sourceValues": {
      "tripLog": "Tură",
      "expedition": "Tabără",
      "event": "Eveniment"
    }
  },
  "events": {
    "title": "Evenimente",
    "titleField": "Titlu",
    "create": "Eveniment nou",
    "edit": "Modifică evenimentul",
    "delete": "Șterge",
    "deleteConfirm": "Ștergi acest eveniment?",
    "searchPlaceholder": "Caută după titlu",
    "kind": "Tip",
    "kindFilter": "Orice tip",
    "kindValues": {
      "clubMeeting": "Ședință de club",
      "training": "Instruire",
      "maintenanceDay": "Zi de lucru",
      "gearCheck": "Verificarea echipamentului",
      "conference": "Conferință",
      "deadline": "Termen limită"
    },
    "dates": "Date",
    "time": "Ora",
    "startTime": "Începe la",
    "endTime": "Se termină la",
    "place": "Loc",
    "description": "Descriere",
    "cavingGroup": "Club de speologie",
    "state": "Stare",
    "stateFilter": "Orice stare",
    "announce": "Anunță",
    "announceSuccess": "Evenimentul a fost anunțat.",
    "unannounce": "Înapoi la ciornă",
    "unannounceSuccess": "Evenimentul s-a întors la ciornă.",
    "propose": "Lansează ideea",
    "proposeSuccess": "Evenimentul a fost propus.",
    "organise": "Începe organizarea",
    "organiseSuccess": "Evenimentul se organizează.",
    "confirm": "Are loc",
    "confirmSuccess": "Evenimentul are loc.",
    "postpone": "Amână",
    "postponeSuccess": "Evenimentul a fost amânat.",
    "reschedule": "Stabilește o dată nouă",
    "rescheduleSuccess": "Evenimentul se organizează din nou.",
    "markDone": "A avut loc",
    "markDoneSuccess": "Evenimentul a fost înregistrat ca desfășurat.",
    "notFound": "Niciun astfel de eveniment",
    "notFoundDetail": "Fie nu există, fie nu îl poți citi. Această pagină nu poate deosebi cele două cazuri și nici nu încearcă.",
    "callOff": "Anulează",
    "callOffConfirm": "Anulezi acest eveniment?",
    "callOffSuccess": "Evenimentul a fost anulat.",
    "maxParticipants": "Locuri",
    "maxParticipantsHelp": "Câți oameni încap la eveniment. Lasă gol pentru fără limită; cine depășește limita așteaptă în ordinea în care a răspuns.",
    "tabResponses": "Cine vine",
    "kindHasResponses": "Unii au spus deja dacă vin, iar un eveniment de acel fel nu primește răspunsuri. Schimbă tipul înapoi sau șterge întâi răspunsurile.",
    "tabHistory": "Istoric",
    "repeats": "Se repetă",
    "repeatsHelp": "Scrie acum toată seria, ca evenimente obișnuite. Fiecare este apoi modificat, confirmat și anulat separat.",
    "repeatFrequency": "Cât de des",
    "repeatFrequencyValues": {
      "daily": "În fiecare zi",
      "weekly": "În fiecare săptămână",
      "fortnightly": "La două săptămâni",
      "monthly": "În fiecare lună"
    },
    "repeatRule": "În cuvintele tale",
    "repeatRuleHelp": "Cum ai descrie repetarea cuiva care citește calendarul — “în fiecare marți, în timpul semestrului”. Se afișează exact așa cum a fost scris și nicio dată nu este dedusă din el.",
    "repeatCount": "Câte",
    "repeatCountHelp": "Prima inclusă. Cel mult {{max}} și niciodată mai mult de doi ani după prima zi.",
    "repeatUntil": "Sau până la, inclusiv",
    "repeatUntilHelp": "Ultima zi în care poate cădea una. Dai asta, sau un număr, sau amândouă.",
    "repeatBoundRequired": "Spune câte sunt sau ultima zi în care cade una. O repetare căreia nu i se spune niciuna nu se scrie deloc.",
    "scope": "Modificarea se aplică la",
    "scopeOccurrence": "Doar această apariție",
    "scopeFollowing": "Aceasta și toate cele următoare",
    "seriesBanner": "O apariție a ceva ce se repetă.",
    "seriesRule": "Descrisă ca: {{rule}}",
    "seriesFrequency": "Revine {{frequency}}.",
    "seriesFrequencyValues": {
      "daily": "în fiecare zi",
      "weekly": "în fiecare săptămână",
      "fortnightly": "la două săptămâni",
      "monthly": "în fiecare lună"
    },
    "seriesFrequencyChangeHelp": "Schimbarea redistribuie această apariție și toate cele următoare pornind de la ziua acesteia. Aparițiile anterioare își păstrează zilele.",
    "seriesOccurrences": "Vezi celelalte apariții",
    "seriesFilter": "Se afișează aparițiile unui singur eveniment care se repetă",
    "seriesEdited": "{{count}} apariții au fost modificate.",
    "seriesDeleteTitle": "Anulezi restul seriei?",
    "seriesDeleteDetail": "Aparițiile care au început deja sunt păstrate oricum ai alege aici: fiecare este consemnarea unei seri care a avut loc și a celor care au spus că vin.",
    "seriesDeleted": "{{deleted}} apariții au dispărut; {{kept}} avuseseră deja loc și au fost păstrate.",
    "recurrenceUnbounded": "Spune câte apariții sunt sau ultima zi în care cade una. Nu s-a scris nimic.",
    "recurrenceNotRepeating": "Ce s-a cerut are loc o singură dată, deci nu e nicio serie de scris. Lasă repetarea oprită pentru un eveniment singular.",
    "recurrenceTooMany": "Sunt mai multe apariții decât scrie o singură cerere. Cere o serie mai scurtă — nu s-a scris nimic, în loc de o parte.",
    "recurrenceHorizonTooFar": "Seria ar ajunge mai departe decât se scrie o serie. Oprește-o mai devreme sau fă-o să se repete mai rar — nu s-a scris nimic, în loc de o parte.",
    "recurrenceCreateOnly": "Repetarea se stabilește când evenimentul este scris. Modificarea acestei apariții modifică această apariție.",
    "seriesPartlyForbidden": "Seria conține o apariție care nu e a ta de modificat, deci nimic nu a fost modificat. O schimbare aplicată pe jumătate ar lăsa calendarul în contradicție cu sine.",
    "notInSeries": "Acest eveniment nu se repetă, deci nu există nicio serie asupra căreia să se acționeze.",
    "seriesMoveOutOfRange": "Mutarea acestei apariții atât de departe ar duce o apariție ulterioară dincolo de sfârșitul calendarului, deci niciuna nu a fost mutată. Alege o zi mai apropiată.",
    "responses": {
      "title": "Cine vine",
      "invite": "Invită",
      "invitePlaceholder": "Cineva cunoscut clubului",
      "signUp": "Înscrie-mă",
      "signUpHint": "Nimeni nu te-a invitat încă, dar oricine poate citi asta se poate trece drept participant, în ordinea în care o spune.",
      "invited": "Adăugat pe listă.",
      "pickFromDirectory": "Alege pe cineva dintre sugestii. O persoană este invitată prin fișa ei din evidențele clubului, nu printr-un nume scris aici — un nume pe care nimeni nu îl poate identifica ar fi un nume pe care nimeni nu îl poate anunța.",
      "empty": "Nimeni nu a fost invitat la acest eveniment încă.",
      "emptyWithheld": "Toți cei de pe lista acestui eveniment sunt persoane despre care nu ai dreptul să fii informat.",
      "unavailable": "Lista acestui eveniment nu a putut fi citită.",
      "limit": "{{attending}} din {{max}} locuri ocupate, {{waiting}} în așteptare.",
      "noLimit": "{{attending}} vin. Acest eveniment nu are limită de participanți.",
      "place": "#{{place}}",
      "attending": "Vine",
      "waiting": "În așteptare",
      "selected": "Ales",
      "select": "Alege această persoană pentru eveniment",
      "deselect": "Pune persoana înapoi în ordine",
      "notePlaceholder": "O vorbă despre asta",
      "removeConfirm": "Ștergi complet această persoană de pe listă, cu răspuns cu tot?",
      "concurrentAnswer": "Altcineva a scris despre această persoană în același moment. Lista a fost citită din nou — repetă modificarea dacă mai este dorită.",
      "caverUnknown": "Evidențele clubului nu conțin pe nimeni cu acest nume.",
      "selectNotAttending": "Doar cineva care a spus că vine poate fi ales pentru eveniment.",
      "noteInvalid": "Această notă este prea lungă pentru a fi păstrată.",
      "kindTakesNoResponses": "Acest fel de eveniment este o dată în calendar, nu o întâlnire: nu are cine să vină la el și nu are ce să răspundă cineva.",
      "withheld": "{{count}} pe listă, care nu îți sunt arătați",
      "withheldDetail": "Pe lista acestui eveniment se află cineva despre care nu ai dreptul să fii informat. Este numărat aici pentru ca cifrele de lângă listă să fie corecte, și nu este numit nicăieri.",
      "responseValues": {
        "pending": "Fără răspuns",
        "yes": "Vine",
        "no": "Nu vine",
        "maybe": "Poate"
      }
    }
  },
  "checklists": {
    "title": "Liste de verificare",
    "subtitle": "Listele pe care o echipă le parcurge înainte de plecare.",
    "new": "Listă nouă",
    "edit": "Modifică lista",
    "empty": "Nicio listă de verificare încă.",
    "saved": "Listă salvată.",
    "saveFailed": "Lista nu a putut fi salvată.",
    "deleteConfirm": "Ștergi această listă? Turele pierd confirmările făcute pe liniile ei.",
    "lineCount": "{{count}} linii",
    "fieldTitle": "Titlu",
    "fieldDescription": "Descriere",
    "fieldVisibility": "Cine o poate citi",
    "visibilityHint": "O listă pe care o poate citi oricine este modul în care se publică una pentru toată instalarea.",
    "fieldCavingGroup": "Club de speologie",
    "fieldItems": "Linii",
    "itemPlaceholder": "Ceva de rezolvat înainte de plecare",
    "addLine": "Adaugă o linie",
    "removeLine": "Elimină această linie",
    "visibilityValues": {
      "private": "Doar eu",
      "cavingGroup": "Clubul meu",
      "authenticated": "Oricine este autentificat",
      "public": "Toată lumea"
    },
    "delete": "Șterge această listă"
  },
  "workAreas": {
    "title": "Zone de lucru",
    "allAreas": "Toate zonele",
    "thisLevel": "La acest nivel",
    "noSubAreas": "Nimic în interiorul acesteia deocamdată.",
    "none": "Nicio zonă de lucru nu a fost marcată încă. Desenează o zonă pe hartă și înregistreaz-o ca zonă de lucru.",
    "untitled": "Zonă fără nume",
    "openOnMap": "Pe hartă",
    "seeAll": "Vezi toate",
    "loadFailed": "Zonele de lucru nu au putut fi încărcate.",
    "truncated": "Nu sunt afișate toate zonele de lucru: instalația conține mai multe decât listează această vizualizare.",
    "subAreaCount": "Zone în interior: {{count}}"
  },
  "accessKeys": {
    "title": "Chei de acces",
    "intro": "O cheie de acces permite unui dispozitiv din teren — TopoDroid pe telefon — să încarce topografii în contul tău fără parola ta. Cheia poate doar încărca topografii: nu poate citi restul contului, nu poate lista sau crea chei și nu poate schimba nimic altceva. Fă câte o cheie pentru fiecare dispozitiv, ca un telefon pierdut să însemne o singură revocare.",
    "signInRequired": "Cheile de acces se gestionează doar când ești autentificat cu parola, nu de pe un dispozitiv care deține o cheie.",
    "loadFailed": "Cheile de acces nu au putut fi încărcate.",
    "createFailed": "Cheia de acces nu a putut fi creată.",
    "createdTitle": "Cheia pentru „{{name}}” — copiaz-o acum, se afișează o singură dată.",
    "createdWarning": "Lipește-o imediat în setările dispozitivului. După ce închizi acest mesaj nu o mai poate citi nimeni, nici tu; dacă se pierde, revoc-o și fă alta. Oricine o deține poate încărca topografii în numele tău.",
    "form": {
      "name": "Nume",
      "namePlaceholder": "TopoDroid pe telefonul meu",
      "lifetime": "Valabilă",
      "days": "{{count}} de zile"
    },
    "create": "Creează cheia",
    "revoke": "Revocă",
    "revokeConfirm": "Revoci „{{name}}”? Dispozitivul care o deține va fi refuzat la următoarea încărcare.",
    "revokedMessage": "Cheie revocată.",
    "empty": "Nu ai nicio cheie de acces încă.",
    "neverUsed": "Niciodată",
    "columns": {
      "name": "Nume",
      "prefix": "Cheia începe cu",
      "purpose": "Pentru",
      "created": "Creată",
      "lastUsed": "Ultima folosire",
      "expires": "Expiră",
      "state": "Stare"
    },
    "purposes": {
      "surveyUpload": "Încărcări de topografii"
    },
    "states": {
      "active": "Activă",
      "expired": "Expirată",
      "revoked": "Revocată"
    }
  },
  "surveyUploads": {
    "stages": {
      "archive": "Arhivare",
      "unpack": "Citirea arhivei",
      "scaffold": "Pregătirea compilării",
      "compile": "Compilare",
      "store": "Salvarea rezultatelor",
      "read": "Citirea rezultatelor"
    },
    "stageStates": {
      "skipped": "Nu era nevoie"
    },
    "status": {
      "receiving": "Se primesc fișiere",
      "queued": "Așteaptă să ruleze",
      "running": "Rulează",
      "succeeded": "Terminat",
      "failed": "Eșuat",
      "abandoned": "Abandonat"
    },
    "origins": {
      "topodroid": "TopoDroid",
      "therion": "Therion",
      "other": "Altă sursă"
    },
    "fileRoles": {
      "archive": "Arhiva topografiei",
      "therionSource": "Sursă Therion",
      "therionSketch": "Schiță",
      "other": "Alt fișier",
      "generatedConfig": "Configurație generată",
      "output": "Rezultat",
      "log": "Jurnal"
    },
    "fileStates": {
      "declared": "Nu a ajuns",
      "received": "Primit",
      "stored": "Salvat",
      "refused": "Refuzat"
    },
    "artefacts": {
      "title": "Rezultate",
      "empty": "Nu s-a produs nimic.",
      "download": "Descarcă",
      "view": "Vezi",
      "log": "Jurnalul compilatorului"
    },
    "problems": {
      "filesMissing": "Un fișier al acestei încărcări nu mai este în depozitul serverului. Cere administratorului să-l restaureze, apoi rulează încărcarea din nou.",
      "archiveInvalid": "Arhiva nu este o arhivă de topografie TopoDroid sau este prea veche ori deteriorată ca să fie citită. Exportă din nou topografia din TopoDroid și încarc-o de la capăt.",
      "archiveTooLarge": "Arhiva conține mai mult decât citește acest server. Exportă o topografie mai mică.",
      "unexpected": "Serverul a eșuat la procesarea acestei încărcări. Administratorul găsește detaliile în jurnalul serverului.",
      "sourceMissing": "S-a cerut compilarea, dar nu a fost trimisă nicio sursă Therion.",
      "sourceInvalid": "O sursă Therion nu a putut fi citită.",
      "compilerUnavailable": "Compilatorul nu a putut fi contactat. Fișierele sunt arhivate; rulează încărcarea din nou mai târziu.",
      "compileFailed": "Therion nu a putut compila topografia. Jurnalul de mai jos arată unde.",
      "compileFailedNoLog": "Therion nu a putut compila topografia.",
      "compileTimeout": "Compilarea a durat mai mult decât permite acest server.",
      "outputMissing": "Compilarea nu a produs un rezultat care fusese cerut.",
      "crsUnknown": "Salvat, dar necitit în stații: topografia este fixată într-un sistem de coordonate pe care acest server nu îl cunoaște.",
      "storeFailed": "Rezultatele nu au putut fi salvate.",
      "notFound": "Această încărcare nu există sau nu ai voie să o vezi.",
      "notCompleted": "Această încărcare nu a primit toate fișierele, așa că nu poate fi rulată din nou.",
      "runInProgress": "O rulare a acestei încărcări așteaptă deja sau este în curs.",
      "outputUnknown": "Unul dintre rezultatele cerute nu este produs de acest server.",
      "publicLinksDisabled": "Această instalare nu face linkuri publice.",
      "publicLinkForbidden": "Pentru un link public trebuie să ai dreptul de a partaja peștera.",
      "publicLinkProtected": "Poziția peșterii este protejată. Un link la rezultatele ei se face doar dacă e cerut explicit, știind că arată pe unde trec galeriile.",
      "forbidden": "Poți vedea această peșteră, dar nu o poți modifica.",
      "requestFailed": "Nu a mers. Încearcă din nou."
    },
    "page": {
      "versionsTitle": "Versiunile acestei topografii",
      "olderVersionsTitle": "Versiunile mai vechi ale acestei topografii ocupă {{size}} cu rezultate (versiuni: {{count}}).",
      "olderVersionsTitleNamed": "Versiunile mai vechi ale topografiei „{{survey}}” ocupă {{size}} cu rezultate (versiuni: {{count}}).",
      "olderVersionsHint": "Fiecare versiune își păstrează rezultatele, dacă instalarea nu păstrează mai puține. Setarea {{setting}} {{keep}} Un administrator o poate pune pe 1 ca să păstreze doar rezultatele celei mai noi versiuni.",
      "olderVersionsKeepAll": "este acum 0, deci fiecare versiune își păstrează rezultatele.",
      "olderVersionsKeepNewest": "este acum {{count}}: atâtea dintre cele mai noi versiuni își păstrează rezultatele.",
      "thisVersion": "(aceasta)",
      "newerExists": "Există o versiune mai nouă a acestei topografii. Deschide-o din lista de mai jos.",
      "notFound": "Încărcarea nu a fost găsită sau nu ai voie să o vezi.",
      "loadFailed": "Încărcarea nu a putut fi încărcată.",
      "version": "Versiunea din {{when}}",
      "rerun": "Rulează din nou",
      "rerunStarted": "Încărcarea va rula din nou.",
      "progressTitle": "Progres",
      "logTitle": "Jurnal",
      "noLog": "Jurnalul este gol.",
      "filesTitle": "Fișiere trimise",
      "noFiles": "Niciun fișier.",
      "fileRole": "Tip",
      "fileStatus": "Stare",
      "detailsTitle": "Despre această încărcare",
      "cave": "Peșteră",
      "caveCreated": "Creată din această încărcare",
      "surveyName": "Numele topografiei",
      "surveyDate": "Data topografiei",
      "surveyTeam": "Echipa",
      "uploaded": "Încărcată",
      "started": "Pornită",
      "finished": "Terminată",
      "notFinished": "Încă nu",
      "outputsAsked": "Rezultate cerute",
      "noCompile": "Niciunul — fișierele au fost arhivate și citite, nu compilate"
    },
    "link": {
      "title": "Link public",
      "none": "Această încărcare nu are link public. Motivul poate fi setarea contului, a instalării sau poziția protejată a peșterii.",
      "make": "Fă un link",
      "madeAt": "Făcut {{when}}",
      "remint": "Fă un link nou",
      "remintConfirm": "Faci un link nou? Adresa veche nu va mai funcționa.",
      "revoke": "Retrage",
      "revokeConfirm": "Retragi linkul? Cine îl are nu va mai putea deschide rezultatele.",
      "made": "Link făcut.",
      "dialogTitle": "Fă un link public",
      "audienceLabel": "Pentru cine se deschide linkul",
      "audience": {
        "public": "Oricine are linkul",
        "organization": "Doar conturile autentificate"
      },
      "audienceHint": {
        "public": "Se deschide fără autentificare, pentru oricine primește adresa.",
        "organization": "Cine îl deschide este rugat să se autentifice cu un cont al acestei instalări. Nu e nevoie de niciun drept asupra peșterii în afară de a avea adresa."
      },
      "protectedWarning": "Poziția acestei peșteri este protejată. Rezultatele — modelul 3D și planșele — arată pe unde trec galeriile ei, iar oricine poate deschide linkul le vede.",
      "protectedAcknowledge": "Înțeleg și vreau un link la rezultatele acestei peșteri protejate.",
      "protectedTag": "Peșteră protejată — link făcut cu știință",
      "open": "Deschide",
      "refusal": {
        "protected-cave": "Nu s-a făcut link public, deoarece poziția peșterii este protejată. Se poate face unul doar cerându-l explicit, știind că rezultatele arată pe unde trec galeriile peșterii.",
        "account-off": "Nu s-a făcut link public, deoarece „Linkuri publice pentru încărcările mele” este oprit pentru contul care a trimis-o.",
        "not-wanted": "Nu s-a făcut link public, deoarece cine a trimis această încărcare a cerut să nu se facă.",
        "installation-off": "Nu s-a făcut link public, deoarece această instalare are linkurile publice oprite.",
        "no-share-right": "Nu s-a făcut link public, deoarece contul care a trimis încărcarea nu poate partaja peștera.",
        "revoked": "Linkul public al acestei încărcări a fost retras. Cine poate modifica peștera poate face unul nou."
      },
      "revoked": "Link retras."
    },
    "surveys": {
      "title": "Topografii",
      "explanation": "Topografiile trimise acestei peșteri de pe un dispozitiv, cu fiecare versiune, cea mai nouă prima. Fiecare versiune arată ce a fost trimis și ce s-a făcut din el; modelele și sursele de mai jos sunt setul întreg al peșterii.",
      "survey": "Topografie",
      "source": "De la",
      "versions": "Versiuni",
      "newest": "Cea mai nouă versiune",
      "sent": "Fișiere trimise",
      "openStatus": "Pagina de stare"
    },
    "outputs": {
      "lox": "Model 3D Therion (.lox)",
      "3d": "Model 3D Survex (.3d)",
      "plan-pdf": "Plan (PDF)",
      "extended-pdf": "Profil dezvoltat (PDF)",
      "plan-svg": "Plan (SVG)",
      "extended-svg": "Profil dezvoltat (SVG)",
      "kml": "Google Earth (KML)",
      "dxf": "Desen CAD (DXF)",
      "sql": "Date de topografie (SQL)",
      "csv": "Date de topografie (CSV)",
      "survey-list-html": "Lista topografiilor (HTML)",
      "continuation-list-html": "Lista continuărilor (HTML)",
      "shp": "Shapefile GIS (SHP)"
    }
  },
  "surveySources": {
    "title": "Surse topografice",
    "explanation": "Materialul din care au fost făcute modelele compilate de mai sus. Păstrat pentru ca topografia să poată fi compilată din nou atunci când uneltele care au produs exportul nu mai există în forma de azi. Un jurnal de compilare este deschis, pentru cifrele de închidere pe care le raportează; nimic altceva de aici nu este citit sau interpretat.",
    "upload": "Arhivează o sursă",
    "uploaded": "Sursă arhivată",
    "uploadFailed": "Fișierul nu a putut fi arhivat",
    "acceptHint": "Therion .th, .th2 și .thconfig, Survex .svx, un .log de compilare sau exportul .zip al unei aplicații de topografie — până la 100 MB.",
    "kind": "Tip",
    "size": "Mărime",
    "revision": "Revizie",
    "download": "Descarcă",
    "empty": "Nicio sursă arhivată încă",
    "deleteConfirm": "Scoți această sursă din arhiva peșterii? Fișierul stocat rămâne.",
    "kinds": {
      "therionSource": "Sursă Therion",
      "therionConfig": "Therion .thconfig",
      "therionLog": "Jurnal de compilare",
      "survexSource": "Survex .svx",
      "topoDroidArchive": "Export din aplicație"
    },
    "problems": {
      "formatUnsupported": "Arhivează o sursă topografică: Therion .th, .th2 sau .thconfig, Survex .svx, un .log de compilare sau exportul .zip al unei aplicații de topografie.",
      "contentMismatch": "Acest fișier nu este ceea ce spune numele lui. O sursă topografică trebuie să fie chiar formatul pe care extensia îl pretinde.",
      "sizeInvalid": "Fișierul este gol sau mai mare de 100 MB.",
      "nameInvalid": "Numele fișierului este prea lung pentru arhivă. Redenumește-l la cel mult 255 de caractere și încearcă din nou.",
      "descriptionInvalid": "Descrierea este prea lungă; păstreaz-o la cel mult 4000 de caractere.",
      "notFound": "Această sursă arhivată nu mai există.",
      "caveNotFound": "Această peșteră nu mai există.",
      "forbidden": "Nu ai voie să modifici arhiva topografică a acestei peșteri."
    }
  },
  "surveyQuality": {
    "title": "Închiderea buclelor",
    "explanation": "Cât de bine s-a închis fiecare topografie, exact așa cum a raportat programul care a compilat-o. Nimic nu este recalculat aici: coloanele sunt ale programului — REL-ERR, ABS-ERR, TOTAL-L, STS și cele trei erori pe axe — astfel încât o valoare de aici și una din propriul jurnal să fie același număr.",
    "statuses": {
      "pending": "În așteptare pentru citire",
      "unreadable": "Nu a putut fi citit"
    },
    "outcomes": {
      "succeeded": "Compilat",
      "succeededWithWarnings": "Compilat cu avertismente",
      "failed": "Compilare eșuată"
    },
    "unreadable": "Acest jurnal nu a putut fi citit, așa că nu se știe nimic despre compilarea pe care o consemna. Nu este o afirmație despre topografie.",
    "compilationFailed": "Această compilare nu s-a încheiat. Ce urmează este ce a apucat rularea să raporteze — nu o topografie fără bucle.",
    "stoppedAt": "S-a oprit la: {{stage}}.",
    "compiler": "Program de compilare",
    "compilerValue": "therion {{version}}",
    "compilerReleased": "Versiune lansată la",
    "readAt": "Jurnal citit aici",
    "revision": "Revizia din arhivă",
    "loopCount": "Bucle găsite de program",
    "averageLoopError": "Eroare medie pe bucle",
    "medianLoopError": "Eroare mediană pe bucle (din tabel)",
    "medianAbsoluteError": "Distanță mediană de închidere (din tabel)",
    "totalLength": "Lungime totală",
    "totalLengthAdjusted": "Lungime totală, ajustată",
    "adjustment": "Ajustarea a deplasat",
    "compilationSeconds": "Durata compilării (s)",
    "noLoops": "Această rulare nu a raportat erori de buclă: topografia nu are bucle închise de verificat.",
    "noLoopTable": "Acest jurnal nu a tipărit un tabel al erorilor de buclă, așa că din el nu se știe cât de bine se închide topografia. Nu este același lucru cu o topografie fără bucle închise.",
    "loopsWithoutTable": "Această rulare a raportat {{loops}} bucle, dar nu a tipărit tabelul erorilor de buclă, așa că din acest jurnal nu se știe cu cât s-a închis fiecare.",
    "orderedBy": {
      "relErr": "Ordonat după REL-ERR, raportul.",
      "absErr": "Ordonat după ABS-ERR, distanța de închidere.",
      "totalLength": "Ordonat după TOTAL-L, lungimea buclei.",
      "table": "În ordinea programului de compilare."
    },
    "orderingExplanation": "O buclă scurtă poate avea în același timp raportul mai prost și distanța mai mică, așa că ordonarea după REL-ERR și cea după ABS-ERR nu dau aceeași listă. Sortează după oricare dintre titluri.",
    "columns": {
      "ordinal": "Bucla",
      "relErr": "REL-ERR",
      "relErrHint": "Raport: eroarea de închidere ca % din lungimea buclei",
      "absErr": "ABS-ERR",
      "absErrHint": "Distanță: cu cât nu s-a închis bucla, în metri",
      "totalLength": "TOTAL-L (m)",
      "stationCount": "STS",
      "errorX": "X-ERROR",
      "errorY": "Y-ERROR",
      "errorZ": "Z-ERROR",
      "stations": "STATIONS"
    }
  },
  "karstArea": {
    "title": "Statistici pe zona carstică",
    "loading": "Se calculează ce conține zona…",
    "basisDeclared": "Numărat pe peșterile declarate ca fiind în această zonă",
    "basisDeclaredDetail": "Apartenența este ierarhia introdusă de cineva, nu un test față de contur. {{drift}} peșteră/peșteri pe care le poți localiza cad în interiorul conturului fără a fi declarate aici, din {{placeable}} peșteri ale zonei pe care le poți localiza — un indiciu despre cât s-a îndepărtat ierarhia de hartă, și nicio parte din cifrele de mai sus.",
    "caveCount": "Peșteri",
    "entranceCount": "Intrări",
    "areaKm2": "Suprafață (km²)",
    "cavesPerKm2": "Peșteri pe km²",
    "surveyedLength": "Galerii topografiate (m)",
    "surveyedPerKm2": "Metri topografiați pe km²",
    "surveyedCaveCount": "Peșteri cu lungime topografiată",
    "ofCaves": "{{measured}} din {{total}}",
    "depressionCount": "Depresiuni cartate",
    "depressionRatio": "Acoperire cu depresiuni (%)",
    "index": "Indice de carstificare",
    "indexUnknown": "nemăsurabil",
    "component": {
      "cave_density": "Densitatea peșterilor",
      "depression_area_ratio": "Acoperire cu depresiuni"
    },
    "componentAbsent": "neînregistrat, deci este exclus din indice în loc să fie socotit zero",
    "componentPresent": "{{value}} față de o referință de {{reference}}",
    "class": {
      "unknown": "Necunoscut",
      "veryLow": "Foarte scăzut",
      "low": "Scăzut",
      "moderate": "Moderat",
      "high": "Ridicat",
      "veryHigh": "Foarte ridicat"
    },
    "deepest": "Cele mai adânci peșteri",
    "longest": "Cele mai lungi peșteri",
    "rockType": "Tip de rocă",
    "rockTypeUnrecorded": "Neînregistrat",
    "notMeasured": "nemăsurat",
    "notMapped": "necartat",
    "metresShort": "m",
    "scopeNote": "Fiecare cifră de aici este numărată pe peșterile pe care le poți citi. Un alt cont poate vedea, pe bună dreptate, totaluri diferite pentru aceeași zonă."
  },
  "karstDensity": {
    "title": "Densitate, spațiere și aliniere",
    "loading": "Se citește grila…",
    "notMeasured": "nemăsurat",
    "protectionNote": "Coordonatele protejate sunt numărate pe grila de {{metres}} m a acestei instalări.",
    "protectionNoteDetail": "Grila a numărat {{counted}} intrări. Cifrele de spațiere și aliniere folosesc doar cele {{placed}} pe care le poți localiza exact — o spațiere măsurată între coordonate rotunjite măsoară rotunjirea, nu peșterile.",
    "cellSize": "Dimensiunea celulei. Cea mai fină publicată de această instalare este {{floor}} m, grila de protecție a locației.",
    "cellMetres": "Celulă (m)",
    "bandwidthMetres": "Lățimea nucleului (m)",
    "cellCount": "Celule",
    "featureCount": "Intrări numărate",
    "studyAreaKm2": "Aria de studiu (km²)",
    "peakDensity": "Densitate netezită maximă (pe km²)",
    "clarkIndex": "Indice Clark–Evans",
    "clarkZ": "z",
    "clarkP": "p",
    "clustered": "Sub unu: intrările stau mai aproape unele de altele decât ar face-o hazardul.",
    "spaced": "Peste unu: intrările sunt mai uniform distanțate decât ar face-o hazardul.",
    "random": "Unu: nu se distinge de hazard.",
    "ripley": "L al lui Ripley, cu banda trasată de {{simulations}} împrăștieri aleatoare din sămânța {{seed}}.",
    "noEnvelope": "Nu s-a rulat nicio simulare, deci nu se trasează nicio bandă și nu s-a testat nicio semnificație.",
    "radiusM": "Rază (m)",
    "observedL": "L",
    "alignment": "Direcții între {{pairs}} perechi de intrări, la {{min}}–{{max}} m distanță.",
    "tooFewPlaceable": "Mai puțin de {{minimum}} intrări de aici pot fi localizate exact, prea puține pentru ca o spațiere să însemne ceva.",
    "autocorrelationTitle": "Zone calde și reci",
    "autocorrelationBasis": "Citit peste cele {{cells}} celule de mai sus și cele {{pairs}} vecinătăți dintre ele, la celula de {{metres}} m a acestei rețele și nu mai fin — ambele cifre sunt aritmetică peste celulele deja desenate, deci niciuna nu poate arăta un detaliu pe care rețeaua nu îl are deja.",
    "autocorrelationUndetermined": "Nu există o dispunere care să poată fi testată aici: prea puține celule, niciuna învecinată, sau fiecare celulă având aceeași densitate.",
    "moranIndex": "Indicele I al lui Moran",
    "moranExpected": "Așteptat din întâmplare",
    "moranZ": "Erori standard",
    "moranP": "p",
    "hotSpots": "{{hot}} celule se citesc drept calde și {{cold}} drept reci, din {{scored}} care au putut fi punctate. Scorul este luat în fiecare celulă deodată și nu este corectat pentru asta, deci câteva celule izbitoare răspândite pe o fereastră mare sunt exact ce produce singură întâmplarea — citește nuanțarea, nu celula individuală.",
    "pattern": {
      "undetermined": "Întrebarea nu a putut fi pusă pentru această fereastră.",
      "random": "Dispunerea nu se deosebește de una întâmplătoare. Aceasta este o nereușită de a găsi o structură, nu o dovadă că nu există una.",
      "clustered": "Celulele dense stau lângă cele dense, iar cele goale lângă cele goale, mai mult decât ar face-o întâmplarea.",
      "dispersed": "Celulele dense și cele goale alternează mai mult decât ar face-o întâmplarea."
    }
  },
  "karstStats": {
    "clusterArbitrary": "Gruparea încă muta peșteri când a atins limita de pași, așa că grupul în care a căzut o peșteră aflată la limită este arbitrar în detalii, nu greșit.",
    "clusterCoverage": "{{measure}}: {{missing}} dintre peșterile luate în considerare nu o înregistrează, iar {{soleReason}} dintre acestea ar fi fost grupate dacă această măsură nu ar fi fost cerută.",
    "clusterEmpty": "Nimic nu a putut fi grupat: mai puțin de {{minimum}} peșteri din acest set înregistrează toate măsurile cerute. Punctele de mai jos sunt desenate necolorate, iar cifrele de mai sus rămân valabile.",
    "clusterGroup": "Grupul {{group}}",
    "clusterMeasures": "Grupat după {{measures}}, fiecare standardizată în prealabil, astfel încât nicio măsură să nu cântărească mai mult decât alta doar pentru că este înregistrată în valori mai mari.",
    "clusterNoSeparation": "Centrele grupurilor nu se separă deloc — cea mai puternică formulare disponibilă a faptului că aici nu există structură. Culorile împart aceste peșteri; nu descoperă nimic despre ele.",
    "clusterNoWork": "Toate peșterile grupate au aceeași valoare pentru {{measure}}, așa că acea măsură nu a mutat nicio peșteră în niciun grup.",
    "clusterNotAsked": "Această listă este restrânsă după ceva ce gruparea la nivel de registru nu poate fi întrebată, așa că peșterile sunt desenate necolorate, nu colorate după gruparea altui set de peșteri.",
    "clusterPopulation": "Grupat pe cele {{eligible}} din {{considered}} peșteri pe care le poți citi din întregul set la care este restrânsă această listă — nu doar din pagina desenată mai jos — și care înregistrează toate măsurile cerute. Celelalte {{excluded}} înregistrează mai puține, așa că nicio grupare nu le poate plasa, iar neavând nici lungime, nici adâncime de reprezentat, lipsesc din grafic, nu sunt desenate în el.",
    "clusterUngrouped": "Negrupate",
    "clusterWeak": "Grupurile sunt la fel de late pe cât sunt de depărtate între ele, deci această grupare este slabă. Metoda returnează exact numărul de grupuri cerut, oricare ar fi datele, inclusiv zgomot, așa că mai jos culorile sunt o împărțire a acestor peșteri, nu o descoperire despre ele.",
    "clusterWithheld": "Unele grupuri conțin mai puțin de {{floor}} peșteri. Acelea nu sunt rezumate, iar peșterile lor sunt desenate necolorate, pentru că o medie pe două peșteri sunt chiar valorile acelor două peșteri, nu ceva despre un grup.",
    "count": "Peșteri",
    "depthAxis": "Denivelare (m)",
    "lengthAxis": "Lungime carotată (m)",
    "nothingMeasured": "Nicio peșteră de pe această pagină nu are lungime măsurată.",
    "powerLawFit": "Ajustare putere (exponent {{exponent}})",
    "rank": "Rang",
    "regression": "Ajustare: pantă {{slope}}, R² {{r2}}",
    "scopeNote": "Calculat din cele {{shown}} din {{total}} peșteri de pe această pagină care au o lungime măsurată. Peșterile fără lungime lipsesc, nu sunt numărate ca zero.",
    "title": "Distribuții",
    "viewByType": "După tip",
    "viewHistogram": "Lungime",
    "viewLengthDepth": "Lungime vs denivelare",
    "viewRankSize": "Rang–mărime"
  },
  "registryStats": {
    "basis": {
      "readable": "Calculat pe peșterile pe care ai voie să le citești. Cineva cu alt acces vede alte cifre pentru același registru, iar ambele sunt corecte.",
      "placeable": "Calculat pe peșterile pe care ai voie să le citești și să le localizezi exact. O peșteră a cărei poziție îți este închisă este numărată în totalurile registrului și nu apare sub niciun loc, pentru că un număr sub un loc ar spune unde se află.",
      "area": "Calculat pe peșterile pe care ai voie să le citești și să le localizezi exact, în zona indicată de tine. O peșteră a cărei poziție îți este închisă lipsește cu totul din aceste cifre, totalurile incluse, pentru că un număr într-o zonă numită ar spune că ea se află acolo."
    },
    "distributionTitle": "Distribuție în registru",
    "asVisibleToYou": "Calculat pe peșterile pe care le poți citi. Cineva cu alte drepturi vede alte cifre pentru același registru, și amândoi au dreptate.",
    "stale": "Acestea sunt cifrele răspunsului anterior, rămase pe ecran cât timp se calculează cel nou. Niciun fișier nu este oferit până când cele două nu coincid.",
    "measure": "Măsurătoare",
    "bins": "Intervale",
    "floor": "Minimum de peșteri pe interval",
    "caveType": "Tip de peșteră",
    "rockType": "Tip de rocă",
    "region": "Regiune",
    "regionPlaceholder": "Numele exact al regiunii",
    "anyValue": "Oricare",
    "filterNote": "Aceste restrângeri se potrivesc exact, iar nimic de aici nu numără câte peșteri ar lăsa fiecare — acel număr este însăși întrebarea, așa că primești răspunsul mai jos, nu pe controale.",
    "linearCount": "Liniar",
    "logCount": "Logaritmic",
    "caves": "Peșteri",
    "binCount": "{{caves}} peșteri",
    "joinedLabel": "{{from}}–{{to}} unite",
    "joinedNote": "Mai multe intervale unite, pentru că unul dintre ele avea prea puține peșteri ca să fie publicat separat.",
    "joinedSummary": "{{joined}} dintre aceste intervale sunt mai multe unite între ele, marcate în grafic și mai late decât restul. Registrul unește un interval cu prea puține peșteri în loc să îl omită, fiindcă omiterea lui ar spune ea însăși că acolo se află ceva.",
    "tailSpan": "Coada ajustată începe la {{from}}: descrie ultimele {{intervals}} dintre cele {{total}} intervale desenate, și nimic în stânga lor.",
    "counts": "Calculat pe cele {{measured}} din {{total}} peșteri ale acestui set care au o valoare înregistrată. O peșteră fără valoare lipsește, nu este numărată ca zero.",
    "noRange": "Nu există un interval de împărțit: nimic din acest set nu înregistrează această măsurătoare sau tot ce o înregistrează are aceeași valoare.",
    "noFigure": "—",
    "percentiles": "Percentile",
    "fraction": "Percentilă",
    "percentileName": "a {{percent}}-a",
    "fits": "Ajustări",
    "lognormal": "Lognormală",
    "lognormalAbsent": "Fără ajustare lognormală: prea puține peșteri înregistrează această măsurătoare sau toate au aceeași valoare. Parametrii ar exista aritmetic și nu ar însemna nimic.",
    "paretoTail": "Coadă de tip putere",
    "paretoAbsent": "Fără coadă ajustată: coada superioară are prea puține peșteri pentru ca un exponent să însemne ceva.",
    "alphaValue": "{{alpha}} ± {{error}}",
    "tailFrom": "Coada începe la",
    "median": "Mediană",
    "mean": "Medie",
    "goodness": "Distanța față de coada ajustată",
    "fittedOver": "Ajustat pe",
    "fittedOverValue": "{{caves}} peșteri",
    "failed": "Distribuția nu a putut fi calculată.",
    "correlationTitle": "Două măsurători una față de cealaltă",
    "correlationFailed": "Relația nu a putut fi calculată.",
    "horizontal": "Măsurătoarea orizontală",
    "vertical": "Măsurătoarea verticală",
    "logFit": "Logaritmic",
    "linearFit": "Liniar",
    "pair": "{{y}} față de {{x}}",
    "fit": "Ajustarea",
    "slope": "Panta",
    "intercept": "Interceptul",
    "rSquared": "Calitatea ajustării (r²)",
    "correlationCoefficient": "Corelație",
    "pairs": "Calculat pe",
    "pairsValue": "{{caves}} peșteri care le înregistrează pe amândouă",
    "form": "Ajustat",
    "drawnNote": "Linia este relația ajustată, trasată peste intervalul acoperit de măsurătoarea orizontală în acest set. Peșterile prin care a fost ajustată nu sunt desenate: registrul răspunde la această întrebare cu relația, nu cu peșterile din spatele ei, iar intervalul trasat poate fi mai larg decât perechile folosite la ajustare.",
    "positiveOnly": "Ajustat pe logaritmii ambelor, așa că o peșteră cu zero sau mai puțin la oricare dintre măsurători nu contribuie la nimic, în loc să fie împinsă în sus. Numărul de lângă ajustare spune câte au rămas.",
    "absence": {
      "noPairs": "Nicio peșteră din acest set nu înregistrează ambele măsurători, deci nu există relație de ajustat și nu se trasează niciuna.",
      "notFitted": "Mai puțin de două peșteri înregistrează ambele măsurători. O linie printr-un singur punct nu este o relație, deci nu se trasează niciuna.",
      "noRange": "Măsurătoarea orizontală nu acoperă niciun interval în acest set, deci nu există pe ce să fie trasată relația. Cifrele de alături rămân valabile.",
      "noPositiveRange": "Ajustarea este făcută pe logaritmi, iar măsurătoarea orizontală ajunge la zero sau sub în acest set, deci nu are un capăt inferior de la care să pornească desenul. Cifrele de alături rămân valabile.",
      "rangeUnknown": "Intervalul acoperit de această măsurătoare în acest set nu a sosit încă, deci nu există pe ce să fie trasată relația. Cifrele de alături sunt deja valabile.",
      "rangeUnavailable": "Intervalul acoperit de această măsurătoare în acest set nu a putut fi citit, așa că relația nu este trasată. Este o cifră care nu a ajuns, nu ceva despre peșteri, iar cifrele de alături rămân valabile."
    },
    "measures": {
      "surveyedLength": "Lungime carotată (m)",
      "estimatedLength": "Lungime estimată (m)",
      "depth": "Denivelare (m)",
      "positiveDepth": "Înălțime peste intrare (m)",
      "negativeDepth": "Adâncime sub intrare (m)",
      "realExtension": "Extindere reală (m)",
      "projectedExtension": "Extindere proiectată (m)",
      "volume": "Volum (m³)",
      "area": "Suprafață (m²)",
      "ramificationIndex": "Indice de ramificație"
    },
    "regionsTitle": "Registrul pe regiuni",
    "regionsCard": "Peșteri per regiune",
    "regionsFailed": "Defalcarea nu a putut fi calculată.",
    "noRegion": "Fără regiune înregistrată",
    "regionsCounts": "{{placed}} peșteri se află sub o regiune mai jos, din {{total}} din acest set pe care le poți citi.",
    "regionsShortfall": "Rândurile de mai jos nu însumează totalul, iar acesta este răspunsul, nu o eroare a lui: {{missing}} dintre cele {{total}} peșteri pe care le poți citi aici au o poziție pe care nu o poți vedea, așa că sunt numărate în total și nu stau sub nicio regiune. Tocmai cărei regiuni îi aparțin este ceea ce nu ți se spune, deci nu există un rând care să le adune și niciun procent care să închidă socoteala.",
    "regionsEmpty": "Nicio peșteră din acest set nu are o poziție pe care să o poți vedea, deci nu este nimic de împărțit pe regiuni. Totalul de mai sus numără în continuare peșterile pe care le poți citi.",
    "categoriesTitle": "Registrul pe categorii",
    "groupBy": "Grupat după",
    "categories": {
      "caveType": "Tip de peșteră",
      "rockType": "Rocă"
    },
    "noCategory": "Neînregistrat",
    "categoriesFailed": "Comparația nu a putut fi calculată.",
    "nothingInScope": "Nicio peșteră în acest domeniu.",
    "categoriesCard": "{{measure}} pe grupe",
    "categoriesNote": "Fiecare cutie merge de la percentila 25 la 75, cu mediana în interior și mustăți până la percentilele 10 și 90. O grupă măsurată pe mai puțin de {{count}} peșteri are doar numărătorile, fără cutie.",
    "measured": "Măsurate",
    "box": "P10 · P25 · mediană · P75 · P90",
    "tooFewForABox": "Prea puține peșteri măsurate pentru o cutie"
  },
  "morphometry": {
    "title": "Formă măsurată",
    "area": "Suprafață",
    "perimeter": "Perimetru",
    "circularity": "Circularitate",
    "longAxis": "Axa lungă",
    "shortAxis": "Axa scurtă",
    "elongation": "Alungire",
    "longAxisAzimuth": "Orientarea axei lungi",
    "centroid": "Centru",
    "unitMetres": "m",
    "unitSquareMetres": "m²",
    "unitDegrees": "°",
    "invalidGeometry": "Conturul se intersectează cu el însuși, deci nu are o suprafață sau o formă măsurabilă. Redesenează-l înainte de a citi ceva din el.",
    "measuredInWorkingSystem": "Măsurat în metri, în sistemul de coordonate de lucru al acestei instalări, nu în gradele în care este stocat conturul.",
    "axisIsNotABearing": "Orientarea axei lungi este o aliniere, nu o direcție: merge de la 0° la 180°, deci 170° și 350° sunt aceeași aliniere."
  },
  "closestApproach": {
    "title": "Cea mai mică distanță",
    "pickOther": "Alege altă peșteră",
    "pickOtherHint": "Alege o a doua peșteră pentru a măsura cât de aproape ajung una de cealaltă.",
    "distance": "Distanța cea mai mică",
    "horizontal": "Orizontal",
    "vertical": "Vertical",
    "bearing": "Azimut",
    "unitMetres": "m",
    "unitDegrees": "°",
    "between": "De la {{from}} la {{to}}.",
    "horizontalIsOfTheSameLine": "Valorile orizontală și verticală sunt cele două componente ale aceleiași linii minime, nu distanța orizontală minimă și distanța verticală minimă, care sunt alte perechi de puncte.",
    "unavailable": "Nicio distanță pentru această pereche",
    "unavailableWhy": "O distanță între două peșteri o localizează pe fiecare pornind de la cealaltă, așa că este dată doar unui cititor care poate vedea exact unde se află amândouă.",
    "absence": {
      "noLineWork": "Cel puțin una dintre aceste două peșteri nu are traseu topografic din care să se măsoare.",
      "noAltitudes": "Cel puțin una dintre aceste două peșteri a fost desenată în plan și nu a înregistrat adâncimi, deci nu există o distanță tridimensională onestă."
    },
    "drawnOnMap": "Linia cea mai scurtă este desenată pe hartă și în vizualizarea 3D. Pe hartă vezi doar proiecția ei în plan; în 3D trece prin rocă, la adâncimile la care au fost măsurate cele două capete."
  },
  "viewLinks": {
    "controls": {
      "map2d": "Harta",
      "scene3d": "Scena 3D",
      "caveview": "Vizualizatorul de topografii",
      "imageView": "Imagine"
    }
  },
  "textLink": {
    "notAnnotated": "Acest document nu este un text cu legături.",
    "empty": "Textul nu conține încă nimic.",
    "popOut": "Deschide într-o fereastră separată",
    "controls": {
      "title": "Unde duc legăturile",
      "hint": "Urmărirea unui pasaj evidențiat mută aceste vizualizări. Oprește una ca să rămână pe loc.",
      "none": "Nu este deschisă nicio hartă, scenă sau vizualizator, deci urmărirea unui pasaj nu are ce muta. Deschide una sau desprinde textul lângă ea."
    },
    "edit": {
      "start": "Editează legăturile",
      "stop": "Oprește editarea",
      "hint": "Selectează orice parte din text ca să o legi de o peșteră, un document, o tură sau altceva.",
      "deleteTitle": "Ștergi această legătură?",
      "deleteBody": "Pasajul nu va mai fi evidențiat. Lucrurile pe care le lega nu sunt afectate."
    },
    "card": {
      "uncertain": "S-ar putea să se fi mutat",
      "uncertainDetail": "Aceste cuvinte nu se află unde le-a înregistrat legătura, deci evidențierea poate fi pe alt pasaj.",
      "noTargets": "Legătura nu indică încă nimic altceva.",
      "openLink": "Legătura",
      "reveal": "Arată",
      "revealHint": "Mută vizualizările deschise la acest lucru, fără a părăsi textul.",
      "revealIn": "Arată în…",
      "otherWindow": "altă fereastră",
      "open": "Deschide",
      "openNewWindow": "Deschide într-o fereastră nouă"
    },
    "section": {
      "none": "Nu s-a scris încă nimic despre acest lucru.",
      "write": "Scrie unul",
      "newTitle": "Notițe despre {{name}}",
      "newTitleBare": "Notițe",
      "newBody": "Scrie aici, apoi selectează orice parte din text ca să o legi."
    }
  },
  "speologie": {
    "title": "Catalogul peșterilor",
    "subtitle": "Caută în catalogul comunitar al peșterilor din România de pe speologie.org și adu peșteri de acolo în această instalare.",
    "portalLink": "Deschide speologie.org",
    "openInPortal": "Deschide pe speologie.org",
    "notConfigured": {
      "title": "Această instalare nu are cheie pentru catalog",
      "body": "Căutarea pe speologie.org are nevoie de o cheie API personală, obținută dintr-un profil de pe acel site și configurată de un administrator. Până atunci, acest ecran nu poate afișa nimic."
    },
    "search": {
      "term": "Denumire",
      "termPlaceholder": "O parte din denumirea peșterii sau codul ei",
      "county": "Județ",
      "countyPlaceholder": "Orice județ",
      "submit": "Caută",
      "clear": "Șterge",
      "needSomething": "Dă o denumire de căutat, un județ, sau ambele.",
      "spellingsWhy": "Româna se scrie cu două convenții de diacritice diferite și adesea fără niciuna, iar căutarea catalogului le tratează ca pe cuvinte diferite. Toate grafiile sunt cerute deodată.",
      "noResults": "Catalogul nu are nimic care să corespundă.",
      "hint": "Catalogul cuprinde aproximativ 8.650 de peșteri publicate. Nu conține coordonate, așa că o peșteră importată de acolo ajunge fără poziție.",
      "spellings": "S-au căutat {{count}} grafii ale a ceea ce ai scris: {{list}}",
      "noResultsHint": "Nimic din catalog nu corespunde. Căutarea lui este sensibilă la diacritice — instalarea cere deja mai multe grafii ale a ceea ce ai scris, dar o denumire lungă cu mai multe litere accentuate poate cere totuși scrierea așa cum o scrie catalogul (Scărișoara, nu Scarisoara).",
      "basin": "Bazin hidrografic",
      "basinPlaceholder": "Orice bazin",
      "basinNarrowed": "{{count}} din cele {{scanned}} peșteri citite se potrivesc cu acel bazin.",
      "basinNarrowedWhy": "Catalogul nu poate căuta după bazin, așa că filtrul restrânge ceea ce a adus căutarea, nu îi pune o altă întrebare. Alegerea unui masiv include toate bazinele din el."
    },
    "columns": {
      "name": "Denumire",
      "county": "Județ",
      "mountain": "Masiv",
      "length": "Lungime (m)",
      "depth": "Denivelare (m)",
      "altitude": "Altitudine (m)",
      "protectionClass": "Clasă",
      "state": "În această instalare",
      "actions": "Acțiuni",
      "basin": "Bazin"
    },
    "state": {
      "imported": "Deja importată",
      "importedElsewhere": "Deja importată, dar nu o poți vedea",
      "notImported": "Încă nu este aici",
      "openCave": "Deschide peștera"
    },
    "flags": {
      "vanished": "Consemnată ca dispărută",
      "sump": "Are sifon"
    },
    "actions": {
      "import": "Importă",
      "refresh": "Actualizează din catalog",
      "details": "Detalii",
      "importSelected": "Importă selecția ({{count}})"
    },
    "detail": {
      "title": "{{name}} — speologie.org",
      "description": "Descriere",
      "noDescription": "Catalogul nu consemnează nicio descriere pentru această peșteră.",
      "descriptionNote": "Afișată exact cum ar fi salvată: formatarea din catalog este transformată în text simplu, iar o descriere foarte lungă este scurtată.",
      "identity": "Identificare",
      "slug": "Identificator din catalog",
      "catalogueId": "Id în catalog",
      "locality": "Localitate",
      "rockCode": "Cod rocă",
      "rockCodeHint": "Catalogul nu publică o legendă pentru acest cod, așa că este păstrat exact cum este scris, fără a fi ghicit.",
      "science": "Interes științific",
      "protectedAreaCode": "Cod arie protejată",
      "hydroNumber": "Număr hidrologic",
      "hydroBasin": "Bazin hidrografic",
      "hydroBasinUnknown": "Catalogul a numit un bazin pe care copia arborelui din această instalare nu îl conține. O reîmprospătare a acelui tabel îl poate rezolva."
    },
    "wizard": {
      "title": "Import din catalog",
      "back": "Înapoi la căutare",
      "nothingSelected": "Nu a fost aleasă nicio peșteră. Întoarce-te la căutare și alege peșterile de importat.",
      "options": "Pentru fiecare peșteră importată",
      "parent": "Așază-le sub",
      "parentPlaceholder": "Nimic — lasă-le la nivelul de sus",
      "noCoordinates": "Catalogul nu publică coordonate",
      "noCoordinatesBody": "O peșteră importată de acolo nu are poziție, deci este în registru și în căutare, dar pe nicio hartă. Dă-i o poziție mai jos și primește o intrare principală acolo; lasă-o așa și poate fi poziționată mai târziu. Peșterile fără poziție se găsesc la Peșteri, cu filtrul „fără poziție”.",
      "candidates": "Peșterile",
      "action": "Ce se face",
      "actionCreate": "Creează",
      "actionUpdate": "Actualizează",
      "actionSkip": "Lasă neatinsă",
      "actionUpdateHint": "Această peșteră a mai fost importată. Actualizarea îi rescrie denumirea, descrierea, regiunea, altitudinea, lungimea, denivelarea și clasa de protecție din catalog; restul a ceea ce este consemnat pe ea rămâne neatins.",
      "caveType": "Tip",
      "caveTypeDerived": "Dedus din denumire",
      "position": "Poziție",
      "unplaced": "Fără poziție",
      "place": "Așază pe hartă",
      "placing": "Dă clic pe hartă pentru a așeza „{{name}}”",
      "clearPosition": "Șterge poziția",
      "commit": "Importă",
      "committing": "Se importă…",
      "subtitle": "Alese de pe speologie.org: {{count}}. Gata de adus."
    },
    "result": {
      "title": "Importul s-a încheiat",
      "created": "Create",
      "updated": "Actualizate",
      "skipped": "Lăsate neatinse",
      "failures": "Acestea nu au putut fi importate",
      "undoHint": "Întregul import este un singur lot și poate fi anulat din Geodate → Istoric importuri.",
      "viewCaves": "Vezi peșterile"
    },
    "errors": {
      "notConfigured": "Această instalare nu are cheie API pentru catalog.",
      "unauthorized": "Catalogul nu a acceptat cheia API a acestei instalări. Un administrator trebuie să configureze una funcțională.",
      "unavailable": "Catalogul nu a putut fi contactat. Este un serviciu mic, întreținut de voluntari — încearcă din nou peste puțin timp.",
      "rejected": "Catalogul a respins cererea. Este o eroare a acestei aplicații, nu ceva ce poți remedia.",
      "searchTooBroad": "Dă o denumire de căutat, un județ, sau ambele.",
      "caveNotFound": "Catalogul nu mai publică acea peșteră.",
      "selectionTooLarge": "Au fost alese prea multe peșteri pentru un singur import. Adu-le în loturi mai mici — fiecare poate fi anulat separat.",
      "importFailed": "Importul nu a putut fi finalizat."
    },
    "paging": {
      "previous": "Anterioare",
      "next": "Următoare",
      "page": "Pagina {{page}}"
    }
  },
  "tripImport": {
    "title": "Importă ture dintr-un tabel",
    "uploadTitle": "Importă ture dintr-un tabel",
    "uploadPrompt": "Trage aici tabelul cu ture sau apasă pentru a alege unul",
    "uploadHint": "Un export separat prin virgulă sau punct și virgulă al listei de ture a clubului. Nimic nu se scrie până nu citești ce ar face.",
    "duplicateTitle": "Ai încărcat deja acest tabel",
    "duplicateBody": "Arhiva păstrează deja exact acest fișier ca „{{name}}”. Deschide analiza care îi corespunde în loc să începi a doua, sau încarcă tabelul din nou ca o copie separată, dacă asta ai vrut.",
    "duplicateResume": "Reia acea analiză",
    "duplicateUploadAgain": "Încarcă-l oricum din nou",
    "optionsReading": "Cum se citește tabelul",
    "optionsMapping": "Care coloană ce înseamnă",
    "optionsCreated": "Ce poate fi creat",
    "optionsAudience": "Pentru cine sunt aceste ture",
    "dateOrderHint": "Acolo unde o dată are o componentă peste doisprezece, fișierul stabilește singur dacă scrie întâi ziua sau luna. Acolo unde nimic nu stabilește, decide această alegere — iar rândurile pe care le hotărăște sunt numărate alături.",
    "dateOrder": "Ordinea datei",
    "dateOrderDayFirst": "Întâi ziua (31/12/2024)",
    "dateOrderMonthFirst": "Întâi luna (12/31/2024)",
    "dateOrderSettled": "Ce a stabilit-o",
    "dateOrderRidesOn": "{{count}} rânduri depind de această alegere",
    "dateOrderSources": {
      "stated": "Alegerea ta",
      "file": "Fișierul însuși",
      "conflict": "Fișierul se contrazice"
    },
    "encoding": "Codificarea caracterelor",
    "encodingHint": "Un tabel nu declară nimic de încredere despre codificarea sa, așa că este dedusă din octeți. O pagină de cod veche citită ca UTF-8 pierde toate diacriticele, așa că răspunsul este arătat aici și poate fi schimbat.",
    "encodingDetect": "Dedu din fișier",
    "encodingSettled": "Ce a stabilit codificarea",
    "encodings": {
      "utf8": "UTF-8",
      "utf16Le": "UTF-16, little-endian",
      "utf16Be": "UTF-16, big-endian",
      "windows1250": "Windows-1250, Europa Centrală",
      "iso88592": "ISO-8859-2, Latin-2",
      "windows1252": "Windows-1252, Europa de Vest"
    },
    "encodingSources": {
      "stated": "Alegerea ta",
      "mark": "O marcă la începutul fișierului",
      "utf8": "Octeții sunt UTF-8 valid",
      "guessed": "Dedusă din octeții cu diacritice"
    },
    "delimiter": "Separatorul de coloane",
    "delimiterHint": "Un singur caracter. Este fixat, nu ghicit: altfel o coloană de text plină de punct și virgulă răstoarnă toată citirea.",
    "separators": "Separatori în interiorul unei celule",
    "separatorsHint": "Caracterele care despart mai multe nume sau peșteri scrise într-o singură celulă.",
    "slashFields": "Desparte și la bară oblică",
    "slashFieldsHint": "Doar pentru coloanele pe care le numești. O bară oblică desparte „n/a” și „Piatra Craiului/Bucegi” la fel de ușor ca două nume, așa că este oprită până o ceri.",
    "unmappedColumns": "Tabelul mai are: {{columns}}. Din ele nu se citește nimic.",
    "mappingAuto": "Detectat automat",
    "fields": {
      "sourceId": "Numărul rândului",
      "startDate": "Data de început",
      "endDate": "Data de sfârșit",
      "title": "Titlu",
      "country": "Țară",
      "massif": "Masiv sau zonă",
      "subArea": "Subzonă",
      "caves": "Peșteri",
      "proposers": "Propusă de",
      "participants": "Participanți",
      "tripType": "Tip",
      "details": "Detalii",
      "details2": "Alte detalii",
      "errors": "Observații despre datele sursei"
    },
    "createHint": "Fiecare este oprit până îl ceri. Potrivirea cu ce există deja se face oricum — acestea hotărăsc doar ce se întâmplă cu un nume căruia nu i-a răspuns nimic. Anularea importului după aceea șterge turele și peșterile și zonele create, dar lasă în urmă speologii și cuvintele de tip adăugate.",
    "createCaves": "Creează peșterile pe care tabelul le numește, dar registrul nu le are",
    "createAreas": "Creează masivele și subzonele pe care registrul nu le are",
    "createCavers": "Creează speologii pe care lista nu îi are",
    "createAbbreviatedCavers": "Creează speologi și din nume prescurtate",
    "createAbbreviatedCaversHint": "Un nume ca „Ion B.” sau un prenume singur devine speolog ca oricare altul. Pornește-l pentru un tabel scris așa peste tot — altfel aproape nimeni din el nu poate fi creat. Vor apărea duplicate: se unesc apoi din lista de speologi.",
    "createTripTypes": "Creează tipurile de tură pe care vocabularul nu le are",
    "audienceHint": "Aleasă o dată și aplicată fiecărui rând. Pornește de la valoarea cea mai restrânsă: un import este un act în masă, iar un act în masă care publică implicit publică dintr-odată toată istoria unui club.",
    "visibility": "Cine poate citi aceste ture",
    "cavingGroup": "Grupul organizator",
    "summaryTitle": "Ce ar face confirmarea",
    "newTripTypes": "Tipuri de tură noi",
    "newCavers": "Speologi noi",
    "newCaves": "Peșteri noi",
    "newAreas": "Zone noi",
    "peopleNeedingADecision": "Persoane care cer o decizie",
    "placesNeedingADecision": "Locuri care cer o decizie",
    "peopleWarningTitle": "{{ambiguous}} nume se potrivesc cu mai mulți speologi, iar {{uncreatable}} nu pot fi create",
    "peopleWarningBody": "Un nume care se potrivește cu mai multe persoane nu este niciodată ghicit — spune care este cel potrivit. Un nume prea scurt ca să identifice pe cineva, o inițială singură sau un singur prenume, nu creează pe nimeni decât dacă îl permiți la ce poate fi creat: o persoană inventată astfel nu ar mai putea fi legată cu certitudine de speologul potrivit. Lăsate așa, aceste nume rămân în textul turei, iar oamenii nu apar pe lista turelor la care au fost.",
    "peopleLeftOff": "Persoane lăsate pe dinafară",
    "leftOffTitle": "Persoane pe care lista nu le are și care vor lipsi din turele lor: {{count}}",
    "leftOffBody": "Cât timp „Creează speologii pe care lista nu îi are” este oprit, nu se creează nimeni: aceste nume rămân în textul turei, iar oamenii nu apar pe lista turelor la care au fost. Pornește opțiunea la ce poate fi creat ca să fie adăugați.",
    "placesWarningTitle": "{{count}} nume de locuri se potrivesc cu mai multe înregistrări",
    "columns": {
      "take": "Ia",
      "line": "Linie",
      "when": "Când",
      "title": "Titlu",
      "type": "Tip",
      "places": "Locuri",
      "people": "Persoane",
      "warnings": "Avertismente",
      "reason": "Motiv"
    },
    "untitledRow": "(fără titlu)",
    "warningCount": "{{count}} avertismente",
    "problemsTitle": "Ce nu a putut fi citit ({{count}} rânduri)",
    "noProblems": "Toate rândurile au fost citite curat.",
    "wholeFile": "Fișierul",
    "atLine": "Linia {{line}}",
    "problems": {
      "mappedColumnMissing": "O coloană numită de această asociere nu există în tabel",
      "mappedColumnTaken": "Două câmpuri arată spre aceeași coloană",
      "unmappedColumn": "O coloană din care nu se citește nimic",
      "raggedRow": "Rândul are alt număr de celule decât antetul",
      "blankRow": "Un rând gol",
      "requiredFieldEmpty": "Un câmp fără de care rândul nu poate exista este gol",
      "dateUnreadable": "O dată într-o formă pe care acest cititor nu o cunoaște",
      "dateOutOfRange": "O dată a cărei zi sau lună nu poate exista",
      "dateTwoDigitYear": "Un an din două cifre, care ar putea fi din oricare secol",
      "dateAmbiguous": "O dată care se citește în ambele feluri",
      "dateOrderConflict": "Fișierul scrie datele în ambele ordini",
      "valueDropped": "O valoare pierdută din cauza separatorilor folosiți",
      "duplicateSourceId": "Două rânduri poartă același număr de rând",
      "tooManyColumns": "Mai multe coloane decât acceptă cititorul",
      "noHeader": "Lipsește linia de antet",
      "unterminatedQuote": "O valoare între ghilimele care nu se închide"
    },
    "searchPlaceholder": "Caută în rânduri",
    "rowCounts": "{{readable}} citibile · {{failed}} necitibile · {{skipped}} lăsate deoparte",
    "truncatedTitle": "Acest tabel este mai lung decât citește o analiză",
    "truncated": "Au fost citite primele {{scanned}} rânduri. Restul nu sunt în această analiză, iar confirmarea nu le-ar crea.",
    "createSelected": "Creează {{count}} ture",
    "resultTitle": "Importul s-a încheiat",
    "viewBatches": "Vezi lotul",
    "createdTrips": "Ture create",
    "createdFeatures": "Peșteri și zone create",
    "skipped": "Lăsate deoparte",
    "undoHint": "Anularea acestui lot șterge turele și peșterile și zonele create. Fiecare tură poate fi restaurată apoi din Ture șterse, cu participanții și legăturile ei. Speologii și tipurile de tură adăugate rămân, pentru că un cuvânt de tip este al întregii instalații, iar o persoană poate fi deja scrisă în altceva.",
    "someFailedTitle": "{{count}} rânduri nu au putut fi create",
    "errors": {
      "fileNotFound": "Acel tabel nu mai este aici sau nu ai dreptul să-l citești.",
      "createForbidden": "Nu ai dreptul să creezi tot ce ar crea aceste alegeri. Oprește ce nu îți trebuie sau cere dreptul.",
      "groupBindingForbidden": "Nu poți înregistra ture sub acel grup.",
      "fileUnreadable": "Fișierul nu a putut fi citit ca tabel.",
      "fileTooLarge": "Fișierul este mai mare decât citește această instalație dintr-o dată.",
      "selectionEmpty": "Niciun rând nu este luat, deci nu e nimic de creat.",
      "selectionTooLarge": "Prea multe rânduri pentru un singur import. Lasă deoparte o parte și confirmă restul.",
      "nothingCreated": "Niciun rând nu a putut fi creat, deci nu s-a creat nimic. Nimic nu s-a schimbat.",
      "commitFailed": "Importul nu a putut fi finalizat.",
      "previewFailed": "Acest tabel nu a putut fi citit cu alegerile curente.",
      "uploadFailed": "Tabelul nu a putut fi încărcat."
    },
    "chooseWhich": "Care dintre cei {{count}}?",
    "andMoreNames": "și încă {{count}}",
    "dateOrderFixedByFile": "Fișierul stabilește acest lucru, așa că alegerea de mai sus nu este folosită.",
    "takeAll": "Ia toate cele {{count}}",
    "skipAll": "Lasă toate deoparte",
    "keepFirst": "Păstrează doar primele",
    "keepFirstApply": "Aplică",
    "typesTitle": "Ce ar face coloana de tip vocabularului",
    "typesHint": "O linie pentru fiecare valoare distinctă, oricâte rânduri ar scrie-o. Un cuvânt de tip adăugat de acest import este valabil pentru toată instalarea și rămâne în urmă dacă importul este anulat, așa că o valoare căreia nu îi răspunde nimic poate fi redenumită înainte de a fi creată sau îndreptată către un tip care există deja.",
    "typesNone": "Fișierul nu scrie niciun tip de tură.",
    "typeAmbiguous": "Îi răspunde mai mult de un tip",
    "typeNoMatch": "Nu îi răspunde nimic",
    "typeOutcomeLinked": "Înregistrat ca „{{name}}”",
    "typeOutcomeCreated": "Se adaugă un cuvânt de tip nou",
    "typeOutcomeNothing": "Nu se adaugă nimic; valoarea este păstrată în textul turei",
    "typeUseExisting": "Folosește în schimb un tip existent",
    "typeColumns": {
      "value": "Cum o scrie fișierul",
      "matched": "Cu ce s-a potrivit",
      "outcome": "Ce ar face confirmarea",
      "instead": "Sau îndreapt-o către"
    }
  },
  "speleolocImport": {
    "title": "Importă o tură înregistrată pe telefon",
    "recordingTitle": "Transformă o înregistrare în tură",
    "uploadTitle": "Importă o tură înregistrată pe telefon",
    "uploadPrompt": "Trage aici un export SpeleoLoc sau apasă pentru a alege unul",
    "uploadHint": "Arhiva exportată de telefon sau baza de date din ea. Fotografiile pe care le poartă nu sunt deschise niciodată — se citește doar înregistrarea și nu se scrie nimic până nu vezi ce ar face.",
    "duplicateTitle": "Ai încărcat deja această arhivă",
    "duplicateBody": "Depozitul păstrează deja exact acest fișier ca „{{name}}”. Deschide recenzia care îi corespunde în loc să începi alta, sau încarcă arhiva din nou ca o copie separată dacă asta ai vrut.",
    "duplicateResume": "Reia acea recenzie",
    "duplicateUploadAgain": "Încarc-o oricum din nou",
    "optionsRecording": "Care înregistrare",
    "recordingHint": "Un export poartă toată baza de date a telefonului, deci de obicei ține fiecare tură înregistrată vreodată pe el. Nimic nu se citește scanare cu scanare până nu spui despre care este vorba.",
    "recording": "Înregistrare",
    "recordingPlaceholder": "Alege o înregistrare din arhivă",
    "recordingFacts": "Începută {{started}} · încheiată {{ended}} · {{scans}} scanări · {{documents}} fotografii rămase în arhivă",
    "scanCount": "{{count}} scanări",
    "optionsDestination": "Unde ajung pozițiile",
    "destinationExisting": "Pe o tură care există deja",
    "destinationNew": "Într-o tură creată de acest import",
    "trip": "Tura",
    "tripPlaceholder": "Caută printre turele tale",
    "tripHint": "Pozițiile se adaugă în istoricul acelei ture. Tura însăși nu este rescrisă, iar o poziție poate fi atribuită doar cuiva aflat deja pe lista ei de participanți.",
    "createTripHint": "Tura este făcută din ce spune înregistrarea — titlul ei și cele două momente — cu exact persoanele pe care le numești mai jos pe lista de participanți. Face parte din același lot, așa că anularea importului ia și tura cu el.",
    "visibility": "Cine poate citi această tură",
    "cavingGroup": "Grupul organizator",
    "optionsSurvey": "În ce topografie sunt pozițiile",
    "surveyHint": "O poziție este aici o stație a unui model topografic, deci un model trebuie numit înainte să se poată propune ceva pornind de la o adâncime. Modelele sunt listate per peșteră, iar o peșteră a cărei poziție exactă nu îți poate fi spusă nu listează niciunul.",
    "cave": "Peștera",
    "cavePlaceholder": "Caută în registru",
    "surveyModel": "Model topografic",
    "surveyModelPlaceholder": "Alege un model al acelei peșteri",
    "candidateCount": "Stații oferite per scanare",
    "candidateCountHint": "Câte stații sunt oferite pentru adâncimea fiecărui reper, cea mai apropiată prima. Mai multe fac o propunere greșită mai ușor de corectat și o înregistrare lungă mai greu de parcurs. Niciodată mai puțin de două: o singură ofertă ar ascunde adâncimile care ajung la două stații deopotrivă, exact lucrul pentru care există acest ecran.",
    "peopleTitle": "Cine a scanat",
    "peopleHint": "Un cont de dispozitiv este o autentificare pe un telefon, nu o persoană, și nimic din arhivă nu spune ce speolog a fost. De aceea aici nu se propune nimic: spune cine este fiecare cont, iar o scanare făcută de un cont pe care nu l-a numit nimeni este lăsată deoparte, nu atribuită unei presupuneri.",
    "peopleUnmappedTitle": "{{count}} conturi de dispozitiv nu numesc pe nimeni",
    "peopleUnmappedBody": "Fiecare scanare făcută de un cont pe care nu l-a numit nimeni rămâne în afara importului. Numește-le aici și scanările lor pot fi luate ca oricare altele.",
    "peopleOffRosterTitle": "{{count}} persoane numite de tine nu sunt pe această tură",
    "peopleOffRosterBody": "A pune pe cineva pe o tură este o afirmație despre cine a fost acolo, iar acest import nu o face. Scanările lor rămân deoparte până când sunt pe lista de participanți a turei sau până când acele scanări sunt atribuite altcuiva.",
    "peopleNone": "Înregistrarea aleasă nu numește niciun cont de dispozitiv.",
    "deviceAccount": "Contul {{id}}",
    "chooseCaver": "Spune cine este",
    "knownLink": "Asociat anterior",
    "unnamedCaver": "Cineva pe care pagina nu îl poate numi",
    "columns": {
      "take": "Ia",
      "when": "Scanat",
      "place": "Reper",
      "station": "Stație",
      "who": "Cine",
      "note": "Notă",
      "reason": "De ce"
    },
    "states": {
      "proposed": "Propusă",
      "tied": "Mai multe stații la acea adâncime",
      "noPlace": "Scanarea nu numește niciun reper",
      "placeUnknown": "Instalarea nu deține acel reper",
      "depthUnknown": "Reperul nu poartă nicio adâncime",
      "noStationAtDepth": "Nicio stație a topografiei nu se află la acea adâncime",
      "modelUnavailable": "Nu este ales niciun model topografic utilizabil"
    },
    "unresolvedHint": "Nu s-a putut propune nimic, așa că această scanare rămâne deoparte.",
    "namedStation": "Va fi înregistrată la {{station}}",
    "namedStationHint": "Nu s-a propus nimic pentru această scanare; acea stație este una numită de tine, iar confirmarea o înregistrează acolo.",
    "clearStation": "Las-o deoparte",
    "noPlaceTitle": "(niciun reper)",
    "placeDepth": "Înregistrat la {{depth, number}} m",
    "candidate": "{{depth, number}} m adâncime · {{delta, number}} m diferență",
    "proposedFrom": "După adâncimea reperului, {{depth, number}} m",
    "whoUnmapped": "Nimeni nu spune al cui este acest cont",
    "whoAnonymous": "Scanarea nu numește niciun cont",
    "noScans": "Nicio scanare de arătat încă. Alege o înregistrare mai sus.",
    "takeAll": "Ia toate cele {{count}}",
    "skipAll": "Lasă toate deoparte",
    "summaryTitle": "Ce ar face confirmarea",
    "scans": "Scanări",
    "proposed": "Cu propunere",
    "unresolved": "Nerezolvate",
    "taken": "Luate",
    "blockersTitle": "Încă nu se poate confirma",
    "blockers": {
      "recording": "Alege despre care înregistrare din arhivă este vorba.",
      "archiveEmpty": "Această arhivă nu conține nicio înregistrare, deci nu este niciuna de ales.",
      "destination": "Alege tura pe care ajung pozițiile sau cere crearea uneia.",
      "model": "Alege modelul topografic ale cărui stații sunt aceste poziții.",
      "modelUnusable": "Modelul topografic ales nu poate fi plasat de acest cont, așa că nu se poate propune nimic din el.",
      "selection": "Nicio scanare nu este luată, deci nu este nimic de înregistrat."
    },
    "unresolvedTitle": "{{count}} scanări nu au nicio stație",
    "unresolvedBody": "Fiecare spune de ce pe rândul ei. Nu pot fi luate, iar confirmarea le lasă neatinse; restul înregistrării nu este afectat.",
    "createTripNote": "Confirmarea creează tura și înregistrează pe ea scanările luate, într-un singur lot.",
    "existingTripNote": "Confirmarea înregistrează scanările luate pe tura aleasă, într-un singur lot. Tura însăși nu este schimbată.",
    "undoHint": "Anularea acestui lot elimină pozițiile înregistrate pe o tură care exista deja. O tură creată de acest import este în schimb ștearsă împreună cu înregistrarea ei și poate fi restaurată din Ture șterse.",
    "recordSelected": "Înregistrează {{count}} poziții",
    "withheldTitle": "Alegerile tale nu îți sunt arătate înapoi",
    "withheldBody": "O stație este o poziție, iar acest cont nu mai poate plasa peștera căreia îi aparține modelul ales. Recenzia este în continuare păstrată și spune ce a spus; doar conținutul ei este reținut aici. Cât timp este așa, nimic din ce schimbi pe această pagină nu se salvează, tocmai ca să rămână întreg ce este păstrat.",
    "archiveEmptyTitle": "Această arhivă nu conține nicio înregistrare",
    "archiveEmptyBody": "Fișierul încărcat a fost citit, iar baza de date a telefonului nu conține nicio tură. Nu este nimic de importat aici — verifică dacă acesta este exportul pe care îl aveai în vedere și dacă înregistrarea a fost salvată pe telefon înainte de a face arhiva.",
    "resultTitle": "Înregistrarea a fost importată",
    "viewBatches": "Vezi lotul",
    "createdPositions": "Poziții înregistrate",
    "skipped": "Lăsate deoparte",
    "tripWasCreated": "Tura a fost creată de acest import, așa că anularea lotului o șterge.",
    "tripWasExisting": "Pozițiile au fost adăugate unei ture care exista deja și pe care acest import nu a schimbat-o.",
    "someFailedTitle": "{{count}} scanări nu au putut fi înregistrate",
    "failures": {
      "pointMissing": "Arhiva nu mai citește acea scanare ca parte a acestei înregistrări.",
      "stationUnresolved": "Nimic nu a spus ce stație este această scanare și nici nu s-a putut propune una.",
      "stationUnknown": "Stația numită nu este una dintre stațiile modelului ales.",
      "caverUnmapped": "Nimeni nu a spus cine este contul care a scanat.",
      "caverNotParticipant": "Persoana numită nu este pe lista de participanți a turei.",
      "recordedInFuture": "Scanarea pretinde un moment de după ceas.",
      "noteTooLong": "Nota scanării este mai lungă decât poate purta o poziție.",
      "unknown": "Scanarea a fost refuzată."
    },
    "errors": {
      "fileNotFound": "Acea arhivă nu mai este aici sau nu o poți citi.",
      "tripNotFound": "Acea tură nu mai este aici sau nu poți adăuga pe ea.",
      "createForbidden": "Nu poți înregistra ture aici.",
      "groupBindingForbidden": "Nu poți organiza ture sub acel grup.",
      "archiveUnreadable": "Fișierul încărcat nu a putut fi citit ca arhivă SpeleoLoc.",
      "archiveTooLarge": "Arhiva este mai mare decât citește această instalare dintr-o dată.",
      "recordingTooLarge": "Acea înregistrare are mai multe scanări decât cuprinde o recenzie. Nimic nu este scurtat, pentru că o listă scurtată arată exact ca una completă.",
      "recordingNotFound": "Acea înregistrare nu mai este în arhivă.",
      "recordingAlreadyConverted": "Această înregistrare a fost deja transformată într-un raport de tură, deci pozițiile ei sunt deja înregistrate.",
      "recordingNotWritable": "Această înregistrare este deja păstrată aici sub un cont ale cărui înregistrări nu le poți schimba.",
      "tripMissing": "Spune unde ajung pozițiile: pe o tură care există sau într-una creată de acest import.",
      "tripAmbiguous": "O înregistrare merge pe o tură sau într-una nouă, nu în amândouă.",
      "modelMissing": "O poziție este o stație a unui model topografic, iar niciunul nu este ales.",
      "modelUnavailable": "Acel model topografic nu există aici sau peștera lui nu poate fi plasată de acest cont.",
      "referenceUnknown": "Nu s-a putut stabili reperul de adâncime al acestei topografii.",
      "selectionEmpty": "Nicio scanare nu este luată, deci nu este nimic de înregistrat.",
      "selectionTooLarge": "Prea multe scanări pentru o singură confirmare. Lasă unele deoparte și înregistrează-le pe celelalte.",
      "nothingCreated": "Nicio scanare dintre cele alese nu a putut fi înregistrată, așa că nu s-a scris nimic. Recenzia a rămas neatinsă.",
      "keptRecordingNotFound": "Înregistrarea aceea nu mai este aici sau nu ai voie s-o citești.",
      "recordingPreviewFailed": "Această înregistrare nu a putut fi citită cu alegerile de acum.",
      "commitFailed": "Înregistrarea nu a putut fi importată.",
      "previewFailed": "Această arhivă nu a putut fi citită cu alegerile curente.",
      "uploadFailed": "Arhiva nu a putut fi încărcată."
    }
  },
  "hypsometry": {
    "caveTitle": "Galerii după altitudine",
    "areaTitle": "Intrări după altitudine",
    "loading": "Se măsoară…",
    "nothingMeasured": "Nu există trasee de măsurat.",
    "noAltitudesTitle": "Nu s-au înregistrat altitudini",
    "noAltitudesReason": "Topografia nu are a treia coordonată, deci nu există nimic de distribuit pe înălțime. O peșteră desenată în plan nu este o peșteră aflată pe un singur nivel.",
    "noEntrances": "Nicio intrare din această zonă nu are o altitudine pe care o poți localiza.",
    "axisAltitude": "Altitudine (m)",
    "axisPassageMetres": "Galerie (m)",
    "axisEntrances": "Intrări",
    "metres": "{{value}} m",
    "springLine": "Izvor",
    "from": "De la (m)",
    "to": "Până la (m)",
    "share": "Pondere",
    "noProposal": "Măsurătorile nu se separă în niveluri.",
    "notConfirmed": "Nu s-a înregistrat încă nicio citire",
    "confirm": "Înregistrează această citire",
    "clear": "Retrage citirea",
    "clearConfirm": "Retragi citirea înregistrată a nivelurilor acestei peșteri?",
    "saved": "Citirea a fost înregistrată.",
    "saveFailed": "Citirea nu a putut fi înregistrată. Reîncarcă și verifică ce este valabil.",
    "entrancesPlaced": "Intrări numărate",
    "springsSeen": "Izvoare dintre ele",
    "countedOverWhatYouMayPlace": "Numărate peste intrările pe care le poți localiza, ceea ce nu este, în mod deliberat, numărul intrărilor din această zonă.",
    "proposalIsNotAnAssertion": "Nivelurile desenate în spatele barelor sunt citite din histogramă prin calcul. Sunt o propunere despre măsurători, nu o afirmație despre peșteră.",
    "springLinesExplained": "Liniile întrerupte sunt altitudinile izvoarelor din această zonă. Un nivel tăiat la înălțimea la care apa părăsește masivul înseamnă altceva decât un nivel aflat oriunde altundeva.",
    "proposedCount": "Niveluri propuse pe baza măsurătorilor: {{count}}",
    "confirmedCount": "Niveluri în citirea înregistrată: {{count}}"
  },
  "structureComparison": {
    "caveTitle": "Galeriile față de structura cartată",
    "areaTitle": "Depresiunile față de structura cartată",
    "loading": "Se compară…",
    "passageRose": "Direcția galeriilor",
    "noPassageTrend": "Traseele acestei peșteri nu au o direcție măsurabilă.",
    "noStructureNearby": "Niciun traseu de fractură pe care îl poți localiza nu este cartat în apropiere.",
    "noStructureInArea": "Niciun traseu de fractură pe care îl poți localiza nu este cartat în această zonă.",
    "noDolines": "Niciun contur de aici nu are o aliniere utilizabilă.",
    "divergence": "Divergență",
    "meanSeparation": "Direcții medii la distanță de",
    "unitDegrees": "°",
    "noDivergence": "O parte nu conține nimic, deci nu există niciun dezacord de raportat. Zero aici ar susține un acord cu o structură pe care nimeni nu a cartat-o.",
    "divergenceScale": "Zero înseamnă că cele două se suprapun ca direcție; unu înseamnă că sunt perpendiculare, la un sfert de tură distanță.",
    "linesOnly": "Se compară doar liniile de fractură și de falie cartate. Măsurătorile de strat și de diaclază luate la o stație sunt un alt fel de înregistrare, iar această instalare nu stochează niciuna.",
    "dolineModeElsewhere": "Compararea axelor lungi ale depresiunilor cu direcțiile faliilor se face pe o zonă, pe pagina zonei respective.",
    "structureRose": "Trasee de fractură ({{count}} pe o rază de {{radius}} m)",
    "areaStructureRose": "Trasee de fractură ({{count}} în această zonă)",
    "dolineRose": "Axele lungi ale depresiunilor ({{count}} contururi)"
  },
  "overburden": {
    "title": "Roca de deasupra",
    "loading": "Se măsoară roca de deasupra…",
    "nothingMeasured": "Această peșteră nu are traseu de-a lungul căruia să se măsoare, deci nu există unde să se întrebe câtă rocă se află deasupra.",
    "noAltitudesTitle": "Traseul acestei peșteri nu conține altitudini.",
    "noAltitudesReason": "Câtă rocă se află deasupra înseamnă suprafața terenului minus altitudinea galeriei, iar o topografie înregistrată ca plan nu are altitudinea până la care să se măsoare. Un profil de zerouri ar desena întreaga peșteră întinsă la suprafață.",
    "noTerrainBuilt": "Pe această instalare nu a fost pregătit niciun model de elevație, deci înălțimea terenului de deasupra acestei peșteri nu este cunoscută nicăieri. Aceasta nu este o afirmație despre peșteră.",
    "noCoverageHere": "Există date de elevație pregătite aici, dar niciuna nu ajunge la această peșteră. Terenul de deasupra ei este necunoscut, nu la nivelul mării.",
    "axisDistance": "Distanța de-a lungul galeriei (m)",
    "axisThickness": "Rocă deasupra (m)",
    "thinnest": "Cea mai subțire",
    "thickest": "Cea mai groasă",
    "mean": "Medie",
    "passageLength": "Galerie măsurată",
    "coverage": "Citiri cu înălțimea terenului",
    "coverageValue": "{{covered}} din {{total}}",
    "unitMetres": "{{value}} m",
    "notMeasured": "—",
    "figuresScope": "Cifrele sunt calculate pe citirile care au obținut o înălțime a terenului și pe niciuna alta, deci o peșteră acoperită parțial de datele de elevație este descrisă doar pe acea parte. O grosime negativă este raportată așa cum a fost măsurată: înseamnă că modelul de elevație pune suprafața sub galerie, iar cele două nu se potrivesc.",
    "gap": {
      "outsideCoverage": "Curba se întrerupe acolo unde niciun model de elevație pregătit nu ajunge la galerie. Nimeni nu știe înălțimea terenului acolo, de aceea linia se oprește în loc să treacă peste gol.",
      "noData": "Curba se întrerupe acolo unde modelul de elevație ajunge la galerie, dar nu înregistrează nimic — o gaură în model, nu o galerie la suprafață.",
      "mixed": "Curba se întrerupe în două feluri de locuri: unde niciun model de elevație pregătit nu ajunge la galerie și unde modelul ajunge, dar nu înregistrează nimic. Niciunul nu înseamnă o galerie la suprafață."
    },
    "distanceNote": "Axa orizontală arată câtă galerie se află înaintea fiecărei citiri, în ordinea în care o înregistrează traseul. O topografie este o rețea, nu o singură parcurgere a peșterii, deci este o lungime și nu un traseu pe care l-ar putea urma cineva.",
    "pressToLocate": "Apasă un punct de pe curbă pentru a marca locul unde a fost luată citirea, pe hartă și în scena 3D.",
    "readout": "{{distance}} de-a lungul · {{thickness}} · segmentul {{segment}} al traseului",
    "readoutWhere": "{{distance}} de-a lungul galeriei",
    "readoutThickness": "{{value}} de rocă deasupra",
    "readoutSegment": "Segmentul {{index}} al traseului",
    "readoutAbsent": {
      "outsideCoverage": "Nicio dată de elevație nu ajunge aici",
      "noData": "Datele de elevație nu înregistrează nimic aici"
    },
    "markLabel": "{{value}} de rocă deasupra",
    "markLabelAbsent": "Roca de deasupra nu se cunoaște aici"
  },
  "altitudeCheck": {
    "title": "Altitudinile intrărilor față de teren",
    "areaTitle": "Altitudinile intrărilor față de teren",
    "loading": "Se compară altitudinile intrărilor cu datele de elevație…",
    "noTerrainBuilt": "Pe această instalație nu au fost pregătite date de elevație, deci altitudinile înregistrate nu pot fi comparate cu terenul. Aceasta nu spune nimic despre intrări.",
    "noEntrances": "Aici nu există intrări pe care să le poți localiza, deci nu e nimic de comparat.",
    "colEntrance": "Intrare",
    "colRecorded": "Înregistrată",
    "colModelled": "Model de elevație",
    "colDifference": "Diferență",
    "colVerdict": "Rezultat",
    "unitMetres": "{{value}} m",
    "notMeasured": "—",
    "unnamedCave": "Peșteră fără nume",
    "verdict": {
      "agrees": "Concordă",
      "disagrees": "Nu concordă",
      "notRecorded": "Altitudine neînregistrată",
      "notModelled": "Fără înălțime a terenului aici"
    },
    "disagreeing_one": "{{count}} intrare diferă de înălțimea terenului cu mai mult de {{tolerance}} m. O diferență de această mărime înseamnă de obicei că greșită e coordonata, nu altitudinea.",
    "disagreeing": "{{count}} de intrări diferă de înălțimea terenului cu mai mult de {{tolerance}} m. O diferență de această mărime înseamnă de obicei că greșită e coordonata, nu altitudinea.",
    "explained": "Diferența este altitudinea înregistrată minus înălțimea terenului dată de modelul de elevație sub intrare. O diferență de peste {{tolerance}} m este semnalată, adică mai mult decât explică eroarea modelului și poalele unui perete stâncos. Completarea preia înălțimea terenului și o scrie doar acolo unde nu e înregistrat nimic: o altitudine măsurată nu este niciodată înlocuită de model.",
    "fill": "Completează din teren",
    "filled": "Altitudinea a fost completată din modelul de elevație.",
    "fillFailed": "Altitudinea nu a putut fi completată. Poate fi deja înregistrată sau datele de elevație nu acoperă această intrare.",
    "entrancesPlaced": "Intrări comparate",
    "compared": "Cu ambele altitudini",
    "disagreeingTitle": "Care nu concordă",
    "notRecordedTitle": "Fără altitudine înregistrată",
    "truncated": "Sunt afișate cele {{count}} cu cele mai mari diferențe. Cifrele de mai sus le numără pe toate.",
    "countedOverWhatYouMayPlace": "Numărate și ordonate peste intrările pe care le poți localiza, ceea ce nu este, în mod deliberat, numărul intrărilor din această zonă."
  },
  "systemFigures": {
    "title": "Adâncime și înălțime între intrări",
    "loading": "Se măsoară pornind de la intrări…",
    "noEntrances": "Această peșteră nu are nicio intrare pe care să o poți localiza, deci nu există de unde să se măsoare.",
    "entrances": "Intrări",
    "highestEntrance": "Cea mai înaltă intrare",
    "lowestEntrance": "Cea mai joasă intrare",
    "entranceSpread": "Diferența de nivel dintre intrări",
    "totalDepth": "Adâncime sub cea mai înaltă intrare",
    "height": "Înălțime deasupra celei mai joase intrări",
    "resurgenceLevel": "Nivelul exurgenței din zonă",
    "potentialDepth": "Adâncime potențială până la nivelul exurgenței",
    "declaredPotentialDepth": "Adâncime potențială înregistrată",
    "disagreesWithRecord": "diferă de cifra calculată",
    "unitMetres": "{{value}} m",
    "notMeasured": "—",
    "noSurveyAltitudes": "Traseul nu conține altitudini, deci adâncimea și înălțimea nu pot fi măsurate din el. Un desen în plan nu este o peșteră fără adâncime.",
    "explained": "Adâncimea se măsoară de la cea mai înaltă intrare până la cel mai de jos punct atins de ridicare, iar înălțimea de la cea mai joasă intrare până la cel mai înalt punct. Nivelul exurgenței este cea mai joasă intrare a unei peșteri-izvor din zona care conține această peșteră, dintre cele pe care le poți localiza; adâncimea potențială este cea mai înaltă intrare minus acest nivel."
  },
  "depthProfile": {
    "title": "Profil de adâncime",
    "loading": "Se desenează profilul…",
    "noAltitudes": "Traseul acestei peșteri nu conține altitudini, deci nu se poate desena un profil de adâncime. Un desen în plan nu este o peșteră fără adâncime.",
    "axisDistance": "Distanța de-a lungul galeriilor (m)",
    "axisDepth": "Altitudine (m)",
    "highest": "Punctul cel mai înalt",
    "lowest": "Punctul cel mai jos",
    "deepest": "Diferența de nivel dintre ele",
    "passageLength": "Lungimea galeriilor",
    "unitMetres": "{{value}} m",
    "readout": "{{distance}} de-a lungul galeriilor: altitudine {{altitude}}, cu {{depth}} sub punctul cel mai înalt",
    "explained": "Distanța este lungimea galeriilor dinaintea fiecărui punct, în ordinea în care o înregistrează releveul, nu un traseu de la intrare, așa că o ramură care urcă din nou apare ca o creștere. Profilul nu conține nicio poziție."
  },
  "terrainProfile": {
    "tool": "Profil de relief: desenează o linie pe hartă",
    "title": "Profil de relief",
    "drawHint": "Fă clic pentru a pune punctele liniei; dublu clic pentru a termina.",
    "failed": "Profilul nu a putut fi citit.",
    "noTerrainBuilt": "Pe această instalație nu s-a construit încă niciun model de relief.",
    "noCoverage": "Datele de elevație nu acoperă această linie.",
    "length": "Lungime",
    "ascent": "Urcare",
    "descent": "Coborâre",
    "axisDistance": "Distanța pe linie (m)",
    "axisElevation": "Altitudine (m)",
    "unitMetres": "{{value}} m",
    "readout": "{{distance}} pe linie: altitudine {{elevation}}",
    "explained": "Altitudinea vine din modelul de elevație al instalației. Unde modelul nu are înălțimea terenului, linia rămâne întreruptă, nu este unită peste gol."
  },
  "terrainStats": {
    "title": "Intrări și doline față de relief",
    "chartLabel": "Ponderea intrărilor, dolinelor și a terenului zonei după {{measure}}",
    "loading": "Se citește relieful…",
    "noTerrainBuilt": "Pe această instalație nu s-a construit încă niciun model de relief.",
    "noLayer": "Pentru această măsurătoare nu a fost calculată încă nicio imagine a reliefului. Un administrator o poate calcula din pagina de relief.",
    "needsSlope": "Orientarea se numără doar pe teren înclinat, iar pentru asta e nevoie de imaginea pantei.",
    "slopeUnit": "Imaginea pantei există doar în procente; clasele sunt tăiate în grade.",
    "entrances": "Intrări",
    "sinkholes": "Doline",
    "background": "Terenul zonei",
    "class": "Clasă",
    "ratio": "Raport",
    "measure": {
      "slope": "Panta",
      "aspect": "Orientarea versantului",
      "position": "Poziția pe relief"
    },
    "classes": {
      "lt5": "sub 5°",
      "5to15": "5–15°",
      "15to30": "15–30°",
      "30to45": "30–45°",
      "gt45": "peste 45°",
      "n": "N",
      "ne": "NE",
      "e": "E",
      "se": "SE",
      "s": "S",
      "sw": "SV",
      "w": "V",
      "nw": "NV",
      "hollow": "adâncitură",
      "level": "plat",
      "rise": "ridicătură"
    },
    "counts": "{{entrances}} intrări și {{sinkholes}} doline citite, față de {{background}} puncte de teren.",
    "explained": "Raportul este ponderea intrărilor (sau a dolinelor) într-o clasă împărțită la ponderea terenului zonei în aceeași clasă: peste 1 înseamnă că peșterile se află acolo mai des decât ar sugera terenul, sub 1 mai rar. Se numără doar ce poți localiza; terenul este eșantionat într-o grilă regulată peste conturul zonei.",
    "flatNote": "Orientarea se numără doar unde panta este de cel puțin 2°."
  },
  "crossSection": {
    "title": "Dimensiunea galeriilor",
    "loading": "Se măsoară…",
    "noReadings": "Traseul acestei peșteri nu conține distanțe până la pereți. Nimeni nu a măsurat cât de lată sau de înaltă este galeria, ceea ce nu înseamnă că galeria nu are dimensiuni.",
    "stations": "Stații măsurate",
    "readings": "Citiri ale pereților",
    "width": "Lățime",
    "height": "Înălțime",
    "ratio": "Lățime pe înălțime",
    "area": "Secțiune",
    "volume": "Volumul galeriilor",
    "median": "Mediană",
    "mean": "Medie",
    "range": "de la {{min}} la {{max}}",
    "quartiles": "Jumătatea din mijloc de la {{lower}} la {{upper}}",
    "measuredOver": "din {{count}} stații",
    "notMeasured": "—",
    "volumeNotComputed": "Nu s-a calculat: nicio porțiune de galerie nu are toți cei patru pereți măsurați la ambele capete. Zero aici ar spune că peștera nu cuprinde niciun spațiu.",
    "volumeScope": "Calculat pe {{measuredLength}} din {{totalLength}} de galerie — {{measured}} din {{total}} porțiuni. O stație la care un perete nu a fost atins iese din estimare în loc să conteze ca zero, deci cifra descrie partea măsurată a peșterii și nimic mai mult.",
    "bandsTitle": "Pe înălțime",
    "bandsNote": "Fiecare felie are {{height}}. O felie în care nu a căzut nicio stație lipsește în loc să fie desenată ca galerie fără dimensiune, iar o stație al cărei traseu nu avea altitudine nu se află în niciuna.",
    "bandLabel": "de la {{from}} la {{to}}",
    "unitMetres": "{{value}} m",
    "unitSquareMetres": "{{value}} m²",
    "unitCubicMetres": "{{value}} m³",
    "ratioNote": "Peste unu înseamnă galerie mai lată decât înaltă; sub unu înseamnă canion.",
    "spreadTitle": "Distribuția dimensiunilor",
    "spreadNote": "Fiecare cutie este jumătatea din mijloc a măsurătorilor, linia din ea este mediana, iar mustățile sunt cea mai mică și cea mai mare valoare. O felie a peșterii pe care nu a măsurat-o nimeni lasă un gol, nu o cutie pe podeaua axei.",
    "bandChartTitle": "Dimensiuni pe înălțime",
    "scaling": "Cum crește înălțimea față de lățime",
    "scalingValue": "înălțimea crește ca lățimea la puterea {{exponent}}",
    "scalingFit": "pe {{count}} stații, explicând {{r2}} din împrăștiere",
    "scalingNote": "O putere apropiată de unu descrie o peșteră ale cărei galerii mari sunt copii la scară ale celor mici; sub unu se lărgește mai repede decât se înalță, peste unu se înalță mai repede. Descrie dimensiunile măsurate și nu estimează niciun debit.",
    "axisMetres": "m"
  },
  "passagePattern": {
    "title": "Ce sugerează forma",
    "loading": "Se citește forma…",
    "suggested": "Sugerat",
    "notAnAssertion": "Tiparul de mai jos este citit din măsurători de reguli ale căror praguri sunt convenții alese, nu măsurători. Este o propunere despre această topografie, nu o afirmație despre peșteră — de aceea este arătată fiecare regulă, inclusiv cele care au privit și au tăcut.",
    "rulesTitle": "Fiecare regulă și ce a făcut",
    "scoresTitle": "Cât a punctat fiecare tipar",
    "assessed": "{{fired}} din {{assessable}} reguli evaluabile s-au declanșat. {{assessable}} din {{total}} reguli au avut cifre de citit.",
    "supports": "Contribuie la",
    "weight": "Pondere",
    "figures": "A citit",
    "network": "Rețea",
    "networkFigures": "{{nodes}} locuri unde galeriile se întâlnesc sau se termină, {{loops}} bucle independente, {{ends}} funduri de sac.",
    "pattern": {
      "insufficient": "Prea puțin măsurat pentru a încerca",
      "undetermined": "Niciun tipar nu s-a detașat",
      "vadoseBranchwork": "Rețea ramificată vadoasă",
      "waterTable": "Peșteră la nivelul pânzei freatice",
      "looping": "Bucle freatice",
      "angularMaze": "Labirint unghiular"
    },
    "outcome": {
      "notAssessable": "Nimic de citit",
      "didNotFire": "Nu s-a declanșat",
      "fired": "S-a declanșat"
    },
    "rule": {
      "networkIsLooped": "Rețeaua se închide des asupra ei însăși",
      "networkIsTreeLike": "Rețeaua aproape că nu se închide asupra ei însăși",
      "networkEndsOften": "O mare parte a rețelei este acolo unde topografia s-a oprit",
      "networkRings": "Galeriile care pleacă dintr-o intersecție sunt ele însele unite",
      "bearingsAreConcentrated": "Galeria urmează puține direcții",
      "passageIsSteep": "Galeria este în medie abruptă",
      "passageIsLevel": "Galeria este orizontală și peștera câștigă puțină înălțime",
      "profileOscillates": "Galeria urcă și coboară, dar peștera rămâne în jurul unui nivel",
      "sectionIsWide": "Secțiunea este mai lată decât înaltă",
      "sectionIsTall": "Secțiunea este mai înaltă decât lată"
    },
    "figure": {
      "loopsPerNode": "Bucle pe intersecție",
      "deadEndFraction": "Funduri de sac",
      "clustering": "Inelaritatea intersecțiilor",
      "orientationEntropy": "Împrăștierea direcțiilor",
      "meanAbsoluteDip": "Panta medie",
      "maximumDip": "Cea mai abruptă urcare",
      "minimumDip": "Cea mai abruptă coborâre",
      "verticality": "Înălțime câștigată pe metru de galerie",
      "medianWidthHeightRatio": "Mediana lățimii pe înălțime"
    },
    "caveat": {
      "figuresAreApproximated": "Cifrele au fost aproximate din traseul stocat, nu preluate din marcajele proprii ale topografului, deci sugestia se sprijină pe o presupunere în locul unei măsurători.",
      "networkIsIncomplete": "Citirea fișierului topografic a pierdut vise sau a contopit stații, deci rețeaua descrisă aici este mai mică decât cea ridicată.",
      "networkCompletenessIsUnknown": "Nimic nu consemnează dacă citirea fișierului a pierdut ceva, ceea ce nu înseamnă că nu s-a pierdut nimic.",
      "noAltitudes": "Traseul nu conține altitudini, deci fiecare regulă despre profil nu a avut ce citi.",
      "noCrossSections": "Nicio stație nu a măsurat o secțiune completă, deci regulile despre forma galeriei nu au avut ce citi.",
      "noNetworkFigures": "Rețeaua de galerii nu a fost niciodată măsurată, deci regulile despre forma ei nu au avut ce citi."
    }
  },
  "imageLink": {
    "regionCount": "Părți legate din această imagine: {{count}}"
  },
  "tripStats": {
    "title": "Sinteza turelor",
    "open": "Sinteză",
    "backToList": "Înapoi la listă",
    "scopeFiltered": "Filtrul curent",
    "scopeAll": "Toate turele",
    "populationFiltered": "cele {{matching}} din {{overall}} ture pe care le poți citi rămase după acest filtru",
    "populationAll": "toate cele {{overall}} ture pe care le poți citi",
    "compareHint": "Treci pe toate turele ca să vezi aceleași grafice fără filtru, ca termen de comparație.",
    "perYear": "Ture pe an, peste {{population}}",
    "byType": "Cu ce scop, peste {{population}}",
    "byArea": "Unde s-a mers, peste {{population}}",
    "byPerson": "Cine a fost, peste {{population}}",
    "year": "An",
    "trips": "Ture",
    "areasSoFar": "Zone distincte atinse",
    "newGroundNote": "Linia arată câte zone distincte atinseseră turele numărate până la sfârșitul fiecărui an. Dacă urcă în continuare, se descoperă teren nou; dacă se aplatizează sub bare care nu se aplatizează, se revine în aceleași locuri.",
    "newWithin": "„Nou” înseamnă nou față de {{population}}, nu față de întreaga arhivă. O zonă în care ajunsese deja o tură din afara lor se numără ca nouă prima dată când ajunge acolo una dintre ele, așa că un filtru mai restrâns pornește linia din nou de la zero.",
    "overlapping": "O tură se numără la fiecare valoare pe care o conține, așa că barele adună mai mult decât cele {{count}} ture numărate.",
    "showingValues": "Se arată cele mai mari {{shown}} din {{distinct}}.",
    "empty": "Nicio tură de numărat.",
    "failed": "Totalurile nu au putut fi calculate."
  },
  "libraryPhotos": {
    "layerName": "Fototecă ({{library}})",
    "browse": {
      "title": "Fototeca",
      "noPositionShown": "Locul în care au fost făcute aceste fotografii nu este afișat aici. Harta este locul unde sunt așezate fotografiile unei fototeci.",
      "showingOf": "Se afișează {{shown}} din {{total}} fotografii pe care le are fototeca",
      "showingUnknownTotal": "Se afișează {{count}} fotografii. Această fototecă nu spune câte are.",
      "pageCapped": "Această instalare cere cel mult {{count}} fotografii odată.",
      "empty": "Această fototecă nu conține nimic care să corespundă.",
      "pastEnd": "Lista s-a terminat înainte de această pagină — fototeca a spus că ar putea exista mai multe, dar nu erau.",
      "silent": "Această fototecă nu a răspuns, așa că nu este nimic de arătat. Poate fi oprită sau încă pornește.",
      "readAt": "Citit din fototecă la {{when}}",
      "previous": "Înapoi",
      "next": "Înainte",
      "page": "Pagina {{page}}",
      "pageTooDeep": "Acea pagină este mai adânc în fototecă decât cere această instalare, așa că nu s-a cerut nimic. Întoarce-te spre prima pagină."
    },
    "search": {
      "placeholderText": "Caută în titluri, descrieri și etichete",
      "placeholderMeaning": "Descrie fotografia",
      "textOnly": "Această fototecă potrivește cuvintele tale cu titluri, descrieri și etichete scrise de cineva. Nu se uită la fotografiile propriu-zise, așa că un cuvânt pe care nu l-a scris nimeni nu găsește nimic, oricât de bine ar descrie ce se vede.",
      "byMeaning": "Această fototecă îți citește cuvintele ca pe o descriere și așază tot ce conține în ordinea apropierii fiecărei fotografii de ea. Nimic nu este potrivit exact și nimic nu este lăsat deoparte, așa că vezi ce a găsit mai apropiat — nu există un număr al celor care corespund.",
      "showing": "Se afișează {{count}} fotografii",
      "showingMore": "Se afișează {{count}} fotografii, iar fototeca spune că mai sunt și altele",
      "empty": "Nu a venit nimic pentru acele cuvinte. Este vorba despre cuvinte, nu despre fototecă, care poate conține multe.",
      "tooLong": "O căutare aici are cel mult {{count}} caractere, iar aceasta a fost mai lungă, așa că nu s-a cerut nimic fototecii.",
      "showingRanked": "Se afișează {{count}} fotografii din fruntea ordinii acestei fototeci",
      "showingRankedMore": "Se afișează {{count}} fotografii din fruntea ordinii acestei fototeci, care continuă dincolo de ele — tot ce conține fototeca se află undeva în ea, deci paginile următoare nu sunt alte potriviri.",
      "noRanking": "Această fototecă nu a pus nimic în ordine pentru acele cuvinte. O ordine are întotdeauna o frunte, deci nu este vorba despre cuvinte: fototeca nu a ordonat nimic, ceea ce se întâmplă când recunoașterea imaginilor este oprită.",
      "silentByMeaning": "Această fototecă nu a răspuns căutării. Recunoașterea imaginilor poate fi oprită, caz în care nu poate răspunde deloc cuvintelor după înțeles — sau fototeca poate fi oprită ori încă pornește.",
      "reduced": "Această fototecă citește două puncte ca numind unul dintre câmpurile ei, așa că i s-a cerut: {{words}}",
      "nothingLeft": "Nu au mai rămas cuvinte după scoaterea separatorilor de câmp, așa că nu s-a cerut nimic niciunei fototeci."
    },
    "albums": {
      "choose": "Toată fototeca",
      "loading": "Se citesc albumele acestei fototeci…",
      "none": "Această fototecă nu are albume",
      "silent": "Această fototecă nu a răspuns despre albumele ei",
      "untitled": "Album fără titlu",
      "withCount": "{{title}} — {{count}} fotografii",
      "truncated": "Aici sunt oferite doar primele {{count}} albume ale acestei fototeci.",
      "notWithASearch": "O căutare este trimisă întreagă fototecii și nu poate fi restrânsă la un album, așa că albumul ales nu este folosit. Șterge căutarea pentru a răsfoi din nou albumul.",
      "showingOf": "Se afișează {{shown}} din {{total}} fotografii pe care fototeca le pune în acest album",
      "showingUnknownTotal": "Se afișează {{count}} fotografii din acest album. Această fototecă nu spune câte pune în el.",
      "nothingIn": "Această fototecă nu pune nimic în acest album. Fototeca a răspuns; poate avea multe în altă parte.",
      "notFound": "Aceea nu este o valoare pe care această instalare o cere unei fototeci ca album, așa că nu s-a cerut nimic."
    },
    "trip": {
      "title": "Fotografii din fototecă",
      "explains": "Fotografii pe care o fototecă conectată le are din zilele în care a avut loc această tură. Ele provin din acea fototecă și nimic de aici nu a fost atribuit turei. Zilele despre care se întreabă depășesc cu cel puțin o zi fiecare capăt al turei, pentru că datele unei ture nu au fus orar, iar ceasul unui aparat foto are — așa că pot apărea fotografii din ziua dinainte sau de după, fiecare cu data ei afișată.",
      "showingOf": "Se afișează {{shown}} din {{total}} fotografii pe care le are fototeca din aceste zile",
      "showingUnknownTotal": "Se afișează {{count}} fotografii din aceste zile. Această fototecă nu spune câte are.",
      "nothingTaken": "Această fototecă nu are nimic făcut în timpul acestei ture. Fototeca a răspuns; poate avea multe din alte zile.",
      "notFound": "Această tură nu a putut fi citită, așa că nu s-a cerut nimic niciunei fototeci despre ea.",
      "datesUnusable": "Datele acestei ture nu dau un interval de timp despre care să fie întrebată o fototecă, așa că nu s-a cerut nimic. Verifică ziua în care a început și ziua în care s-a terminat."
    },
    "detail": {
      "title": "Fotografie",
      "takenAt": "Făcută",
      "camera": "Aparat foto",
      "lens": "Obiectiv",
      "aperture": "Diafragmă",
      "exposure": "Timp de expunere",
      "iso": "ISO",
      "focalLength": "Distanță focală",
      "library": "Fototecă",
      "isVideo": "Acesta este un material video. Aici se vede doar un cadru din el.",
      "gone": "Această fototecă nu mai raportează fotografia respectivă. Lista a fost citită cu puțin timp în urmă, iar fototeca s-a schimbat de atunci.",
      "silent": "Această fototecă nu a răspuns despre fotografia respectivă."
    },
    "source": {
      "immich": "Immich",
      "photoprism": "PhotoPrism"
    },
    "loading": "Se citește fototeca…",
    "count": "{{count}} fotografii afișate",
    "empty": "Fototeca nu are fotografii în această zonă.",
    "unavailable": "Fototeca nu a răspuns. Fotografiile afișate sunt ultimele poziții citite din ea.",
    "truncated": "Se afișează doar primele {{count}} fotografii din această zonă — apropie harta pentru a le vedea pe celelalte.",
    "readAt": "Poziții citite {{when}}",
    "notConfigured": "Nicio fototecă nu este conectată la această instalare.",
    "takenAt": "Fotografiată {{when}}",
    "noTitle": "Fără titlu",
    "video": "Videoclip",
    "thumbnailFailed": "Fotografia nu a putut fi încărcată.",
    "asPictures": "Arată fotografiile propriu-zise",
    "picturesSuppressed": "Prea multe fotografii aici pentru a fi arătate ca imagini — apropie harta.",
    "createFeature": "Creează un obiect aici",
    "createTitle": "Creează un obiect din această fotografie",
    "createHint": "Poziția vine din fotografia însăși, citită din fototeca ce o deține. Restul se poate modifica ulterior.",
    "kind": "Ce este?",
    "kindCave": "Peșteră",
    "kindEntrance": "Intrare de peșteră",
    "kindOther": "Alt tip",
    "featureType": "Tip",
    "cave": "Peștera de care aparține",
    "name": "Nume",
    "created": "{{name}} a fost creat la poziția înregistrată de această fotografie.",
    "openCreated": "Deschide-l",
    "nearbyTitle": "Există deja ceva înregistrat în apropiere",
    "nearbyHint": "Verifică să nu fie același loc înregistrat a doua oară.",
    "nearbyItem": "{{name}} — la {{distance}} m",
    "refusals": {
      "photographGone": "Fototeca nu mai raportează această fotografie în zona de pe ecran, așa că nu s-a creat nimic. Reîmprospătează harta și pornește din nou de la fotografie.",
      "answerTruncated": "Sunt aici mai multe fotografii decât răspunde fototeca deodată, iar aceasta nu a fost în răspunsul ei. Apropie harta și încearcă din nou.",
      "caveGone": "Peștera nu mai există sau nu o poți vedea.",
      "caveForbidden": "Nu poți adăuga o intrare la această peșteră.",
      "typeUnknown": "Această instalare nu are un tip cu care să creeze acest obiect.",
      "positionInvalid": "Fototeca a raportat o poziție care nu este un loc de pe Pământ, așa că nu s-a creat nimic.",
      "notAllowed": "Nu ai acces la fototecile acestei instalări.",
      "createForbidden": "Nu poți crea obiecte aici.",
      "propertiesRefused": "Acest tip nu poate păstra cele două linii care spun din ce fototecă vine poziția, așa că nu s-a creat nimic.",
      "needsContainer": "Acest tip trebuie să stea în interiorul altui obiect, lucru pe care acest dialog nu îl cere. Creează-l din hartă.",
      "librarySilent": "Fototeca nu a răspuns, așa că nu s-a creat nimic. Poate fi ocupată sau încă pornește — încearcă din nou peste puțin timp."
    },
    "health": {
      "notAnswering": "Fototeca este configurată, dar nu a răspuns. Verifică dacă rulează și dacă adresa este corectă.",
      "credentialRefused": "Fototeca nu a acceptat credențialul cu care este configurată această instalare. Emite unul nou în fototecă și setează-l aici.",
      "missingPermissions": "Credențialului folosit de această instalare îi lipsesc: {{permissions}}. Adaugă-i-le în setările fototecii.",
      "unreadable": "Fototeca a răspuns, dar într-un fel pe care această instalare nu l-a putut citi.",
      "partlyAnswering": "Fototeca a răspuns, dar una dintre întrebările pe care i le pune această instalare nu a primit răspuns. Poate fi ocupată sau încă pornește.",
      "picturesStopped": "Fotografiile din această fototecă nu mai sunt cerute: a răspuns unei cereri de imagine fără imagine, ceea ce poate însemna că nu mai ajunge la originalele ei.",
      "versionChecked": "Versiunea {{version}} · verificat {{when}}",
      "checked": "Verificat {{when}}",
      "recheckFailed": "Fototeca tot nu a răspuns, așa că nimic nu s-a schimbat.",
      "recheckRefused": "Fototeca a răspuns și nu a acceptat credențialul cu care este configurată această instalare, așa că nimic nu s-a schimbat.",
      "suspended": "Această instalare nu folosește deocamdată această fototecă. Ea rulează în continuare și este accesibilă la adresa ei."
    },
    "notConnected": "{{library}} nu este conectată: această instalare nu are adresă sau credențial pentru ea.",
    "recheck": "Verifică din nou",
    "admin": {
      "suspend": "Oprește folosirea acestei fototeci",
      "suspendHint": "Cât timp este pornit, nimic de aici nu întreabă fototeca nimic: fără strat pe hartă, fără răsfoire, fără căutare și fără fotografii.",
      "stillHoldsEverything": "Oprirea folosirii ei de către SilexGIS nu schimbă nimic din ce conține, ce indexează sau cine se poate autentifica direct în ea.",
      "stopCommand": "Pentru a opri fototeca însăși, folosește implementarea: {{command}}",
      "cannotConnect": "{{library}} nu este conectată: această instalare nu are adresă sau credențial pentru ea. Conectarea ei ține de implementare și nu se poate face din această pagină.",
      "none": "Această instalare nu a primit nicio fototecă, deci nu este nimic de oprit."
    }
  },
  "karstlinkExport": {
    "menuItem": "KarstLink (JSON-LD)",
    "notInWindow": "Nu cât timp lista este restrânsă la fereastra hărții — elimină fereastra pentru a exporta toată lista filtrată.",
    "changeAnswer": "KarstLink (JSON-LD) — schimbă răspunsul meu…",
    "title": "Export de peșteri pentru schimb de date",
    "intro": "Peșteri descrise în vocabularul publicat pentru peșteri și carst, ca fișier pe care îl poți da altcuiva. Un fișier trăiește mai mult decât permisiunea care l-a produs, așa că ce spune despre o locație protejată se decide aici și se scrie chiar în fișier.",
    "download": "Exportă",
    "caveCount": "{{count}} peșteră/peșteri în acest export.",
    "protectedCount": "Dintre acestea, {{count}} au o locație pe care această instalare o protejează. Răspunsul de mai jos li se aplică tuturor.",
    "noneProtected": "Niciuna dintre ele nu are o locație protejată de această instalare, deci nimic de mai jos nu schimbă acest fișier.",
    "tooMany": "Această selecție conține {{count}} peșteră/peșteri, iar un fișier poate conține {{limit}}. Restrânge filtrele și exportă pe părți — un fișier oprit la o limită arată exact ca unul complet pentru cine îl primește.",
    "remember": "Ține minte acest răspuns și nu mă mai întreba",
    "askAgain": "Exportul nu a putut fi făcut cu răspunsul memorat. Alege din nou.",
    "treatments": {
      "grid_position": {
        "label": "Așază-le pe grila de protecție",
        "help": "Aceeași poziție aproximativă pe care harta o arată deja oricui nu are dreptul să vadă poziția exactă. Fișierul spune, lângă fiecare, cât de departe poate fi de locul real."
      },
      "no_position": {
        "label": "Include-le fără coordonate",
        "help": "Tot restul despre peșteră — numele, codul, lungimea și adâncimea — și nimic despre unde se află."
      },
      "omit": {
        "label": "Lasă-le complet în afara fișierului",
        "help": "Fișierul declară câte peșteri au fost lăsate afară, altfel numărătorile făcute pe el ar contrazice registrul, iar destinatarul nu ar avea cum să afle."
      }
    },
    "errors": {
      "tooManyCaves": "Un fișier poate conține {{count}} peșteri. Restrânge filtrele și exportă pe părți."
    }
  },
  "externalIds": {
    "title": "Identificatori în alte registre",
    "explanation": "Numărul sub care un alt registru cunoaște această peșteră. Este singurul mod stabil de a spune că o peșteră de aici și una de acolo sunt aceeași: numele nu sunt stabile, iar poziția este exact ceea ce nu poate fi împărtășit. Se păstrează doar numărul — nimic altceva din ce spune registrul nu este copiat aici, așa că nimic de aici nu poate rămâne în urmă părând totuși de încredere.",
    "placeholder": "Neînregistrat",
    "lookup": "Caută această peșteră în Grottocenter",
    "lookupFailed": "Grottocenter nu a putut fi întrebat.",
    "notConfigured": "Această instalare nu caută peșteri în Grottocenter. Un administrator activează integrarea înainte de a putea fi folosită; până atunci nu se trimite nimic nicăieri.",
    "noCandidates": "Grottocenter nu a oferit nimic pentru acest nume.",
    "accept": "Înregistrează-l pe acesta",
    "systems": {
      "grottocenter": "Grottocenter",
      "national_cadastre": "Cadastru național"
    }
  },
  "rastermap": {
    "tab3d": "3D",
    "untitledMap": "Hartă fără titlu",
    "imageMissing": "Imaginea hărții nu poate fi afișată.",
    "supersededPoints": "Puncte plasate pe o scanare mai veche a acestei hărți: {{count}}",
    "addMap": "Adaugă hartă",
    "declareTitle": "Adaugă o hartă a acestui model",
    "editMapTitle": "Setările hărții — {{title}}",
    "mapDocument": "Documentul cu imaginea hărții",
    "notAnImage": "Fișierul curent al documentului ales nu este o imagine, deci nu poate fi afișat ca hartă.",
    "viewKind": "Vedere",
    "viewKinds": {
      "plan": "Plan",
      "profile": "Profil",
      "other": "Altă vedere"
    },
    "undeclare": "Elimină harta de pe acest model",
    "undeclareConfirm": "Elimini această hartă de pe model?",
    "undeclareHint": "Se elimină doar declararea: documentul rămâne, iar punctele de stație rămân pe legăturile lor.",
    "mapDeclared": "Hartă adăugată.",
    "mapRemoved": "Hartă eliminată.",
    "definePoints": "Definește puncte",
    "doneDefining": "Gata",
    "mapSettings": "Setările hărții",
    "armedStation": "Se plasează {{station}} — apasă punctul ei pe hartă",
    "armHint": "Apasă o stație în vederea 3D sau caut-o după nume",
    "stationPlaceholder": "Numele stației…",
    "pickSingleStation": "Alege o singură stație — o topografie sau o vizată nu poate fi un punct.",
    "alreadyPinned": "{{station}} are deja un punct pe această hartă",
    "moveHere": "Mută-l aici",
    "pinTitle": "Punctul {{station}}",
    "movePin": "Mută",
    "deletePin": "Șterge",
    "cannotEditPin": "Nu poți corecta acest punct — aparține unei legături pe care nu o poți edita.",
    "replacePin": "Replasează",
    "pinSaved": "Punct salvat pentru {{station}}.",
    "pinDeleted": "Punct șters."
  },
  "placeMap": {
    "openAsMap": "Deschide ca hartă",
    "title": "{{title}} — hartă",
    "untitled": "Hartă",
    "earlierPicture_one": "{{count}} punct a fost măsurat pe o imagine anterioară.",
    "earlierPicture": "{{count}} de puncte au fost măsurate pe o imagine anterioară.",
    "notOnPicture_one": "{{count}} punct nu este pe această imagine.",
    "notOnPicture": "{{count}} de puncte nu sunt pe această imagine.",
    "addPoint": "Adaugă un punct",
    "addHint": "Fă clic pe hartă acolo unde este locul.",
    "moveHint": "Fă clic pe hartă acolo unde trebuie să fie {{place}}.",
    "stopPlacing": "Oprește",
    "pickPlaceTitle": "Ce loc este aici?",
    "pickPlace": "Loc",
    "move": "Mută",
    "delete": "Șterge",
    "deleteConfirm": "Ștergi acest punct de pe hartă? Telefoanele care au harta vor fi anunțate.",
    "saved": "Punct salvat.",
    "deleted": "Punct șters.",
    "cannotEdit": "Nu poți modifica punctele acestei hărți.",
    "unnamedPlace": "Loc fără nume"
  },
  "publishedTrips": {
    "title": "Ture publicate",
    "intro": "Toate linkurile de urmărire date de această instalare și ce deschide fiecare pentru cine îl are. Un link rămâne în listă și după ce a fost retras, cât timp tura lui există.",
    "asOf": "Stările sunt cele de la {{when}}.",
    "refresh": "Reîncarcă",
    "namesShown": "Paginile publicate de această instalare arată numele reale ale echipei.",
    "namesHidden": "Paginile publicate de această instalare arată locuri în echipă, nu numele oamenilor.",
    "archiveOff": "Turele trecute sunt oprite aici, așa că niciun link nu este în arhivă: după ce pagina proprie a unei ture s-a închis, linkul ei nu mai deschide nimic.",
    "settings": {
      "title": "Pe ce se sprijină aceste stări în această instalare",
      "lifetime": "Un link expiră singur după ultima zi a turei lui, orice s-ar întâmpla cu urmărirea (data din coloana „Expiră la”) — {{span}}",
      "grace": "„Abia încheiată” ține atât după încheierea urmăririi și niciodată peste data la care expiră linkul — {{span}}",
      "graceNone": "„Abia încheiată” nu se folosește aici: linkul nu mai deschide pagina din clipa în care urmărirea este încheiată.",
      "retention": "„În arhivă” ține atât după ultima zi a unei ture — {{span}}",
      "retentionUnlimited": "„În arhivă” nu are aici limită de timp.",
      "siblings": "Un link vechi mai arată echipele urmărite acum în peștera lui atât timp după ultima zi a turei lui — {{span}}",
      "siblingsUnlimited": "Un link vechi arată în continuare echipele urmărite acum în peștera lui, fără limită de timp.",
      "siblingsNone": "Un link vechi nu mai arată echipele urmărite acum în peștera lui de îndată ce tura lui s-a terminat și pagina ei s-a încheiat.",
      "siblingsWhileArchived": "Un link vechi arată în continuare echipele urmărite acum în peștera lui cât timp tura lui rămâne în arhivă (rândul de mai sus).",
      "siblingsWithinArchive": "Un link vechi mai arată echipele urmărite acum în peștera lui atât timp după ultima zi a turei lui, și niciodată după ce tura lui a ieșit din arhivă — {{span}}",
      "siblingsArchiveOff": "Un link vechi nu arată aici nicio echipă: cu turele trecute oprite, un link a cărui pagină proprie s-a încheiat nu mai deschide nimic.",
      "readLimit": "Cereri pe minut pe care o adresă le poate face către paginile publicate, înainte de a i se spune să aștepte: {{limit}}",
      "span": {
        "days": "zile: {{amount}}",
        "hours": "ore: {{amount}}",
        "minutes": "minute: {{amount}}",
        "seconds": "secunde: {{amount}}"
      }
    },
    "anyStatus": "Orice stare",
    "empty": "Pe această instalare nu a fost publicat nimic.",
    "emptyFiltered": "Niciun link nu are această stare.",
    "emptyLongRunning": "Nicio tură publicată nu are urmărirea pornită de atât timp.",
    "emptyBoth": "Niciun link nu are această stare și urmărirea pornită de atât timp.",
    "seenFrom": "Această cerere a ajuns la server de la:",
    "seenFromExplain": "Dacă este adresa ta, setările pentru proxy sunt corecte. Dacă este adresa unui reverse proxy aflat în fața acestei instalări — unul care adaugă el însuși adresa fiecărui apelant în X-Forwarded-For — numărul declarat de proxy-uri este prea mic: toți cititorii din spatele acelui proxy sunt numărați ca unul singur și împart același buget de cereri, așa că paginile publicate încep să refuze cititori când este aglomerat. Ghidul de instalare arată cum se setează SILEXGIS__Proxy__Hops. Dacă este în schimb un gateway care doar transmite conexiunile mai departe și nu scrie acest antet (de exemplu adresa de gateway a unei rețele Docker), nu mări numărul: nicio valoare nu rezolvă asta, iar numărarea lui ar permite unui apelant să își aleagă adresa sub care este numărat.",
    "seenFromUnknown": "Serverul nu a putut stabili de la ce adresă a venit această cerere.",
    "longRunning": {
      "label": "Urmărire pornită de mai mult de (zile)",
      "any": "Oricât"
    },
    "watch": {
      "running": "Zile de la pornire: {{days}}",
      "runningLapsed": "Urmărirea este încă pornită, dar acest link a expirat.",
      "closed": "Încheiată la {{when}}",
      "open": "Fila Urmărire",
      "unknown": "Neînregistrat"
    },
    "unavailable": "Lista linkurilor publicate nu a putut fi citită.",
    "failed": "Operația nu a putut fi dusă la capăt. Reîncarcă lista ca să vezi ce linkuri mai sunt active.",
    "irreversible": "Această operație nu poate fi anulată.",
    "noCave": "Fără peșteră",
    "unnamedCave": "Peșteră fără nume",
    "unknownPublisher": "Cont care nu mai este afișat",
    "revokedAt": "Retras la {{when}}",
    "statuses": {
      "followable": "Urmărire în curs",
      "inGrace": "Abia încheiată",
      "inArchive": "În arhivă",
      "withheld": "Reținut",
      "lapsed": "Nu deschide nimic",
      "revoked": "Retras"
    },
    "statusHelp": {
      "followable": "Urmărirea este pornită, iar linkul arată echipa așa cum este raportată.",
      "inGrace": "Urmărirea a fost încheiată. Pentru scurt timp linkul mai deschide pagina, care spune că toată lumea a ieșit.",
      "inArchive": "Tura s-a terminat. Linkul o deschide, împreună cu celelalte ture încheiate ale peșterii, ca istoric.",
      "withheld": "Linkul ar deschide ceva dacă nu ar fi peștera: urmărirea și-a pierdut peștera sau poziția peșterii este acum protejată. Răspunde ca un link necunoscut cât timp ține această situație, nu mai mult.",
      "lapsed": "Nimeni nu a retras linkul și totuși nu deschide nimic: a expirat, urmărirea lui a fost oprită sau arhiva nu mai acoperă tura.",
      "revoked": "Cineva a retras linkul. Nu deschide nimic și nu va mai deschide niciodată."
    },
    "columns": {
      "status": "Stare",
      "trip": "Tură",
      "tripDate": "Data turei",
      "cave": "Peșteră",
      "publishedBy": "Publicat de",
      "createdAt": "Publicat la",
      "expiresAt": "Expiră la",
      "watchArmedAt": "Urmărire pornită la",
      "watchArmedAtHelp": "Când a fost pornită ultima dată urmărirea acestei ture. Urmărirea nu este încheiată decât de un om, așa că una pornită de mult mai mult timp decât a durat tura a fost, cel mai probabil, uitată: echipa rămâne pe pagina publicată ca fiind încă în peșteră sau, după ce linkul a expirat, nu mai este în nicio listă publică. Încheie-o din fila Urmărire a turei.",
      "handle": "Cod în jurnal",
      "handleHelp": "Codul scurt pe care jurnalul de cereri îl scrie în locul adresei unui link, ca o linie din jurnal să poată fi potrivită cu un rând de aici. Nu deschide nimic."
    },
    "refused": {
      "title": "Doar pentru administratorii deplini",
      "text": "Această pagină arată toate turele publicate ale instalării, peste regulile de acces ale fiecărei ture, și le poate retrage pe toate. Este deschisă administratorilor deplini și nimănui altcuiva."
    },
    "bounds": {
      "tag": "Peșteră protejată în apropiere?",
      "title": "O peșteră protejată se află în zona unei topografii publicate",
      "explain": "Poziția unei peșteri protejate, alta decât cea a turei, sau a uneia dintre intrările ei, cade în dreptunghiul acoperit de stațiile topografiei pe care o predă acest link. Verificarea se face doar după poziție și nu poate vedea în interiorul fișierului: se poate ca topografia să nu intre deloc în acea peșteră, iar una care intră poate trece nemarcată. Nimic nu a fost refuzat — deschide topografia și judecă dacă linkul trebuie să rămână."
    },
    "actions": {
      "replace": "Înlocuiește linkul",
      "unpublishTrip": "Retrage publicarea turei",
      "unpublishEverything": "Retrage tot ce este publicat"
    },
    "replace": {
      "title": "Înlocuiești acest link?",
      "stops": "Adresa veche nu mai răspunde din acest moment. Oriunde a fost lipită — un mesaj, un articol, un bloc de site — nu mai deschide nimic.",
      "keeps": "O adresă nouă este arătată aici, o singură dată. Expiră atunci când ar fi expirat cea veche, tura rămâne în lista de ture trecute a peșterii și nimeni din tură nu este anunțat."
    },
    "replaced": {
      "title": "Adresa nouă este gata",
      "once": "Copiaz-o acum — este singurul moment în care este arătată. Adresa veche nu mai răspunde.",
      "expires": "Expiră la {{when}}, la fel ca cea veche.",
      "done": "Am copiat-o"
    },
    "trip": {
      "title": "Retragi publicarea acestei ture?",
      "stops": "Toate linkurile de urmărire ale acestei ture sunt retrase pe loc. Oricine are unul nu va mai putea deschide pagina.",
      "leavesHistory": "Tura iese și din lista publică de ture trecute a peșterii ei. O tură încheiată se publică din nou doar pornindu-i iar urmărirea.",
      "done": "Linkuri retrase: {{links}}"
    },
    "everything": {
      "title": "Retragi tot ce este publicat?",
      "stops": "Toate linkurile de urmărire ale acestei instalări sunt retrase pe loc — toate turele, toate peșterile. Linkuri încă active în această listă: {{links}}. Toate paginile publicate încetează să răspundă, pe această instalare și pe orice site care arată una.",
      "deletedToo": "Sunt retrase și linkurile turelor șterse. O tură ștearsă poate fi restaurată, iar linkurile ei ar răspunde din nou odată cu ea, așa că sunt retrase acum; această listă nu le arată. De aceea numărul de linkuri retrase poate fi mai mare decât cel de mai sus.",
      "leavesHistory": "Lista publică de ture trecute a fiecărei peșteri se golește. O tură încheiată se publică din nou doar pornindu-i iar urmărirea, tură cu tură.",
      "typeWord": "Ca să continui, scrie {{word}} mai jos.",
      "word": "RETRAGE",
      "done": "Linkuri retrase: {{links}} · Ture: {{trips}}",
      "doneMoreThanListed": "Linkuri retrase: {{links}} · Ture: {{trips}} · Linkuri arătate de această listă: {{listed}}. Sunt retrase și linkurile turelor șterse, pe care lista nu le arată."
    }
  },
  "shortcuts": {
    "title": "Scurtături de tastatură",
    "open": "Scurtături de tastatură (?)",
    "keys": "Taste",
    "does": "Acțiune",
    "context": {
      "screen": "Pe acest ecran",
      "map": "Când harta are focusul",
      "panelHandle": "Când mânerul unei secțiuni de panou are focusul",
      "scene3dCallout": "În fișa selecției din scena 3D",
      "lightbox": "În vizualizatorul de fotografii",
      "passage": "Pe un pasaj marcat dintr-un text"
    },
    "action": {
      "help": "Afișează lista scurtăturilor",
      "clearSelection": "Golește selecția",
      "toggleLeftDock": "Arată sau ascunde panoul din stânga",
      "toggleRightDock": "Arată sau ascunde panoul din dreapta",
      "selectionBack": "Selecția anterioară",
      "selectionForward": "Selecția următoare",
      "pan": "Mută harta",
      "zoomIn": "Mărește",
      "zoomOut": "Micșorează",
      "moveSectionUp": "Mută secțiunea mai sus",
      "moveSectionDown": "Mută secțiunea mai jos",
      "dismissCallout": "Închide fișa",
      "closeViewer": "Închide vizualizatorul",
      "previousPhoto": "Fotografia anterioară",
      "nextPhoto": "Fotografia următoare",
      "zoomInPhoto": "Mărește fotografia",
      "zoomOutPhoto": "Micșorează fotografia",
      "resetPhoto": "Înapoi la fotografia întreagă",
      "followPassage": "Urmează legătura",
      "contextMenu": "Deschide meniul hărții în mijlocul vederii"
    },
    "keyCap": {
      "ctrl": "Ctrl",
      "command": "⌘ Cmd",
      "alt": "Alt",
      "option": "⌥ Option",
      "shift": "Shift",
      "escape": "Esc",
      "enter": "Enter",
      "space": "Spațiu",
      "menu": "Meniu"
    }
  },
  "a11y": {
    "skipToMain": "Sari la conținutul principal",
    "skipToMap": "Sari la hartă",
    "mainNav": "Navigația principală",
    "mapScale": "Scara hărții",
    "viewName": "Numele vederii de salvat",
    "shareView": "Partajează vederea {{name}}",
    "deleteView": "Șterge vederea {{name}}",
    "map": "Hartă. Săgețile o mută, plus și minus schimbă scara; apasă ? pentru toate scurtăturile.",
    "editEntrance": "Editează intrarea {{name}}",
    "deleteEntrance": "Șterge intrarea {{name}}",
    "layerTransparency": "Transparența stratului {{name}}",
    "previousPage": "Pagina anterioară",
    "nextPage": "Pagina următoare",
    "previousPages": "Cinci pagini înapoi",
    "nextPages": "Cinci pagini înainte",
    "dateFrom": "De la data",
    "dateTo": "Până la data",
    "baseLayerChooser": "Schimbă stratul de bază",
    "search": "Caută"
  },
  "mapFilter": {
    "unreadableLink": "Filtrul din acest link nu a putut fi citit, așa că harta arată tot ce poți vedea. Cere celui care l-a trimis un link nou.",
    "refused": "Filtrul hărții nu poate fi rulat cu drepturile tale — poate a fost șters sau modificat. Straturile sale nu arată nimic până nu îl golești.",
    "active": "Hartă filtrată după {{name}}",
    "activeUnnamed": "Hartă filtrată după un filtru dintr-un link sau dintr-o vedere salvată",
    "savedUnavailable": "un filtru salvat pe care nu îl poți deschide",
    "clear": "Golește filtrul hărții",
    "edit": "Condiții…",
    "editTitle": "Condițiile hărții",
    "applySaved": "Aplică un filtru salvat…",
    "noSaved": "Încă nu există filtre salvate",
    "saveAs": "Salvează ca filtru…",
    "saveTitle": "Salvează aceste condiții ca filtru",
    "saved": "„{{name}}” a fost salvat — harta îl urmează acum",
    "drawHint": "Apasă pentru a pune colțurile, dublu clic pentru a termina. Apasă Escape pentru a renunța."
  },
  "worldFilter": {
    "advanced": "Condiții…",
    "geofileTitle": "Condiții pentru fișierele geodata",
    "rasterTitle": "Condiții pentru hărțile georeferențiate",
    "on": "active",
    "applySaved": "Aplică un filtru salvat…",
    "noSaved": "Încă nu există filtre salvate",
    "saveAs": "Salvează ca filtru…",
    "manage": "Filtre salvate",
    "forget": "Nu mai numi acest filtru salvat",
    "active": "Filtru salvat: {{name}}",
    "activeUnavailable": "Filtrul salvat nu îți este disponibil",
    "changed": "modificat între timp",
    "saveTitle": "Salvează aceste condiții ca filtru",
    "saved": "Salvat ca „{{name}}”.",
    "savedUnreadable": "Acel filtru salvat nu poate fi citit cu accesul tău, așa că nu a fost aplicat.",
    "savedNotAboutThis": "Acel filtru salvat nu se referă la acest fel de listă.",
    "unreadableLink": "Condițiile din acest link nu au putut fi citite, așa că au fost lăsate deoparte. Cere-i celui care l-a trimis un link nou.",
    "refused": "Aceste condiții nu au putut fi aplicate. Modifică-le sau nu mai numi filtrul salvat."
  },
  "quickFilters": {
    "label": "Filtre salvate fixate",
    "none": "Niciun filtru fixat — fixează unul din Filtre salvate",
    "gone": "Un filtru fixat care nu mai există",
    "unreadable": "{{name}} (nu poate fi rulat)",
    "unpin": "Scoate fixarea pentru {{name}}",
    "pin": "Fixează ca filtru rapid",
    "unpinRow": "Scoate din filtrele rapide",
    "full": "Sunt deja fixate {{count}} filtre — scoate unul ca să fixezi altul"
  },
  "filterLayers": {
    "add": "Adaugă un strat dintr-un filtru salvat…",
    "full": "Harta ține cel mult {{count}} straturi din filtre — elimină unul ca să adaugi altul",
    "noneToAdd": "Niciun filtru salvat de adăugat — salvează mai întâi unul din registrul peșterilor",
    "unavailableName": "Un filtru salvat pe care nu îl poți deschide",
    "unreadable": "Ilizibil",
    "unreadableHint": "Filtrul a fost șters, nu mai este partajat cu tine sau nu mai poate fi rulat. Stratul nu desenează nimic până îl elimini.",
    "changeColor": "Culoarea stratului {{name}}: {{color}}. Schimbă culoarea",
    "changeSymbol": "Simbolul stratului {{name}}: {{symbol}}. Schimbă simbolul",
    "remove": "Elimină stratul {{name}}",
    "colors": {
      "violet": "violet",
      "magenta": "magenta",
      "indigo": "indigo",
      "green": "verde",
      "gold": "auriu",
      "slate": "gri ardezie"
    },
    "symbols": {
      "circle": "cerc",
      "square": "pătrat",
      "triangle": "triunghi",
      "diamond": "romb"
    }
  },
  "coordinates": {
    "formats": {
      "dd": "Grade zecimale",
      "ddm": "Grade, minute zecimale",
      "dms": "Grade, minute, secunde",
      "utm": "UTM, cu zonă",
      "mgrs": "MGRS (caroiaj militar)",
      "stereo70": "Stereo 70 (România)",
      "lv95": "Caroiajul elvețian LV95",
      "lv03": "Caroiajul elvețian LV03 (vechi)",
      "pluscode": "Plus Code"
    },
    "settingLabels": {
      "decimals": "Zecimale",
      "style": "Scrise",
      "minutesDecimals": "Zecimale la minute",
      "secondsDecimals": "Zecimale la secunde",
      "zone": "Zonă",
      "precisionMetres": "Precizie",
      "spacing": "Spațiere",
      "axes": "Axe",
      "length": "Lungimea codului"
    },
    "choices": {
      "style": {
        "letters": "Cu N, S, E, W",
        "signed": "Cu semn, latitudinea întâi"
      },
      "zone": {
        "auto": "Fiecare poziție în zona ei",
        "forced": "Mereu zona {{zone}}"
      },
      "metres": "{{value}} m",
      "kilometres": "{{value}} km",
      "spacing": {
        "spaced": "Cu spații",
        "compact": "Fără spații"
      },
      "axes": {
        "en": "E … N …",
        "xy": "X (nord) … Y (est) …"
      },
      "length": {
        "8": "8 — circa 275 m",
        "10": "10 — circa 14 m",
        "11": "11 — circa 3,5 m",
        "12": "12 — circa 1 m",
        "13": "13 — circa 25 cm"
      },
      "places": "{{count}} zecimale"
    },
    "settings": {
      "title": "Coordonate",
      "intro": "Cum sunt scrise pozițiile oriunde sunt afișate sau copiate și în ce alte formate este listată o poziție afișată în detaliu. Aceste setări îți urmează contul.",
      "shownAs": "Coordonate afișate ca",
      "listed": "Listate și la „Alte formate”",
      "listedHint": "O poziție afișată în detaliu — o intrare selectată, intrările unei peșteri — poate fi deschisă și în aceste formate, fiecare cu butonul ei de copiere. Un format care nu are referință pentru o poziție (un caroiaj național în afara țării lui) este omis acolo.",
      "perFormat": "Setările fiecărui format",
      "sample": "Punct de exemplu: vârful Moldoveanu",
      "notAvailable": "Nu este disponibil aici",
      "reading": {
        "title": "Citirea pozițiilor pe care le tastezi sau le lipești",
        "intro": "Cum este citită o poziție când textul însuși nu o spune: două numere fără litere de emisferă și o referință UTM fără literă. Un text care o spune — o literă, un număr peste 90 — este citit mereu așa cum e scris. Aceste setări îți urmează contul.",
        "pairOrder": "Două numere fără litere",
        "pairOrderValues": {
          "latLon": "Întâi latitudinea, apoi longitudinea (45.53, 25.44)",
          "lonLat": "Întâi longitudinea, apoi latitudinea (25.44, 45.53)"
        },
        "bareUtmHemisphere": "O referință UTM fără literă",
        "bareUtmHemisphereValues": {
          "north": "Emisfera nordică",
          "south": "Emisfera sudică"
        }
      },
      "notes": {
        "utm": "O zonă aleasă aici este păstrată pentru pozițiile de lângă marginea ei, ca o echipă care lucrează peste margine să citească un singur caroiaj; departe de zonă se folosește zona proprie a poziției.",
        "stereo70": "Convertit din WGS84 cu transformarea uzuală în șapte parametri: precisă la câțiva metri, potrivită pentru a găsi o peșteră, nu pentru o topografie. Oferit doar în România.",
        "lv95": "Precis la circa un metru. Oferit doar în Elveția și Liechtenstein.",
        "lv03": "Precis la circa un metru. Oferit doar în Elveția și Liechtenstein.",
        "mgrs": "O poziție protejată este numită mereu prin pătratul ei de 10 km.",
        "pluscode": "Doar coduri globale: un cod scurt are nevoie de un oraș apropiat pentru a fi citit înapoi."
      }
    },
    "others": {
      "show": "Alte formate",
      "hide": "Ascunde celelalte formate",
      "approximate": "Poziție aproximativă: fiecare format este scris nu mai fin decât caroiajul de protecție.",
      "openConverter": "Deschide în convertorul de coordonate"
    },
    "input": {
      "label": "Scrie sau lipește o poziție",
      "placeholder": "45.59944, 24.73617 · 45°35′58″N 24°44′10″E · 35T 401234 5049876",
      "anyFormat": "Orice format",
      "readAs": "Citită ca {{format}}: {{position}}",
      "pick": "Textul poate fi citit în mai multe feluri — alege unul:",
      "use": "Folosește",
      "openConverter": "Convertor de coordonate"
    },
    "errors": {
      "unrecognised": "Nu este o poziție în niciun format pe care aplicația îl citește.",
      "latitudeRange": "Latitudinea este în afara intervalului −90…90.",
      "longitudeRange": "Longitudinea este în afara intervalului −180…180.",
      "minutesRange": "Minutele trebuie să fie sub 60.",
      "secondsRange": "Secundele trebuie să fie sub 60.",
      "fractionNotLast": "Doar ultima parte a unui unghi poate avea zecimale.",
      "unitOrder": "Gradele, minutele și secundele sunt în ordinea greșită.",
      "hemisphereConflict": "Ambele valori numesc aceeași direcție (două latitudini sau două longitudini).",
      "componentCount": "O poziție are nevoie de exact două valori.",
      "utmZoneRange": "O zonă UTM este între 1 și 60.",
      "utmBandUnknown": "Aceasta nu este literă de bandă de latitudine UTM.",
      "utmBandMismatch": "Poziția nu se află în banda numită de literă.",
      "utmEastingRange": "Valoarea est este în afara unei zone UTM.",
      "utmNorthingRange": "Valoarea nord este în afara unei zone UTM.",
      "plusCodeShort": "Un Plus Code scurt are nevoie de un oraș apropiat; scrie codul complet.",
      "plusCodeInvalid": "Nu este un Plus Code valid.",
      "mgrsInvalid": "Nu este o referință MGRS validă.",
      "gridOutsideArea": "Poziția se află în afara zonei în care este folosit acest caroiaj."
    },
    "assumptions": {
      "latLonOrder": "Două numere fără litere au fost citite ca latitudine, apoi longitudine.",
      "northernHemisphere": "Nu s-a dat emisfera: s-a presupus cea nordică.",
      "lonLatOrder": "Două numere fără litere au fost citite ca longitudine, apoi latitudine.",
      "southernHemisphere": "Nu s-a dat emisfera: s-a presupus cea sudică.",
      "utmLetterAsBand": "Litera a fost citită ca bandă de latitudine.",
      "utmLetterAsHemisphere": "Litera a fost citită ca emisferă.",
      "gridAxisOrder": "Primul număr a fost citit ca valoarea est."
    },
    "converter": {
      "title": "Convertor de coordonate",
      "intro": "Scrie sau lipește o poziție în orice format pe care aplicația îl citește și vezi-o în toate formatele deodată. Totul se convertește în acest browser, iar nimic din ce scrii sau lipești aici nu este salvat și nu este trimis serverului aplicației. Singura excepție este afișarea poziției pe hartă: harta își încarcă imaginile de fundal pentru zona din jurul poziției de la OpenStreetMap. Pozițiile sunt scrise cu setările tale pentru fiecare format (Setări › Coordonate).",
      "single": "O poziție",
      "readAsFormat": "Citit ca",
      "copy": "Copiază",
      "copied": "Copiat",
      "showOnMap": "Arată pe o hartă",
      "hideMap": "Ascunde harta",
      "openMainMap": "Deschide locul pe harta principală",
      "mapHint": "Un marcaj temporar, pe o hartă separată: nu se adaugă nimic pe harta ta și nu se salvează nimic. Imaginile de fundal pentru această zonă sunt încărcate de la OpenStreetMap.",
      "batch": "Mai multe poziții",
      "batchHint": "Lipește câte o poziție pe linie, sau un tabel (CSV) și alege coloana care conține poziția — sau două, latitudinea și longitudinea. Fiecare linie se convertește separat; o linie care nu poate fi citită spune de ce.",
      "mode": "Lipit ca",
      "modeLines": "Câte una pe linie",
      "modeCsv": "Un tabel (CSV)",
      "separator": "Separatorul coloanelor",
      "separators": {
        "auto": "Separator: ghicit",
        "comma": "Virgulă",
        "semicolon": "Punct și virgulă",
        "tab": "Tab"
      },
      "header": "Prima linie conține numele coloanelor",
      "positionColumns": "Coloana (coloanele) cu poziția",
      "columnN": "Coloana {{n}}",
      "batchInput": "Pozițiile de convertit",
      "batchPlaceholder": "45°35′58″N 24°44′10″E\n35T 401234 5049876\nE 535046 N 448044",
      "csvPlaceholder": "nume;latitudine;longitudine\nintrarea 1;45.59944;24.73617",
      "convert": "Convertește",
      "download": "Descarcă CSV",
      "summary": "Linii citite: {{count}}; neconvertite: {{failed}}.",
      "leftOut": "Linii rămase necitite: {{count}} — se convertesc cel mult 5000 deodată.",
      "columns": {
        "line": "Linia",
        "input": "Textul citit",
        "result": "Poziția",
        "error": "Neconvertit deoarece"
      },
      "batchErrors": {
        "ambiguous": "Textul poate fi citit ca mai multe poziții: alege formatul în care este scris.",
        "missingColumn": "Coloana aleasă este goală pe această linie.",
        "empty": "Nu este nimic de citit."
      }
    }
  }
}
